import { openBlock as R, createBlock as ht, Transition as qt, withCtx as ft, withDirectives as he, createElementVNode as E, normalizeClass as re, createElementBlock as M, createCommentVNode as Q, toDisplayString as me, vShow as fe, resolveComponent as it, renderSlot as Tr, createVNode as Ue, defineComponent as Wh, h as Xc, withModifiers as zn, watch as bl, reactive as v0, withKeys as y0, defineAsyncComponent as Gh, Fragment as ci, renderList as ui, createStaticVNode as di, normalizeStyle as J, pushScopeId as b0, popScopeId as x0, createTextVNode as S0, inject as G, ref as Wi, computed as hr, unref as N, onMounted as w0, TransitionGroup as E0 } from "vue";
function T0(t, e) {
  for (var r = 0; r < e.length; r++) {
    const i = e[r];
    if (typeof i != "string" && !Array.isArray(i)) {
      for (const n in i)
        if (n !== "default" && !(n in t)) {
          const a = Object.getOwnPropertyDescriptor(i, n);
          a && Object.defineProperty(t, n, a.get ? a : {
            enumerable: !0,
            get: () => i[n]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }));
}
const na = "2", hi = "S", Sr = "ACP", fi = "AFP", nn = "FP", Pr = "T", $t = "CSCP", Qt = "CFPP", nt = "PP", an = "WACP", Yh = "GACP", Xh = "GAFP", sn = "WAFP", kt = "MP", on = "TTCP", qh = "CT", P0 = "INCP", O0 = "PFFP", C0 = "PFS", I0 = "PFRM", _0 = "PFMP", A0 = "PFWP", R0 = "PFAP", M0 = "PFPP", gi = "CPPLS", pi = "CPPLMP", Or = "CPPLCSP", mi = "CPPLPI", ni = "CPPLPB", St = "CPPLPP", fr = {
  [hi]: {
    "075DW": {
      edge: 0.75,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "150DW": {
      edge: 1.25,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "250DW": {
      edge: 2.5,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    BF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    WF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#fafafa"
    },
    EF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#3f2003"
    },
    NF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#EBDCC8"
    },
    GF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    SF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    RW: {
      edge: 1.25,
      gap: 0.5,
      mat: 0,
      frame: 1.25,
      color: "#3f2003"
    },
    RL: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 0,
      color: "#ffffff"
    }
  },
  [nn]: {
    NOMA: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "250MA": {
      edge: 0,
      gap: 0,
      mat: 2.5,
      frame: 0,
      color: ""
    },
    BF: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 1,
      color: "#333333"
    },
    WF: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 1,
      color: "#fafafa"
    },
    EF: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 1,
      color: "#3f2003"
    },
    RW: {
      edge: 0,
      gap: 0.5,
      mat: 0,
      frame: 0.75,
      color: "#3f2003"
    }
  },
  [Sr]: {
    "075DW": {
      edge: 0.75,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "150DW": {
      edge: 1.25,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "250DW": {
      edge: 2.5,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    BF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    WF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#fafafa"
    },
    EF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#3f2003"
    },
    NF: {
      edge: 1.25,
      gap: 0.5,
      mat: 0,
      frame: 1.25,
      color: "#3f2003"
    },
    GF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    SF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    RW: {
      edge: 1.25,
      gap: 0.5,
      mat: 0,
      frame: 1.25,
      color: "#3f2003"
    },
    RL: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 0,
      color: "#ffffff"
    }
  },
  [qh]: {
    "075DW": {
      edge: 0.75,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    BF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    WF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#fafafa"
    },
    EF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#3f2003"
    }
  },
  [fi]: {
    NOMA: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "250MA": {
      edge: 0,
      gap: 0,
      mat: 2.5,
      frame: 0,
      color: ""
    },
    BF: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 1,
      color: "#333333"
    },
    WF: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 1,
      color: "#fafafa"
    },
    EF: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 1,
      color: "#3f2003"
    },
    RW: {
      edge: 0,
      gap: 0.5,
      mat: 0,
      frame: 0.75,
      color: "#3f2003"
    }
  },
  [an]: {
    "075DW": {
      edge: 0.75,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "150DW": {
      edge: 1.25,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "250DW": {
      edge: 2.5,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    BF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    WF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#fafafa"
    },
    EF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#3f2003"
    },
    NF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#EBDCC8"
    },
    GF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    SF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    RW: {
      edge: 1.25,
      gap: 0.5,
      mat: 0,
      frame: 1.25,
      color: "#3f2003"
    },
    RL: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 0,
      color: "#ffffff"
    }
  },
  [on]: {
    "075DW": {
      edge: 0.75,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    BF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    }
  },
  [sn]: {
    NOMA: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "250MA": {
      edge: 0,
      gap: 0,
      mat: 2.5,
      frame: 0,
      color: ""
    },
    BF: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 1.25,
      color: "#333333"
    },
    WF: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 1.25,
      color: "#fafafa"
    },
    EF: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 1.25,
      color: "#3f2003"
    },
    RW: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 1,
      color: "#3f2003"
    }
  },
  [Yh]: {
    "075DW": {
      edge: 0.75,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "150DW": {
      edge: 1.25,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "250DW": {
      edge: 2.5,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    BF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    WF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#fafafa"
    },
    EF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#3f2003"
    },
    NF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#EBDCC8"
    },
    GF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    SF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    RW: {
      edge: 1.25,
      gap: 0.5,
      mat: 0,
      frame: 1.25,
      color: "#3f2003"
    },
    RL: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 0,
      color: "#ffffff"
    }
  },
  [Xh]: {
    NOMA: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "250MA": {
      edge: 0,
      gap: 0,
      mat: 2.5,
      frame: 0,
      color: ""
    },
    BF: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 1,
      color: "#333333"
    },
    WF: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 1,
      color: "#fafafa"
    },
    EF: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 1,
      color: "#3f2003"
    },
    RW: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 1,
      color: "#3f2003"
    }
  },
  [Pr]: {
    "075DW": {
      edge: 0.75,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "150DW": {
      edge: 1.25,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    RL: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 0,
      color: "#ffffff"
    }
  },
  [$t]: {
    "075DW": {
      edge: 0.75,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "150DW": {
      edge: 1.25,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "250DW": {
      edge: 2.5,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    BF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    WF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#fafafa"
    },
    EF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#3f2003"
    },
    NF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#EBDCC8"
    },
    GF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    SF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    RW: {
      edge: 1.25,
      gap: 0.5,
      mat: 0,
      frame: 0.75,
      color: "#3f2003"
    },
    RL: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 0,
      color: "#ffffff"
    }
  },
  [Qt]: {
    NOMA: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "250MA": {
      edge: 0,
      gap: 0,
      mat: 2.5,
      frame: 0,
      color: ""
    },
    BF: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 1,
      color: "#333333"
    },
    WF: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 1,
      color: "#fafafa"
    },
    EF: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 1,
      color: "#3f2003"
    },
    RW: {
      edge: 0,
      gap: 0.5,
      mat: 0,
      frame: 0.75,
      color: "#3f2003"
    }
  },
  [nt]: {
    "075DW": {
      edge: 1,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "150DW": {
      edge: 1.25,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "250DW": {
      edge: 2.5,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    BF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    WF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#fafafa"
    },
    EF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#3f2003"
    },
    NF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#EBDCC8"
    },
    GF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    SF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    RW: {
      edge: 1.25,
      gap: 0.5,
      mat: 0,
      frame: 1.25,
      color: "#3f2003"
    },
    RL: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 0,
      color: "#ffffff"
    }
  },
  [kt]: {},
  [gi]: {
    "075DW": {
      edge: 0.75,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "150DW": {
      edge: 1.25,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "250DW": {
      edge: 2.5,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    BF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    WF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#fafafa"
    },
    EF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#3f2003"
    },
    NF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#EBDCC8"
    },
    GF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    SF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    RW: {
      edge: 1.25,
      gap: 0.5,
      mat: 0,
      frame: 1.25,
      color: "#3f2003"
    },
    RL: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 0,
      color: "#ffffff"
    }
  },
  [pi]: {},
  [mi]: {},
  [ni]: {},
  [Or]: {
    "075DW": {
      edge: 0.75,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "150DW": {
      edge: 1.25,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "250DW": {
      edge: 2.5,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    BF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    WF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#fafafa"
    },
    EF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#3f2003"
    },
    NF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#EBDCC8"
    },
    GF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    SF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    RW: {
      edge: 1.25,
      gap: 0.5,
      mat: 0,
      frame: 0.75,
      color: "#3f2003"
    },
    RL: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 0,
      color: "#ffffff"
    }
  },
  [St]: {
    "075DW": {
      edge: 0.75,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "150DW": {
      edge: 1.25,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    "250DW": {
      edge: 2.5,
      gap: 0,
      mat: 0,
      frame: 0,
      color: ""
    },
    BF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    WF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#fafafa"
    },
    EF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#3f2003"
    },
    NF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#EBDCC8"
    },
    GF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    SF: {
      edge: 1.25,
      gap: 0.375,
      mat: 0,
      frame: 0.375,
      color: "#333333"
    },
    RW: {
      edge: 1.25,
      gap: 0.5,
      mat: 0,
      frame: 1.25,
      color: "#3f2003"
    },
    RL: {
      edge: 0,
      gap: 0,
      mat: 0,
      frame: 0,
      color: "#ffffff"
    }
  }
}, Kh = {
  [kt]: {
    cornerRadius: "1%"
  },
  [pi]: {
    cornerRadius: "1%"
  },
  [mi]: {
    cornerRadius: "1%"
  }
}, Zh = {
  [hi]: {
    BB: {
      color: "#000"
    },
    WB: {
      color: "#fff"
    },
    PB: {
      color: ""
    },
    BLB: {
      color: ""
    }
  },
  [on]: {
    BB: {
      color: "#000"
    },
    WB: {
      color: "#fff"
    },
    PB: {
      color: ""
    }
  },
  [nn]: {
    BB: {
      color: "#000"
    },
    WB: {
      color: "#fff"
    },
    PB: {
      color: ""
    }
  },
  [Sr]: {
    BB: {
      color: "#000"
    },
    WB: {
      color: "#fff"
    },
    PB: {
      color: ""
    }
  },
  [fi]: {
    BB: {
      color: "#000"
    },
    WB: {
      color: "#fff"
    },
    PB: {
      color: ""
    }
  },
  [an]: {
    BB: {
      color: "#000"
    },
    WB: {
      color: "#fff"
    },
    PB: {
      color: ""
    }
  },
  [sn]: {
    BB: {
      color: "#000"
    },
    WB: {
      color: "#fff"
    },
    PB: {
      color: ""
    }
  },
  [Pr]: {
    BB: {
      color: "#000"
    },
    WB: {
      color: "#fff"
    },
    PB: {
      color: ""
    }
  },
  [$t]: {
    BB: {
      color: "#000"
    },
    WB: {
      color: "#fff"
    },
    PB: {
      color: ""
    }
  },
  [Qt]: {
    BB: {
      color: "#000"
    },
    WB: {
      color: "#fff"
    },
    PB: {
      color: ""
    }
  },
  [nt]: {
    BB: {
      color: "#000"
    },
    WB: {
      color: "#fff"
    },
    PB: {
      color: ""
    }
  },
  [gi]: {
    BB: {
      color: "#000"
    },
    WB: {
      color: "#fff"
    },
    PB: {
      color: ""
    },
    BLB: {
      color: ""
    }
  },
  [Or]: {
    BB: {
      color: "#000"
    },
    WB: {
      color: "#fff"
    },
    PB: {
      color: ""
    }
  }
}, uo = {
  [hi]: 1,
  [on]: 1,
  [Sr]: 1,
  [fi]: 1,
  [nn]: 1,
  [Pr]: 3,
  [$t]: 1,
  [Qt]: 1,
  [nt]: 1,
  [an]: 1,
  [sn]: 1,
  [kt]: 1,
  [gi]: 1,
  [pi]: 1,
  [mi]: 1,
  [ni]: 1,
  [Or]: 1
}, Qh = {
  [$t]: {
    NB: {
      size: 0
    },
    RT: {
      size: 1
    },
    RTK: {
      size: 2.5
    }
  },
  [Qt]: {
    NB: {
      size: 0
    },
    RT: {
      size: 1
    },
    RTK: {
      size: 2.5
    }
  },
  [Or]: {
    NB: {
      size: 0
    },
    RT: {
      size: 1
    },
    RTK: {
      size: 2.5
    }
  }
}, Jh = {
  [$t]: {
    BB: {
      color: "#000"
    },
    WB: {
      color: "#fff"
    }
  },
  [Qt]: {
    BB: {
      color: "#000"
    },
    WB: {
      color: "#fff"
    }
  },
  [Or]: {
    BB: {
      color: "#000"
    },
    WB: {
      color: "#fff"
    }
  }
}, ef = {
  [hi]: {
    suggestedSizes: !0,
    uploadLater: !0,
    multipleImages: !1
  },
  [on]: {
    suggestedSizes: !1,
    uploadLater: !0,
    multipleImages: !1
  },
  [nn]: {
    suggestedSizes: !0,
    uploadLater: !0,
    multipleImages: !1
  },
  [Sr]: {
    suggestedSizes: !0,
    uploadLater: !1,
    multipleImages: !1
  },
  [fi]: {
    suggestedSizes: !0,
    uploadLater: !1,
    multipleImages: !1
  },
  [an]: {
    suggestedSizes: !0,
    uploadLater: !1,
    multipleImages: !1
  },
  [sn]: {
    suggestedSizes: !0,
    uploadLater: !1,
    multipleImages: !1
  },
  [Pr]: {
    suggestedSizes: !0,
    uploadLater: !0,
    multipleImages: !1
  },
  [$t]: {
    suggestedSizes: !1,
    uploadLater: !1,
    multipleImages: !0
  },
  [Qt]: {
    suggestedSizes: !1,
    uploadLater: !1,
    multipleImages: !0
  },
  [nt]: {
    suggestedSizes: !1,
    uploadLater: !1,
    multipleImages: !1
  },
  [kt]: {
    suggestedSizes: !0,
    uploadLater: !0,
    multipleImages: !1
  },
  [gi]: {
    suggestedSizes: !0,
    uploadLater: !0,
    multipleImages: !1
  },
  [pi]: {
    suggestedSizes: !0,
    uploadLater: !0,
    multipleImages: !1
  },
  [ni]: {
    suggestedSizes: !1,
    uploadLater: !0,
    multipleImages: !1
  },
  [mi]: {
    suggestedSizes: !1,
    uploadLater: !0,
    multipleImages: !1
  },
  [Or]: {
    suggestedSizes: !1,
    uploadLater: !1,
    multipleImages: !0
  },
  [St]: {
    suggestedSizes: !1,
    uploadLater: !1,
    multipleImages: !1
  }
}, tf = {
  [hi]: {
    name: "canvas",
    frame: {
      "075DW": !0,
      "150DW": !0,
      WF: !0,
      BF: !0,
      EF: !0,
      GF: !0,
      SF: !0,
      NF: !0
    },
    edge: {
      PB: !0,
      BB: !0,
      WB: !0
    }
  },
  [kt]: {
    name: "metal"
  },
  [gi]: {
    name: "canvas",
    frame: {
      "075DW": !0,
      "150DW": !0,
      WF: !0,
      BF: !0,
      EF: !0,
      GF: !0,
      SF: !0,
      NF: !0
    },
    edge: {
      PB: !0,
      BB: !0,
      WB: !0
    }
  },
  [pi]: {
    name: "metal"
  },
  [mi]: {
    name: "metal"
  }
}, $A = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AR3_ATTRIBUTES: tf,
  BORDERS: Qh,
  BORDER_COLORS: Jh,
  COLORS: Zh,
  CORNER_RADIUS: Kh,
  CPPL_PRODUCT_COLLAGE_CANVAS_PRINT: Or,
  CPPL_PRODUCT_METAL_PRINT: pi,
  CPPL_PRODUCT_PET_PORTRAIT: St,
  CPPL_PRODUCT_PHOTO_BLANKET: ni,
  CPPL_PRODUCT_PILLOW: mi,
  CPPL_PRODUCT_SINGLE_PANEL: gi,
  DIMENSIONS: fr,
  PANELS: uo,
  PF_PRODUCT_ACRYLIC_PRINT: R0,
  PF_PRODUCT_FRAMED_PRINT: O0,
  PF_PRODUCT_METAL_PRINT: _0,
  PF_PRODUCT_PAPER_PRINT: M0,
  PF_PRODUCT_READY_MADE: I0,
  PF_PRODUCT_SINGLE_PANEL: C0,
  PF_PRODUCT_WOOD_PRINT: A0,
  PRODUCT_ART_FRAMED_PRINT: fi,
  PRODUCT_ART_SINGLE_PANEL: Sr,
  PRODUCT_CANVAS_TILE: qh,
  PRODUCT_COLLAGE_CANVAS_PRINT: $t,
  PRODUCT_COLLAGE_FRAMED_PRINT: Qt,
  PRODUCT_FRAMED_PRINT: nn,
  PRODUCT_GENERATIVE_ART_FRAMED_PRINT: Xh,
  PRODUCT_GENERATIVE_ART_SINGLE_PANEL: Yh,
  PRODUCT_METAL_PRINT: kt,
  PRODUCT_PET_PORTRAIT: nt,
  PRODUCT_SINGLE_PANEL: hi,
  PRODUCT_TABLETOP_CANVAS_PRINT: on,
  PRODUCT_TRIPTYCH_PRINT: Pr,
  PRODUCT_VERSION: na,
  PRODUCT_WORD_ART_FRAMED_PRINT: sn,
  PRODUCT_WORD_ART_SINGLE_PANEL: an,
  SLUG_INCLUDE_PRINT: P0,
  SUPPORTS: ef
}, Symbol.toStringTag, { value: "Module" })), mr = "075DW", ei = "150DW", UA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  CANVAS_DEPTH_075DW: mr,
  CANVAS_DEPTH_150DW: ei
}, Symbol.toStringTag, { value: "Module" })), Ce = (t, e) => {
  const r = t.__vccOpts || t;
  for (const [i, n] of e)
    r[i] = n;
  return r;
}, L0 = {
  props: {
    label: {
      type: String,
      default: null
    },
    visible: {
      type: Boolean,
      default: !1
    },
    overlay: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {};
  },
  computed: {
    classList() {
      return [
        this.overlay ? "z-40" : ""
      ];
    },
    classListBackground() {
      return [
        "absolute inset-0 bg-white opacity-75 z-10"
      ];
    },
    classListSpinner() {
      return [
        "w-6 h-6 stroke-current"
      ];
    },
    classListLabel() {
      return [
        "text-sm text-center"
      ];
    }
  }
}, D0 = { class: "absolute top-50 left-50 -translate-center z-20 flex flex-col items-center justify-center" }, N0 = /* @__PURE__ */ E("circle", {
  "data-path": "",
  cx: "50",
  cy: "50",
  r: "20",
  fill: "none"
}, null, -1), j0 = [
  N0
];
function k0(t, e, r, i, n, a) {
  return R(), ht(qt, { name: "transition-fade" }, {
    default: ft(() => [
      he(E("div", {
        class: re(a.classList)
      }, [
        r.overlay ? (R(), M("div", {
          key: 0,
          "data-background": "",
          class: re(a.classListBackground)
        }, null, 2)) : Q("", !0),
        E("div", D0, [
          (R(), M("svg", {
            "data-loader": "",
            viewBox: "25 25 50 50",
            class: re(a.classListSpinner)
          }, j0, 2)),
          r.label ? (R(), M("div", {
            key: 0,
            "data-label": "",
            class: re(a.classListLabel)
          }, me(r.label), 3)) : Q("", !0)
        ])
      ], 2), [
        [fe, r.visible]
      ])
    ]),
    _: 1
  });
}
const xl = /* @__PURE__ */ Ce(L0, [["render", k0]]), z0 = {
  components: {
    Loader: xl
  },
  props: {
    label: {
      type: String,
      required: !0
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    loading: {
      type: Boolean,
      default: !1
    },
    inverted: {
      type: Boolean,
      default: !1
    },
    primary: {
      type: Boolean,
      default: !1
    },
    secondary: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  data() {
    return {};
  },
  computed: {
    classList() {
      return [
        "btn",
        this.inverted ? "btn--inverted" : "",
        this.disabled ? "btn--disabled" : "",
        this.primary ? "btn--primary" : "",
        this.secondary ? "btn--secondary" : ""
      ];
    },
    classListLabel() {
      return [
        "transition-opacity",
        this.loading ? "opacity-0" : ""
      ];
    },
    classListLoader() {
      return [
        "absolute top-50 left-50 -translate-center text-white transition-opacity",
        this.loading ? "opacity-100" : "opacity-0"
      ];
    }
  },
  methods: {
    handleClick() {
      this.$emit("click");
    }
  }
}, B0 = ["disabled"];
function F0(t, e, r, i, n, a) {
  const s = it("Loader");
  return R(), M("button", {
    class: re(a.classList),
    disabled: r.disabled || r.loading,
    onClick: e[0] || (e[0] = (...o) => a.handleClick && a.handleClick(...o))
  }, [
    Tr(t.$slots, "default"),
    E("div", {
      "data-label": "",
      class: re(a.classListLabel)
    }, me(r.label), 3),
    Ue(s, {
      visible: r.loading,
      class: re(a.classListLoader)
    }, null, 8, ["visible", "class"])
  ], 10, B0);
}
const $0 = /* @__PURE__ */ Ce(z0, [["render", F0]]);
var xt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function ln(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var rf = { exports: {} };
(function(t, e) {
  (function(i, n) {
    t.exports = n();
  })(typeof self < "u" ? self : xt, function() {
    return (
      /******/
      function(r) {
        var i = {};
        function n(a) {
          if (i[a])
            return i[a].exports;
          var s = i[a] = {
            /******/
            i: a,
            /******/
            l: !1,
            /******/
            exports: {}
            /******/
          };
          return r[a].call(s.exports, s, s.exports, n), s.l = !0, s.exports;
        }
        return n.m = r, n.c = i, n.d = function(a, s, o) {
          n.o(a, s) || Object.defineProperty(a, s, {
            /******/
            configurable: !1,
            /******/
            enumerable: !0,
            /******/
            get: o
            /******/
          });
        }, n.r = function(a) {
          Object.defineProperty(a, "__esModule", { value: !0 });
        }, n.n = function(a) {
          var s = a && a.__esModule ? (
            /******/
            function() {
              return a.default;
            }
          ) : (
            /******/
            function() {
              return a;
            }
          );
          return n.d(s, "a", s), s;
        }, n.o = function(a, s) {
          return Object.prototype.hasOwnProperty.call(a, s);
        }, n.p = "", n(n.s = 0);
      }({
        /***/
        "./dist/icons.json": (
          /*!*************************!*\
            !*** ./dist/icons.json ***!
            \*************************/
          /*! exports provided: activity, airplay, alert-circle, alert-octagon, alert-triangle, align-center, align-justify, align-left, align-right, anchor, aperture, archive, arrow-down-circle, arrow-down-left, arrow-down-right, arrow-down, arrow-left-circle, arrow-left, arrow-right-circle, arrow-right, arrow-up-circle, arrow-up-left, arrow-up-right, arrow-up, at-sign, award, bar-chart-2, bar-chart, battery-charging, battery, bell-off, bell, bluetooth, bold, book-open, book, bookmark, box, briefcase, calendar, camera-off, camera, cast, check-circle, check-square, check, chevron-down, chevron-left, chevron-right, chevron-up, chevrons-down, chevrons-left, chevrons-right, chevrons-up, chrome, circle, clipboard, clock, cloud-drizzle, cloud-lightning, cloud-off, cloud-rain, cloud-snow, cloud, code, codepen, codesandbox, coffee, columns, command, compass, copy, corner-down-left, corner-down-right, corner-left-down, corner-left-up, corner-right-down, corner-right-up, corner-up-left, corner-up-right, cpu, credit-card, crop, crosshair, database, delete, disc, divide-circle, divide-square, divide, dollar-sign, download-cloud, download, dribbble, droplet, edit-2, edit-3, edit, external-link, eye-off, eye, facebook, fast-forward, feather, figma, file-minus, file-plus, file-text, file, film, filter, flag, folder-minus, folder-plus, folder, framer, frown, gift, git-branch, git-commit, git-merge, git-pull-request, github, gitlab, globe, grid, hard-drive, hash, headphones, heart, help-circle, hexagon, home, image, inbox, info, instagram, italic, key, layers, layout, life-buoy, link-2, link, linkedin, list, loader, lock, log-in, log-out, mail, map-pin, map, maximize-2, maximize, meh, menu, message-circle, message-square, mic-off, mic, minimize-2, minimize, minus-circle, minus-square, minus, monitor, moon, more-horizontal, more-vertical, mouse-pointer, move, music, navigation-2, navigation, octagon, package, paperclip, pause-circle, pause, pen-tool, percent, phone-call, phone-forwarded, phone-incoming, phone-missed, phone-off, phone-outgoing, phone, pie-chart, play-circle, play, plus-circle, plus-square, plus, pocket, power, printer, radio, refresh-ccw, refresh-cw, repeat, rewind, rotate-ccw, rotate-cw, rss, save, scissors, search, send, server, settings, share-2, share, shield-off, shield, shopping-bag, shopping-cart, shuffle, sidebar, skip-back, skip-forward, slack, slash, sliders, smartphone, smile, speaker, square, star, stop-circle, sun, sunrise, sunset, table, tablet, tag, target, terminal, thermometer, thumbs-down, thumbs-up, toggle-left, toggle-right, tool, trash-2, trash, trello, trending-down, trending-up, triangle, truck, tv, twitch, twitter, type, umbrella, underline, unlock, upload-cloud, upload, user-check, user-minus, user-plus, user-x, user, users, video-off, video, voicemail, volume-1, volume-2, volume-x, volume, watch, wifi-off, wifi, wind, x-circle, x-octagon, x-square, x, youtube, zap-off, zap, zoom-in, zoom-out, default */
          /***/
          function(r) {
            r.exports = { activity: '<polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>', airplay: '<path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path><polygon points="12 15 17 21 7 21 12 15"></polygon>', "alert-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>', "alert-octagon": '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>', "alert-triangle": '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line>', "align-center": '<line x1="18" y1="10" x2="6" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="18" y1="18" x2="6" y2="18"></line>', "align-justify": '<line x1="21" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="21" y1="18" x2="3" y2="18"></line>', "align-left": '<line x1="17" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="17" y1="18" x2="3" y2="18"></line>', "align-right": '<line x1="21" y1="10" x2="7" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="21" y1="18" x2="7" y2="18"></line>', anchor: '<circle cx="12" cy="5" r="3"></circle><line x1="12" y1="22" x2="12" y2="8"></line><path d="M5 12H2a10 10 0 0 0 20 0h-3"></path>', aperture: '<circle cx="12" cy="12" r="10"></circle><line x1="14.31" y1="8" x2="20.05" y2="17.94"></line><line x1="9.69" y1="8" x2="21.17" y2="8"></line><line x1="7.38" y1="12" x2="13.12" y2="2.06"></line><line x1="9.69" y1="16" x2="3.95" y2="6.06"></line><line x1="14.31" y1="16" x2="2.83" y2="16"></line><line x1="16.62" y1="12" x2="10.88" y2="21.94"></line>', archive: '<polyline points="21 8 21 21 3 21 3 8"></polyline><rect x="1" y="3" width="22" height="5"></rect><line x1="10" y1="12" x2="14" y2="12"></line>', "arrow-down-circle": '<circle cx="12" cy="12" r="10"></circle><polyline points="8 12 12 16 16 12"></polyline><line x1="12" y1="8" x2="12" y2="16"></line>', "arrow-down-left": '<line x1="17" y1="7" x2="7" y2="17"></line><polyline points="17 17 7 17 7 7"></polyline>', "arrow-down-right": '<line x1="7" y1="7" x2="17" y2="17"></line><polyline points="17 7 17 17 7 17"></polyline>', "arrow-down": '<line x1="12" y1="5" x2="12" y2="19"></line><polyline points="19 12 12 19 5 12"></polyline>', "arrow-left-circle": '<circle cx="12" cy="12" r="10"></circle><polyline points="12 8 8 12 12 16"></polyline><line x1="16" y1="12" x2="8" y2="12"></line>', "arrow-left": '<line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>', "arrow-right-circle": '<circle cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8"></polyline><line x1="8" y1="12" x2="16" y2="12"></line>', "arrow-right": '<line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>', "arrow-up-circle": '<circle cx="12" cy="12" r="10"></circle><polyline points="16 12 12 8 8 12"></polyline><line x1="12" y1="16" x2="12" y2="8"></line>', "arrow-up-left": '<line x1="17" y1="17" x2="7" y2="7"></line><polyline points="7 17 7 7 17 7"></polyline>', "arrow-up-right": '<line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline>', "arrow-up": '<line x1="12" y1="19" x2="12" y2="5"></line><polyline points="5 12 12 5 19 12"></polyline>', "at-sign": '<circle cx="12" cy="12" r="4"></circle><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path>', award: '<circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>', "bar-chart-2": '<line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line>', "bar-chart": '<line x1="12" y1="20" x2="12" y2="10"></line><line x1="18" y1="20" x2="18" y2="4"></line><line x1="6" y1="20" x2="6" y2="16"></line>', "battery-charging": '<path d="M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"></path><line x1="23" y1="13" x2="23" y2="11"></line><polyline points="11 6 7 12 13 12 9 18"></polyline>', battery: '<rect x="1" y="6" width="18" height="12" rx="2" ry="2"></rect><line x1="23" y1="13" x2="23" y2="11"></line>', "bell-off": '<path d="M13.73 21a2 2 0 0 1-3.46 0"></path><path d="M18.63 13A17.89 17.89 0 0 1 18 8"></path><path d="M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14"></path><path d="M18 8a6 6 0 0 0-9.33-5"></path><line x1="1" y1="1" x2="23" y2="23"></line>', bell: '<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path>', bluetooth: '<polyline points="6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"></polyline>', bold: '<path d="M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path><path d="M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path>', "book-open": '<path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>', book: '<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>', bookmark: '<path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>', box: '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>', briefcase: '<rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>', calendar: '<rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line>', "camera-off": '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56"></path>', camera: '<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle>', cast: '<path d="M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"></path><line x1="2" y1="20" x2="2.01" y2="20"></line>', "check-circle": '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline>', "check-square": '<polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>', check: '<polyline points="20 6 9 17 4 12"></polyline>', "chevron-down": '<polyline points="6 9 12 15 18 9"></polyline>', "chevron-left": '<polyline points="15 18 9 12 15 6"></polyline>', "chevron-right": '<polyline points="9 18 15 12 9 6"></polyline>', "chevron-up": '<polyline points="18 15 12 9 6 15"></polyline>', "chevrons-down": '<polyline points="7 13 12 18 17 13"></polyline><polyline points="7 6 12 11 17 6"></polyline>', "chevrons-left": '<polyline points="11 17 6 12 11 7"></polyline><polyline points="18 17 13 12 18 7"></polyline>', "chevrons-right": '<polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline>', "chevrons-up": '<polyline points="17 11 12 6 7 11"></polyline><polyline points="17 18 12 13 7 18"></polyline>', chrome: '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle><line x1="21.17" y1="8" x2="12" y2="8"></line><line x1="3.95" y1="6.06" x2="8.54" y2="14"></line><line x1="10.88" y1="21.94" x2="15.46" y2="14"></line>', circle: '<circle cx="12" cy="12" r="10"></circle>', clipboard: '<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>', clock: '<circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>', "cloud-drizzle": '<line x1="8" y1="19" x2="8" y2="21"></line><line x1="8" y1="13" x2="8" y2="15"></line><line x1="16" y1="19" x2="16" y2="21"></line><line x1="16" y1="13" x2="16" y2="15"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="12" y1="15" x2="12" y2="17"></line><path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"></path>', "cloud-lightning": '<path d="M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"></path><polyline points="13 11 9 17 15 17 11 23"></polyline>', "cloud-off": '<path d="M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3"></path><line x1="1" y1="1" x2="23" y2="23"></line>', "cloud-rain": '<line x1="16" y1="13" x2="16" y2="21"></line><line x1="8" y1="13" x2="8" y2="21"></line><line x1="12" y1="15" x2="12" y2="23"></line><path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"></path>', "cloud-snow": '<path d="M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"></path><line x1="8" y1="16" x2="8.01" y2="16"></line><line x1="8" y1="20" x2="8.01" y2="20"></line><line x1="12" y1="18" x2="12.01" y2="18"></line><line x1="12" y1="22" x2="12.01" y2="22"></line><line x1="16" y1="16" x2="16.01" y2="16"></line><line x1="16" y1="20" x2="16.01" y2="20"></line>', cloud: '<path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>', code: '<polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline>', codepen: '<polygon points="12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"></polygon><line x1="12" y1="22" x2="12" y2="15.5"></line><polyline points="22 8.5 12 15.5 2 8.5"></polyline><polyline points="2 15.5 12 8.5 22 15.5"></polyline><line x1="12" y1="2" x2="12" y2="8.5"></line>', codesandbox: '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="7.5 4.21 12 6.81 16.5 4.21"></polyline><polyline points="7.5 19.79 7.5 14.6 3 12"></polyline><polyline points="21 12 16.5 14.6 16.5 19.79"></polyline><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>', coffee: '<path d="M18 8h1a4 4 0 0 1 0 8h-1"></path><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path><line x1="6" y1="1" x2="6" y2="4"></line><line x1="10" y1="1" x2="10" y2="4"></line><line x1="14" y1="1" x2="14" y2="4"></line>', columns: '<path d="M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18"></path>', command: '<path d="M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"></path>', compass: '<circle cx="12" cy="12" r="10"></circle><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>', copy: '<rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>', "corner-down-left": '<polyline points="9 10 4 15 9 20"></polyline><path d="M20 4v7a4 4 0 0 1-4 4H4"></path>', "corner-down-right": '<polyline points="15 10 20 15 15 20"></polyline><path d="M4 4v7a4 4 0 0 0 4 4h12"></path>', "corner-left-down": '<polyline points="14 15 9 20 4 15"></polyline><path d="M20 4h-7a4 4 0 0 0-4 4v12"></path>', "corner-left-up": '<polyline points="14 9 9 4 4 9"></polyline><path d="M20 20h-7a4 4 0 0 1-4-4V4"></path>', "corner-right-down": '<polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>', "corner-right-up": '<polyline points="10 9 15 4 20 9"></polyline><path d="M4 20h7a4 4 0 0 0 4-4V4"></path>', "corner-up-left": '<polyline points="9 14 4 9 9 4"></polyline><path d="M20 20v-7a4 4 0 0 0-4-4H4"></path>', "corner-up-right": '<polyline points="15 14 20 9 15 4"></polyline><path d="M4 20v-7a4 4 0 0 1 4-4h12"></path>', cpu: '<rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect><rect x="9" y="9" width="6" height="6"></rect><line x1="9" y1="1" x2="9" y2="4"></line><line x1="15" y1="1" x2="15" y2="4"></line><line x1="9" y1="20" x2="9" y2="23"></line><line x1="15" y1="20" x2="15" y2="23"></line><line x1="20" y1="9" x2="23" y2="9"></line><line x1="20" y1="14" x2="23" y2="14"></line><line x1="1" y1="9" x2="4" y2="9"></line><line x1="1" y1="14" x2="4" y2="14"></line>', "credit-card": '<rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line>', crop: '<path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"></path><path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"></path>', crosshair: '<circle cx="12" cy="12" r="10"></circle><line x1="22" y1="12" x2="18" y2="12"></line><line x1="6" y1="12" x2="2" y2="12"></line><line x1="12" y1="6" x2="12" y2="2"></line><line x1="12" y1="22" x2="12" y2="18"></line>', database: '<ellipse cx="12" cy="5" rx="9" ry="3"></ellipse><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>', delete: '<path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path><line x1="18" y1="9" x2="12" y2="15"></line><line x1="12" y1="9" x2="18" y2="15"></line>', disc: '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="3"></circle>', "divide-circle": '<line x1="8" y1="12" x2="16" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line><line x1="12" y1="8" x2="12" y2="8"></line><circle cx="12" cy="12" r="10"></circle>', "divide-square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="8" y1="12" x2="16" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line><line x1="12" y1="8" x2="12" y2="8"></line>', divide: '<circle cx="12" cy="6" r="2"></circle><line x1="5" y1="12" x2="19" y2="12"></line><circle cx="12" cy="18" r="2"></circle>', "dollar-sign": '<line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>', "download-cloud": '<polyline points="8 17 12 21 16 17"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"></path>', download: '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line>', dribbble: '<circle cx="12" cy="12" r="10"></circle><path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"></path>', droplet: '<path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"></path>', "edit-2": '<path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>', "edit-3": '<path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>', edit: '<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>', "external-link": '<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line>', "eye-off": '<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line>', eye: '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle>', facebook: '<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>', "fast-forward": '<polygon points="13 19 22 12 13 5 13 19"></polygon><polygon points="2 19 11 12 2 5 2 19"></polygon>', feather: '<path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"></path><line x1="16" y1="8" x2="2" y2="22"></line><line x1="17.5" y1="15" x2="9" y2="15"></line>', figma: '<path d="M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z"></path><path d="M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z"></path><path d="M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z"></path><path d="M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z"></path><path d="M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z"></path>', "file-minus": '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="9" y1="15" x2="15" y2="15"></line>', "file-plus": '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="12" y1="18" x2="12" y2="12"></line><line x1="9" y1="15" x2="15" y2="15"></line>', "file-text": '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline>', file: '<path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline>', film: '<rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect><line x1="7" y1="2" x2="7" y2="22"></line><line x1="17" y1="2" x2="17" y2="22"></line><line x1="2" y1="12" x2="22" y2="12"></line><line x1="2" y1="7" x2="7" y2="7"></line><line x1="2" y1="17" x2="7" y2="17"></line><line x1="17" y1="17" x2="22" y2="17"></line><line x1="17" y1="7" x2="22" y2="7"></line>', filter: '<polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>', flag: '<path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path><line x1="4" y1="22" x2="4" y2="15"></line>', "folder-minus": '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="9" y1="14" x2="15" y2="14"></line>', "folder-plus": '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="12" y1="11" x2="12" y2="17"></line><line x1="9" y1="14" x2="15" y2="14"></line>', folder: '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>', framer: '<path d="M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7"></path>', frown: '<circle cx="12" cy="12" r="10"></circle><path d="M16 16s-1.5-2-4-2-4 2-4 2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>', gift: '<polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>', "git-branch": '<line x1="6" y1="3" x2="6" y2="15"></line><circle cx="18" cy="6" r="3"></circle><circle cx="6" cy="18" r="3"></circle><path d="M18 9a9 9 0 0 1-9 9"></path>', "git-commit": '<circle cx="12" cy="12" r="4"></circle><line x1="1.05" y1="12" x2="7" y2="12"></line><line x1="17.01" y1="12" x2="22.96" y2="12"></line>', "git-merge": '<circle cx="18" cy="18" r="3"></circle><circle cx="6" cy="6" r="3"></circle><path d="M6 21V9a9 9 0 0 0 9 9"></path>', "git-pull-request": '<circle cx="18" cy="18" r="3"></circle><circle cx="6" cy="6" r="3"></circle><path d="M13 6h3a2 2 0 0 1 2 2v7"></path><line x1="6" y1="9" x2="6" y2="21"></line>', github: '<path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>', gitlab: '<path d="M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"></path>', globe: '<circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>', grid: '<rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect>', "hard-drive": '<line x1="22" y1="12" x2="2" y2="12"></line><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path><line x1="6" y1="16" x2="6.01" y2="16"></line><line x1="10" y1="16" x2="10.01" y2="16"></line>', hash: '<line x1="4" y1="9" x2="20" y2="9"></line><line x1="4" y1="15" x2="20" y2="15"></line><line x1="10" y1="3" x2="8" y2="21"></line><line x1="16" y1="3" x2="14" y2="21"></line>', headphones: '<path d="M3 18v-6a9 9 0 0 1 18 0v6"></path><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>', heart: '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>', "help-circle": '<circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line>', hexagon: '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>', home: '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline>', image: '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline>', inbox: '<polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>', info: '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line>', instagram: '<rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>', italic: '<line x1="19" y1="4" x2="10" y2="4"></line><line x1="14" y1="20" x2="5" y2="20"></line><line x1="15" y1="4" x2="9" y2="20"></line>', key: '<path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>', layers: '<polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline>', layout: '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line>', "life-buoy": '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle><line x1="4.93" y1="4.93" x2="9.17" y2="9.17"></line><line x1="14.83" y1="14.83" x2="19.07" y2="19.07"></line><line x1="14.83" y1="9.17" x2="19.07" y2="4.93"></line><line x1="14.83" y1="9.17" x2="18.36" y2="5.64"></line><line x1="4.93" y1="19.07" x2="9.17" y2="14.83"></line>', "link-2": '<path d="M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"></path><line x1="8" y1="12" x2="16" y2="12"></line>', link: '<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>', linkedin: '<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle>', list: '<line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line>', loader: '<line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>', lock: '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path>', "log-in": '<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path><polyline points="10 17 15 12 10 7"></polyline><line x1="15" y1="12" x2="3" y2="12"></line>', "log-out": '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line>', mail: '<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline>', "map-pin": '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>', map: '<polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon><line x1="8" y1="2" x2="8" y2="18"></line><line x1="16" y1="6" x2="16" y2="22"></line>', "maximize-2": '<polyline points="15 3 21 3 21 9"></polyline><polyline points="9 21 3 21 3 15"></polyline><line x1="21" y1="3" x2="14" y2="10"></line><line x1="3" y1="21" x2="10" y2="14"></line>', maximize: '<path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>', meh: '<circle cx="12" cy="12" r="10"></circle><line x1="8" y1="15" x2="16" y2="15"></line><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>', menu: '<line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line>', "message-circle": '<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>', "message-square": '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>', "mic-off": '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"></path><path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>', mic: '<path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>', "minimize-2": '<polyline points="4 14 10 14 10 20"></polyline><polyline points="20 10 14 10 14 4"></polyline><line x1="14" y1="10" x2="21" y2="3"></line><line x1="3" y1="21" x2="10" y2="14"></line>', minimize: '<path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>', "minus-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line>', "minus-square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="8" y1="12" x2="16" y2="12"></line>', minus: '<line x1="5" y1="12" x2="19" y2="12"></line>', monitor: '<rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line>', moon: '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>', "more-horizontal": '<circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle>', "more-vertical": '<circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle>', "mouse-pointer": '<path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"></path><path d="M13 13l6 6"></path>', move: '<polyline points="5 9 2 12 5 15"></polyline><polyline points="9 5 12 2 15 5"></polyline><polyline points="15 19 12 22 9 19"></polyline><polyline points="19 9 22 12 19 15"></polyline><line x1="2" y1="12" x2="22" y2="12"></line><line x1="12" y1="2" x2="12" y2="22"></line>', music: '<path d="M9 18V5l12-2v13"></path><circle cx="6" cy="18" r="3"></circle><circle cx="18" cy="16" r="3"></circle>', "navigation-2": '<polygon points="12 2 19 21 12 17 5 21 12 2"></polygon>', navigation: '<polygon points="3 11 22 2 13 21 11 13 3 11"></polygon>', octagon: '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>', package: '<line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>', paperclip: '<path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>', "pause-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="10" y1="15" x2="10" y2="9"></line><line x1="14" y1="15" x2="14" y2="9"></line>', pause: '<rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect>', "pen-tool": '<path d="M12 19l7-7 3 3-7 7-3-3z"></path><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"></path><path d="M2 2l7.586 7.586"></path><circle cx="11" cy="11" r="2"></circle>', percent: '<line x1="19" y1="5" x2="5" y2="19"></line><circle cx="6.5" cy="6.5" r="2.5"></circle><circle cx="17.5" cy="17.5" r="2.5"></circle>', "phone-call": '<path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>', "phone-forwarded": '<polyline points="19 1 23 5 19 9"></polyline><line x1="15" y1="5" x2="23" y2="5"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>', "phone-incoming": '<polyline points="16 2 16 8 22 8"></polyline><line x1="23" y1="1" x2="16" y2="8"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>', "phone-missed": '<line x1="23" y1="1" x2="17" y2="7"></line><line x1="17" y1="1" x2="23" y2="7"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>', "phone-off": '<path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"></path><line x1="23" y1="1" x2="1" y2="23"></line>', "phone-outgoing": '<polyline points="23 7 23 1 17 1"></polyline><line x1="16" y1="8" x2="23" y2="1"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>', phone: '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>', "pie-chart": '<path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path>', "play-circle": '<circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon>', play: '<polygon points="5 3 19 12 5 21 5 3"></polygon>', "plus-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line>', "plus-square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line>', plus: '<line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line>', pocket: '<path d="M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"></path><polyline points="8 10 12 14 16 10"></polyline>', power: '<path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path><line x1="12" y1="2" x2="12" y2="12"></line>', printer: '<polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect>', radio: '<circle cx="12" cy="12" r="2"></circle><path d="M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"></path>', "refresh-ccw": '<polyline points="1 4 1 10 7 10"></polyline><polyline points="23 20 23 14 17 14"></polyline><path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>', "refresh-cw": '<polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>', repeat: '<polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path>', rewind: '<polygon points="11 19 2 12 11 5 11 19"></polygon><polygon points="22 19 13 12 22 5 22 19"></polygon>', "rotate-ccw": '<polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>', "rotate-cw": '<polyline points="23 4 23 10 17 10"></polyline><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>', rss: '<path d="M4 11a9 9 0 0 1 9 9"></path><path d="M4 4a16 16 0 0 1 16 16"></path><circle cx="5" cy="19" r="1"></circle>', save: '<path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline>', scissors: '<circle cx="6" cy="6" r="3"></circle><circle cx="6" cy="18" r="3"></circle><line x1="20" y1="4" x2="8.12" y2="15.88"></line><line x1="14.47" y1="14.48" x2="20" y2="20"></line><line x1="8.12" y1="8.12" x2="12" y2="12"></line>', search: '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>', send: '<line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>', server: '<rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect><rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect><line x1="6" y1="6" x2="6.01" y2="6"></line><line x1="6" y1="18" x2="6.01" y2="18"></line>', settings: '<circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>', "share-2": '<circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>', share: '<path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path><polyline points="16 6 12 2 8 6"></polyline><line x1="12" y1="2" x2="12" y2="15"></line>', "shield-off": '<path d="M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18"></path><path d="M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38"></path><line x1="1" y1="1" x2="23" y2="23"></line>', shield: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>', "shopping-bag": '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path>', "shopping-cart": '<circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>', shuffle: '<polyline points="16 3 21 3 21 8"></polyline><line x1="4" y1="20" x2="21" y2="3"></line><polyline points="21 16 21 21 16 21"></polyline><line x1="15" y1="15" x2="21" y2="21"></line><line x1="4" y1="4" x2="9" y2="9"></line>', sidebar: '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="3" x2="9" y2="21"></line>', "skip-back": '<polygon points="19 20 9 12 19 4 19 20"></polygon><line x1="5" y1="19" x2="5" y2="5"></line>', "skip-forward": '<polygon points="5 4 15 12 5 20 5 4"></polygon><line x1="19" y1="5" x2="19" y2="19"></line>', slack: '<path d="M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"></path><path d="M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path><path d="M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"></path><path d="M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"></path><path d="M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"></path><path d="M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"></path><path d="M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"></path><path d="M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"></path>', slash: '<circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>', sliders: '<line x1="4" y1="21" x2="4" y2="14"></line><line x1="4" y1="10" x2="4" y2="3"></line><line x1="12" y1="21" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="3"></line><line x1="20" y1="21" x2="20" y2="16"></line><line x1="20" y1="12" x2="20" y2="3"></line><line x1="1" y1="14" x2="7" y2="14"></line><line x1="9" y1="8" x2="15" y2="8"></line><line x1="17" y1="16" x2="23" y2="16"></line>', smartphone: '<rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>', smile: '<circle cx="12" cy="12" r="10"></circle><path d="M8 14s1.5 2 4 2 4-2 4-2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>', speaker: '<rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><circle cx="12" cy="14" r="4"></circle><line x1="12" y1="6" x2="12.01" y2="6"></line>', square: '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>', star: '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>', "stop-circle": '<circle cx="12" cy="12" r="10"></circle><rect x="9" y="9" width="6" height="6"></rect>', sun: '<circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>', sunrise: '<path d="M17 18a5 5 0 0 0-10 0"></path><line x1="12" y1="2" x2="12" y2="9"></line><line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line><line x1="1" y1="18" x2="3" y2="18"></line><line x1="21" y1="18" x2="23" y2="18"></line><line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line><line x1="23" y1="22" x2="1" y2="22"></line><polyline points="8 6 12 2 16 6"></polyline>', sunset: '<path d="M17 18a5 5 0 0 0-10 0"></path><line x1="12" y1="9" x2="12" y2="2"></line><line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line><line x1="1" y1="18" x2="3" y2="18"></line><line x1="21" y1="18" x2="23" y2="18"></line><line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line><line x1="23" y1="22" x2="1" y2="22"></line><polyline points="16 5 12 9 8 5"></polyline>', table: '<path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"></path>', tablet: '<rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>', tag: '<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line>', target: '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>', terminal: '<polyline points="4 17 10 11 4 5"></polyline><line x1="12" y1="19" x2="20" y2="19"></line>', thermometer: '<path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"></path>', "thumbs-down": '<path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"></path>', "thumbs-up": '<path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>', "toggle-left": '<rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="8" cy="12" r="3"></circle>', "toggle-right": '<rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="16" cy="12" r="3"></circle>', tool: '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>', "trash-2": '<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>', trash: '<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>', trello: '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><rect x="7" y="7" width="3" height="9"></rect><rect x="14" y="7" width="3" height="5"></rect>', "trending-down": '<polyline points="23 18 13.5 8.5 8.5 13.5 1 6"></polyline><polyline points="17 18 23 18 23 12"></polyline>', "trending-up": '<polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline>', triangle: '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>', truck: '<rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle>', tv: '<rect x="2" y="7" width="20" height="15" rx="2" ry="2"></rect><polyline points="17 2 12 7 7 2"></polyline>', twitch: '<path d="M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7"></path>', twitter: '<path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>', type: '<polyline points="4 7 4 4 20 4 20 7"></polyline><line x1="9" y1="20" x2="15" y2="20"></line><line x1="12" y1="4" x2="12" y2="20"></line>', umbrella: '<path d="M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7"></path>', underline: '<path d="M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"></path><line x1="4" y1="21" x2="20" y2="21"></line>', unlock: '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 9.9-1"></path>', "upload-cloud": '<polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline>', upload: '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line>', "user-check": '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><polyline points="17 11 19 13 23 9"></polyline>', "user-minus": '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="23" y1="11" x2="17" y2="11"></line>', "user-plus": '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line>', "user-x": '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="18" y1="8" x2="23" y2="13"></line><line x1="23" y1="8" x2="18" y2="13"></line>', user: '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle>', users: '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>', "video-off": '<path d="M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"></path><line x1="1" y1="1" x2="23" y2="23"></line>', video: '<polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>', voicemail: '<circle cx="5.5" cy="11.5" r="4.5"></circle><circle cx="18.5" cy="11.5" r="4.5"></circle><line x1="5.5" y1="16" x2="18.5" y2="16"></line>', "volume-1": '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>', "volume-2": '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>', "volume-x": '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line>', volume: '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>', watch: '<circle cx="12" cy="12" r="7"></circle><polyline points="12 9 12 12 13.5 13.5"></polyline><path d="M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83"></path>', "wifi-off": '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"></path><path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"></path><path d="M10.71 5.05A16 16 0 0 1 22.58 9"></path><path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line>', wifi: '<path d="M5 12.55a11 11 0 0 1 14.08 0"></path><path d="M1.42 9a16 16 0 0 1 21.16 0"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line>', wind: '<path d="M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"></path>', "x-circle": '<circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>', "x-octagon": '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>', "x-square": '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="15"></line><line x1="15" y1="9" x2="9" y2="15"></line>', x: '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>', youtube: '<path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>', "zap-off": '<polyline points="12.41 6.75 13 2 10.57 4.92"></polyline><polyline points="18.57 12.91 21 10 15.66 10"></polyline><polyline points="8 8 3 14 12 14 11 22 16 16"></polyline><line x1="1" y1="1" x2="23" y2="23"></line>', zap: '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>', "zoom-in": '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line>', "zoom-out": '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="8" y1="11" x2="14" y2="11"></line>' };
          }
        ),
        /***/
        "./node_modules/classnames/dedupe.js": (
          /*!*******************************************!*\
            !*** ./node_modules/classnames/dedupe.js ***!
            \*******************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a, s;
            /*!
              Copyright (c) 2016 Jed Watson.
              Licensed under the MIT License (MIT), see
              http://jedwatson.github.io/classnames
            */
            (function() {
              var o = function() {
                function l() {
                }
                l.prototype = /* @__PURE__ */ Object.create(null);
                function c(y, x) {
                  for (var w = x.length, P = 0; P < w; ++P)
                    p(y, x[P]);
                }
                var u = {}.hasOwnProperty;
                function d(y, x) {
                  y[x] = !0;
                }
                function h(y, x) {
                  for (var w in x)
                    u.call(x, w) && (y[w] = !!x[w]);
                }
                var f = /\s+/;
                function v(y, x) {
                  for (var w = x.split(f), P = w.length, O = 0; O < P; ++O)
                    y[w[O]] = !0;
                }
                function p(y, x) {
                  if (x) {
                    var w = typeof x;
                    w === "string" ? v(y, x) : Array.isArray(x) ? c(y, x) : w === "object" ? h(y, x) : w === "number" && d(y, x);
                  }
                }
                function b() {
                  for (var y = arguments.length, x = Array(y), w = 0; w < y; w++)
                    x[w] = arguments[w];
                  var P = new l();
                  c(P, x);
                  var O = [];
                  for (var A in P)
                    P[A] && O.push(A);
                  return O.join(" ");
                }
                return b;
              }();
              typeof r < "u" && r.exports ? r.exports = o : (a = [], s = (function() {
                return o;
              }).apply(i, a), s !== void 0 && (r.exports = s));
            })();
          }
        ),
        /***/
        "./node_modules/core-js/es/array/from.js": (
          /*!***********************************************!*\
            !*** ./node_modules/core-js/es/array/from.js ***!
            \***********************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            n(
              /*! ../../modules/es.string.iterator */
              "./node_modules/core-js/modules/es.string.iterator.js"
            ), n(
              /*! ../../modules/es.array.from */
              "./node_modules/core-js/modules/es.array.from.js"
            );
            var a = n(
              /*! ../../internals/path */
              "./node_modules/core-js/internals/path.js"
            );
            r.exports = a.Array.from;
          }
        ),
        /***/
        "./node_modules/core-js/internals/a-function.js": (
          /*!******************************************************!*\
            !*** ./node_modules/core-js/internals/a-function.js ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(r, i) {
            r.exports = function(n) {
              if (typeof n != "function")
                throw TypeError(String(n) + " is not a function");
              return n;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/an-object.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/internals/an-object.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/is-object */
              "./node_modules/core-js/internals/is-object.js"
            );
            r.exports = function(s) {
              if (!a(s))
                throw TypeError(String(s) + " is not an object");
              return s;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/array-from.js": (
          /*!******************************************************!*\
            !*** ./node_modules/core-js/internals/array-from.js ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/bind-context */
              "./node_modules/core-js/internals/bind-context.js"
            ), s = n(
              /*! ../internals/to-object */
              "./node_modules/core-js/internals/to-object.js"
            ), o = n(
              /*! ../internals/call-with-safe-iteration-closing */
              "./node_modules/core-js/internals/call-with-safe-iteration-closing.js"
            ), l = n(
              /*! ../internals/is-array-iterator-method */
              "./node_modules/core-js/internals/is-array-iterator-method.js"
            ), c = n(
              /*! ../internals/to-length */
              "./node_modules/core-js/internals/to-length.js"
            ), u = n(
              /*! ../internals/create-property */
              "./node_modules/core-js/internals/create-property.js"
            ), d = n(
              /*! ../internals/get-iterator-method */
              "./node_modules/core-js/internals/get-iterator-method.js"
            );
            r.exports = function(f) {
              var v = s(f), p = typeof this == "function" ? this : Array, b = arguments.length, y = b > 1 ? arguments[1] : void 0, x = y !== void 0, w = 0, P = d(v), O, A, I, D;
              if (x && (y = a(y, b > 2 ? arguments[2] : void 0, 2)), P != null && !(p == Array && l(P)))
                for (D = P.call(v), A = new p(); !(I = D.next()).done; w++)
                  u(
                    A,
                    w,
                    x ? o(D, y, [I.value, w], !0) : I.value
                  );
              else
                for (O = c(v.length), A = new p(O); O > w; w++)
                  u(A, w, x ? y(v[w], w) : v[w]);
              return A.length = w, A;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/array-includes.js": (
          /*!**********************************************************!*\
            !*** ./node_modules/core-js/internals/array-includes.js ***!
            \**********************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/to-indexed-object */
              "./node_modules/core-js/internals/to-indexed-object.js"
            ), s = n(
              /*! ../internals/to-length */
              "./node_modules/core-js/internals/to-length.js"
            ), o = n(
              /*! ../internals/to-absolute-index */
              "./node_modules/core-js/internals/to-absolute-index.js"
            );
            r.exports = function(l) {
              return function(c, u, d) {
                var h = a(c), f = s(h.length), v = o(d, f), p;
                if (l && u != u) {
                  for (; f > v; )
                    if (p = h[v++], p != p)
                      return !0;
                } else
                  for (; f > v; v++)
                    if ((l || v in h) && h[v] === u)
                      return l || v || 0;
                return !l && -1;
              };
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/bind-context.js": (
          /*!********************************************************!*\
            !*** ./node_modules/core-js/internals/bind-context.js ***!
            \********************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/a-function */
              "./node_modules/core-js/internals/a-function.js"
            );
            r.exports = function(s, o, l) {
              if (a(s), o === void 0)
                return s;
              switch (l) {
                case 0:
                  return function() {
                    return s.call(o);
                  };
                case 1:
                  return function(c) {
                    return s.call(o, c);
                  };
                case 2:
                  return function(c, u) {
                    return s.call(o, c, u);
                  };
                case 3:
                  return function(c, u, d) {
                    return s.call(o, c, u, d);
                  };
              }
              return function() {
                return s.apply(o, arguments);
              };
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/call-with-safe-iteration-closing.js": (
          /*!****************************************************************************!*\
            !*** ./node_modules/core-js/internals/call-with-safe-iteration-closing.js ***!
            \****************************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/an-object */
              "./node_modules/core-js/internals/an-object.js"
            );
            r.exports = function(s, o, l, c) {
              try {
                return c ? o(a(l)[0], l[1]) : o(l);
              } catch (d) {
                var u = s.return;
                throw u !== void 0 && a(u.call(s)), d;
              }
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/check-correctness-of-iteration.js": (
          /*!**************************************************************************!*\
            !*** ./node_modules/core-js/internals/check-correctness-of-iteration.js ***!
            \**************************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/well-known-symbol */
              "./node_modules/core-js/internals/well-known-symbol.js"
            ), s = a("iterator"), o = !1;
            try {
              var l = 0, c = {
                next: function() {
                  return { done: !!l++ };
                },
                return: function() {
                  o = !0;
                }
              };
              c[s] = function() {
                return this;
              }, Array.from(c, function() {
                throw 2;
              });
            } catch {
            }
            r.exports = function(u, d) {
              if (!d && !o)
                return !1;
              var h = !1;
              try {
                var f = {};
                f[s] = function() {
                  return {
                    next: function() {
                      return { done: h = !0 };
                    }
                  };
                }, u(f);
              } catch {
              }
              return h;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/classof-raw.js": (
          /*!*******************************************************!*\
            !*** ./node_modules/core-js/internals/classof-raw.js ***!
            \*******************************************************/
          /*! no static exports found */
          /***/
          function(r, i) {
            var n = {}.toString;
            r.exports = function(a) {
              return n.call(a).slice(8, -1);
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/classof.js": (
          /*!***************************************************!*\
            !*** ./node_modules/core-js/internals/classof.js ***!
            \***************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/classof-raw */
              "./node_modules/core-js/internals/classof-raw.js"
            ), s = n(
              /*! ../internals/well-known-symbol */
              "./node_modules/core-js/internals/well-known-symbol.js"
            ), o = s("toStringTag"), l = a(function() {
              return arguments;
            }()) == "Arguments", c = function(u, d) {
              try {
                return u[d];
              } catch {
              }
            };
            r.exports = function(u) {
              var d, h, f;
              return u === void 0 ? "Undefined" : u === null ? "Null" : typeof (h = c(d = Object(u), o)) == "string" ? h : l ? a(d) : (f = a(d)) == "Object" && typeof d.callee == "function" ? "Arguments" : f;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/copy-constructor-properties.js": (
          /*!***********************************************************************!*\
            !*** ./node_modules/core-js/internals/copy-constructor-properties.js ***!
            \***********************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/has */
              "./node_modules/core-js/internals/has.js"
            ), s = n(
              /*! ../internals/own-keys */
              "./node_modules/core-js/internals/own-keys.js"
            ), o = n(
              /*! ../internals/object-get-own-property-descriptor */
              "./node_modules/core-js/internals/object-get-own-property-descriptor.js"
            ), l = n(
              /*! ../internals/object-define-property */
              "./node_modules/core-js/internals/object-define-property.js"
            );
            r.exports = function(c, u) {
              for (var d = s(u), h = l.f, f = o.f, v = 0; v < d.length; v++) {
                var p = d[v];
                a(c, p) || h(c, p, f(u, p));
              }
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/correct-prototype-getter.js": (
          /*!********************************************************************!*\
            !*** ./node_modules/core-js/internals/correct-prototype-getter.js ***!
            \********************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/fails */
              "./node_modules/core-js/internals/fails.js"
            );
            r.exports = !a(function() {
              function s() {
              }
              return s.prototype.constructor = null, Object.getPrototypeOf(new s()) !== s.prototype;
            });
          }
        ),
        /***/
        "./node_modules/core-js/internals/create-iterator-constructor.js": (
          /*!***********************************************************************!*\
            !*** ./node_modules/core-js/internals/create-iterator-constructor.js ***!
            \***********************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/iterators-core */
              "./node_modules/core-js/internals/iterators-core.js"
            ).IteratorPrototype, s = n(
              /*! ../internals/object-create */
              "./node_modules/core-js/internals/object-create.js"
            ), o = n(
              /*! ../internals/create-property-descriptor */
              "./node_modules/core-js/internals/create-property-descriptor.js"
            ), l = n(
              /*! ../internals/set-to-string-tag */
              "./node_modules/core-js/internals/set-to-string-tag.js"
            ), c = n(
              /*! ../internals/iterators */
              "./node_modules/core-js/internals/iterators.js"
            ), u = function() {
              return this;
            };
            r.exports = function(d, h, f) {
              var v = h + " Iterator";
              return d.prototype = s(a, { next: o(1, f) }), l(d, v, !1, !0), c[v] = u, d;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/create-property-descriptor.js": (
          /*!**********************************************************************!*\
            !*** ./node_modules/core-js/internals/create-property-descriptor.js ***!
            \**********************************************************************/
          /*! no static exports found */
          /***/
          function(r, i) {
            r.exports = function(n, a) {
              return {
                enumerable: !(n & 1),
                configurable: !(n & 2),
                writable: !(n & 4),
                value: a
              };
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/create-property.js": (
          /*!***********************************************************!*\
            !*** ./node_modules/core-js/internals/create-property.js ***!
            \***********************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/to-primitive */
              "./node_modules/core-js/internals/to-primitive.js"
            ), s = n(
              /*! ../internals/object-define-property */
              "./node_modules/core-js/internals/object-define-property.js"
            ), o = n(
              /*! ../internals/create-property-descriptor */
              "./node_modules/core-js/internals/create-property-descriptor.js"
            );
            r.exports = function(l, c, u) {
              var d = a(c);
              d in l ? s.f(l, d, o(0, u)) : l[d] = u;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/define-iterator.js": (
          /*!***********************************************************!*\
            !*** ./node_modules/core-js/internals/define-iterator.js ***!
            \***********************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/export */
              "./node_modules/core-js/internals/export.js"
            ), s = n(
              /*! ../internals/create-iterator-constructor */
              "./node_modules/core-js/internals/create-iterator-constructor.js"
            ), o = n(
              /*! ../internals/object-get-prototype-of */
              "./node_modules/core-js/internals/object-get-prototype-of.js"
            ), l = n(
              /*! ../internals/object-set-prototype-of */
              "./node_modules/core-js/internals/object-set-prototype-of.js"
            ), c = n(
              /*! ../internals/set-to-string-tag */
              "./node_modules/core-js/internals/set-to-string-tag.js"
            ), u = n(
              /*! ../internals/hide */
              "./node_modules/core-js/internals/hide.js"
            ), d = n(
              /*! ../internals/redefine */
              "./node_modules/core-js/internals/redefine.js"
            ), h = n(
              /*! ../internals/well-known-symbol */
              "./node_modules/core-js/internals/well-known-symbol.js"
            ), f = n(
              /*! ../internals/is-pure */
              "./node_modules/core-js/internals/is-pure.js"
            ), v = n(
              /*! ../internals/iterators */
              "./node_modules/core-js/internals/iterators.js"
            ), p = n(
              /*! ../internals/iterators-core */
              "./node_modules/core-js/internals/iterators-core.js"
            ), b = p.IteratorPrototype, y = p.BUGGY_SAFARI_ITERATORS, x = h("iterator"), w = "keys", P = "values", O = "entries", A = function() {
              return this;
            };
            r.exports = function(I, D, k, W, $, z, X) {
              s(k, D, W);
              var U = function(ue) {
                if (ue === $ && V)
                  return V;
                if (!y && ue in Y)
                  return Y[ue];
                switch (ue) {
                  case w:
                    return function() {
                      return new k(this, ue);
                    };
                  case P:
                    return function() {
                      return new k(this, ue);
                    };
                  case O:
                    return function() {
                      return new k(this, ue);
                    };
                }
                return function() {
                  return new k(this);
                };
              }, ie = D + " Iterator", q = !1, Y = I.prototype, te = Y[x] || Y["@@iterator"] || $ && Y[$], V = !y && te || U($), K = D == "Array" && Y.entries || te, ne, oe, Se;
              if (K && (ne = o(K.call(new I())), b !== Object.prototype && ne.next && (!f && o(ne) !== b && (l ? l(ne, b) : typeof ne[x] != "function" && u(ne, x, A)), c(ne, ie, !0, !0), f && (v[ie] = A))), $ == P && te && te.name !== P && (q = !0, V = function() {
                return te.call(this);
              }), (!f || X) && Y[x] !== V && u(Y, x, V), v[D] = V, $)
                if (oe = {
                  values: U(P),
                  keys: z ? V : U(w),
                  entries: U(O)
                }, X)
                  for (Se in oe)
                    (y || q || !(Se in Y)) && d(Y, Se, oe[Se]);
                else
                  a({ target: D, proto: !0, forced: y || q }, oe);
              return oe;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/descriptors.js": (
          /*!*******************************************************!*\
            !*** ./node_modules/core-js/internals/descriptors.js ***!
            \*******************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/fails */
              "./node_modules/core-js/internals/fails.js"
            );
            r.exports = !a(function() {
              return Object.defineProperty({}, "a", { get: function() {
                return 7;
              } }).a != 7;
            });
          }
        ),
        /***/
        "./node_modules/core-js/internals/document-create-element.js": (
          /*!*******************************************************************!*\
            !*** ./node_modules/core-js/internals/document-create-element.js ***!
            \*******************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            ), s = n(
              /*! ../internals/is-object */
              "./node_modules/core-js/internals/is-object.js"
            ), o = a.document, l = s(o) && s(o.createElement);
            r.exports = function(c) {
              return l ? o.createElement(c) : {};
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/enum-bug-keys.js": (
          /*!*********************************************************!*\
            !*** ./node_modules/core-js/internals/enum-bug-keys.js ***!
            \*********************************************************/
          /*! no static exports found */
          /***/
          function(r, i) {
            r.exports = [
              "constructor",
              "hasOwnProperty",
              "isPrototypeOf",
              "propertyIsEnumerable",
              "toLocaleString",
              "toString",
              "valueOf"
            ];
          }
        ),
        /***/
        "./node_modules/core-js/internals/export.js": (
          /*!**************************************************!*\
            !*** ./node_modules/core-js/internals/export.js ***!
            \**************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            ), s = n(
              /*! ../internals/object-get-own-property-descriptor */
              "./node_modules/core-js/internals/object-get-own-property-descriptor.js"
            ).f, o = n(
              /*! ../internals/hide */
              "./node_modules/core-js/internals/hide.js"
            ), l = n(
              /*! ../internals/redefine */
              "./node_modules/core-js/internals/redefine.js"
            ), c = n(
              /*! ../internals/set-global */
              "./node_modules/core-js/internals/set-global.js"
            ), u = n(
              /*! ../internals/copy-constructor-properties */
              "./node_modules/core-js/internals/copy-constructor-properties.js"
            ), d = n(
              /*! ../internals/is-forced */
              "./node_modules/core-js/internals/is-forced.js"
            );
            r.exports = function(h, f) {
              var v = h.target, p = h.global, b = h.stat, y, x, w, P, O, A;
              if (p ? x = a : b ? x = a[v] || c(v, {}) : x = (a[v] || {}).prototype, x)
                for (w in f) {
                  if (O = f[w], h.noTargetGet ? (A = s(x, w), P = A && A.value) : P = x[w], y = d(p ? w : v + (b ? "." : "#") + w, h.forced), !y && P !== void 0) {
                    if (typeof O == typeof P)
                      continue;
                    u(O, P);
                  }
                  (h.sham || P && P.sham) && o(O, "sham", !0), l(x, w, O, h);
                }
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/fails.js": (
          /*!*************************************************!*\
            !*** ./node_modules/core-js/internals/fails.js ***!
            \*************************************************/
          /*! no static exports found */
          /***/
          function(r, i) {
            r.exports = function(n) {
              try {
                return !!n();
              } catch {
                return !0;
              }
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/function-to-string.js": (
          /*!**************************************************************!*\
            !*** ./node_modules/core-js/internals/function-to-string.js ***!
            \**************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/shared */
              "./node_modules/core-js/internals/shared.js"
            );
            r.exports = a("native-function-to-string", Function.toString);
          }
        ),
        /***/
        "./node_modules/core-js/internals/get-iterator-method.js": (
          /*!***************************************************************!*\
            !*** ./node_modules/core-js/internals/get-iterator-method.js ***!
            \***************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/classof */
              "./node_modules/core-js/internals/classof.js"
            ), s = n(
              /*! ../internals/iterators */
              "./node_modules/core-js/internals/iterators.js"
            ), o = n(
              /*! ../internals/well-known-symbol */
              "./node_modules/core-js/internals/well-known-symbol.js"
            ), l = o("iterator");
            r.exports = function(c) {
              if (c != null)
                return c[l] || c["@@iterator"] || s[a(c)];
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/global.js": (
          /*!**************************************************!*\
            !*** ./node_modules/core-js/internals/global.js ***!
            \**************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            (function(a) {
              var s = "object", o = function(l) {
                return l && l.Math == Math && l;
              };
              r.exports = // eslint-disable-next-line no-undef
              o(typeof globalThis == s && globalThis) || o(typeof window == s && window) || o(typeof self == s && self) || o(typeof a == s && a) || // eslint-disable-next-line no-new-func
              Function("return this")();
            }).call(this, n(
              /*! ./../../webpack/buildin/global.js */
              "./node_modules/webpack/buildin/global.js"
            ));
          }
        ),
        /***/
        "./node_modules/core-js/internals/has.js": (
          /*!***********************************************!*\
            !*** ./node_modules/core-js/internals/has.js ***!
            \***********************************************/
          /*! no static exports found */
          /***/
          function(r, i) {
            var n = {}.hasOwnProperty;
            r.exports = function(a, s) {
              return n.call(a, s);
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/hidden-keys.js": (
          /*!*******************************************************!*\
            !*** ./node_modules/core-js/internals/hidden-keys.js ***!
            \*******************************************************/
          /*! no static exports found */
          /***/
          function(r, i) {
            r.exports = {};
          }
        ),
        /***/
        "./node_modules/core-js/internals/hide.js": (
          /*!************************************************!*\
            !*** ./node_modules/core-js/internals/hide.js ***!
            \************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/descriptors */
              "./node_modules/core-js/internals/descriptors.js"
            ), s = n(
              /*! ../internals/object-define-property */
              "./node_modules/core-js/internals/object-define-property.js"
            ), o = n(
              /*! ../internals/create-property-descriptor */
              "./node_modules/core-js/internals/create-property-descriptor.js"
            );
            r.exports = a ? function(l, c, u) {
              return s.f(l, c, o(1, u));
            } : function(l, c, u) {
              return l[c] = u, l;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/html.js": (
          /*!************************************************!*\
            !*** ./node_modules/core-js/internals/html.js ***!
            \************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            ), s = a.document;
            r.exports = s && s.documentElement;
          }
        ),
        /***/
        "./node_modules/core-js/internals/ie8-dom-define.js": (
          /*!**********************************************************!*\
            !*** ./node_modules/core-js/internals/ie8-dom-define.js ***!
            \**********************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/descriptors */
              "./node_modules/core-js/internals/descriptors.js"
            ), s = n(
              /*! ../internals/fails */
              "./node_modules/core-js/internals/fails.js"
            ), o = n(
              /*! ../internals/document-create-element */
              "./node_modules/core-js/internals/document-create-element.js"
            );
            r.exports = !a && !s(function() {
              return Object.defineProperty(o("div"), "a", {
                get: function() {
                  return 7;
                }
              }).a != 7;
            });
          }
        ),
        /***/
        "./node_modules/core-js/internals/indexed-object.js": (
          /*!**********************************************************!*\
            !*** ./node_modules/core-js/internals/indexed-object.js ***!
            \**********************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/fails */
              "./node_modules/core-js/internals/fails.js"
            ), s = n(
              /*! ../internals/classof-raw */
              "./node_modules/core-js/internals/classof-raw.js"
            ), o = "".split;
            r.exports = a(function() {
              return !Object("z").propertyIsEnumerable(0);
            }) ? function(l) {
              return s(l) == "String" ? o.call(l, "") : Object(l);
            } : Object;
          }
        ),
        /***/
        "./node_modules/core-js/internals/internal-state.js": (
          /*!**********************************************************!*\
            !*** ./node_modules/core-js/internals/internal-state.js ***!
            \**********************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/native-weak-map */
              "./node_modules/core-js/internals/native-weak-map.js"
            ), s = n(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            ), o = n(
              /*! ../internals/is-object */
              "./node_modules/core-js/internals/is-object.js"
            ), l = n(
              /*! ../internals/hide */
              "./node_modules/core-js/internals/hide.js"
            ), c = n(
              /*! ../internals/has */
              "./node_modules/core-js/internals/has.js"
            ), u = n(
              /*! ../internals/shared-key */
              "./node_modules/core-js/internals/shared-key.js"
            ), d = n(
              /*! ../internals/hidden-keys */
              "./node_modules/core-js/internals/hidden-keys.js"
            ), h = s.WeakMap, f, v, p, b = function(I) {
              return p(I) ? v(I) : f(I, {});
            }, y = function(I) {
              return function(D) {
                var k;
                if (!o(D) || (k = v(D)).type !== I)
                  throw TypeError("Incompatible receiver, " + I + " required");
                return k;
              };
            };
            if (a) {
              var x = new h(), w = x.get, P = x.has, O = x.set;
              f = function(I, D) {
                return O.call(x, I, D), D;
              }, v = function(I) {
                return w.call(x, I) || {};
              }, p = function(I) {
                return P.call(x, I);
              };
            } else {
              var A = u("state");
              d[A] = !0, f = function(I, D) {
                return l(I, A, D), D;
              }, v = function(I) {
                return c(I, A) ? I[A] : {};
              }, p = function(I) {
                return c(I, A);
              };
            }
            r.exports = {
              set: f,
              get: v,
              has: p,
              enforce: b,
              getterFor: y
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/is-array-iterator-method.js": (
          /*!********************************************************************!*\
            !*** ./node_modules/core-js/internals/is-array-iterator-method.js ***!
            \********************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/well-known-symbol */
              "./node_modules/core-js/internals/well-known-symbol.js"
            ), s = n(
              /*! ../internals/iterators */
              "./node_modules/core-js/internals/iterators.js"
            ), o = a("iterator"), l = Array.prototype;
            r.exports = function(c) {
              return c !== void 0 && (s.Array === c || l[o] === c);
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/is-forced.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/internals/is-forced.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/fails */
              "./node_modules/core-js/internals/fails.js"
            ), s = /#|\.prototype\./, o = function(h, f) {
              var v = c[l(h)];
              return v == d ? !0 : v == u ? !1 : typeof f == "function" ? a(f) : !!f;
            }, l = o.normalize = function(h) {
              return String(h).replace(s, ".").toLowerCase();
            }, c = o.data = {}, u = o.NATIVE = "N", d = o.POLYFILL = "P";
            r.exports = o;
          }
        ),
        /***/
        "./node_modules/core-js/internals/is-object.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/internals/is-object.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(r, i) {
            r.exports = function(n) {
              return typeof n == "object" ? n !== null : typeof n == "function";
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/is-pure.js": (
          /*!***************************************************!*\
            !*** ./node_modules/core-js/internals/is-pure.js ***!
            \***************************************************/
          /*! no static exports found */
          /***/
          function(r, i) {
            r.exports = !1;
          }
        ),
        /***/
        "./node_modules/core-js/internals/iterators-core.js": (
          /*!**********************************************************!*\
            !*** ./node_modules/core-js/internals/iterators-core.js ***!
            \**********************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/object-get-prototype-of */
              "./node_modules/core-js/internals/object-get-prototype-of.js"
            ), s = n(
              /*! ../internals/hide */
              "./node_modules/core-js/internals/hide.js"
            ), o = n(
              /*! ../internals/has */
              "./node_modules/core-js/internals/has.js"
            ), l = n(
              /*! ../internals/well-known-symbol */
              "./node_modules/core-js/internals/well-known-symbol.js"
            ), c = n(
              /*! ../internals/is-pure */
              "./node_modules/core-js/internals/is-pure.js"
            ), u = l("iterator"), d = !1, h = function() {
              return this;
            }, f, v, p;
            [].keys && (p = [].keys(), "next" in p ? (v = a(a(p)), v !== Object.prototype && (f = v)) : d = !0), f == null && (f = {}), !c && !o(f, u) && s(f, u, h), r.exports = {
              IteratorPrototype: f,
              BUGGY_SAFARI_ITERATORS: d
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/iterators.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/internals/iterators.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(r, i) {
            r.exports = {};
          }
        ),
        /***/
        "./node_modules/core-js/internals/native-symbol.js": (
          /*!*********************************************************!*\
            !*** ./node_modules/core-js/internals/native-symbol.js ***!
            \*********************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/fails */
              "./node_modules/core-js/internals/fails.js"
            );
            r.exports = !!Object.getOwnPropertySymbols && !a(function() {
              return !String(Symbol());
            });
          }
        ),
        /***/
        "./node_modules/core-js/internals/native-weak-map.js": (
          /*!***********************************************************!*\
            !*** ./node_modules/core-js/internals/native-weak-map.js ***!
            \***********************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            ), s = n(
              /*! ../internals/function-to-string */
              "./node_modules/core-js/internals/function-to-string.js"
            ), o = a.WeakMap;
            r.exports = typeof o == "function" && /native code/.test(s.call(o));
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-create.js": (
          /*!*********************************************************!*\
            !*** ./node_modules/core-js/internals/object-create.js ***!
            \*********************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/an-object */
              "./node_modules/core-js/internals/an-object.js"
            ), s = n(
              /*! ../internals/object-define-properties */
              "./node_modules/core-js/internals/object-define-properties.js"
            ), o = n(
              /*! ../internals/enum-bug-keys */
              "./node_modules/core-js/internals/enum-bug-keys.js"
            ), l = n(
              /*! ../internals/hidden-keys */
              "./node_modules/core-js/internals/hidden-keys.js"
            ), c = n(
              /*! ../internals/html */
              "./node_modules/core-js/internals/html.js"
            ), u = n(
              /*! ../internals/document-create-element */
              "./node_modules/core-js/internals/document-create-element.js"
            ), d = n(
              /*! ../internals/shared-key */
              "./node_modules/core-js/internals/shared-key.js"
            ), h = d("IE_PROTO"), f = "prototype", v = function() {
            }, p = function() {
              var b = u("iframe"), y = o.length, x = "<", w = "script", P = ">", O = "java" + w + ":", A;
              for (b.style.display = "none", c.appendChild(b), b.src = String(O), A = b.contentWindow.document, A.open(), A.write(x + w + P + "document.F=Object" + x + "/" + w + P), A.close(), p = A.F; y--; )
                delete p[f][o[y]];
              return p();
            };
            r.exports = Object.create || function(y, x) {
              var w;
              return y !== null ? (v[f] = a(y), w = new v(), v[f] = null, w[h] = y) : w = p(), x === void 0 ? w : s(w, x);
            }, l[h] = !0;
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-define-properties.js": (
          /*!********************************************************************!*\
            !*** ./node_modules/core-js/internals/object-define-properties.js ***!
            \********************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/descriptors */
              "./node_modules/core-js/internals/descriptors.js"
            ), s = n(
              /*! ../internals/object-define-property */
              "./node_modules/core-js/internals/object-define-property.js"
            ), o = n(
              /*! ../internals/an-object */
              "./node_modules/core-js/internals/an-object.js"
            ), l = n(
              /*! ../internals/object-keys */
              "./node_modules/core-js/internals/object-keys.js"
            );
            r.exports = a ? Object.defineProperties : function(u, d) {
              o(u);
              for (var h = l(d), f = h.length, v = 0, p; f > v; )
                s.f(u, p = h[v++], d[p]);
              return u;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-define-property.js": (
          /*!******************************************************************!*\
            !*** ./node_modules/core-js/internals/object-define-property.js ***!
            \******************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/descriptors */
              "./node_modules/core-js/internals/descriptors.js"
            ), s = n(
              /*! ../internals/ie8-dom-define */
              "./node_modules/core-js/internals/ie8-dom-define.js"
            ), o = n(
              /*! ../internals/an-object */
              "./node_modules/core-js/internals/an-object.js"
            ), l = n(
              /*! ../internals/to-primitive */
              "./node_modules/core-js/internals/to-primitive.js"
            ), c = Object.defineProperty;
            i.f = a ? c : function(d, h, f) {
              if (o(d), h = l(h, !0), o(f), s)
                try {
                  return c(d, h, f);
                } catch {
                }
              if ("get" in f || "set" in f)
                throw TypeError("Accessors not supported");
              return "value" in f && (d[h] = f.value), d;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-get-own-property-descriptor.js": (
          /*!******************************************************************************!*\
            !*** ./node_modules/core-js/internals/object-get-own-property-descriptor.js ***!
            \******************************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/descriptors */
              "./node_modules/core-js/internals/descriptors.js"
            ), s = n(
              /*! ../internals/object-property-is-enumerable */
              "./node_modules/core-js/internals/object-property-is-enumerable.js"
            ), o = n(
              /*! ../internals/create-property-descriptor */
              "./node_modules/core-js/internals/create-property-descriptor.js"
            ), l = n(
              /*! ../internals/to-indexed-object */
              "./node_modules/core-js/internals/to-indexed-object.js"
            ), c = n(
              /*! ../internals/to-primitive */
              "./node_modules/core-js/internals/to-primitive.js"
            ), u = n(
              /*! ../internals/has */
              "./node_modules/core-js/internals/has.js"
            ), d = n(
              /*! ../internals/ie8-dom-define */
              "./node_modules/core-js/internals/ie8-dom-define.js"
            ), h = Object.getOwnPropertyDescriptor;
            i.f = a ? h : function(v, p) {
              if (v = l(v), p = c(p, !0), d)
                try {
                  return h(v, p);
                } catch {
                }
              if (u(v, p))
                return o(!s.f.call(v, p), v[p]);
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-get-own-property-names.js": (
          /*!*************************************************************************!*\
            !*** ./node_modules/core-js/internals/object-get-own-property-names.js ***!
            \*************************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/object-keys-internal */
              "./node_modules/core-js/internals/object-keys-internal.js"
            ), s = n(
              /*! ../internals/enum-bug-keys */
              "./node_modules/core-js/internals/enum-bug-keys.js"
            ), o = s.concat("length", "prototype");
            i.f = Object.getOwnPropertyNames || function(c) {
              return a(c, o);
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-get-own-property-symbols.js": (
          /*!***************************************************************************!*\
            !*** ./node_modules/core-js/internals/object-get-own-property-symbols.js ***!
            \***************************************************************************/
          /*! no static exports found */
          /***/
          function(r, i) {
            i.f = Object.getOwnPropertySymbols;
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-get-prototype-of.js": (
          /*!*******************************************************************!*\
            !*** ./node_modules/core-js/internals/object-get-prototype-of.js ***!
            \*******************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/has */
              "./node_modules/core-js/internals/has.js"
            ), s = n(
              /*! ../internals/to-object */
              "./node_modules/core-js/internals/to-object.js"
            ), o = n(
              /*! ../internals/shared-key */
              "./node_modules/core-js/internals/shared-key.js"
            ), l = n(
              /*! ../internals/correct-prototype-getter */
              "./node_modules/core-js/internals/correct-prototype-getter.js"
            ), c = o("IE_PROTO"), u = Object.prototype;
            r.exports = l ? Object.getPrototypeOf : function(d) {
              return d = s(d), a(d, c) ? d[c] : typeof d.constructor == "function" && d instanceof d.constructor ? d.constructor.prototype : d instanceof Object ? u : null;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-keys-internal.js": (
          /*!****************************************************************!*\
            !*** ./node_modules/core-js/internals/object-keys-internal.js ***!
            \****************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/has */
              "./node_modules/core-js/internals/has.js"
            ), s = n(
              /*! ../internals/to-indexed-object */
              "./node_modules/core-js/internals/to-indexed-object.js"
            ), o = n(
              /*! ../internals/array-includes */
              "./node_modules/core-js/internals/array-includes.js"
            ), l = n(
              /*! ../internals/hidden-keys */
              "./node_modules/core-js/internals/hidden-keys.js"
            ), c = o(!1);
            r.exports = function(u, d) {
              var h = s(u), f = 0, v = [], p;
              for (p in h)
                !a(l, p) && a(h, p) && v.push(p);
              for (; d.length > f; )
                a(h, p = d[f++]) && (~c(v, p) || v.push(p));
              return v;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-keys.js": (
          /*!*******************************************************!*\
            !*** ./node_modules/core-js/internals/object-keys.js ***!
            \*******************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/object-keys-internal */
              "./node_modules/core-js/internals/object-keys-internal.js"
            ), s = n(
              /*! ../internals/enum-bug-keys */
              "./node_modules/core-js/internals/enum-bug-keys.js"
            );
            r.exports = Object.keys || function(l) {
              return a(l, s);
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-property-is-enumerable.js": (
          /*!*************************************************************************!*\
            !*** ./node_modules/core-js/internals/object-property-is-enumerable.js ***!
            \*************************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = {}.propertyIsEnumerable, s = Object.getOwnPropertyDescriptor, o = s && !a.call({ 1: 2 }, 1);
            i.f = o ? function(c) {
              var u = s(this, c);
              return !!u && u.enumerable;
            } : a;
          }
        ),
        /***/
        "./node_modules/core-js/internals/object-set-prototype-of.js": (
          /*!*******************************************************************!*\
            !*** ./node_modules/core-js/internals/object-set-prototype-of.js ***!
            \*******************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/validate-set-prototype-of-arguments */
              "./node_modules/core-js/internals/validate-set-prototype-of-arguments.js"
            );
            r.exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
              var s = !1, o = {}, l;
              try {
                l = Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set, l.call(o, []), s = o instanceof Array;
              } catch {
              }
              return function(u, d) {
                return a(u, d), s ? l.call(u, d) : u.__proto__ = d, u;
              };
            }() : void 0);
          }
        ),
        /***/
        "./node_modules/core-js/internals/own-keys.js": (
          /*!****************************************************!*\
            !*** ./node_modules/core-js/internals/own-keys.js ***!
            \****************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            ), s = n(
              /*! ../internals/object-get-own-property-names */
              "./node_modules/core-js/internals/object-get-own-property-names.js"
            ), o = n(
              /*! ../internals/object-get-own-property-symbols */
              "./node_modules/core-js/internals/object-get-own-property-symbols.js"
            ), l = n(
              /*! ../internals/an-object */
              "./node_modules/core-js/internals/an-object.js"
            ), c = a.Reflect;
            r.exports = c && c.ownKeys || function(d) {
              var h = s.f(l(d)), f = o.f;
              return f ? h.concat(f(d)) : h;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/path.js": (
          /*!************************************************!*\
            !*** ./node_modules/core-js/internals/path.js ***!
            \************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            r.exports = n(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            );
          }
        ),
        /***/
        "./node_modules/core-js/internals/redefine.js": (
          /*!****************************************************!*\
            !*** ./node_modules/core-js/internals/redefine.js ***!
            \****************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            ), s = n(
              /*! ../internals/shared */
              "./node_modules/core-js/internals/shared.js"
            ), o = n(
              /*! ../internals/hide */
              "./node_modules/core-js/internals/hide.js"
            ), l = n(
              /*! ../internals/has */
              "./node_modules/core-js/internals/has.js"
            ), c = n(
              /*! ../internals/set-global */
              "./node_modules/core-js/internals/set-global.js"
            ), u = n(
              /*! ../internals/function-to-string */
              "./node_modules/core-js/internals/function-to-string.js"
            ), d = n(
              /*! ../internals/internal-state */
              "./node_modules/core-js/internals/internal-state.js"
            ), h = d.get, f = d.enforce, v = String(u).split("toString");
            s("inspectSource", function(p) {
              return u.call(p);
            }), (r.exports = function(p, b, y, x) {
              var w = x ? !!x.unsafe : !1, P = x ? !!x.enumerable : !1, O = x ? !!x.noTargetGet : !1;
              if (typeof y == "function" && (typeof b == "string" && !l(y, "name") && o(y, "name", b), f(y).source = v.join(typeof b == "string" ? b : "")), p === a) {
                P ? p[b] = y : c(b, y);
                return;
              } else
                w ? !O && p[b] && (P = !0) : delete p[b];
              P ? p[b] = y : o(p, b, y);
            })(Function.prototype, "toString", function() {
              return typeof this == "function" && h(this).source || u.call(this);
            });
          }
        ),
        /***/
        "./node_modules/core-js/internals/require-object-coercible.js": (
          /*!********************************************************************!*\
            !*** ./node_modules/core-js/internals/require-object-coercible.js ***!
            \********************************************************************/
          /*! no static exports found */
          /***/
          function(r, i) {
            r.exports = function(n) {
              if (n == null)
                throw TypeError("Can't call method on " + n);
              return n;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/set-global.js": (
          /*!******************************************************!*\
            !*** ./node_modules/core-js/internals/set-global.js ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            ), s = n(
              /*! ../internals/hide */
              "./node_modules/core-js/internals/hide.js"
            );
            r.exports = function(o, l) {
              try {
                s(a, o, l);
              } catch {
                a[o] = l;
              }
              return l;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/set-to-string-tag.js": (
          /*!*************************************************************!*\
            !*** ./node_modules/core-js/internals/set-to-string-tag.js ***!
            \*************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/object-define-property */
              "./node_modules/core-js/internals/object-define-property.js"
            ).f, s = n(
              /*! ../internals/has */
              "./node_modules/core-js/internals/has.js"
            ), o = n(
              /*! ../internals/well-known-symbol */
              "./node_modules/core-js/internals/well-known-symbol.js"
            ), l = o("toStringTag");
            r.exports = function(c, u, d) {
              c && !s(c = d ? c : c.prototype, l) && a(c, l, { configurable: !0, value: u });
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/shared-key.js": (
          /*!******************************************************!*\
            !*** ./node_modules/core-js/internals/shared-key.js ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/shared */
              "./node_modules/core-js/internals/shared.js"
            ), s = n(
              /*! ../internals/uid */
              "./node_modules/core-js/internals/uid.js"
            ), o = a("keys");
            r.exports = function(l) {
              return o[l] || (o[l] = s(l));
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/shared.js": (
          /*!**************************************************!*\
            !*** ./node_modules/core-js/internals/shared.js ***!
            \**************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            ), s = n(
              /*! ../internals/set-global */
              "./node_modules/core-js/internals/set-global.js"
            ), o = n(
              /*! ../internals/is-pure */
              "./node_modules/core-js/internals/is-pure.js"
            ), l = "__core-js_shared__", c = a[l] || s(l, {});
            (r.exports = function(u, d) {
              return c[u] || (c[u] = d !== void 0 ? d : {});
            })("versions", []).push({
              version: "3.1.3",
              mode: o ? "pure" : "global",
              copyright: "© 2019 Denis Pushkarev (zloirock.ru)"
            });
          }
        ),
        /***/
        "./node_modules/core-js/internals/string-at.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/internals/string-at.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/to-integer */
              "./node_modules/core-js/internals/to-integer.js"
            ), s = n(
              /*! ../internals/require-object-coercible */
              "./node_modules/core-js/internals/require-object-coercible.js"
            );
            r.exports = function(o, l, c) {
              var u = String(s(o)), d = a(l), h = u.length, f, v;
              return d < 0 || d >= h ? c ? "" : void 0 : (f = u.charCodeAt(d), f < 55296 || f > 56319 || d + 1 === h || (v = u.charCodeAt(d + 1)) < 56320 || v > 57343 ? c ? u.charAt(d) : f : c ? u.slice(d, d + 2) : (f - 55296 << 10) + (v - 56320) + 65536);
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/to-absolute-index.js": (
          /*!*************************************************************!*\
            !*** ./node_modules/core-js/internals/to-absolute-index.js ***!
            \*************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/to-integer */
              "./node_modules/core-js/internals/to-integer.js"
            ), s = Math.max, o = Math.min;
            r.exports = function(l, c) {
              var u = a(l);
              return u < 0 ? s(u + c, 0) : o(u, c);
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/to-indexed-object.js": (
          /*!*************************************************************!*\
            !*** ./node_modules/core-js/internals/to-indexed-object.js ***!
            \*************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/indexed-object */
              "./node_modules/core-js/internals/indexed-object.js"
            ), s = n(
              /*! ../internals/require-object-coercible */
              "./node_modules/core-js/internals/require-object-coercible.js"
            );
            r.exports = function(o) {
              return a(s(o));
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/to-integer.js": (
          /*!******************************************************!*\
            !*** ./node_modules/core-js/internals/to-integer.js ***!
            \******************************************************/
          /*! no static exports found */
          /***/
          function(r, i) {
            var n = Math.ceil, a = Math.floor;
            r.exports = function(s) {
              return isNaN(s = +s) ? 0 : (s > 0 ? a : n)(s);
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/to-length.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/internals/to-length.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/to-integer */
              "./node_modules/core-js/internals/to-integer.js"
            ), s = Math.min;
            r.exports = function(o) {
              return o > 0 ? s(a(o), 9007199254740991) : 0;
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/to-object.js": (
          /*!*****************************************************!*\
            !*** ./node_modules/core-js/internals/to-object.js ***!
            \*****************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/require-object-coercible */
              "./node_modules/core-js/internals/require-object-coercible.js"
            );
            r.exports = function(s) {
              return Object(a(s));
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/to-primitive.js": (
          /*!********************************************************!*\
            !*** ./node_modules/core-js/internals/to-primitive.js ***!
            \********************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/is-object */
              "./node_modules/core-js/internals/is-object.js"
            );
            r.exports = function(s, o) {
              if (!a(s))
                return s;
              var l, c;
              if (o && typeof (l = s.toString) == "function" && !a(c = l.call(s)) || typeof (l = s.valueOf) == "function" && !a(c = l.call(s)) || !o && typeof (l = s.toString) == "function" && !a(c = l.call(s)))
                return c;
              throw TypeError("Can't convert object to primitive value");
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/uid.js": (
          /*!***********************************************!*\
            !*** ./node_modules/core-js/internals/uid.js ***!
            \***********************************************/
          /*! no static exports found */
          /***/
          function(r, i) {
            var n = 0, a = Math.random();
            r.exports = function(s) {
              return "Symbol(".concat(s === void 0 ? "" : s, ")_", (++n + a).toString(36));
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/validate-set-prototype-of-arguments.js": (
          /*!*******************************************************************************!*\
            !*** ./node_modules/core-js/internals/validate-set-prototype-of-arguments.js ***!
            \*******************************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/is-object */
              "./node_modules/core-js/internals/is-object.js"
            ), s = n(
              /*! ../internals/an-object */
              "./node_modules/core-js/internals/an-object.js"
            );
            r.exports = function(o, l) {
              if (s(o), !a(l) && l !== null)
                throw TypeError("Can't set " + String(l) + " as a prototype");
            };
          }
        ),
        /***/
        "./node_modules/core-js/internals/well-known-symbol.js": (
          /*!*************************************************************!*\
            !*** ./node_modules/core-js/internals/well-known-symbol.js ***!
            \*************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/global */
              "./node_modules/core-js/internals/global.js"
            ), s = n(
              /*! ../internals/shared */
              "./node_modules/core-js/internals/shared.js"
            ), o = n(
              /*! ../internals/uid */
              "./node_modules/core-js/internals/uid.js"
            ), l = n(
              /*! ../internals/native-symbol */
              "./node_modules/core-js/internals/native-symbol.js"
            ), c = a.Symbol, u = s("wks");
            r.exports = function(d) {
              return u[d] || (u[d] = l && c[d] || (l ? c : o)("Symbol." + d));
            };
          }
        ),
        /***/
        "./node_modules/core-js/modules/es.array.from.js": (
          /*!*******************************************************!*\
            !*** ./node_modules/core-js/modules/es.array.from.js ***!
            \*******************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/export */
              "./node_modules/core-js/internals/export.js"
            ), s = n(
              /*! ../internals/array-from */
              "./node_modules/core-js/internals/array-from.js"
            ), o = n(
              /*! ../internals/check-correctness-of-iteration */
              "./node_modules/core-js/internals/check-correctness-of-iteration.js"
            ), l = !o(function(c) {
              Array.from(c);
            });
            a({ target: "Array", stat: !0, forced: l }, {
              from: s
            });
          }
        ),
        /***/
        "./node_modules/core-js/modules/es.string.iterator.js": (
          /*!************************************************************!*\
            !*** ./node_modules/core-js/modules/es.string.iterator.js ***!
            \************************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ../internals/string-at */
              "./node_modules/core-js/internals/string-at.js"
            ), s = n(
              /*! ../internals/internal-state */
              "./node_modules/core-js/internals/internal-state.js"
            ), o = n(
              /*! ../internals/define-iterator */
              "./node_modules/core-js/internals/define-iterator.js"
            ), l = "String Iterator", c = s.set, u = s.getterFor(l);
            o(String, "String", function(d) {
              c(this, {
                type: l,
                string: String(d),
                index: 0
              });
            }, function() {
              var h = u(this), f = h.string, v = h.index, p;
              return v >= f.length ? { value: void 0, done: !0 } : (p = a(f, v, !0), h.index += p.length, { value: p, done: !1 });
            });
          }
        ),
        /***/
        "./node_modules/webpack/buildin/global.js": (
          /*!***********************************!*\
            !*** (webpack)/buildin/global.js ***!
            \***********************************/
          /*! no static exports found */
          /***/
          function(r, i) {
            var n;
            n = function() {
              return this;
            }();
            try {
              n = n || Function("return this")() || (0, eval)("this");
            } catch {
              typeof window == "object" && (n = window);
            }
            r.exports = n;
          }
        ),
        /***/
        "./src/default-attrs.json": (
          /*!********************************!*\
            !*** ./src/default-attrs.json ***!
            \********************************/
          /*! exports provided: xmlns, width, height, viewBox, fill, stroke, stroke-width, stroke-linecap, stroke-linejoin, default */
          /***/
          function(r) {
            r.exports = { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", "stroke-width": 2, "stroke-linecap": "round", "stroke-linejoin": "round" };
          }
        ),
        /***/
        "./src/icon.js": (
          /*!*********************!*\
            !*** ./src/icon.js ***!
            \*********************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            Object.defineProperty(i, "__esModule", {
              value: !0
            });
            var a = Object.assign || function(p) {
              for (var b = 1; b < arguments.length; b++) {
                var y = arguments[b];
                for (var x in y)
                  Object.prototype.hasOwnProperty.call(y, x) && (p[x] = y[x]);
              }
              return p;
            }, s = function() {
              function p(b, y) {
                for (var x = 0; x < y.length; x++) {
                  var w = y[x];
                  w.enumerable = w.enumerable || !1, w.configurable = !0, "value" in w && (w.writable = !0), Object.defineProperty(b, w.key, w);
                }
              }
              return function(b, y, x) {
                return y && p(b.prototype, y), x && p(b, x), b;
              };
            }(), o = n(
              /*! classnames/dedupe */
              "./node_modules/classnames/dedupe.js"
            ), l = d(o), c = n(
              /*! ./default-attrs.json */
              "./src/default-attrs.json"
            ), u = d(c);
            function d(p) {
              return p && p.__esModule ? p : { default: p };
            }
            function h(p, b) {
              if (!(p instanceof b))
                throw new TypeError("Cannot call a class as a function");
            }
            var f = function() {
              function p(b, y) {
                var x = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                h(this, p), this.name = b, this.contents = y, this.tags = x, this.attrs = a({}, u.default, { class: "feather feather-" + b });
              }
              return s(p, [{
                key: "toSvg",
                value: function() {
                  var y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, x = a({}, this.attrs, y, { class: (0, l.default)(this.attrs.class, y.class) });
                  return "<svg " + v(x) + ">" + this.contents + "</svg>";
                }
                /**
                 * Return string representation of an `Icon`.
                 *
                 * Added for backward compatibility. If old code expects `feather.icons.<name>`
                 * to be a string, `toString()` will get implicitly called.
                 *
                 * @returns {string}
                 */
              }, {
                key: "toString",
                value: function() {
                  return this.contents;
                }
              }]), p;
            }();
            function v(p) {
              return Object.keys(p).map(function(b) {
                return b + '="' + p[b] + '"';
              }).join(" ");
            }
            i.default = f;
          }
        ),
        /***/
        "./src/icons.js": (
          /*!**********************!*\
            !*** ./src/icons.js ***!
            \**********************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            Object.defineProperty(i, "__esModule", {
              value: !0
            });
            var a = n(
              /*! ./icon */
              "./src/icon.js"
            ), s = d(a), o = n(
              /*! ../dist/icons.json */
              "./dist/icons.json"
            ), l = d(o), c = n(
              /*! ./tags.json */
              "./src/tags.json"
            ), u = d(c);
            function d(h) {
              return h && h.__esModule ? h : { default: h };
            }
            i.default = Object.keys(l.default).map(function(h) {
              return new s.default(h, l.default[h], u.default[h]);
            }).reduce(function(h, f) {
              return h[f.name] = f, h;
            }, {});
          }
        ),
        /***/
        "./src/index.js": (
          /*!**********************!*\
            !*** ./src/index.js ***!
            \**********************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            var a = n(
              /*! ./icons */
              "./src/icons.js"
            ), s = d(a), o = n(
              /*! ./to-svg */
              "./src/to-svg.js"
            ), l = d(o), c = n(
              /*! ./replace */
              "./src/replace.js"
            ), u = d(c);
            function d(h) {
              return h && h.__esModule ? h : { default: h };
            }
            r.exports = { icons: s.default, toSvg: l.default, replace: u.default };
          }
        ),
        /***/
        "./src/replace.js": (
          /*!************************!*\
            !*** ./src/replace.js ***!
            \************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            Object.defineProperty(i, "__esModule", {
              value: !0
            });
            var a = Object.assign || function(v) {
              for (var p = 1; p < arguments.length; p++) {
                var b = arguments[p];
                for (var y in b)
                  Object.prototype.hasOwnProperty.call(b, y) && (v[y] = b[y]);
              }
              return v;
            }, s = n(
              /*! classnames/dedupe */
              "./node_modules/classnames/dedupe.js"
            ), o = u(s), l = n(
              /*! ./icons */
              "./src/icons.js"
            ), c = u(l);
            function u(v) {
              return v && v.__esModule ? v : { default: v };
            }
            function d() {
              var v = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
              if (typeof document > "u")
                throw new Error("`feather.replace()` only works in a browser environment.");
              var p = document.querySelectorAll("[data-feather]");
              Array.from(p).forEach(function(b) {
                return h(b, v);
              });
            }
            function h(v) {
              var p = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, b = f(v), y = b["data-feather"];
              delete b["data-feather"];
              var x = c.default[y].toSvg(a({}, p, b, { class: (0, o.default)(p.class, b.class) })), w = new DOMParser().parseFromString(x, "image/svg+xml"), P = w.querySelector("svg");
              v.parentNode.replaceChild(P, v);
            }
            function f(v) {
              return Array.from(v.attributes).reduce(function(p, b) {
                return p[b.name] = b.value, p;
              }, {});
            }
            i.default = d;
          }
        ),
        /***/
        "./src/tags.json": (
          /*!***********************!*\
            !*** ./src/tags.json ***!
            \***********************/
          /*! exports provided: activity, airplay, alert-circle, alert-octagon, alert-triangle, align-center, align-justify, align-left, align-right, anchor, archive, at-sign, award, aperture, bar-chart, bar-chart-2, battery, battery-charging, bell, bell-off, bluetooth, book-open, book, bookmark, box, briefcase, calendar, camera, cast, chevron-down, chevron-up, circle, clipboard, clock, cloud-drizzle, cloud-lightning, cloud-rain, cloud-snow, cloud, codepen, codesandbox, code, coffee, columns, command, compass, copy, corner-down-left, corner-down-right, corner-left-down, corner-left-up, corner-right-down, corner-right-up, corner-up-left, corner-up-right, cpu, credit-card, crop, crosshair, database, delete, disc, dollar-sign, droplet, edit, edit-2, edit-3, eye, eye-off, external-link, facebook, fast-forward, figma, file-minus, file-plus, file-text, film, filter, flag, folder-minus, folder-plus, folder, framer, frown, gift, git-branch, git-commit, git-merge, git-pull-request, github, gitlab, globe, hard-drive, hash, headphones, heart, help-circle, hexagon, home, image, inbox, instagram, key, layers, layout, life-bouy, link, link-2, linkedin, list, lock, log-in, log-out, mail, map-pin, map, maximize, maximize-2, meh, menu, message-circle, message-square, mic-off, mic, minimize, minimize-2, minus, monitor, moon, more-horizontal, more-vertical, mouse-pointer, move, music, navigation, navigation-2, octagon, package, paperclip, pause, pause-circle, pen-tool, percent, phone-call, phone-forwarded, phone-incoming, phone-missed, phone-off, phone-outgoing, phone, play, pie-chart, play-circle, plus, plus-circle, plus-square, pocket, power, printer, radio, refresh-cw, refresh-ccw, repeat, rewind, rotate-ccw, rotate-cw, rss, save, scissors, search, send, settings, share-2, shield, shield-off, shopping-bag, shopping-cart, shuffle, skip-back, skip-forward, slack, slash, sliders, smartphone, smile, speaker, star, stop-circle, sun, sunrise, sunset, tablet, tag, target, terminal, thermometer, thumbs-down, thumbs-up, toggle-left, toggle-right, tool, trash, trash-2, triangle, truck, tv, twitch, twitter, type, umbrella, unlock, user-check, user-minus, user-plus, user-x, user, users, video-off, video, voicemail, volume, volume-1, volume-2, volume-x, watch, wifi-off, wifi, wind, x-circle, x-octagon, x-square, x, youtube, zap-off, zap, zoom-in, zoom-out, default */
          /***/
          function(r) {
            r.exports = { activity: ["pulse", "health", "action", "motion"], airplay: ["stream", "cast", "mirroring"], "alert-circle": ["warning", "alert", "danger"], "alert-octagon": ["warning", "alert", "danger"], "alert-triangle": ["warning", "alert", "danger"], "align-center": ["text alignment", "center"], "align-justify": ["text alignment", "justified"], "align-left": ["text alignment", "left"], "align-right": ["text alignment", "right"], anchor: [], archive: ["index", "box"], "at-sign": ["mention", "at", "email", "message"], award: ["achievement", "badge"], aperture: ["camera", "photo"], "bar-chart": ["statistics", "diagram", "graph"], "bar-chart-2": ["statistics", "diagram", "graph"], battery: ["power", "electricity"], "battery-charging": ["power", "electricity"], bell: ["alarm", "notification", "sound"], "bell-off": ["alarm", "notification", "silent"], bluetooth: ["wireless"], "book-open": ["read", "library"], book: ["read", "dictionary", "booklet", "magazine", "library"], bookmark: ["read", "clip", "marker", "tag"], box: ["cube"], briefcase: ["work", "bag", "baggage", "folder"], calendar: ["date"], camera: ["photo"], cast: ["chromecast", "airplay"], "chevron-down": ["expand"], "chevron-up": ["collapse"], circle: ["off", "zero", "record"], clipboard: ["copy"], clock: ["time", "watch", "alarm"], "cloud-drizzle": ["weather", "shower"], "cloud-lightning": ["weather", "bolt"], "cloud-rain": ["weather"], "cloud-snow": ["weather", "blizzard"], cloud: ["weather"], codepen: ["logo"], codesandbox: ["logo"], code: ["source", "programming"], coffee: ["drink", "cup", "mug", "tea", "cafe", "hot", "beverage"], columns: ["layout"], command: ["keyboard", "cmd", "terminal", "prompt"], compass: ["navigation", "safari", "travel", "direction"], copy: ["clone", "duplicate"], "corner-down-left": ["arrow", "return"], "corner-down-right": ["arrow"], "corner-left-down": ["arrow"], "corner-left-up": ["arrow"], "corner-right-down": ["arrow"], "corner-right-up": ["arrow"], "corner-up-left": ["arrow"], "corner-up-right": ["arrow"], cpu: ["processor", "technology"], "credit-card": ["purchase", "payment", "cc"], crop: ["photo", "image"], crosshair: ["aim", "target"], database: ["storage", "memory"], delete: ["remove"], disc: ["album", "cd", "dvd", "music"], "dollar-sign": ["currency", "money", "payment"], droplet: ["water"], edit: ["pencil", "change"], "edit-2": ["pencil", "change"], "edit-3": ["pencil", "change"], eye: ["view", "watch"], "eye-off": ["view", "watch", "hide", "hidden"], "external-link": ["outbound"], facebook: ["logo", "social"], "fast-forward": ["music"], figma: ["logo", "design", "tool"], "file-minus": ["delete", "remove", "erase"], "file-plus": ["add", "create", "new"], "file-text": ["data", "txt", "pdf"], film: ["movie", "video"], filter: ["funnel", "hopper"], flag: ["report"], "folder-minus": ["directory"], "folder-plus": ["directory"], folder: ["directory"], framer: ["logo", "design", "tool"], frown: ["emoji", "face", "bad", "sad", "emotion"], gift: ["present", "box", "birthday", "party"], "git-branch": ["code", "version control"], "git-commit": ["code", "version control"], "git-merge": ["code", "version control"], "git-pull-request": ["code", "version control"], github: ["logo", "version control"], gitlab: ["logo", "version control"], globe: ["world", "browser", "language", "translate"], "hard-drive": ["computer", "server", "memory", "data"], hash: ["hashtag", "number", "pound"], headphones: ["music", "audio", "sound"], heart: ["like", "love", "emotion"], "help-circle": ["question mark"], hexagon: ["shape", "node.js", "logo"], home: ["house", "living"], image: ["picture"], inbox: ["email"], instagram: ["logo", "camera"], key: ["password", "login", "authentication", "secure"], layers: ["stack"], layout: ["window", "webpage"], "life-bouy": ["help", "life ring", "support"], link: ["chain", "url"], "link-2": ["chain", "url"], linkedin: ["logo", "social media"], list: ["options"], lock: ["security", "password", "secure"], "log-in": ["sign in", "arrow", "enter"], "log-out": ["sign out", "arrow", "exit"], mail: ["email", "message"], "map-pin": ["location", "navigation", "travel", "marker"], map: ["location", "navigation", "travel"], maximize: ["fullscreen"], "maximize-2": ["fullscreen", "arrows", "expand"], meh: ["emoji", "face", "neutral", "emotion"], menu: ["bars", "navigation", "hamburger"], "message-circle": ["comment", "chat"], "message-square": ["comment", "chat"], "mic-off": ["record", "sound", "mute"], mic: ["record", "sound", "listen"], minimize: ["exit fullscreen", "close"], "minimize-2": ["exit fullscreen", "arrows", "close"], minus: ["subtract"], monitor: ["tv", "screen", "display"], moon: ["dark", "night"], "more-horizontal": ["ellipsis"], "more-vertical": ["ellipsis"], "mouse-pointer": ["arrow", "cursor"], move: ["arrows"], music: ["note"], navigation: ["location", "travel"], "navigation-2": ["location", "travel"], octagon: ["stop"], package: ["box", "container"], paperclip: ["attachment"], pause: ["music", "stop"], "pause-circle": ["music", "audio", "stop"], "pen-tool": ["vector", "drawing"], percent: ["discount"], "phone-call": ["ring"], "phone-forwarded": ["call"], "phone-incoming": ["call"], "phone-missed": ["call"], "phone-off": ["call", "mute"], "phone-outgoing": ["call"], phone: ["call"], play: ["music", "start"], "pie-chart": ["statistics", "diagram"], "play-circle": ["music", "start"], plus: ["add", "new"], "plus-circle": ["add", "new"], "plus-square": ["add", "new"], pocket: ["logo", "save"], power: ["on", "off"], printer: ["fax", "office", "device"], radio: ["signal"], "refresh-cw": ["synchronise", "arrows"], "refresh-ccw": ["arrows"], repeat: ["loop", "arrows"], rewind: ["music"], "rotate-ccw": ["arrow"], "rotate-cw": ["arrow"], rss: ["feed", "subscribe"], save: ["floppy disk"], scissors: ["cut"], search: ["find", "magnifier", "magnifying glass"], send: ["message", "mail", "email", "paper airplane", "paper aeroplane"], settings: ["cog", "edit", "gear", "preferences"], "share-2": ["network", "connections"], shield: ["security", "secure"], "shield-off": ["security", "insecure"], "shopping-bag": ["ecommerce", "cart", "purchase", "store"], "shopping-cart": ["ecommerce", "cart", "purchase", "store"], shuffle: ["music"], "skip-back": ["music"], "skip-forward": ["music"], slack: ["logo"], slash: ["ban", "no"], sliders: ["settings", "controls"], smartphone: ["cellphone", "device"], smile: ["emoji", "face", "happy", "good", "emotion"], speaker: ["audio", "music"], star: ["bookmark", "favorite", "like"], "stop-circle": ["media", "music"], sun: ["brightness", "weather", "light"], sunrise: ["weather", "time", "morning", "day"], sunset: ["weather", "time", "evening", "night"], tablet: ["device"], tag: ["label"], target: ["logo", "bullseye"], terminal: ["code", "command line", "prompt"], thermometer: ["temperature", "celsius", "fahrenheit", "weather"], "thumbs-down": ["dislike", "bad", "emotion"], "thumbs-up": ["like", "good", "emotion"], "toggle-left": ["on", "off", "switch"], "toggle-right": ["on", "off", "switch"], tool: ["settings", "spanner"], trash: ["garbage", "delete", "remove", "bin"], "trash-2": ["garbage", "delete", "remove", "bin"], triangle: ["delta"], truck: ["delivery", "van", "shipping", "transport", "lorry"], tv: ["television", "stream"], twitch: ["logo"], twitter: ["logo", "social"], type: ["text"], umbrella: ["rain", "weather"], unlock: ["security"], "user-check": ["followed", "subscribed"], "user-minus": ["delete", "remove", "unfollow", "unsubscribe"], "user-plus": ["new", "add", "create", "follow", "subscribe"], "user-x": ["delete", "remove", "unfollow", "unsubscribe", "unavailable"], user: ["person", "account"], users: ["group"], "video-off": ["camera", "movie", "film"], video: ["camera", "movie", "film"], voicemail: ["phone"], volume: ["music", "sound", "mute"], "volume-1": ["music", "sound"], "volume-2": ["music", "sound"], "volume-x": ["music", "sound", "mute"], watch: ["clock", "time"], "wifi-off": ["disabled"], wifi: ["connection", "signal", "wireless"], wind: ["weather", "air"], "x-circle": ["cancel", "close", "delete", "remove", "times", "clear"], "x-octagon": ["delete", "stop", "alert", "warning", "times", "clear"], "x-square": ["cancel", "close", "delete", "remove", "times", "clear"], x: ["cancel", "close", "delete", "remove", "times", "clear"], youtube: ["logo", "video", "play"], "zap-off": ["flash", "camera", "lightning"], zap: ["flash", "camera", "lightning"], "zoom-in": ["magnifying glass"], "zoom-out": ["magnifying glass"] };
          }
        ),
        /***/
        "./src/to-svg.js": (
          /*!***********************!*\
            !*** ./src/to-svg.js ***!
            \***********************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            Object.defineProperty(i, "__esModule", {
              value: !0
            });
            var a = n(
              /*! ./icons */
              "./src/icons.js"
            ), s = o(a);
            function o(c) {
              return c && c.__esModule ? c : { default: c };
            }
            function l(c) {
              var u = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
              if (console.warn("feather.toSvg() is deprecated. Please use feather.icons[name].toSvg() instead."), !c)
                throw new Error("The required `key` (icon name) parameter is missing.");
              if (!s.default[c])
                throw new Error("No icon matching '" + c + "'. See the complete list of icons at https://feathericons.com");
              return s.default[c].toSvg(u);
            }
            i.default = l;
          }
        ),
        /***/
        0: (
          /*!**************************************************!*\
            !*** multi core-js/es/array/from ./src/index.js ***!
            \**************************************************/
          /*! no static exports found */
          /***/
          function(r, i, n) {
            n(
              /*! core-js/es/array/from */
              "./node_modules/core-js/es/array/from.js"
            ), r.exports = n(
              /*! /home/runner/work/feather/feather/src/index.js */
              "./src/index.js"
            );
          }
        )
        /******/
      })
    );
  });
})(rf);
var aa = rf.exports;
const U0 = /* @__PURE__ */ ln(aa), V0 = /* @__PURE__ */ T0({
  __proto__: null,
  default: U0
}, [aa]);
/*! vue-feather v2.0.0 | (c) 2018-present Chen Fengyuan | MIT */
var Sl = Wh({
  name: "VueFeather",
  props: {
    animation: {
      type: String,
      default: void 0
    },
    animationSpeed: {
      type: String,
      default: void 0
    },
    fill: {
      type: String,
      default: "none"
    },
    size: {
      type: [Number, String],
      default: 24
    },
    stroke: {
      type: String,
      default: "currentColor"
    },
    strokeLinecap: {
      type: String,
      default: "round"
    },
    strokeLinejoin: {
      type: String,
      default: "round"
    },
    strokeWidth: {
      type: [Number, String],
      default: 2
    },
    tag: {
      type: String,
      default: "i"
    },
    type: {
      type: String,
      default: "feather",
      validator(t) {
        if (!V0)
          throw new Error("The Feather icons is required.");
        if (!aa.icons[t])
          throw new Error(`"${t}" is not an available icon type.`);
        return !0;
      }
    }
  },
  computed: {
    isRemSize() {
      return typeof this.size == "string" && this.size.endsWith("rem");
    }
  },
  render() {
    const { animation: t, animationSpeed: e, isRemSize: r, size: i, type: n } = this, a = aa.icons[n];
    return Xc(this.tag, {
      ...this.$attrs,
      "data-name": n,
      "data-tags": a.tags,
      "data-type": n,
      class: {
        "vue-feather": !0,
        [`vue-feather--${n}`]: n,
        [`vue-feather--${t}`]: t,
        [`vue-feather--${e}`]: e
      },
      style: r ? {
        height: i,
        width: i
      } : void 0
    }, [
      Xc(
        "svg",
        // XXX: The `width` and `height` attributes do not support the `rem` unit in Safari (#13).
        {
          ...a.attrs,
          fill: this.fill,
          height: r ? void 0 : i,
          stroke: this.stroke,
          "stroke-linecap": this.strokeLinecap,
          "stroke-linejoin": this.strokeLinejoin,
          "stroke-width": this.strokeWidth,
          width: r ? void 0 : i,
          class: [a.attrs.class, "vue-feather__content"],
          innerHTML: a.contents
        }
      )
    ]);
  }
});
function H0(t, e) {
  e === void 0 && (e = {});
  var r = e.insertAt;
  if (!(!t || typeof document > "u")) {
    var i = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
    n.type = "text/css", r === "top" && i.firstChild ? i.insertBefore(n, i.firstChild) : i.appendChild(n), n.styleSheet ? n.styleSheet.cssText = t : n.appendChild(document.createTextNode(t));
  }
}
var W0 = "@keyframes vue-feather--spin{0%{transform:rotate(0)}to{transform:rotate(1turn)}}.vue-feather{display:inline-block;overflow:hidden}.vue-feather--spin{animation:vue-feather--spin 2s linear infinite}.vue-feather--pulse{animation:vue-feather--spin 2s steps(8) infinite}.vue-feather--slow{animation-duration:3s}.vue-feather--fast{animation-duration:1s}.vue-feather__content{display:block;height:inherit;width:inherit}";
H0(W0);
const G0 = {
  components: {
    VueFeather: Sl
  },
  props: {
    checked: {
      type: Boolean,
      default: !1
    },
    customSize: {
      type: Number
    }
  },
  data() {
    return {
      size: "5"
    };
  },
  computed: {
    classList() {
      return [
        "w-" + this.size,
        "h-" + this.size,
        "rounded-full border-2 text-white flex justify-center items-center bg-blue-500 opacity-1 border-blue-500"
      ];
    },
    classListIcon() {
      return [
        "w-3 h-3"
      ];
    }
  },
  mounted() {
    this.size = this.customSize ? this.customSize.toString() : this.size;
  }
};
function Y0(t, e, r, i, n, a) {
  const s = it("vue-feather");
  return R(), ht(qt, { name: "transition-fade" }, {
    default: ft(() => [
      he(E("div", {
        "data-checkmark": "",
        class: re(a.classList)
      }, [
        Ue(s, {
          type: "check",
          class: re(a.classListIcon)
        }, null, 8, ["class"])
      ], 2), [
        [fe, r.checked]
      ])
    ]),
    _: 1
  });
}
const VA = /* @__PURE__ */ Ce(G0, [["render", Y0]]), X0 = {
  data() {
    return {};
  },
  computed: {
    classList() {
      return [
        "flex-grow flex flex-col overflow-hidden relative"
      ];
    }
  }
};
function q0(t, e, r, i, n, a) {
  return R(), M("div", {
    class: re(a.classList)
  }, [
    Tr(t.$slots, "default")
  ], 2);
}
const K0 = /* @__PURE__ */ Ce(X0, [["render", q0]]), Z0 = {
  data() {
    return {};
  },
  computed: {
    classList() {
      return [
        "flex justify-center items-center min-h-14 relative"
      ];
    }
  }
};
function Q0(t, e, r, i, n, a) {
  return R(), M("div", {
    class: re(a.classList)
  }, [
    Tr(t.$slots, "default")
  ], 2);
}
const J0 = /* @__PURE__ */ Ce(Z0, [["render", Q0]]), em = {
  data() {
    return {};
  },
  props: {
    showChat: {
      type: Boolean,
      default: !0
    }
  },
  computed: {
    classList() {
      return [
        this.showChat ? "flex justify-center items-center h-14 relative z-10" : "flex justify-end items-center h-14 relative z-10"
      ];
    }
  }
};
function tm(t, e, r, i, n, a) {
  return R(), M("div", {
    class: re(a.classList)
  }, [
    Tr(t.$slots, "default")
  ], 2);
}
const rm = /* @__PURE__ */ Ce(em, [["render", tm]]), sa = 72, im = 7e8, nm = 1e6, wl = "landscape", El = "portrait", Tl = "square", HA = (t) => {
  t = t.replace(/\s(?:\S*?)?:?xmlns:?.*?=["']{1}\S*?["']{1}/gmi, "");
  const e = t.match(/<\/?\w*?\b[^>]*>/gmi);
  return e && e.length && t.match(/<svg/gmi) && (e[0] = e[0].replace(/>/mi, ' xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">'), t = e.join("")), t;
}, WA = (t) => new XMLSerializer().serializeToString(t), Ni = (t, e) => {
  let r = !1;
  if (!t)
    return t;
  t[0] == "#" && (t = t.slice(1), r = !0);
  let i = parseInt(t, 16), n = (i >> 16) + e;
  n > 255 ? n = 255 : n < 0 && (n = 0);
  let a = (i >> 8 & 255) + e;
  a > 255 ? a = 255 : a < 0 && (a = 0);
  let s = (i & 255) + e;
  return s > 255 ? s = 255 : s < 0 && (s = 0), (r ? "#" : "") + (s | a << 8 | n << 16).toString(16);
}, am = (t) => {
  const i = new DOMParser().parseFromString(t, "image/svg+xml").querySelectorAll("image"), n = {};
  return i.forEach((a, s) => {
    const o = parseInt(a.getAttribute("data-id"), 10);
    let l = a.getAttribute("data-pane");
    const c = parseFloat(a.getAttribute("data-translate-x")), u = parseFloat(a.getAttribute("data-translate-y")), d = parseFloat(a.getAttribute("data-scale")), h = parseFloat(a.getAttribute("data-rotate"));
    isNaN(parseInt(l, 10)) || (l = `pane_${s + 1}`), n[l] = {
      id: o,
      transform: {
        x: c,
        y: u,
        scale: d,
        rotate: h
      }
    };
  }), n;
}, sm = (t) => {
  const e = {}, r = om(t);
  return Object.values(r).map((i, n) => {
    e[`pane_${n + 1}`] = i;
  }), e;
}, om = (t) => Object.keys(t).sort((e, r) => parseInt(e.split("_")[1]) - parseInt(r.split("_")[1])).reduce((e, r) => (e[r] = t[r], e), {}), qc = (t) => {
  var s, o, l, c, u;
  if (t.version === "2")
    return t;
  const e = ((s = t.S) == null ? void 0 : s.svgData) || ((o = t.FP) == null ? void 0 : o.svgData) || "", n = new DOMParser().parseFromString(e, "image/svg+xml").querySelectorAll("image"), a = {};
  if (t.productSlug === $t && ((l = t.S) != null && l.imageData) && ((c = t.S) != null && c.productData)) {
    const d = JSON.parse((u = t.S) == null ? void 0 : u.imageData);
    Object.keys(d).map((v, p) => {
      const y = d[v].dimensions.originalBitmapWidth, x = d[v].dimensions.originalBitmapHeight, w = d[v].transform.zoom, P = d[v].transform.rotate, O = d[v].url, A = d[v].thumb;
      a[p] = {
        id: 100,
        width: y,
        height: x,
        originalPath: O,
        thumbPath: A,
        transform: {
          x: 0,
          y: 0,
          scale: w,
          rotate: P
        }
      };
    });
    const h = JSON.parse(t.S.productData), f = h.layout.svgIcon.substr(0, h.layout.svgIcon.length - 4);
    t.options[19] = f;
  } else
    n.forEach((d) => {
      const h = t.image.id, f = parseInt(d.getAttribute("data-original-width"), 10), v = parseInt(d.getAttribute("data-original-height"), 10), p = d.getAttribute("data-original"), b = d.getAttribute("xlink:href"), y = 0, x = parseFloat(d.getAttribute("data-translate-x")), w = parseFloat(d.getAttribute("data-translate-y")), P = parseFloat(d.getAttribute("data-scale")), O = parseFloat(d.getAttribute("data-rotate"));
      a[y] = {
        id: h,
        width: f,
        height: v,
        originalPath: p,
        thumbPath: b,
        transform: {
          x,
          y: w,
          scale: P,
          rotate: O
        }
      };
    }), t.productSlug === nt && t.color && (t.selectedPetPortraitColor = t.color, delete t.color, t.note && (t.selectedPetPortraitStyle = t.note.split("||")[2]), t.text && (t.petPortraitName = t.text, delete t.text));
  return t.S && delete t.S, t.FP && delete t.FP, t.images = a, t.uploadLater = Object.keys(n).length === 0, t.version = "2", t.svg = "", t;
}, Kc = (t, e) => {
  let r = 1e4, i;
  return t.map((n, a) => {
    const s = Math.abs(n - e);
    s < r && (r = s, i = a);
  }), i;
}, GA = (t) => t && "relList" in t && "supports" in t.relList && typeof t.relList.supports == "function" && t.relList.supports("ar") && !/CriOS\/[\d]+/.test(navigator.userAgent), lm = (t, e, r, i, n) => {
  const a = i * sa > t / r, s = n * sa > e / r;
  return a || s;
}, YA = (t) => new Promise(async (e, r) => {
  let i = new FileReader();
  const n = t.slice(0, 4);
  i.readAsArrayBuffer(n), i.onload = function(a) {
    var u;
    const s = new Uint8Array((u = a.target) == null ? void 0 : u.result);
    let o = [];
    s.forEach((d) => {
      o.push(d.toString(16));
    });
    const l = o.join("").toUpperCase();
    let c;
    if (l.includes("FFD8FF"))
      c = !0;
    else
      switch (l) {
        case "89504E47":
        case "00024":
        case "00018":
        case "0001C":
        case "00028":
        case "52494646":
          c = !0;
          break;
        case "49492A0":
        case "4D4D02A":
        case "4D4D002A":
          c = !!(t.type && (t.type === "image/tiff" || t.type === "image/x-tiff"));
          break;
        default:
          c = !1;
          break;
      }
    e(c);
  }, i.onerror = function(a) {
    r(t.name);
  };
}), XA = (t) => new Promise(async (e, r) => {
  let i;
  if (t.type !== "image/tiff" && t.type !== "image/x-tiff") {
    const n = new Image();
    n.src = URL.createObjectURL(t), await n.decode();
    const a = n.width, s = n.height;
    i = a * s, i < nm || i > im ? e(!1) : e(!0);
  } else
    e(!0);
}), qA = (t, e, r, i) => e ? r.$i18n.te(t + e) ? r.$i18n.t(t + e, i) : e : r.$i18n.te(t) ? r.$i18n.t(t, i) : t, cm = (t, e, r) => {
  if (("which" in r ? r.which : r.keyCode) === 9) {
    const n = r.shiftKey;
    n && document.activeElement === t ? (r.preventDefault(), e.focus()) : !n && document.activeElement === e && (r.preventDefault(), t.focus());
  }
}, um = (t) => {
  let e = new Image(), r = 1, i = !1;
  const n = () => {
    e.removeEventListener("load", a), e.removeEventListener("error", s);
  }, a = () => {
    i = !0, n();
  }, s = () => {
    r < 3 && !i ? setTimeout(() => {
      r++, e.src = t;
    }, 200) : n();
  };
  e.addEventListener("load", a), e.addEventListener("error", s), e.src = t;
}, dm = () => {
  const t = Math.floor(Math.random() * 1073741824), e = Date.now() % 1e6;
  return t * 1e3 + e;
}, hm = (t, e) => {
  let r;
  return t / e > 1 ? r = wl : t / e < 1 ? r = El : r = Tl, r;
};
function fm(t, e, r, i) {
  const n = t / e, a = [];
  if (r <= e)
    return a;
  let s = e, o = t;
  n > 1 ? (s = i, o = Math.round(s * n)) : (o = i, s = Math.round(o / n)), (s > r || o > r) && (n > 1 ? (o = r, s = Math.round(o / n)) : (s = r, o = Math.round(s * n)));
  const l = (s - e) / 9;
  for (let c = 0; c < 8; c++) {
    const u = Math.round(e + l * (c + 1)), d = Math.round(u * n);
    if (u > r || d > r)
      break;
    a.push({
      id: c,
      value: `${d}|${u}`,
      label: `${d}" x ${u}"`,
      disabled: !1
    });
  }
  return a.length > 0 && (a[a.length - 1] = {
    id: a.length - 1,
    value: `${o}|${s}`,
    label: `${o}" x ${s}"`,
    disabled: !1
  }), a.length === 0 && a.push({
    id: 0,
    value: `${t}|${e}`,
    label: `${t}" x ${e}"`,
    disabled: !1
  }), a;
}
function gm(t, e, r, i) {
  const n = t / e, a = 0.1, s = n * (1 - a), o = n * (1 + a), l = r / i;
  return l >= s && l <= o;
}
const pm = (t) => {
  if (t = t.replace(/^#/, ""), !t || !/^[0-9A-Fa-f]{3}$|^[0-9A-Fa-f]{6}$/.test(t))
    throw new Error("Invalid hex color format");
  t.length === 3 && (t = t.split("").map((a) => a + a).join(""));
  const e = parseInt(t.slice(0, 2), 16), r = parseInt(t.slice(2, 4), 16), i = parseInt(t.slice(4, 6), 16);
  return 0.2126 * e + 0.7152 * r + 0.0722 * i >= 127.5;
}, KA = (t) => new Promise((e, r) => {
  try {
    if (typeof window.zE > "u")
      return console.warn("Zendesk is undefined"), e(!1);
    window.zE("messenger:on", "unreadMessages", () => {
      t || (t = !0, window.zE("messenger", "hide")), e(!0);
    });
  } catch (i) {
    console.warn("Zendesk chat widget not available:", i), r(i);
  }
}), ZA = (t) => {
  try {
    t && typeof window.zE < "u" && window.zE("messenger", "show");
  } catch (e) {
    console.warn("Zendesk chat widget not available:", e);
  }
}, QA = () => {
  var t;
  if (window.adaEmbed && typeof window.adaEmbed == "object") {
    const e = (t = document.querySelector('meta[name="chat-handle"]')) == null ? void 0 : t.getAttribute("content");
    e && window.adaEmbed.start({ handle: e });
  }
}, JA = () => {
  window.adaEmbed && typeof window.adaEmbed == "object" && window.adaEmbed.stop();
}, mm = {
  components: {
    ActionButton: $0,
    Body: K0,
    Footer: J0,
    Header: rm,
    VueFeather: Sl
  },
  props: {
    heading: {
      type: String,
      default: ""
    },
    hasCancelOption: {
      type: Boolean,
      default: !1
    },
    cancelLabel: {
      type: String,
      default: ""
    },
    confirmLabel: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: !1
    },
    custom: {
      type: Boolean,
      default: !1
    },
    transitionName: {
      type: String,
      default: "transition-fade-pop"
    },
    maxWidth: {
      type: String,
      default: "max-w-md"
    },
    type: {
      type: String,
      default: "info",
      validator: (t) => ["info", "alert", "positive", "negative"].indexOf(t) !== -1
    },
    icon: {
      type: Boolean,
      default: !0
    }
  },
  data() {
    return {
      triggerElement: null
    };
  },
  computed: {
    classList() {
      return [
        `bg-${this.shade}-50 text-${this.shade}-500`
      ];
    },
    shade() {
      switch (this.type) {
        case "alert":
          return "orange";
        case "positive":
          return "green";
        case "negative":
          return "red";
        case "info":
        default:
          return "blue";
      }
    },
    iconType() {
      switch (this.type) {
        case "alert":
          return "alert-circle";
        case "positive":
          return "thumbs-up";
        case "negative":
          return "thumbs-down";
        case "info":
        default:
          return "info";
      }
    },
    contentClassList() {
      return [
        this.custom ? "overflow-auto" : "overflow-hidden",
        "relative m-4 bg-white rounded shadow-lg w-full",
        this.maxWidth ? this.maxWidth : "max-w-md"
      ];
    }
  },
  unmounted() {
    document.removeEventListener("keydown", this.handleKeyDown);
  },
  watch: {
    visible: function(t) {
      t ? (document.body.classList.add("overflow-hidden", "lg:overflow-hidden"), document.body.classList.remove("lg:overflow-auto", "lg:scrolling-touch"), document.addEventListener("keyup", this.handleKeyUp), document.addEventListener("keydown", this.handleKeyDown), this.focusDialog()) : (document.body.classList.add("lg:overflow-auto", "lg:scrolling-touch"), document.body.classList.remove("overflow-hidden", "lg:overflow-hidden"), document.removeEventListener("keyup", this.handleKeyUp), document.removeEventListener("keydown", this.handleKeyDown), this.focusTriggerElement());
    }
  },
  methods: {
    handleCancel() {
      this.hasCancelOption ? this.$emit("cancel") : this.$emit("confirm");
    },
    handleConfirm() {
      this.$emit("confirm");
    },
    handleKeyUp(t) {
      ("which" in t ? t.which : t.keyCode) === 27 && this.handleCancel();
    },
    handleKeyDown(t) {
      const e = this.$refs.confirmBtn;
      e && cm(this.$refs.dialog, e.$el, t);
    },
    focusDialog() {
      this.triggerElement = document.activeElement, this.$nextTick(() => {
        let t = this.$refs.dialog;
        t == null || t.focus();
      });
    },
    focusTriggerElement() {
      this.$nextTick(() => {
        var t;
        (t = this.triggerElement) == null || t.focus();
      });
    }
  }
}, vm = { class: "flex flex-col items-center text-center sm:flex-row sm:items-start sm:text-left" }, ym = ["innerHTML"], bm = {
  "data-body": "",
  class: "text-gray-500 leading-tight text-sm w-full"
}, xm = {
  key: 0,
  "data-footer": "",
  class: "bg-gray-50 p-3 flex flex-col sm:flex-row sm:justify-end"
};
function Sm(t, e, r, i, n, a) {
  const s = it("vue-feather"), o = it("ActionButton");
  return R(), ht(qt, { name: "transition-fade" }, {
    default: ft(() => [
      he(E("div", {
        "data-dialog": "",
        role: "dialog",
        "aria-modal": "true",
        ref: "dialog",
        tabindex: "0",
        class: re(["fixed inset-0 z-50 flex justify-center", r.custom ? "items-center" : "items-end sm:items-center"])
      }, [
        E("div", {
          "data-background": "",
          class: "absolute inset-0 bg-black opacity-75",
          onClick: e[0] || (e[0] = zn((...l) => a.handleCancel && a.handleCancel(...l), ["self"]))
        }),
        Ue(qt, { name: r.transitionName }, {
          default: ft(() => [
            r.visible ? (R(), M("div", {
              key: 0,
              "data-content": "",
              class: re(a.contentClassList)
            }, [
              E("div", {
                class: re(r.custom ? "" : "p-4")
              }, [
                E("div", vm, [
                  !r.custom && r.icon ? (R(), M("div", {
                    key: 0,
                    "data-icon": "",
                    class: re(["w-8 h-8 rounded-full flex justify-center items-center flex-shrink-0", a.classList])
                  }, [
                    Ue(s, {
                      type: a.iconType,
                      "data-icon-svg": "",
                      class: "w-4 h-4"
                    }, null, 8, ["type"])
                  ], 2)) : Q("", !0),
                  E("div", {
                    class: re(["w-full", r.custom ? "" : "pt-2 sm:pt-0 sm:pl-4"])
                  }, [
                    r.heading && !r.custom ? (R(), M("div", {
                      key: 0,
                      "data-heading": "",
                      tabindex: "0",
                      class: "font-bold text-lg mb-2 leading-tight",
                      innerHTML: r.heading ? r.heading : t.$t("message.dialog.heading")
                    }, null, 8, ym)) : Q("", !0),
                    E("div", bm, [
                      Tr(t.$slots, "default")
                    ])
                  ], 2)
                ])
              ], 2),
              r.custom ? Q("", !0) : (R(), M("div", xm, [
                r.hasCancelOption ? (R(), ht(o, {
                  key: 0,
                  class: "order-2 w-auto bg-white mt-2 sm:order-1 sm:mt-0 sm:mr-2",
                  "data-cancel": "",
                  label: r.cancelLabel ? r.cancelLabel : t.$t("message.dialog.cancelLabel"),
                  onClick: a.handleCancel
                }, null, 8, ["label", "onClick"])) : Q("", !0),
                Ue(o, {
                  class: "order-1 w-auto sm:order-2 text-white btn--primary",
                  "data-test-id": "login-button",
                  "data-confirm": "",
                  ref: "confirmBtn",
                  label: r.confirmLabel ? r.confirmLabel : t.$t("message.dialog.confirmLabel"),
                  onClick: a.handleConfirm
                }, null, 8, ["label", "onClick"])
              ]))
            ], 2)) : Q("", !0)
          ]),
          _: 3
        }, 8, ["name"])
      ], 2), [
        [fe, r.visible]
      ])
    ]),
    _: 3
  });
}
const e8 = /* @__PURE__ */ Ce(mm, [["render", Sm]]);
var nf = { exports: {} };
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(t) {
  (function(e, r, i, n) {
    var a = ["", "webkit", "Moz", "MS", "ms", "o"], s = r.createElement("div"), o = "function", l = Math.round, c = Math.abs, u = Date.now;
    function d(g, m, S) {
      return setTimeout(w(g, S), m);
    }
    function h(g, m, S) {
      return Array.isArray(g) ? (f(g, S[m], S), !0) : !1;
    }
    function f(g, m, S) {
      var T;
      if (g)
        if (g.forEach)
          g.forEach(m, S);
        else if (g.length !== n)
          for (T = 0; T < g.length; )
            m.call(S, g[T], T, g), T++;
        else
          for (T in g)
            g.hasOwnProperty(T) && m.call(S, g[T], T, g);
    }
    function v(g, m, S) {
      var T = "DEPRECATED METHOD: " + m + `
` + S + ` AT 
`;
      return function() {
        var _ = new Error("get-stack-trace"), L = _ && _.stack ? _.stack.replace(/^[^\(]+?[\n$]/gm, "").replace(/^\s+at\s+/gm, "").replace(/^Object.<anonymous>\s*\(/gm, "{anonymous}()@") : "Unknown Stack Trace", H = e.console && (e.console.warn || e.console.log);
        return H && H.call(e.console, T, L), g.apply(this, arguments);
      };
    }
    var p;
    typeof Object.assign != "function" ? p = function(m) {
      if (m === n || m === null)
        throw new TypeError("Cannot convert undefined or null to object");
      for (var S = Object(m), T = 1; T < arguments.length; T++) {
        var _ = arguments[T];
        if (_ !== n && _ !== null)
          for (var L in _)
            _.hasOwnProperty(L) && (S[L] = _[L]);
      }
      return S;
    } : p = Object.assign;
    var b = v(function(m, S, T) {
      for (var _ = Object.keys(S), L = 0; L < _.length; )
        (!T || T && m[_[L]] === n) && (m[_[L]] = S[_[L]]), L++;
      return m;
    }, "extend", "Use `assign`."), y = v(function(m, S) {
      return b(m, S, !0);
    }, "merge", "Use `assign`.");
    function x(g, m, S) {
      var T = m.prototype, _;
      _ = g.prototype = Object.create(T), _.constructor = g, _._super = T, S && p(_, S);
    }
    function w(g, m) {
      return function() {
        return g.apply(m, arguments);
      };
    }
    function P(g, m) {
      return typeof g == o ? g.apply(m && m[0] || n, m) : g;
    }
    function O(g, m) {
      return g === n ? m : g;
    }
    function A(g, m, S) {
      f(W(m), function(T) {
        g.addEventListener(T, S, !1);
      });
    }
    function I(g, m, S) {
      f(W(m), function(T) {
        g.removeEventListener(T, S, !1);
      });
    }
    function D(g, m) {
      for (; g; ) {
        if (g == m)
          return !0;
        g = g.parentNode;
      }
      return !1;
    }
    function k(g, m) {
      return g.indexOf(m) > -1;
    }
    function W(g) {
      return g.trim().split(/\s+/g);
    }
    function $(g, m, S) {
      if (g.indexOf && !S)
        return g.indexOf(m);
      for (var T = 0; T < g.length; ) {
        if (S && g[T][S] == m || !S && g[T] === m)
          return T;
        T++;
      }
      return -1;
    }
    function z(g) {
      return Array.prototype.slice.call(g, 0);
    }
    function X(g, m, S) {
      for (var T = [], _ = [], L = 0; L < g.length; ) {
        var H = m ? g[L][m] : g[L];
        $(_, H) < 0 && T.push(g[L]), _[L] = H, L++;
      }
      return S && (m ? T = T.sort(function(Re, Fe) {
        return Re[m] > Fe[m];
      }) : T = T.sort()), T;
    }
    function U(g, m) {
      for (var S, T, _ = m[0].toUpperCase() + m.slice(1), L = 0; L < a.length; ) {
        if (S = a[L], T = S ? S + _ : m, T in g)
          return T;
        L++;
      }
      return n;
    }
    var ie = 1;
    function q() {
      return ie++;
    }
    function Y(g) {
      var m = g.ownerDocument || g;
      return m.defaultView || m.parentWindow || e;
    }
    var te = /mobile|tablet|ip(ad|hone|od)|android/i, V = "ontouchstart" in e, K = U(e, "PointerEvent") !== n, ne = V && te.test(navigator.userAgent), oe = "touch", Se = "pen", ue = "mouse", Ge = "kinect", Ut = 25, ve = 1, Qe = 2, le = 4, ae = 8, mt = 1, Z = 2, Le = 4, De = 8, Je = 16, Be = Z | Le, Ne = De | Je, vt = Be | Ne, Vt = ["x", "y"], Ve = ["clientX", "clientY"];
    function ye(g, m) {
      var S = this;
      this.manager = g, this.callback = m, this.element = g.element, this.target = g.options.inputTarget, this.domHandler = function(T) {
        P(g.options.enable, [g]) && S.handler(T);
      }, this.init();
    }
    ye.prototype = {
      /**
       * should handle the inputEvent data and trigger the callback
       * @virtual
       */
      handler: function() {
      },
      /**
       * bind the events
       */
      init: function() {
        this.evEl && A(this.element, this.evEl, this.domHandler), this.evTarget && A(this.target, this.evTarget, this.domHandler), this.evWin && A(Y(this.element), this.evWin, this.domHandler);
      },
      /**
       * unbind the events
       */
      destroy: function() {
        this.evEl && I(this.element, this.evEl, this.domHandler), this.evTarget && I(this.target, this.evTarget, this.domHandler), this.evWin && I(Y(this.element), this.evWin, this.domHandler);
      }
    };
    function Ct(g) {
      var m, S = g.options.inputClass;
      return S ? m = S : K ? m = Za : ne ? m = Sn : V ? m = Qa : m = Wt, new m(g, It);
    }
    function It(g, m, S) {
      var T = S.pointers.length, _ = S.changedPointers.length, L = m & ve && T - _ === 0, H = m & (le | ae) && T - _ === 0;
      S.isFirst = !!L, S.isFinal = !!H, L && (g.session = {}), S.eventType = m, je(g, S), g.emit("hammer.input", S), g.recognize(S), g.session.prevInput = S;
    }
    function je(g, m) {
      var S = g.session, T = m.pointers, _ = T.length;
      S.firstInput || (S.firstInput = Dr(m)), _ > 1 && !S.firstMultiple ? S.firstMultiple = Dr(m) : _ === 1 && (S.firstMultiple = !1);
      var L = S.firstInput, H = S.firstMultiple, Ee = H ? H.center : L.center, Re = m.center = Nr(T);
      m.timeStamp = u(), m.deltaTime = m.timeStamp - L.timeStamp, m.angle = Ht(Ee, Re), m.distance = _t(Ee, Re), Ci(S, m), m.offsetDirection = ar(m.deltaX, m.deltaY);
      var Fe = nr(m.deltaTime, m.deltaX, m.deltaY);
      m.overallVelocityX = Fe.x, m.overallVelocityY = Fe.y, m.overallVelocity = c(Fe.x) > c(Fe.y) ? Fe.x : Fe.y, m.scale = H ? xn(H.pointers, T) : 1, m.rotation = H ? bn(H.pointers, T) : 0, m.maxPointers = S.prevInput ? m.pointers.length > S.prevInput.maxPointers ? m.pointers.length : S.prevInput.maxPointers : m.pointers.length, Ii(S, m);
      var bt = g.element;
      D(m.srcEvent.target, bt) && (bt = m.srcEvent.target), m.target = bt;
    }
    function Ci(g, m) {
      var S = m.center, T = g.offsetDelta || {}, _ = g.prevDelta || {}, L = g.prevInput || {};
      (m.eventType === ve || L.eventType === le) && (_ = g.prevDelta = {
        x: L.deltaX || 0,
        y: L.deltaY || 0
      }, T = g.offsetDelta = {
        x: S.x,
        y: S.y
      }), m.deltaX = _.x + (S.x - T.x), m.deltaY = _.y + (S.y - T.y);
    }
    function Ii(g, m) {
      var S = g.lastInterval || m, T = m.timeStamp - S.timeStamp, _, L, H, Ee;
      if (m.eventType != ae && (T > Ut || S.velocity === n)) {
        var Re = m.deltaX - S.deltaX, Fe = m.deltaY - S.deltaY, bt = nr(T, Re, Fe);
        L = bt.x, H = bt.y, _ = c(bt.x) > c(bt.y) ? bt.x : bt.y, Ee = ar(Re, Fe), g.lastInterval = m;
      } else
        _ = S.velocity, L = S.velocityX, H = S.velocityY, Ee = S.direction;
      m.velocity = _, m.velocityX = L, m.velocityY = H, m.direction = Ee;
    }
    function Dr(g) {
      for (var m = [], S = 0; S < g.pointers.length; )
        m[S] = {
          clientX: l(g.pointers[S].clientX),
          clientY: l(g.pointers[S].clientY)
        }, S++;
      return {
        timeStamp: u(),
        pointers: m,
        center: Nr(m),
        deltaX: g.deltaX,
        deltaY: g.deltaY
      };
    }
    function Nr(g) {
      var m = g.length;
      if (m === 1)
        return {
          x: l(g[0].clientX),
          y: l(g[0].clientY)
        };
      for (var S = 0, T = 0, _ = 0; _ < m; )
        S += g[_].clientX, T += g[_].clientY, _++;
      return {
        x: l(S / m),
        y: l(T / m)
      };
    }
    function nr(g, m, S) {
      return {
        x: m / g || 0,
        y: S / g || 0
      };
    }
    function ar(g, m) {
      return g === m ? mt : c(g) >= c(m) ? g < 0 ? Z : Le : m < 0 ? De : Je;
    }
    function _t(g, m, S) {
      S || (S = Vt);
      var T = m[S[0]] - g[S[0]], _ = m[S[1]] - g[S[1]];
      return Math.sqrt(T * T + _ * _);
    }
    function Ht(g, m, S) {
      S || (S = Vt);
      var T = m[S[0]] - g[S[0]], _ = m[S[1]] - g[S[1]];
      return Math.atan2(_, T) * 180 / Math.PI;
    }
    function bn(g, m) {
      return Ht(m[1], m[0], Ve) + Ht(g[1], g[0], Ve);
    }
    function xn(g, m) {
      return _t(m[0], m[1], Ve) / _t(g[0], g[1], Ve);
    }
    var _i = {
      mousedown: ve,
      mousemove: Qe,
      mouseup: le
    }, Ai = "mousedown", Ri = "mousemove mouseup";
    function Wt() {
      this.evEl = Ai, this.evWin = Ri, this.pressed = !1, ye.apply(this, arguments);
    }
    x(Wt, ye, {
      /**
       * handle mouse events
       * @param {Object} ev
       */
      handler: function(m) {
        var S = _i[m.type];
        S & ve && m.button === 0 && (this.pressed = !0), S & Qe && m.which !== 1 && (S = le), this.pressed && (S & le && (this.pressed = !1), this.callback(this.manager, S, {
          pointers: [m],
          changedPointers: [m],
          pointerType: ue,
          srcEvent: m
        }));
      }
    });
    var jr = {
      pointerdown: ve,
      pointermove: Qe,
      pointerup: le,
      pointercancel: ae,
      pointerout: ae
    }, kr = {
      2: oe,
      3: Se,
      4: ue,
      5: Ge
      // see https://twitter.com/jacobrossi/status/480596438489890816
    }, zr = "pointerdown", Ae = "pointermove pointerup pointercancel";
    e.MSPointerEvent && !e.PointerEvent && (zr = "MSPointerDown", Ae = "MSPointerMove MSPointerUp MSPointerCancel");
    function Za() {
      this.evEl = zr, this.evWin = Ae, ye.apply(this, arguments), this.store = this.manager.session.pointerEvents = [];
    }
    x(Za, ye, {
      /**
       * handle mouse events
       * @param {Object} ev
       */
      handler: function(m) {
        var S = this.store, T = !1, _ = m.type.toLowerCase().replace("ms", ""), L = jr[_], H = kr[m.pointerType] || m.pointerType, Ee = H == oe, Re = $(S, m.pointerId, "pointerId");
        L & ve && (m.button === 0 || Ee) ? Re < 0 && (S.push(m), Re = S.length - 1) : L & (le | ae) && (T = !0), !(Re < 0) && (S[Re] = m, this.callback(this.manager, L, {
          pointers: S,
          changedPointers: [m],
          pointerType: H,
          srcEvent: m
        }), T && S.splice(Re, 1));
      }
    });
    var r0 = {
      touchstart: ve,
      touchmove: Qe,
      touchend: le,
      touchcancel: ae
    }, i0 = "touchstart", n0 = "touchstart touchmove touchend touchcancel";
    function kc() {
      this.evTarget = i0, this.evWin = n0, this.started = !1, ye.apply(this, arguments);
    }
    x(kc, ye, {
      handler: function(m) {
        var S = r0[m.type];
        if (S === ve && (this.started = !0), !!this.started) {
          var T = a0.call(this, m, S);
          S & (le | ae) && T[0].length - T[1].length === 0 && (this.started = !1), this.callback(this.manager, S, {
            pointers: T[0],
            changedPointers: T[1],
            pointerType: oe,
            srcEvent: m
          });
        }
      }
    });
    function a0(g, m) {
      var S = z(g.touches), T = z(g.changedTouches);
      return m & (le | ae) && (S = X(S.concat(T), "identifier", !0)), [S, T];
    }
    var s0 = {
      touchstart: ve,
      touchmove: Qe,
      touchend: le,
      touchcancel: ae
    }, o0 = "touchstart touchmove touchend touchcancel";
    function Sn() {
      this.evTarget = o0, this.targetIds = {}, ye.apply(this, arguments);
    }
    x(Sn, ye, {
      handler: function(m) {
        var S = s0[m.type], T = l0.call(this, m, S);
        T && this.callback(this.manager, S, {
          pointers: T[0],
          changedPointers: T[1],
          pointerType: oe,
          srcEvent: m
        });
      }
    });
    function l0(g, m) {
      var S = z(g.touches), T = this.targetIds;
      if (m & (ve | Qe) && S.length === 1)
        return T[S[0].identifier] = !0, [S, S];
      var _, L, H = z(g.changedTouches), Ee = [], Re = this.target;
      if (L = S.filter(function(Fe) {
        return D(Fe.target, Re);
      }), m === ve)
        for (_ = 0; _ < L.length; )
          T[L[_].identifier] = !0, _++;
      for (_ = 0; _ < H.length; )
        T[H[_].identifier] && Ee.push(H[_]), m & (le | ae) && delete T[H[_].identifier], _++;
      if (Ee.length)
        return [
          // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
          X(L.concat(Ee), "identifier", !0),
          Ee
        ];
    }
    var c0 = 2500, zc = 25;
    function Qa() {
      ye.apply(this, arguments);
      var g = w(this.handler, this);
      this.touch = new Sn(this.manager, g), this.mouse = new Wt(this.manager, g), this.primaryTouch = null, this.lastTouches = [];
    }
    x(Qa, ye, {
      /**
       * handle mouse and touch events
       * @param {Hammer} manager
       * @param {String} inputEvent
       * @param {Object} inputData
       */
      handler: function(m, S, T) {
        var _ = T.pointerType == oe, L = T.pointerType == ue;
        if (!(L && T.sourceCapabilities && T.sourceCapabilities.firesTouchEvents)) {
          if (_)
            u0.call(this, S, T);
          else if (L && d0.call(this, T))
            return;
          this.callback(m, S, T);
        }
      },
      /**
       * remove the event listeners
       */
      destroy: function() {
        this.touch.destroy(), this.mouse.destroy();
      }
    });
    function u0(g, m) {
      g & ve ? (this.primaryTouch = m.changedPointers[0].identifier, Bc.call(this, m)) : g & (le | ae) && Bc.call(this, m);
    }
    function Bc(g) {
      var m = g.changedPointers[0];
      if (m.identifier === this.primaryTouch) {
        var S = { x: m.clientX, y: m.clientY };
        this.lastTouches.push(S);
        var T = this.lastTouches, _ = function() {
          var L = T.indexOf(S);
          L > -1 && T.splice(L, 1);
        };
        setTimeout(_, c0);
      }
    }
    function d0(g) {
      for (var m = g.srcEvent.clientX, S = g.srcEvent.clientY, T = 0; T < this.lastTouches.length; T++) {
        var _ = this.lastTouches[T], L = Math.abs(m - _.x), H = Math.abs(S - _.y);
        if (L <= zc && H <= zc)
          return !0;
      }
      return !1;
    }
    var Fc = U(s.style, "touchAction"), $c = Fc !== n, Uc = "compute", Vc = "auto", Ja = "manipulation", sr = "none", Mi = "pan-x", Li = "pan-y", wn = f0();
    function es(g, m) {
      this.manager = g, this.set(m);
    }
    es.prototype = {
      /**
       * set the touchAction value on the element or enable the polyfill
       * @param {String} value
       */
      set: function(g) {
        g == Uc && (g = this.compute()), $c && this.manager.element.style && wn[g] && (this.manager.element.style[Fc] = g), this.actions = g.toLowerCase().trim();
      },
      /**
       * just re-set the touchAction value
       */
      update: function() {
        this.set(this.manager.options.touchAction);
      },
      /**
       * compute the value for the touchAction property based on the recognizer's settings
       * @returns {String} value
       */
      compute: function() {
        var g = [];
        return f(this.manager.recognizers, function(m) {
          P(m.options.enable, [m]) && (g = g.concat(m.getTouchAction()));
        }), h0(g.join(" "));
      },
      /**
       * this method is called on each input cycle and provides the preventing of the browser behavior
       * @param {Object} input
       */
      preventDefaults: function(g) {
        var m = g.srcEvent, S = g.offsetDirection;
        if (this.manager.session.prevented) {
          m.preventDefault();
          return;
        }
        var T = this.actions, _ = k(T, sr) && !wn[sr], L = k(T, Li) && !wn[Li], H = k(T, Mi) && !wn[Mi];
        if (_) {
          var Ee = g.pointers.length === 1, Re = g.distance < 2, Fe = g.deltaTime < 250;
          if (Ee && Re && Fe)
            return;
        }
        if (!(H && L) && (_ || L && S & Be || H && S & Ne))
          return this.preventSrc(m);
      },
      /**
       * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
       * @param {Object} srcEvent
       */
      preventSrc: function(g) {
        this.manager.session.prevented = !0, g.preventDefault();
      }
    };
    function h0(g) {
      if (k(g, sr))
        return sr;
      var m = k(g, Mi), S = k(g, Li);
      return m && S ? sr : m || S ? m ? Mi : Li : k(g, Ja) ? Ja : Vc;
    }
    function f0() {
      if (!$c)
        return !1;
      var g = {}, m = e.CSS && e.CSS.supports;
      return ["auto", "manipulation", "pan-y", "pan-x", "pan-x pan-y", "none"].forEach(function(S) {
        g[S] = m ? e.CSS.supports("touch-action", S) : !0;
      }), g;
    }
    var En = 1, et = 2, Br = 4, Gt = 8, At = Gt, Di = 16, yt = 32;
    function Rt(g) {
      this.options = p({}, this.defaults, g || {}), this.id = q(), this.manager = null, this.options.enable = O(this.options.enable, !0), this.state = En, this.simultaneous = {}, this.requireFail = [];
    }
    Rt.prototype = {
      /**
       * @virtual
       * @type {Object}
       */
      defaults: {},
      /**
       * set options
       * @param {Object} options
       * @return {Recognizer}
       */
      set: function(g) {
        return p(this.options, g), this.manager && this.manager.touchAction.update(), this;
      },
      /**
       * recognize simultaneous with an other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      recognizeWith: function(g) {
        if (h(g, "recognizeWith", this))
          return this;
        var m = this.simultaneous;
        return g = Tn(g, this), m[g.id] || (m[g.id] = g, g.recognizeWith(this)), this;
      },
      /**
       * drop the simultaneous link. it doesnt remove the link on the other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      dropRecognizeWith: function(g) {
        return h(g, "dropRecognizeWith", this) ? this : (g = Tn(g, this), delete this.simultaneous[g.id], this);
      },
      /**
       * recognizer can only run when an other is failing
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      requireFailure: function(g) {
        if (h(g, "requireFailure", this))
          return this;
        var m = this.requireFail;
        return g = Tn(g, this), $(m, g) === -1 && (m.push(g), g.requireFailure(this)), this;
      },
      /**
       * drop the requireFailure link. it does not remove the link on the other recognizer.
       * @param {Recognizer} otherRecognizer
       * @returns {Recognizer} this
       */
      dropRequireFailure: function(g) {
        if (h(g, "dropRequireFailure", this))
          return this;
        g = Tn(g, this);
        var m = $(this.requireFail, g);
        return m > -1 && this.requireFail.splice(m, 1), this;
      },
      /**
       * has require failures boolean
       * @returns {boolean}
       */
      hasRequireFailures: function() {
        return this.requireFail.length > 0;
      },
      /**
       * if the recognizer can recognize simultaneous with an other recognizer
       * @param {Recognizer} otherRecognizer
       * @returns {Boolean}
       */
      canRecognizeWith: function(g) {
        return !!this.simultaneous[g.id];
      },
      /**
       * You should use `tryEmit` instead of `emit` directly to check
       * that all the needed recognizers has failed before emitting.
       * @param {Object} input
       */
      emit: function(g) {
        var m = this, S = this.state;
        function T(_) {
          m.manager.emit(_, g);
        }
        S < Gt && T(m.options.event + Hc(S)), T(m.options.event), g.additionalEvent && T(g.additionalEvent), S >= Gt && T(m.options.event + Hc(S));
      },
      /**
       * Check that all the require failure recognizers has failed,
       * if true, it emits a gesture event,
       * otherwise, setup the state to FAILED.
       * @param {Object} input
       */
      tryEmit: function(g) {
        if (this.canEmit())
          return this.emit(g);
        this.state = yt;
      },
      /**
       * can we emit?
       * @returns {boolean}
       */
      canEmit: function() {
        for (var g = 0; g < this.requireFail.length; ) {
          if (!(this.requireFail[g].state & (yt | En)))
            return !1;
          g++;
        }
        return !0;
      },
      /**
       * update the recognizer
       * @param {Object} inputData
       */
      recognize: function(g) {
        var m = p({}, g);
        if (!P(this.options.enable, [this, m])) {
          this.reset(), this.state = yt;
          return;
        }
        this.state & (At | Di | yt) && (this.state = En), this.state = this.process(m), this.state & (et | Br | Gt | Di) && this.tryEmit(m);
      },
      /**
       * return the state of the recognizer
       * the actual recognizing happens in this method
       * @virtual
       * @param {Object} inputData
       * @returns {Const} STATE
       */
      process: function(g) {
      },
      // jshint ignore:line
      /**
       * return the preferred touch-action
       * @virtual
       * @returns {Array}
       */
      getTouchAction: function() {
      },
      /**
       * called when the gesture isn't allowed to recognize
       * like when another is being recognized or it is disabled
       * @virtual
       */
      reset: function() {
      }
    };
    function Hc(g) {
      return g & Di ? "cancel" : g & Gt ? "end" : g & Br ? "move" : g & et ? "start" : "";
    }
    function Wc(g) {
      return g == Je ? "down" : g == De ? "up" : g == Z ? "left" : g == Le ? "right" : "";
    }
    function Tn(g, m) {
      var S = m.manager;
      return S ? S.get(g) : g;
    }
    function st() {
      Rt.apply(this, arguments);
    }
    x(st, Rt, {
      /**
       * @namespace
       * @memberof AttrRecognizer
       */
      defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
      },
      /**
       * Used to check if it the recognizer receives valid input, like input.distance > 10.
       * @memberof AttrRecognizer
       * @param {Object} input
       * @returns {Boolean} recognized
       */
      attrTest: function(g) {
        var m = this.options.pointers;
        return m === 0 || g.pointers.length === m;
      },
      /**
       * Process the input and return the state for the recognizer
       * @memberof AttrRecognizer
       * @param {Object} input
       * @returns {*} State
       */
      process: function(g) {
        var m = this.state, S = g.eventType, T = m & (et | Br), _ = this.attrTest(g);
        return T && (S & ae || !_) ? m | Di : T || _ ? S & le ? m | Gt : m & et ? m | Br : et : yt;
      }
    });
    function Pn() {
      st.apply(this, arguments), this.pX = null, this.pY = null;
    }
    x(Pn, st, {
      /**
       * @namespace
       * @memberof PanRecognizer
       */
      defaults: {
        event: "pan",
        threshold: 10,
        pointers: 1,
        direction: vt
      },
      getTouchAction: function() {
        var g = this.options.direction, m = [];
        return g & Be && m.push(Li), g & Ne && m.push(Mi), m;
      },
      directionTest: function(g) {
        var m = this.options, S = !0, T = g.distance, _ = g.direction, L = g.deltaX, H = g.deltaY;
        return _ & m.direction || (m.direction & Be ? (_ = L === 0 ? mt : L < 0 ? Z : Le, S = L != this.pX, T = Math.abs(g.deltaX)) : (_ = H === 0 ? mt : H < 0 ? De : Je, S = H != this.pY, T = Math.abs(g.deltaY))), g.direction = _, S && T > m.threshold && _ & m.direction;
      },
      attrTest: function(g) {
        return st.prototype.attrTest.call(this, g) && (this.state & et || !(this.state & et) && this.directionTest(g));
      },
      emit: function(g) {
        this.pX = g.deltaX, this.pY = g.deltaY;
        var m = Wc(g.direction);
        m && (g.additionalEvent = this.options.event + m), this._super.emit.call(this, g);
      }
    });
    function ts() {
      st.apply(this, arguments);
    }
    x(ts, st, {
      /**
       * @namespace
       * @memberof PinchRecognizer
       */
      defaults: {
        event: "pinch",
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function() {
        return [sr];
      },
      attrTest: function(g) {
        return this._super.attrTest.call(this, g) && (Math.abs(g.scale - 1) > this.options.threshold || this.state & et);
      },
      emit: function(g) {
        if (g.scale !== 1) {
          var m = g.scale < 1 ? "in" : "out";
          g.additionalEvent = this.options.event + m;
        }
        this._super.emit.call(this, g);
      }
    });
    function rs() {
      Rt.apply(this, arguments), this._timer = null, this._input = null;
    }
    x(rs, Rt, {
      /**
       * @namespace
       * @memberof PressRecognizer
       */
      defaults: {
        event: "press",
        pointers: 1,
        time: 251,
        // minimal time of the pointer to be pressed
        threshold: 9
        // a minimal movement is ok, but keep it low
      },
      getTouchAction: function() {
        return [Vc];
      },
      process: function(g) {
        var m = this.options, S = g.pointers.length === m.pointers, T = g.distance < m.threshold, _ = g.deltaTime > m.time;
        if (this._input = g, !T || !S || g.eventType & (le | ae) && !_)
          this.reset();
        else if (g.eventType & ve)
          this.reset(), this._timer = d(function() {
            this.state = At, this.tryEmit();
          }, m.time, this);
        else if (g.eventType & le)
          return At;
        return yt;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function(g) {
        this.state === At && (g && g.eventType & le ? this.manager.emit(this.options.event + "up", g) : (this._input.timeStamp = u(), this.manager.emit(this.options.event, this._input)));
      }
    });
    function is() {
      st.apply(this, arguments);
    }
    x(is, st, {
      /**
       * @namespace
       * @memberof RotateRecognizer
       */
      defaults: {
        event: "rotate",
        threshold: 0,
        pointers: 2
      },
      getTouchAction: function() {
        return [sr];
      },
      attrTest: function(g) {
        return this._super.attrTest.call(this, g) && (Math.abs(g.rotation) > this.options.threshold || this.state & et);
      }
    });
    function ns() {
      st.apply(this, arguments);
    }
    x(ns, st, {
      /**
       * @namespace
       * @memberof SwipeRecognizer
       */
      defaults: {
        event: "swipe",
        threshold: 10,
        velocity: 0.3,
        direction: Be | Ne,
        pointers: 1
      },
      getTouchAction: function() {
        return Pn.prototype.getTouchAction.call(this);
      },
      attrTest: function(g) {
        var m = this.options.direction, S;
        return m & (Be | Ne) ? S = g.overallVelocity : m & Be ? S = g.overallVelocityX : m & Ne && (S = g.overallVelocityY), this._super.attrTest.call(this, g) && m & g.offsetDirection && g.distance > this.options.threshold && g.maxPointers == this.options.pointers && c(S) > this.options.velocity && g.eventType & le;
      },
      emit: function(g) {
        var m = Wc(g.offsetDirection);
        m && this.manager.emit(this.options.event + m, g), this.manager.emit(this.options.event, g);
      }
    });
    function On() {
      Rt.apply(this, arguments), this.pTime = !1, this.pCenter = !1, this._timer = null, this._input = null, this.count = 0;
    }
    x(On, Rt, {
      /**
       * @namespace
       * @memberof PinchRecognizer
       */
      defaults: {
        event: "tap",
        pointers: 1,
        taps: 1,
        interval: 300,
        // max time between the multi-tap taps
        time: 250,
        // max time of the pointer to be down (like finger on the screen)
        threshold: 9,
        // a minimal movement is ok, but keep it low
        posThreshold: 10
        // a multi-tap can be a bit off the initial position
      },
      getTouchAction: function() {
        return [Ja];
      },
      process: function(g) {
        var m = this.options, S = g.pointers.length === m.pointers, T = g.distance < m.threshold, _ = g.deltaTime < m.time;
        if (this.reset(), g.eventType & ve && this.count === 0)
          return this.failTimeout();
        if (T && _ && S) {
          if (g.eventType != le)
            return this.failTimeout();
          var L = this.pTime ? g.timeStamp - this.pTime < m.interval : !0, H = !this.pCenter || _t(this.pCenter, g.center) < m.posThreshold;
          this.pTime = g.timeStamp, this.pCenter = g.center, !H || !L ? this.count = 1 : this.count += 1, this._input = g;
          var Ee = this.count % m.taps;
          if (Ee === 0)
            return this.hasRequireFailures() ? (this._timer = d(function() {
              this.state = At, this.tryEmit();
            }, m.interval, this), et) : At;
        }
        return yt;
      },
      failTimeout: function() {
        return this._timer = d(function() {
          this.state = yt;
        }, this.options.interval, this), yt;
      },
      reset: function() {
        clearTimeout(this._timer);
      },
      emit: function() {
        this.state == At && (this._input.tapCount = this.count, this.manager.emit(this.options.event, this._input));
      }
    });
    function Mt(g, m) {
      return m = m || {}, m.recognizers = O(m.recognizers, Mt.defaults.preset), new as(g, m);
    }
    Mt.VERSION = "2.0.7", Mt.defaults = {
      /**
       * set if DOM events are being triggered.
       * But this is slower and unused by simple implementations, so disabled by default.
       * @type {Boolean}
       * @default false
       */
      domEvents: !1,
      /**
       * The value for the touchAction property/fallback.
       * When set to `compute` it will magically set the correct value based on the added recognizers.
       * @type {String}
       * @default compute
       */
      touchAction: Uc,
      /**
       * @type {Boolean}
       * @default true
       */
      enable: !0,
      /**
       * EXPERIMENTAL FEATURE -- can be removed/changed
       * Change the parent input target element.
       * If Null, then it is being set the to main element.
       * @type {Null|EventTarget}
       * @default null
       */
      inputTarget: null,
      /**
       * force an input class
       * @type {Null|Function}
       * @default null
       */
      inputClass: null,
      /**
       * Default recognizer setup when calling `Hammer()`
       * When creating a new Manager these will be skipped.
       * @type {Array}
       */
      preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [is, { enable: !1 }],
        [ts, { enable: !1 }, ["rotate"]],
        [ns, { direction: Be }],
        [Pn, { direction: Be }, ["swipe"]],
        [On],
        [On, { event: "doubletap", taps: 2 }, ["tap"]],
        [rs]
      ],
      /**
       * Some CSS properties can be used to improve the working of Hammer.
       * Add them to this method and they will be set when creating a new Manager.
       * @namespace
       */
      cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: "none",
        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: "none",
        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: "none",
        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: "none",
        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: "none",
        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: "rgba(0,0,0,0)"
      }
    };
    var g0 = 1, Gc = 2;
    function as(g, m) {
      this.options = p({}, Mt.defaults, m || {}), this.options.inputTarget = this.options.inputTarget || g, this.handlers = {}, this.session = {}, this.recognizers = [], this.oldCssProps = {}, this.element = g, this.input = Ct(this), this.touchAction = new es(this, this.options.touchAction), Yc(this, !0), f(this.options.recognizers, function(S) {
        var T = this.add(new S[0](S[1]));
        S[2] && T.recognizeWith(S[2]), S[3] && T.requireFailure(S[3]);
      }, this);
    }
    as.prototype = {
      /**
       * set options
       * @param {Object} options
       * @returns {Manager}
       */
      set: function(g) {
        return p(this.options, g), g.touchAction && this.touchAction.update(), g.inputTarget && (this.input.destroy(), this.input.target = g.inputTarget, this.input.init()), this;
      },
      /**
       * stop recognizing for this session.
       * This session will be discarded, when a new [input]start event is fired.
       * When forced, the recognizer cycle is stopped immediately.
       * @param {Boolean} [force]
       */
      stop: function(g) {
        this.session.stopped = g ? Gc : g0;
      },
      /**
       * run the recognizers!
       * called by the inputHandler function on every movement of the pointers (touches)
       * it walks through all the recognizers and tries to detect the gesture that is being made
       * @param {Object} inputData
       */
      recognize: function(g) {
        var m = this.session;
        if (!m.stopped) {
          this.touchAction.preventDefaults(g);
          var S, T = this.recognizers, _ = m.curRecognizer;
          (!_ || _ && _.state & At) && (_ = m.curRecognizer = null);
          for (var L = 0; L < T.length; )
            S = T[L], m.stopped !== Gc && // 1
            (!_ || S == _ || // 2
            S.canRecognizeWith(_)) ? S.recognize(g) : S.reset(), !_ && S.state & (et | Br | Gt) && (_ = m.curRecognizer = S), L++;
        }
      },
      /**
       * get a recognizer by its event name.
       * @param {Recognizer|String} recognizer
       * @returns {Recognizer|Null}
       */
      get: function(g) {
        if (g instanceof Rt)
          return g;
        for (var m = this.recognizers, S = 0; S < m.length; S++)
          if (m[S].options.event == g)
            return m[S];
        return null;
      },
      /**
       * add a recognizer to the manager
       * existing recognizers with the same event name will be removed
       * @param {Recognizer} recognizer
       * @returns {Recognizer|Manager}
       */
      add: function(g) {
        if (h(g, "add", this))
          return this;
        var m = this.get(g.options.event);
        return m && this.remove(m), this.recognizers.push(g), g.manager = this, this.touchAction.update(), g;
      },
      /**
       * remove a recognizer by name or instance
       * @param {Recognizer|String} recognizer
       * @returns {Manager}
       */
      remove: function(g) {
        if (h(g, "remove", this))
          return this;
        if (g = this.get(g), g) {
          var m = this.recognizers, S = $(m, g);
          S !== -1 && (m.splice(S, 1), this.touchAction.update());
        }
        return this;
      },
      /**
       * bind event
       * @param {String} events
       * @param {Function} handler
       * @returns {EventEmitter} this
       */
      on: function(g, m) {
        if (g !== n && m !== n) {
          var S = this.handlers;
          return f(W(g), function(T) {
            S[T] = S[T] || [], S[T].push(m);
          }), this;
        }
      },
      /**
       * unbind event, leave emit blank to remove all handlers
       * @param {String} events
       * @param {Function} [handler]
       * @returns {EventEmitter} this
       */
      off: function(g, m) {
        if (g !== n) {
          var S = this.handlers;
          return f(W(g), function(T) {
            m ? S[T] && S[T].splice($(S[T], m), 1) : delete S[T];
          }), this;
        }
      },
      /**
       * emit event to the listeners
       * @param {String} event
       * @param {Object} data
       */
      emit: function(g, m) {
        this.options.domEvents && p0(g, m);
        var S = this.handlers[g] && this.handlers[g].slice();
        if (!(!S || !S.length)) {
          m.type = g, m.preventDefault = function() {
            m.srcEvent.preventDefault();
          };
          for (var T = 0; T < S.length; )
            S[T](m), T++;
        }
      },
      /**
       * destroy the manager and unbinds all events
       * it doesn't unbind dom events, that is the user own responsibility
       */
      destroy: function() {
        this.element && Yc(this, !1), this.handlers = {}, this.session = {}, this.input.destroy(), this.element = null;
      }
    };
    function Yc(g, m) {
      var S = g.element;
      if (S.style) {
        var T;
        f(g.options.cssProps, function(_, L) {
          T = U(S.style, L), m ? (g.oldCssProps[T] = S.style[T], S.style[T] = _) : S.style[T] = g.oldCssProps[T] || "";
        }), m || (g.oldCssProps = {});
      }
    }
    function p0(g, m) {
      var S = r.createEvent("Event");
      S.initEvent(g, !0, !0), S.gesture = m, m.target.dispatchEvent(S);
    }
    p(Mt, {
      INPUT_START: ve,
      INPUT_MOVE: Qe,
      INPUT_END: le,
      INPUT_CANCEL: ae,
      STATE_POSSIBLE: En,
      STATE_BEGAN: et,
      STATE_CHANGED: Br,
      STATE_ENDED: Gt,
      STATE_RECOGNIZED: At,
      STATE_CANCELLED: Di,
      STATE_FAILED: yt,
      DIRECTION_NONE: mt,
      DIRECTION_LEFT: Z,
      DIRECTION_RIGHT: Le,
      DIRECTION_UP: De,
      DIRECTION_DOWN: Je,
      DIRECTION_HORIZONTAL: Be,
      DIRECTION_VERTICAL: Ne,
      DIRECTION_ALL: vt,
      Manager: as,
      Input: ye,
      TouchAction: es,
      TouchInput: Sn,
      MouseInput: Wt,
      PointerEventInput: Za,
      TouchMouseInput: Qa,
      SingleTouchInput: kc,
      Recognizer: Rt,
      AttrRecognizer: st,
      Tap: On,
      Pan: Pn,
      Swipe: ns,
      Pinch: ts,
      Rotate: is,
      Press: rs,
      on: A,
      off: I,
      each: f,
      merge: y,
      extend: b,
      assign: p,
      inherit: x,
      bindFn: w,
      prefixed: U
    });
    var m0 = typeof e < "u" ? e : typeof self < "u" ? self : {};
    m0.Hammer = Mt, typeof n == "function" && n.amd ? n(function() {
      return Mt;
    }) : t.exports ? t.exports = Mt : e[i] = Mt;
  })(window, document, "Hammer");
})(nf);
var wm = nf.exports;
const vr = /* @__PURE__ */ ln(wm);
function Em() {
  return af().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function af() {
  return typeof navigator < "u" && typeof window < "u" ? window : typeof globalThis < "u" ? globalThis : {};
}
const Tm = typeof Proxy == "function", Pm = "devtools-plugin:setup", Om = "plugin:settings:set";
let Fr, ho;
function Cm() {
  var t;
  return Fr !== void 0 || (typeof window < "u" && window.performance ? (Fr = !0, ho = window.performance) : typeof globalThis < "u" && (!((t = globalThis.perf_hooks) === null || t === void 0) && t.performance) ? (Fr = !0, ho = globalThis.perf_hooks.performance) : Fr = !1), Fr;
}
function Im() {
  return Cm() ? ho.now() : Date.now();
}
class _m {
  constructor(e, r) {
    this.target = null, this.targetQueue = [], this.onQueue = [], this.plugin = e, this.hook = r;
    const i = {};
    if (e.settings)
      for (const s in e.settings) {
        const o = e.settings[s];
        i[s] = o.defaultValue;
      }
    const n = `__vue-devtools-plugin-settings__${e.id}`;
    let a = Object.assign({}, i);
    try {
      const s = localStorage.getItem(n), o = JSON.parse(s);
      Object.assign(a, o);
    } catch {
    }
    this.fallbacks = {
      getSettings() {
        return a;
      },
      setSettings(s) {
        try {
          localStorage.setItem(n, JSON.stringify(s));
        } catch {
        }
        a = s;
      },
      now() {
        return Im();
      }
    }, r && r.on(Om, (s, o) => {
      s === this.plugin.id && this.fallbacks.setSettings(o);
    }), this.proxiedOn = new Proxy({}, {
      get: (s, o) => this.target ? this.target.on[o] : (...l) => {
        this.onQueue.push({
          method: o,
          args: l
        });
      }
    }), this.proxiedTarget = new Proxy({}, {
      get: (s, o) => this.target ? this.target[o] : o === "on" ? this.proxiedOn : Object.keys(this.fallbacks).includes(o) ? (...l) => (this.targetQueue.push({
        method: o,
        args: l,
        resolve: () => {
        }
      }), this.fallbacks[o](...l)) : (...l) => new Promise((c) => {
        this.targetQueue.push({
          method: o,
          args: l,
          resolve: c
        });
      })
    });
  }
  async setRealTarget(e) {
    this.target = e;
    for (const r of this.onQueue)
      this.target.on[r.method](...r.args);
    for (const r of this.targetQueue)
      r.resolve(await this.target[r.method](...r.args));
  }
}
function Am(t, e) {
  const r = t, i = af(), n = Em(), a = Tm && r.enableEarlyProxy;
  if (n && (i.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !a))
    n.emit(Pm, t, e);
  else {
    const s = a ? new _m(r, n) : null;
    (i.__VUE_DEVTOOLS_PLUGINS__ = i.__VUE_DEVTOOLS_PLUGINS__ || []).push({
      pluginDescriptor: r,
      setupFn: e,
      proxy: s
    }), s && e(s.proxiedTarget);
  }
}
/*!
 * vuex v4.0.2
 * (c) 2021 Evan You
 * @license MIT
 */
var Rm = "store";
function Cr(t, e) {
  Object.keys(t).forEach(function(r) {
    return e(t[r], r);
  });
}
function sf(t) {
  return t !== null && typeof t == "object";
}
function Mm(t) {
  return t && typeof t.then == "function";
}
function gt(t, e) {
  if (!t)
    throw new Error("[vuex] " + e);
}
function Lm(t, e) {
  return function() {
    return t(e);
  };
}
function of(t, e, r) {
  return e.indexOf(t) < 0 && (r && r.prepend ? e.unshift(t) : e.push(t)), function() {
    var i = e.indexOf(t);
    i > -1 && e.splice(i, 1);
  };
}
function lf(t, e) {
  t._actions = /* @__PURE__ */ Object.create(null), t._mutations = /* @__PURE__ */ Object.create(null), t._wrappedGetters = /* @__PURE__ */ Object.create(null), t._modulesNamespaceMap = /* @__PURE__ */ Object.create(null);
  var r = t.state;
  Oa(t, r, [], t._modules.root, !0), Pl(t, r, e);
}
function Pl(t, e, r) {
  var i = t._state;
  t.getters = {}, t._makeLocalGettersCache = /* @__PURE__ */ Object.create(null);
  var n = t._wrappedGetters, a = {};
  Cr(n, function(s, o) {
    a[o] = Lm(s, t), Object.defineProperty(t.getters, o, {
      // TODO: use `computed` when it's possible. at the moment we can't due to
      // https://github.com/vuejs/vuex/pull/1883
      get: function() {
        return a[o]();
      },
      enumerable: !0
      // for local getters
    });
  }), t._state = v0({
    data: e
  }), t.strict && zm(t), i && r && t._withCommit(function() {
    i.data = null;
  });
}
function Oa(t, e, r, i, n) {
  var a = !r.length, s = t._modules.getNamespace(r);
  if (i.namespaced && (t._modulesNamespaceMap[s] && process.env.NODE_ENV !== "production" && console.error("[vuex] duplicate namespace " + s + " for the namespaced module " + r.join("/")), t._modulesNamespaceMap[s] = i), !a && !n) {
    var o = Ol(e, r.slice(0, -1)), l = r[r.length - 1];
    t._withCommit(function() {
      process.env.NODE_ENV !== "production" && l in o && console.warn(
        '[vuex] state field "' + l + '" was overridden by a module with the same name at "' + r.join(".") + '"'
      ), o[l] = i.state;
    });
  }
  var c = i.context = Dm(t, s, r);
  i.forEachMutation(function(u, d) {
    var h = s + d;
    Nm(t, h, u, c);
  }), i.forEachAction(function(u, d) {
    var h = u.root ? d : s + d, f = u.handler || u;
    jm(t, h, f, c);
  }), i.forEachGetter(function(u, d) {
    var h = s + d;
    km(t, h, u, c);
  }), i.forEachChild(function(u, d) {
    Oa(t, e, r.concat(d), u, n);
  });
}
function Dm(t, e, r) {
  var i = e === "", n = {
    dispatch: i ? t.dispatch : function(a, s, o) {
      var l = oa(a, s, o), c = l.payload, u = l.options, d = l.type;
      if ((!u || !u.root) && (d = e + d, process.env.NODE_ENV !== "production" && !t._actions[d])) {
        console.error("[vuex] unknown local action type: " + l.type + ", global type: " + d);
        return;
      }
      return t.dispatch(d, c);
    },
    commit: i ? t.commit : function(a, s, o) {
      var l = oa(a, s, o), c = l.payload, u = l.options, d = l.type;
      if ((!u || !u.root) && (d = e + d, process.env.NODE_ENV !== "production" && !t._mutations[d])) {
        console.error("[vuex] unknown local mutation type: " + l.type + ", global type: " + d);
        return;
      }
      t.commit(d, c, u);
    }
  };
  return Object.defineProperties(n, {
    getters: {
      get: i ? function() {
        return t.getters;
      } : function() {
        return cf(t, e);
      }
    },
    state: {
      get: function() {
        return Ol(t.state, r);
      }
    }
  }), n;
}
function cf(t, e) {
  if (!t._makeLocalGettersCache[e]) {
    var r = {}, i = e.length;
    Object.keys(t.getters).forEach(function(n) {
      if (n.slice(0, i) === e) {
        var a = n.slice(i);
        Object.defineProperty(r, a, {
          get: function() {
            return t.getters[n];
          },
          enumerable: !0
        });
      }
    }), t._makeLocalGettersCache[e] = r;
  }
  return t._makeLocalGettersCache[e];
}
function Nm(t, e, r, i) {
  var n = t._mutations[e] || (t._mutations[e] = []);
  n.push(function(s) {
    r.call(t, i.state, s);
  });
}
function jm(t, e, r, i) {
  var n = t._actions[e] || (t._actions[e] = []);
  n.push(function(s) {
    var o = r.call(t, {
      dispatch: i.dispatch,
      commit: i.commit,
      getters: i.getters,
      state: i.state,
      rootGetters: t.getters,
      rootState: t.state
    }, s);
    return Mm(o) || (o = Promise.resolve(o)), t._devtoolHook ? o.catch(function(l) {
      throw t._devtoolHook.emit("vuex:error", l), l;
    }) : o;
  });
}
function km(t, e, r, i) {
  if (t._wrappedGetters[e]) {
    process.env.NODE_ENV !== "production" && console.error("[vuex] duplicate getter key: " + e);
    return;
  }
  t._wrappedGetters[e] = function(a) {
    return r(
      i.state,
      // local state
      i.getters,
      // local getters
      a.state,
      // root state
      a.getters
      // root getters
    );
  };
}
function zm(t) {
  bl(function() {
    return t._state.data;
  }, function() {
    process.env.NODE_ENV !== "production" && gt(t._committing, "do not mutate vuex store state outside mutation handlers.");
  }, { deep: !0, flush: "sync" });
}
function Ol(t, e) {
  return e.reduce(function(r, i) {
    return r[i];
  }, t);
}
function oa(t, e, r) {
  return sf(t) && t.type && (r = e, e = t, t = t.type), process.env.NODE_ENV !== "production" && gt(typeof t == "string", "expects string as the type, but found " + typeof t + "."), { type: t, payload: e, options: r };
}
var Bm = "vuex bindings", Zc = "vuex:mutations", ss = "vuex:actions", $r = "vuex", Fm = 0;
function $m(t, e) {
  Am(
    {
      id: "org.vuejs.vuex",
      app: t,
      label: "Vuex",
      homepage: "https://next.vuex.vuejs.org/",
      logo: "https://vuejs.org/images/icons/favicon-96x96.png",
      packageName: "vuex",
      componentStateTypes: [Bm]
    },
    function(r) {
      r.addTimelineLayer({
        id: Zc,
        label: "Vuex Mutations",
        color: Qc
      }), r.addTimelineLayer({
        id: ss,
        label: "Vuex Actions",
        color: Qc
      }), r.addInspector({
        id: $r,
        label: "Vuex",
        icon: "storage",
        treeFilterPlaceholder: "Filter stores..."
      }), r.on.getInspectorTree(function(i) {
        if (i.app === t && i.inspectorId === $r)
          if (i.filter) {
            var n = [];
            ff(n, e._modules.root, i.filter, ""), i.rootNodes = n;
          } else
            i.rootNodes = [
              hf(e._modules.root, "")
            ];
      }), r.on.getInspectorState(function(i) {
        if (i.app === t && i.inspectorId === $r) {
          var n = i.nodeId;
          cf(e, n), i.state = Hm(
            Gm(e._modules, n),
            n === "root" ? e.getters : e._makeLocalGettersCache,
            n
          );
        }
      }), r.on.editInspectorState(function(i) {
        if (i.app === t && i.inspectorId === $r) {
          var n = i.nodeId, a = i.path;
          n !== "root" && (a = n.split("/").filter(Boolean).concat(a)), e._withCommit(function() {
            i.set(e._state.data, a, i.state.value);
          });
        }
      }), e.subscribe(function(i, n) {
        var a = {};
        i.payload && (a.payload = i.payload), a.state = n, r.notifyComponentUpdate(), r.sendInspectorTree($r), r.sendInspectorState($r), r.addTimelineEvent({
          layerId: Zc,
          event: {
            time: Date.now(),
            title: i.type,
            data: a
          }
        });
      }), e.subscribeAction({
        before: function(i, n) {
          var a = {};
          i.payload && (a.payload = i.payload), i._id = Fm++, i._time = Date.now(), a.state = n, r.addTimelineEvent({
            layerId: ss,
            event: {
              time: i._time,
              title: i.type,
              groupId: i._id,
              subtitle: "start",
              data: a
            }
          });
        },
        after: function(i, n) {
          var a = {}, s = Date.now() - i._time;
          a.duration = {
            _custom: {
              type: "duration",
              display: s + "ms",
              tooltip: "Action duration",
              value: s
            }
          }, i.payload && (a.payload = i.payload), a.state = n, r.addTimelineEvent({
            layerId: ss,
            event: {
              time: Date.now(),
              title: i.type,
              groupId: i._id,
              subtitle: "end",
              data: a
            }
          });
        }
      });
    }
  );
}
var Qc = 8702998, Um = 6710886, Vm = 16777215, uf = {
  label: "namespaced",
  textColor: Vm,
  backgroundColor: Um
};
function df(t) {
  return t && t !== "root" ? t.split("/").slice(-2, -1)[0] : "Root";
}
function hf(t, e) {
  return {
    id: e || "root",
    // all modules end with a `/`, we want the last segment only
    // cart/ -> cart
    // nested/cart/ -> cart
    label: df(e),
    tags: t.namespaced ? [uf] : [],
    children: Object.keys(t._children).map(
      function(r) {
        return hf(
          t._children[r],
          e + r + "/"
        );
      }
    )
  };
}
function ff(t, e, r, i) {
  i.includes(r) && t.push({
    id: i || "root",
    label: i.endsWith("/") ? i.slice(0, i.length - 1) : i || "Root",
    tags: e.namespaced ? [uf] : []
  }), Object.keys(e._children).forEach(function(n) {
    ff(t, e._children[n], r, i + n + "/");
  });
}
function Hm(t, e, r) {
  e = r === "root" ? e : e[r];
  var i = Object.keys(e), n = {
    state: Object.keys(t.state).map(function(s) {
      return {
        key: s,
        editable: !0,
        value: t.state[s]
      };
    })
  };
  if (i.length) {
    var a = Wm(e);
    n.getters = Object.keys(a).map(function(s) {
      return {
        key: s.endsWith("/") ? df(s) : s,
        editable: !1,
        value: fo(function() {
          return a[s];
        })
      };
    });
  }
  return n;
}
function Wm(t) {
  var e = {};
  return Object.keys(t).forEach(function(r) {
    var i = r.split("/");
    if (i.length > 1) {
      var n = e, a = i.pop();
      i.forEach(function(s) {
        n[s] || (n[s] = {
          _custom: {
            value: {},
            display: s,
            tooltip: "Module",
            abstract: !0
          }
        }), n = n[s]._custom.value;
      }), n[a] = fo(function() {
        return t[r];
      });
    } else
      e[r] = fo(function() {
        return t[r];
      });
  }), e;
}
function Gm(t, e) {
  var r = e.split("/").filter(function(i) {
    return i;
  });
  return r.reduce(
    function(i, n, a) {
      var s = i[n];
      if (!s)
        throw new Error('Missing module "' + n + '" for path "' + e + '".');
      return a === r.length - 1 ? s : s._children;
    },
    e === "root" ? t : t.root._children
  );
}
function fo(t) {
  try {
    return t();
  } catch (e) {
    return e;
  }
}
var pt = function(e, r) {
  this.runtime = r, this._children = /* @__PURE__ */ Object.create(null), this._rawModule = e;
  var i = e.state;
  this.state = (typeof i == "function" ? i() : i) || {};
}, gf = { namespaced: { configurable: !0 } };
gf.namespaced.get = function() {
  return !!this._rawModule.namespaced;
};
pt.prototype.addChild = function(e, r) {
  this._children[e] = r;
};
pt.prototype.removeChild = function(e) {
  delete this._children[e];
};
pt.prototype.getChild = function(e) {
  return this._children[e];
};
pt.prototype.hasChild = function(e) {
  return e in this._children;
};
pt.prototype.update = function(e) {
  this._rawModule.namespaced = e.namespaced, e.actions && (this._rawModule.actions = e.actions), e.mutations && (this._rawModule.mutations = e.mutations), e.getters && (this._rawModule.getters = e.getters);
};
pt.prototype.forEachChild = function(e) {
  Cr(this._children, e);
};
pt.prototype.forEachGetter = function(e) {
  this._rawModule.getters && Cr(this._rawModule.getters, e);
};
pt.prototype.forEachAction = function(e) {
  this._rawModule.actions && Cr(this._rawModule.actions, e);
};
pt.prototype.forEachMutation = function(e) {
  this._rawModule.mutations && Cr(this._rawModule.mutations, e);
};
Object.defineProperties(pt.prototype, gf);
var Ir = function(e) {
  this.register([], e, !1);
};
Ir.prototype.get = function(e) {
  return e.reduce(function(r, i) {
    return r.getChild(i);
  }, this.root);
};
Ir.prototype.getNamespace = function(e) {
  var r = this.root;
  return e.reduce(function(i, n) {
    return r = r.getChild(n), i + (r.namespaced ? n + "/" : "");
  }, "");
};
Ir.prototype.update = function(e) {
  pf([], this.root, e);
};
Ir.prototype.register = function(e, r, i) {
  var n = this;
  i === void 0 && (i = !0), process.env.NODE_ENV !== "production" && mf(e, r);
  var a = new pt(r, i);
  if (e.length === 0)
    this.root = a;
  else {
    var s = this.get(e.slice(0, -1));
    s.addChild(e[e.length - 1], a);
  }
  r.modules && Cr(r.modules, function(o, l) {
    n.register(e.concat(l), o, i);
  });
};
Ir.prototype.unregister = function(e) {
  var r = this.get(e.slice(0, -1)), i = e[e.length - 1], n = r.getChild(i);
  if (!n) {
    process.env.NODE_ENV !== "production" && console.warn(
      "[vuex] trying to unregister module '" + i + "', which is not registered"
    );
    return;
  }
  n.runtime && r.removeChild(i);
};
Ir.prototype.isRegistered = function(e) {
  var r = this.get(e.slice(0, -1)), i = e[e.length - 1];
  return r ? r.hasChild(i) : !1;
};
function pf(t, e, r) {
  if (process.env.NODE_ENV !== "production" && mf(t, r), e.update(r), r.modules)
    for (var i in r.modules) {
      if (!e.getChild(i)) {
        process.env.NODE_ENV !== "production" && console.warn(
          "[vuex] trying to add a new module '" + i + "' on hot reloading, manual reload is needed"
        );
        return;
      }
      pf(
        t.concat(i),
        e.getChild(i),
        r.modules[i]
      );
    }
}
var Jc = {
  assert: function(t) {
    return typeof t == "function";
  },
  expected: "function"
}, Ym = {
  assert: function(t) {
    return typeof t == "function" || typeof t == "object" && typeof t.handler == "function";
  },
  expected: 'function or object with "handler" function'
}, eu = {
  getters: Jc,
  mutations: Jc,
  actions: Ym
};
function mf(t, e) {
  Object.keys(eu).forEach(function(r) {
    if (e[r]) {
      var i = eu[r];
      Cr(e[r], function(n, a) {
        gt(
          i.assert(n),
          Xm(t, r, a, n, i.expected)
        );
      });
    }
  });
}
function Xm(t, e, r, i, n) {
  var a = e + " should be " + n + ' but "' + e + "." + r + '"';
  return t.length > 0 && (a += ' in module "' + t.join(".") + '"'), a += " is " + JSON.stringify(i) + ".", a;
}
var Ke = function t(e) {
  var r = this;
  e === void 0 && (e = {}), process.env.NODE_ENV !== "production" && (gt(typeof Promise < "u", "vuex requires a Promise polyfill in this browser."), gt(this instanceof t, "store must be called with the new operator."));
  var i = e.plugins;
  i === void 0 && (i = []);
  var n = e.strict;
  n === void 0 && (n = !1);
  var a = e.devtools;
  this._committing = !1, this._actions = /* @__PURE__ */ Object.create(null), this._actionSubscribers = [], this._mutations = /* @__PURE__ */ Object.create(null), this._wrappedGetters = /* @__PURE__ */ Object.create(null), this._modules = new Ir(e), this._modulesNamespaceMap = /* @__PURE__ */ Object.create(null), this._subscribers = [], this._makeLocalGettersCache = /* @__PURE__ */ Object.create(null), this._devtools = a;
  var s = this, o = this, l = o.dispatch, c = o.commit;
  this.dispatch = function(h, f) {
    return l.call(s, h, f);
  }, this.commit = function(h, f, v) {
    return c.call(s, h, f, v);
  }, this.strict = n;
  var u = this._modules.root.state;
  Oa(this, u, [], this._modules.root), Pl(this, u), i.forEach(function(d) {
    return d(r);
  });
}, Cl = { state: { configurable: !0 } };
Ke.prototype.install = function(e, r) {
  e.provide(r || Rm, this), e.config.globalProperties.$store = this;
  var i = this._devtools !== void 0 ? this._devtools : process.env.NODE_ENV !== "production" || !1;
  i && $m(e, this);
};
Cl.state.get = function() {
  return this._state.data;
};
Cl.state.set = function(t) {
  process.env.NODE_ENV !== "production" && gt(!1, "use store.replaceState() to explicit replace store state.");
};
Ke.prototype.commit = function(e, r, i) {
  var n = this, a = oa(e, r, i), s = a.type, o = a.payload, l = a.options, c = { type: s, payload: o }, u = this._mutations[s];
  if (!u) {
    process.env.NODE_ENV !== "production" && console.error("[vuex] unknown mutation type: " + s);
    return;
  }
  this._withCommit(function() {
    u.forEach(function(h) {
      h(o);
    });
  }), this._subscribers.slice().forEach(function(d) {
    return d(c, n.state);
  }), process.env.NODE_ENV !== "production" && l && l.silent && console.warn(
    "[vuex] mutation type: " + s + ". Silent option has been removed. Use the filter functionality in the vue-devtools"
  );
};
Ke.prototype.dispatch = function(e, r) {
  var i = this, n = oa(e, r), a = n.type, s = n.payload, o = { type: a, payload: s }, l = this._actions[a];
  if (!l) {
    process.env.NODE_ENV !== "production" && console.error("[vuex] unknown action type: " + a);
    return;
  }
  try {
    this._actionSubscribers.slice().filter(function(u) {
      return u.before;
    }).forEach(function(u) {
      return u.before(o, i.state);
    });
  } catch (u) {
    process.env.NODE_ENV !== "production" && (console.warn("[vuex] error in before action subscribers: "), console.error(u));
  }
  var c = l.length > 1 ? Promise.all(l.map(function(u) {
    return u(s);
  })) : l[0](s);
  return new Promise(function(u, d) {
    c.then(function(h) {
      try {
        i._actionSubscribers.filter(function(f) {
          return f.after;
        }).forEach(function(f) {
          return f.after(o, i.state);
        });
      } catch (f) {
        process.env.NODE_ENV !== "production" && (console.warn("[vuex] error in after action subscribers: "), console.error(f));
      }
      u(h);
    }, function(h) {
      try {
        i._actionSubscribers.filter(function(f) {
          return f.error;
        }).forEach(function(f) {
          return f.error(o, i.state, h);
        });
      } catch (f) {
        process.env.NODE_ENV !== "production" && (console.warn("[vuex] error in error action subscribers: "), console.error(f));
      }
      d(h);
    });
  });
};
Ke.prototype.subscribe = function(e, r) {
  return of(e, this._subscribers, r);
};
Ke.prototype.subscribeAction = function(e, r) {
  var i = typeof e == "function" ? { before: e } : e;
  return of(i, this._actionSubscribers, r);
};
Ke.prototype.watch = function(e, r, i) {
  var n = this;
  return process.env.NODE_ENV !== "production" && gt(typeof e == "function", "store.watch only accepts a function."), bl(function() {
    return e(n.state, n.getters);
  }, r, Object.assign({}, i));
};
Ke.prototype.replaceState = function(e) {
  var r = this;
  this._withCommit(function() {
    r._state.data = e;
  });
};
Ke.prototype.registerModule = function(e, r, i) {
  i === void 0 && (i = {}), typeof e == "string" && (e = [e]), process.env.NODE_ENV !== "production" && (gt(Array.isArray(e), "module path must be a string or an Array."), gt(e.length > 0, "cannot register the root module by using registerModule.")), this._modules.register(e, r), Oa(this, this.state, e, this._modules.get(e), i.preserveState), Pl(this, this.state);
};
Ke.prototype.unregisterModule = function(e) {
  var r = this;
  typeof e == "string" && (e = [e]), process.env.NODE_ENV !== "production" && gt(Array.isArray(e), "module path must be a string or an Array."), this._modules.unregister(e), this._withCommit(function() {
    var i = Ol(r.state, e.slice(0, -1));
    delete i[e[e.length - 1]];
  }), lf(this);
};
Ke.prototype.hasModule = function(e) {
  return typeof e == "string" && (e = [e]), process.env.NODE_ENV !== "production" && gt(Array.isArray(e), "module path must be a string or an Array."), this._modules.isRegistered(e);
};
Ke.prototype.hotUpdate = function(e) {
  this._modules.update(e), lf(this, !0);
};
Ke.prototype._withCommit = function(e) {
  var r = this._committing;
  this._committing = !0, e(), this._committing = r;
};
Object.defineProperties(Ke.prototype, Cl);
var vf = bf(function(t, e) {
  var r = {};
  return process.env.NODE_ENV !== "production" && !_l(e) && console.error("[vuex] mapGetters: mapper parameter must be either an Array or an Object"), yf(e).forEach(function(i) {
    var n = i.key, a = i.val;
    a = t + a, r[n] = function() {
      if (!(t && !xf(this.$store, "mapGetters", t))) {
        if (process.env.NODE_ENV !== "production" && !(a in this.$store.getters)) {
          console.error("[vuex] unknown getter: " + a);
          return;
        }
        return this.$store.getters[a];
      }
    }, r[n].vuex = !0;
  }), r;
}), Il = bf(function(t, e) {
  var r = {};
  return process.env.NODE_ENV !== "production" && !_l(e) && console.error("[vuex] mapActions: mapper parameter must be either an Array or an Object"), yf(e).forEach(function(i) {
    var n = i.key, a = i.val;
    r[n] = function() {
      for (var o = [], l = arguments.length; l--; )
        o[l] = arguments[l];
      var c = this.$store.dispatch;
      if (t) {
        var u = xf(this.$store, "mapActions", t);
        if (!u)
          return;
        c = u.context.dispatch;
      }
      return typeof a == "function" ? a.apply(this, [c].concat(o)) : c.apply(this.$store, [a].concat(o));
    };
  }), r;
});
function yf(t) {
  return _l(t) ? Array.isArray(t) ? t.map(function(e) {
    return { key: e, val: e };
  }) : Object.keys(t).map(function(e) {
    return { key: e, val: t[e] };
  }) : [];
}
function _l(t) {
  return Array.isArray(t) || sf(t);
}
function bf(t) {
  return function(e, r) {
    return typeof e != "string" ? (r = e, e = "") : e.charAt(e.length - 1) !== "/" && (e += "/"), t(e, r);
  };
}
function xf(t, e, r) {
  var i = t._modulesNamespaceMap[r];
  return process.env.NODE_ENV !== "production" && !i && console.error("[vuex] module namespace not found in " + e + "(): " + r), i;
}
const qm = "warningImageTooSmall", Sf = "en-US", Km = "de-DE", Zm = "fr-FR", ti = 1, Al = 2, Qm = "cancel", Jm = "reset", wf = {
  [ti]: {
    name: "zoom",
    svg: `<svg class="w-5 h-5" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_205_15)">
              <path
                  d="M98.861 93.363L74.4561 68.9587C80.5223 61.6638 84.177 52.2965 84.177 42.0898C84.177 18.8814 65.2961 0 42.0887 0C18.8808 0 -0.00012207 18.8814 -0.00012207 42.0898C-0.00012207 65.2967 18.8808 84.1766 42.0887 84.1766C52.2948 84.1766 61.6627 80.5224 68.9575 74.4562L93.3629 98.8611C94.1218 99.6205 95.1171 100 96.1119 100C97.1067 100 98.102 99.6205 98.8615 98.8611C100.38 97.3427 100.38 94.8814 98.861 93.363ZM7.77577 42.0898C7.77577 23.169 23.1684 7.77589 42.0887 7.77589C61.0085 7.77589 76.4006 23.169 76.4006 42.0898C76.4006 61.0091 61.0085 76.4007 42.0887 76.4007C23.1684 76.4007 7.77577 61.0091 7.77577 42.0898Z"
                  fill="#7D7E82"/>
            </g>
          </svg>`
  },
  [Al]: {
    name: "crop",
    svg: `<svg class="w-5 h-5" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M27.7778 72.2222V0H16.6667V16.6667H0V27.7778H16.6667V72.2222C16.6667 78.3333 21.6611 83.3333 27.7778 83.3333H72.2222V100H83.3333V83.3333H100V72.2222H27.7778ZM72.2222 66.6667H83.3333V27.7778C83.3333 21.6667 78.3389 16.6667 72.2222 16.6667H33.3333V27.7778H72.2222V66.6667Z"
                fill="#7D7E82"/>
          </svg>`
  }
  // [EDIT_TOOL_ROTATE_CLOCKWISE]: {
  //     name: 'rotate',
  //     svg: `<svg class="w-5 h-5" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
  //         <g clip-path="url(#clip0_205_17)">
  //           <path
  //               d="M3.85712 92.8572V50C3.85929 48.1063 4.61254 46.2907 5.95161 44.9517C7.29069 43.6126 9.10624 42.8594 11 42.8572H53.8571C55.7508 42.8594 57.5664 43.6126 58.9055 44.9517C60.2445 46.2907 60.9978 48.1063 61 50V92.8572C60.9978 94.7509 60.2445 96.5665 58.9055 97.9055C57.5664 99.2446 55.7508 99.9979 53.8571 100H11C9.10624 99.9979 7.29069 99.2446 5.95161 97.9055C4.61254 96.5665 3.85929 94.7509 3.85712 92.8572V92.8572Z"
  //               fill="#7D7E82"/>
  //           <path
  //               d="M57.4287 0L62.4644 5.03571L53.2501 14.2857H71.7144C78.3425 14.2931 84.6971 16.9294 89.3839 21.6162C94.0707 26.303 96.707 32.6576 96.7144 39.2857V57.1428H89.5715V39.2857C89.5661 34.5514 87.683 30.0125 84.3353 26.6648C80.9876 23.3171 76.4487 21.434 71.7144 21.4286H53.2501L62.4644 30.6786L57.4287 35.7143L39.5715 17.8571L57.4287 0Z"
  //               fill="#7D7E82"/>
  //         </g>
  //       </svg>`
  // },
  // [EDIT_TOOL_FLIP_HORIZONTAL]: {
  //     name: 'flip',
  //     svg: `<svg class="w-5 h-5" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
  //         <g clip-path="url(#clip0_205_18)">
  //           <path
  //               d="M37.8114 2.5941L0.313374 94.256C-0.808053 96.997 1.20805 100 4.16962 100H41.6677C43.9687 100 45.8341 98.1347 45.8341 95.8336V4.17156C45.8341 -0.397737 39.5414 -1.63517 37.8114 2.5941ZM37.5013 91.667H10.3757L37.5013 25.3601V91.667Z"
  //               fill="#7D7E82"/>
  //           <path
  //               d="M99.6871 94.2558L62.189 2.59396C60.459 -1.63512 54.1664 -0.397685 54.1664 4.17141V95.8333C54.1664 98.1343 56.0317 99.9997 58.3328 99.9997H95.8308C98.7924 99.9999 100.809 96.9969 99.6871 94.2558ZM62.4993 91.6669V25.36L89.6249 91.6669H62.4993V91.6669Z"
  //               fill="#7D7E82"/>
  //           <path d="M59.9989 95.9999V13.9999L93.9989 95.9999H59.9989Z" fill="#7D7E82" stroke="#7D7E82"/>
  //         </g>
  //       </svg>`
  // }
}, ev = {
  name: "Pane",
  props: {
    image: {
      type: Object,
      default: null,
      validator: (t) => t.hasOwnProperty("width") && t.hasOwnProperty("height") && t.hasOwnProperty("thumbPath") && t.hasOwnProperty("id")
    },
    width: {
      type: Number,
      required: !0
    },
    height: {
      type: Number,
      required: !0
    },
    x: {
      type: Number,
      required: !0
    },
    y: {
      type: Number,
      required: !0
    },
    events: {
      type: Boolean,
      default: !0
    },
    placeholder: {
      type: Boolean,
      default: !0
    },
    renderMode: {
      type: Boolean,
      default: !1
    },
    name: {
      type: String,
      default: "pane_1"
    },
    productSlug: {
      type: String,
      required: !0
    },
    selectedEditToolId: {
      type: Number,
      default: null
    },
    imageEditTrigger: {
      type: String,
      default: null
    },
    locale: {
      type: String,
      default: Sf
    },
    featureFlags: {
      type: Object,
      default: () => {
      }
    },
    tileIndex: {
      type: Number,
      default: null
    },
    disableZoomCrop: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["click"],
  data() {
    var t, e, r, i, n, a, s, o;
    return {
      hammer: null,
      svgPoint: null,
      panning: !1,
      currentWidth: 100,
      currentHeight: 100,
      currentX: 0,
      currentXStart: 0,
      currentY: 0,
      currentYStart: 0,
      currentTransform: "",
      scaleStart: 1,
      currentRotate: ((e = (t = this.image) == null ? void 0 : t.transform) == null ? void 0 : e.rotate) || 0,
      currentRotateStart: 0,
      currentThumb: "",
      currentOriginal: "",
      currentOriginalWidth: 0,
      currentOriginalHeight: 0,
      currentScale: ((i = (r = this.image) == null ? void 0 : r.transform) == null ? void 0 : i.scale) || 1,
      currentTranslateX: ((a = (n = this.image) == null ? void 0 : n.transform) == null ? void 0 : a.x) || 0,
      currentTranslateY: ((o = (s = this.image) == null ? void 0 : s.transform) == null ? void 0 : o.y) || 0,
      preEditPosition: null,
      minScale: 1,
      maxScale: 50,
      pan: null,
      pinch: null,
      injectedScale: this.imageEdits ? this.imageEdits.scale : null,
      injectedRotate: this.rotate ? this.rotate : null
    };
  },
  inject: {
    imageEdits: {
      default: null
    },
    rotate: {
      default: 0
    },
    disablePaneTap: {
      default: !1
    }
  },
  computed: {
    /**
     * Returns the transform attribute for the SVGImageElement.
     *
     * It clamps the x, y, scale, and rotate values in order to make sure the
     * image can't be positioned too far inside the view.
     *
     * @return {String}
     */
    transform() {
      const t = this.clampImage(), { x: e, y: r, scale: i, rotate: n } = t, a = this.width, s = this.height;
      let o = i.toFixed(4), l = 0, c = 0, u = i.toFixed(4), d = (a / 2 - i * (a / 2)).toFixed(4), h = (s / 2 - i * (s / 2)).toFixed(4);
      const f = `translate(${e} ${r})`, v = `rotate(${n} ${a / 2} ${s / 2})`, p = `matrix(${o} ${l} ${c} ${u} ${d} ${h})`;
      return `${f} ${v} ${p}`;
    },
    isLowRes() {
      return this.image ? lm(this.image.width, this.image.height, this.currentScale, this.currentWidth, this.currentHeight) : !1;
    },
    imageSelectorMultiplicator() {
      return this.productSlug === Pr ? 0.25 : 0.5;
    },
    placeHolderText() {
      let t = 1.9, e = 4.5;
      switch (this.locale) {
        case Zm:
          t = 1.3, e = 4;
          break;
        case Km:
          t = 1.7, e = 4.1;
          break;
      }
      return {
        size: t,
        xPos: e
      };
    },
    enableZoomCrop() {
      var t;
      return this.disableZoomCrop === !0 ? !1 : (t = this.featureFlags) != null && t.enableImageEditor ? this.selectedEditToolId === ti || this.selectedEditToolId === Al : !0;
    },
    useStore() {
      var t;
      return (t = this.featureFlags) == null ? void 0 : t.enableImageEditor;
    },
    isCollageProduct() {
      return this.productSlug === $t || this.productSlug === Qt;
    },
    paneAriaLabel() {
      let t, e = this.tileIndex + 1;
      return e ? t = "tile " + e + " " + this.name : t = this.name, "Selectable " + t;
    },
    // Image's width and height need to be inverted if rotation is 90 or 270
    // Example, if a landscape image is rotated 90 degrees within a landscape canvas,
    // the images "height" will need to equal the full width of the canvas.
    invertDimensions() {
      if (this.currentRotate === 90 || this.currentRotate === 270)
        return !0;
    }
  },
  /**
   * The component's watched properties.
   *
   * @type {Object}
   */
  watch: {
    injectedScale: function(t) {
      this.setCurrentScale(parseInt(t));
    },
    injectedRotate: function(t) {
      this.setCurrentRotate(parseInt(t)), this.resetImage();
    },
    image: function(t, e) {
      this.resetImage(!0), this.currentScale = this.getImageScale(), this.currentTranslateX = this.getImageTranslateX(), this.currentTranslateY = this.getImageTranslateY();
    },
    width: function(t, e) {
      this.resetImage(!1, e, this.height);
    },
    height: function(t, e) {
      this.resetImage(!1, this.width, e);
    },
    imageEditTrigger: {
      deep: !0,
      handler: function(t) {
        if (t)
          switch (t) {
            case "cancel":
              this.revertImage();
              break;
            case "reset":
              this.resetImage(!0);
              break;
          }
      }
    }
  },
  mounted() {
    this.hammer = new vr.Manager(this.$el), this.hammer.options.domEvents = !0, this.createSVGPoint();
    const t = new vr.Tap();
    this.hammer.add(t), this.hammer.on("tap", (i) => this.handleTap()), this.pan = new vr.Pan({ threshold: 1, pointers: 0 }), this.pinch = new vr.Pinch({ threshold: 0 }), this.initializePanPinch(), this.$el.addEventListener("touchmove", (i) => {
      this.selectedEditToolId && this.preventEvent(i);
    }, { passive: !1 });
    let e = !1;
    try {
      var r = Object.defineProperty({}, "passive", {
        get: () => {
          e = { passive: !0 };
        }
      });
      window.addEventListener("testPassive", null, r), window.removeEventListener("testPassive", null, r);
    } catch {
    }
    this.$el.addEventListener("wheel", (i) => {
      e || i.preventDefault(), this.handleWheel(i, this.$el);
    }, e), um(this.getImageThumb()), this.resetImage();
  },
  methods: {
    ...Il({
      setWarning: "builder/setWarning",
      resetImageTrigger: "image/resetImageTrigger"
    }),
    /**
     * Prevents the default event for dragging the SVG/image, which interferes
     * with the pan handler.
     */
    handleDragStart(t) {
      this.preventEvent(t);
    },
    /**
     * Gets the image's x offset so that it's rendered in the center of the
     * pane.
     *
     * @return {Float}
     */
    getImageX() {
      return (this.getImageWidth() - this.width) / -2;
    },
    /**
     * Gets the image's y offset so that it's rendered in the center of the
     * pane.
     *
     * @return {Float}
     */
    getImageY() {
      return (this.getImageHeight() - this.height) / -2;
    },
    /**
     * Gets the image's thumbnail URL.
     *
     * @return {Float}
     */
    getImageThumb() {
      return this.image ? this.image.thumbPath : this.currentThumb;
    },
    /**
     * Gets the image's original URL.
     *
     * @return {Float}
     */
    getImageOriginal() {
      return this.image ? this.image.originalPath : this.currentOriginal;
    },
    /**
     * Gets the image's original width.
     *
     * @return {Float}
     */
    getImageOriginalWidth() {
      return this.image ? this.image.width : this.currentOriginalWidth;
    },
    /**
     * Gets the image's original height.
     *
     * @return {Float}
     */
    getImageOriginalHeight() {
      return this.image ? this.image.height : this.currentOriginalHeight;
    },
    /**
     * Gets the image's width so that it's rendered in the center of the pane.
     *
     * @return {Float}
     */
    getImageWidth() {
      return this.invertDimensions ? this.getImageHeightCalc() : this.getImageWidthCalc();
    },
    getImageWidthCalc() {
      let t = this.width / this.height, e;
      this.invertDimensions ? e = this.image ? this.image.height / this.image.width : this.currentHeight / this.currentWidth : e = this.image ? this.image.width / this.image.height : this.currentWidth / this.currentHeight;
      let r;
      return t >= e ? r = this.width : r = this.width * (e / t), r;
    },
    /**
     * Gets the image's height so that it's rendered in the center of the
     * pane.
     *
     * @return {Float}
     */
    getImageHeight() {
      return this.invertDimensions ? this.getImageWidthCalc() : this.getImageHeightCalc();
    },
    getImageHeightCalc() {
      let t = this.width / this.height, e;
      this.invertDimensions ? e = this.image ? this.image.height / this.image.width : this.currentHeight / this.currentWidth : e = this.image ? this.image.width / this.image.height : this.currentWidth / this.currentHeight;
      let r;
      return t >= e ? r = this.height / (e / t) : r = this.height, r;
    },
    /**
     * Gets the image's scale.
     *
     * @return {Float}
     */
    getImageScale() {
      return this.image && this.image.transform ? this.image.transform.scale : this.currentScale;
    },
    /**
     * Gets the image's translate X value.
     *
     * @return {Float}
     */
    getImageTranslateX() {
      return this.image && this.image.transform ? this.image.transform.x : this.currentTranslateX;
    },
    /**
     * Gets the image's translate X value.
     *
     * @return {Float}
     */
    getImageTranslateY() {
      return this.image && this.image.transform ? this.image.transform.y : this.currentTranslateX;
    },
    /**
     * Handles taps on the pane.
     *
     * Doesn't use the Hammer tap handler, because it'll fire a different event
     * that interferes with things like the modal background clicks.
     */
    handleTap() {
      this.events && !this.panning && !this.disablePaneTap && this.$emit("click");
    },
    /**
     * Handles the pan event on the image.
     *
     * @param {Event} event
     */
    handlePan(t) {
      if (this.events && this.enableZoomCrop) {
        if (this.panning = !0, t.type === "panstart")
          this.currentXStart = this.currentTranslateX, this.currentYStart = this.currentTranslateY;
        else if (t.type === "panend")
          setTimeout(() => {
            this.panning = !1;
          }, 150);
        else {
          const e = this.getSvgPoints(t.center.x, t.center.y), r = this.getSvgPoints(t.center.x + t.deltaX, t.center.y + t.deltaY);
          let i = this.currentXStart + (r.x - e.x), n = this.currentYStart + (r.y - e.y);
          this.setCurrentTranslateX(i), this.setCurrentTranslateY(n);
        }
        this.preventEvent(t);
      }
    },
    handlePinch(t) {
      if (this.events && this.enableZoomCrop) {
        if (t.type === "pinchstart")
          this.scaleStart = this.currentScale;
        else {
          let e = this.scaleStart * t.scale;
          this.setCurrentScale(this.clampScale(e));
        }
        this.preventEvent(t);
      }
    },
    /**
     * Handles zooming with the mousewheel.
     *
     * @param {Event} event
     */
    handleWheel(t) {
      if (this.events && this.enableZoomCrop) {
        let e = this.currentScale;
        e += e * (-t.deltaY / 200), this.setCurrentScale(this.clampScale(e)), this.imageEdits && (this.imageEdits.scale = this.currentScale), this.preventEvent(t);
      }
    },
    /**
     * Clmaps the image to the boundaries of the pane.
     */
    clampImage() {
      const t = this.width, e = this.height;
      let r = this.currentWidth, i = this.currentHeight;
      this.invertDimensions && (r = this.currentHeight, i = this.currentWidth);
      const n = this.currentScale, a = this.currentRotate;
      let s = this.currentTranslateX, o = this.currentTranslateY, l = (t - r * n) / 2, c = (e - i * n) / 2;
      return s < l && (s = l), s > Math.abs(l) && (s = Math.abs(l)), o < c && (o = c), o > Math.abs(c) && (o = Math.abs(c)), this.setCurrentTranslateX(s), this.setCurrentTranslateY(o), this.setCurrentScale(n), this.setCurrentRotate(a), { x: s, y: o, scale: n, rotate: a };
    },
    /**
     * Resets the used image and clamps it to the canvas boundaries.
     */
    resetImage(t, e, r) {
      let i = this.getImageWidth(), n = this.getImageHeight(), a = this.getImageX(), s = this.getImageY(), o = this.getImageThumb(), l = this.getImageOriginal(), c = this.getImageOriginalWidth(), u = this.getImageOriginalHeight(), d = e > 0 ? this.currentTranslateX / e * this.width : this.getImageTranslateX(), h = r > 0 ? this.currentTranslateY / r * this.height : this.getImageTranslateY();
      this.currentWidth = i, this.currentHeight = n, this.currentX = a, this.currentY = s, this.currentThumb = o, this.currentOriginal = l, this.currentOriginalWidth = c, this.currentOriginalHeight = u, this.setCurrentTranslateX(d), this.setCurrentTranslateY(h), t && (this.setCurrentScale(1), this.setCurrentTranslateX(0), this.setCurrentTranslateY(0), this.currentTransform = "", this.currentRotate = 0);
    },
    /**
     * Reverts image to its pre-edit position
     *
     */
    revertImage() {
      this.preEditPosition && (this.setCurrentScale(this.preEditPosition.scale), this.setCurrentTranslateX(this.preEditPosition.translateX), this.setCurrentTranslateY(this.preEditPosition.translateY), this.preEditPosition = null);
    },
    /**
     * Clamps the scale between a minimum and maximum.
     *
     * @param {Number} scale
     * @return {Number}
     */
    clampScale(t) {
      return Math.min(Math.max(t, this.minScale), this.maxScale);
    },
    /**
     * Gets a point in SVG space.
     *
     * @param {Number} x
     * @param {Number} y
     * @return {matrixTransform}
     */
    getSvgPoints(t, e) {
      return this.svgPoint.x = t, this.svgPoint.y = e, this.svgPoint.matrixTransform(this.$el.getScreenCTM().inverse());
    },
    /**
     * Creates an SVGPoint.
     */
    createSVGPoint() {
      this.svgPoint = this.$el.createSVGPoint ? this.$el.createSVGPoint() : null;
    },
    /**
     * Handles clicking on the warning.
     */
    handleWarningClick() {
      this.setWarning(qm);
    },
    /**
     * Prevents default on an event when possible.
     */
    preventEvent(t) {
      t.cancelable && t.preventDefault();
    },
    setCurrentScale(t) {
      this.currentScale = t;
    },
    setCurrentTranslateX(t) {
      this.currentTranslateX = t;
    },
    setCurrentTranslateY(t) {
      this.currentTranslateY = t;
    },
    setCurrentRotate(t) {
      this.currentRotate = t;
    },
    initializePanPinch() {
      this.preEditPosition = {
        scale: this.currentScale,
        translateX: this.currentTranslateX,
        translateY: this.currentTranslateY
      }, this.productSlug !== nt && (this.hammer.add(this.pan), this.hammer.add(this.pinch).recognizeWith([this.pan]), this.hammer.on("panstart panmove panend", (t) => this.handlePan(t, this.$el)), this.hammer.on("pinchstart pinchmove", (t) => this.handlePinch(t, this.$el)));
    }
  }
}, tv = ["viewBox", "x", "y", "width", "height"], rv = ["aria-label", "id"], iv = ["viewBox"], nv = ["width", "height"], av = ["x", "y", "width", "height"], sv = /* @__PURE__ */ E("rect", {
  x: "0",
  y: "0",
  rx: ".25",
  ry: ".25",
  width: "16",
  height: "4",
  class: "fill-current text-blue-50 pointer-events-none",
  tabindex: "-1",
  "aria-hidden": "true"
}, null, -1), ov = /* @__PURE__ */ E("svg", {
  viewBox: "0 0 28 28",
  x: ".75",
  y: ".75",
  width: "3",
  height: "3",
  class: "fill-current text-blue-500 pointer-events-none",
  tabindex: "-1",
  "aria-hidden": "true"
}, [
  /* @__PURE__ */ E("path", { d: "M19 2h-14c-1.7 0-3 1.3-3 3v14c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3v-14c0-1.7-1.3-3-3-3zM4 5c0-0.6 0.4-1 1-1h14c0.6 0 1 0.4 1 1v7.6l-3.3-3.3c-0.4-0.4-1-0.4-1.4 0l-10.6 10.6c-0.4-0.1-0.7-0.5-0.7-0.9v-14zM19 20h-11.6l8.6-8.6 4 4v3.6c0 0.6-0.4 1-1 1z" }),
  /* @__PURE__ */ E("path", { d: "M8.5 11c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5zM8.5 8c0.3 0 0.5 0.2 0.5 0.5s-0.2 0.5-0.5 0.5-0.5-0.2-0.5-0.5 0.2-0.5 0.5-0.5z" })
], -1), lv = ["x", "font-size"], cv = ["width", "height"], uv = ["width", "height", "x", "y", "data-id", "data-pane", "data-translate-x", "data-translate-y", "data-scale", "data-rotate", "data-original", "data-original-width", "data-original-height", "xlink:href", "transform"], dv = ["width", "height"];
function hv(t, e, r, i, n, a) {
  return R(), M("svg", {
    "data-svg": "",
    viewBox: `0 0 ${r.width} ${r.height}`,
    x: r.x,
    y: r.y,
    width: r.width,
    height: r.height,
    tabindex: "-1",
    class: "outline-none"
  }, [
    E("rect", {
      x: "0",
      y: "0",
      width: "100%",
      height: "100%",
      fill: "#ffffff",
      tabindex: "0",
      class: "outline-none focus-visible:stroke-blue",
      "data-test-id": "select-image",
      "aria-label": a.paneAriaLabel,
      id: `tile_${r.tileIndex}-${r.name}`,
      role: "button",
      onKeydown: e[0] || (e[0] = y0((...s) => a.handleTap && a.handleTap(...s), ["enter"]))
    }, null, 40, rv),
    he((R(), M("svg", {
      "data-placeholder": "",
      class: "cursor-pointer outline-none",
      viewBox: `0 0 ${r.width} ${r.height}`
    }, [
      E("rect", {
        width: r.width,
        height: r.height,
        fill: "#ffffff",
        class: "outline-none",
        tabindex: "-1",
        "aria-hidden": "true"
      }, null, 8, nv),
      (R(), M("svg", {
        viewBox: "0 0 16 4",
        x: r.width / 2 - r.width * a.imageSelectorMultiplicator / 2,
        y: r.height / 2 - r.width * a.imageSelectorMultiplicator / 8,
        width: r.width * a.imageSelectorMultiplicator,
        height: r.width * a.imageSelectorMultiplicator / 4,
        tabindex: "-1",
        class: "outline-none"
      }, [
        sv,
        ov,
        E("text", {
          x: a.placeHolderText.xPos,
          y: "2.2",
          "dominant-baseline": "middle",
          "font-size": a.placeHolderText.size,
          class: "fill-current text-blue-500 pointer-events-none outline-none",
          tabindex: "-1"
        }, me(t.$t("message.builder.selectImage")), 9, lv)
      ], 8, av))
    ], 8, iv)), [
      [fe, r.placeholder && !r.renderMode]
    ]),
    r.image ? (R(), M("rect", {
      key: 0,
      "data-pane-background": "",
      width: r.width,
      height: r.height,
      fill: "#ffffff",
      "aria-hidden": "true",
      class: "outline-none",
      tabindex: "-1"
    }, null, 8, cv)) : Q("", !0),
    r.image ? (R(), M("image", {
      key: n.currentThumb,
      "data-image": "",
      tabindex: "-1",
      width: n.currentWidth,
      height: n.currentHeight,
      x: n.currentX,
      y: n.currentY,
      "data-id": r.image ? r.image.id : null,
      "data-pane": r.name,
      "data-translate-x": n.currentTranslateX,
      "data-translate-y": n.currentTranslateY,
      "data-scale": n.currentScale,
      "data-rotate": n.currentRotate,
      "data-original": n.currentOriginal,
      "data-original-width": n.currentOriginalWidth,
      "data-original-height": n.currentOriginalHeight,
      "xlink:href": n.currentThumb,
      transform: a.transform,
      preserveAspectRatio: "xMidYMid slice",
      class: "pane-image",
      "aria-hidden": "true",
      onDragstart: e[1] || (e[1] = (...s) => a.handleDragStart && a.handleDragStart(...s))
    }, null, 40, uv)) : Q("", !0),
    r.image ? (R(), M("rect", {
      key: 2,
      width: r.width,
      height: r.height,
      fill: "#ffffff",
      "fill-opacity": "0",
      class: "outline-none",
      tabindex: "-1"
    }, null, 8, dv)) : Q("", !0)
  ], 8, tv);
}
const fv = /* @__PURE__ */ Ce(ev, [["render", hv]]), gv = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: fv
}, Symbol.toStringTag, { value: "Module" })), pv = {
  name: "Panes",
  components: {
    Pane: Gh(() => Promise.resolve().then(() => gv))
  },
  props: {
    panes: {
      type: Array,
      default: () => []
    },
    width: {
      type: Number,
      required: !0
    },
    height: {
      type: Number,
      required: !0
    },
    edge: {
      type: Number,
      required: !0
    },
    edgeColor: {
      type: String,
      required: !0
    },
    edgeType: {
      type: String,
      default: ""
    },
    border: {
      type: Number,
      required: !0
    },
    borderColor: {
      type: String,
      required: !0
    },
    events: {
      type: Boolean,
      default: !0
    },
    images: {
      type: Object,
      required: !0
    },
    uploadLater: {
      type: Boolean,
      default: !1
    },
    isArt: {
      type: Boolean,
      default: !1
    },
    renderMode: {
      type: Boolean,
      default: !1
    },
    productSlug: {
      type: String,
      required: !0
    },
    mgiPhotoBorderBleed: {
      type: Number,
      default: 0
    },
    mgiImage: {
      type: Object,
      default: null
    },
    mgiPrintEdge: {
      type: Number,
      default: 0
    },
    proofIndex: {
      type: Number,
      default: null
    },
    tileIndex: {
      type: Number,
      default: 0
    },
    disableCollageOuterBorder: {
      type: Boolean,
      default: !1
    },
    filter: {
      type: String,
      default: null
    },
    selectedEditToolId: {
      type: Number,
      default: null
    },
    imageEditTrigger: {
      type: String,
      default: null
    },
    locale: {
      type: String,
      default: Sf
    },
    featureFlags: {
      type: Object,
      default: () => {
      }
    },
    disableZoomCrop: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {};
  },
  computed: {
    hasPhotoBorder() {
      return (!this.edgeColor || this.mgiPrintEdge !== 0 || this.mgiPhotoBorderBleed !== 0) && this.edgeType !== "BLB";
    },
    mgiOffset() {
      let t = 0;
      return this.mgiPrintEdge ? t = this.mgiPrintEdge - this.edge : this.mgiPhotoBorderBleed && (t = this.mgiPhotoBorderBleed), t;
    },
    borderOffset() {
      return this.disableCollageOuterBorder ? 0 : this.borderDimensions;
    },
    totalWidth() {
      return this.width + (this.hasPhotoBorder ? 2 * this.edge : 0);
    },
    totalHeight() {
      return this.height + (this.hasPhotoBorder ? 2 * this.edge : 0);
    },
    totalInnerWidth() {
      return this.disableCollageOuterBorder ? this.totalWidth + this.borderDimensions : this.totalWidth - this.borderDimensions;
    },
    totalInnerHeight() {
      return this.disableCollageOuterBorder ? this.totalHeight + this.borderDimensions : this.totalHeight - this.borderDimensions;
    },
    aspectRatio() {
      return this.totalWidth / this.totalHeight;
    },
    offset() {
      return this.borderDimensions / 2;
    },
    borderDimensions() {
      return this.totalWidth / 100 * this.border;
    },
    classList() {
      return [
        "flex-1 max-w-full max-h-full absolute bottom-0 right-0 z-40 opacity-100 outline-none",
        this.aspectRatio >= 1 ? "w-full h-auto" : "h-full w-auto"
      ];
    },
    sourceSelectorId() {
      return this.proofIndex !== null ? "source-" + this.proofIndex : this.tileIndex !== null ? "source-" + this.tileIndex : "source";
    },
    filterString() {
      return this.filter && !this.selectedEditToolId ? "url(#" + this.filter + ")" : null;
    },
    lomoPointLightOffsets() {
      return {
        x: this.width / 2 + (this.hasPhotoBorder ? this.edge : 0),
        y: this.height / 2 + (this.hasPhotoBorder ? this.edge : 0)
      };
    }
  },
  methods: {
    handleClick(t) {
      this.$emit("paneClick", t);
    },
    getImage(t) {
      return this.mgiImage ? this.mgiImage : t;
    }
  }
}, mv = ["id", "viewBox", "filter"], vv = /* @__PURE__ */ E("filter", { id: "SP" }, [
  /* @__PURE__ */ E("feColorMatrix", {
    type: "matrix",
    values: ` 0.397  0.397  0.397  0.000 -0.005
               0.326  0.326  0.326  0.000 -0.004
               0.261  0.261  0.261  0.000 -0.003
               0.000  0.000  0.000  1.000  0.000`
  })
], -1), yv = {
  id: "LM",
  "color-interpolation-filters": "sRGB"
}, bv = /* @__PURE__ */ E("feFlood", {
  id: "vignette-flood",
  x: "0",
  y: "0",
  result: "blackfield",
  "flood-color": "#000000",
  "flood-opacity": "1"
}, null, -1), xv = {
  id: "vignette-specular",
  result: "spotlight",
  "lighting-color": "#FFFFFF",
  surfaceScale: "1",
  specularConstant: "1",
  specularExponent: 128
}, Sv = ["x", "y", "z"], wv = /* @__PURE__ */ E("feBlend", {
  id: "vignette-mask",
  result: "mask",
  in: "blackfield",
  in2: "spotlight",
  mode: "lighten"
}, null, -1), Ev = /* @__PURE__ */ E("feBlend", {
  id: "vignette-mask-multiply",
  in: "mask",
  in2: "SourceGraphic",
  mode: "multiply",
  result: "vignette-result"
}, null, -1), Tv = /* @__PURE__ */ E("feColorMatrix", {
  type: "matrix",
  values: `1.320 -0.054 -0.003  0.000 -0.035
              -0.015  1.290 -0.003  0.000 -0.035
              -0.015 -0.054  1.340  0.000 -0.035
               0.000  0.000  0.000  1.000  0.000`
}, null, -1), Pv = /* @__PURE__ */ E("filter", { id: "BW" }, [
  /* @__PURE__ */ E("feColorMatrix", {
    type: "matrix",
    values: `0.33 0.33 0.33 0 0
                             0.33 0.33 0.33 0 0
                             0.33 0.33 0.33 0 0
                             0 0 0 1 0`
  })
], -1), Ov = { id: "VT" }, Cv = /* @__PURE__ */ E("feFlood", {
  id: "vignette-flood",
  x: "0",
  y: "0",
  result: "blackfield",
  "flood-color": "#000000",
  "flood-opacity": "1"
}, null, -1), Iv = {
  id: "vignette-specular",
  result: "spotlight",
  "lighting-color": "#FFFFFF",
  surfaceScale: "1",
  specularConstant: "0.7",
  specularExponent: 128
}, _v = ["x", "y", "z"], Av = /* @__PURE__ */ di(`<feBlend id="vignette-mask" result="mask" in="blackfield" in2="spotlight" mode="soft-light"></feBlend><feFlood id="vignette-flood2" x="0" y="0" result="magentaField" flood-color="#FF00FF" flood-opacity="0.04"></feFlood><feBlend id="vignette-mask" result="maskMagenta" in="magentaField" in2="SourceGraphic" mode="soft-light"></feBlend><feBlend id="vignette-mask-multiply" in="mask" in2="maskMagenta" mode="soft-light" result="vignette-result"></feBlend><feColorMatrix type="matrix" values="0.778  0.187  0.038  0.000 -0.012
               0.118  0.641  0.093  0.000 -0.011
               0.095 -0.118  0.889  0.000 -0.011
               0.000  0.000  0.000  1.000  0.000"></feColorMatrix>`, 5), Rv = ["width", "height", "fill"];
function Mv(t, e, r, i, n, a) {
  const s = it("Pane");
  return R(), M("svg", {
    id: a.sourceSelectorId,
    "data-panes": "",
    viewBox: `0 0 ${a.totalWidth} ${a.totalHeight}`,
    class: re(a.classList),
    filter: a.filterString,
    tabindex: "-1"
  }, [
    E("defs", null, [
      vv,
      E("filter", yv, [
        bv,
        E("feSpecularLighting", xv, [
          E("fePointLight", {
            id: "vignette-pointlight",
            x: a.lomoPointLightOffsets.x,
            y: a.lomoPointLightOffsets.y,
            z: r.width >= r.height ? r.width * 3.25 : r.height * 3.25
          }, null, 8, Sv)
        ]),
        wv,
        Ev,
        Tv
      ]),
      Pv,
      E("filter", Ov, [
        Cv,
        E("feSpecularLighting", Iv, [
          E("fePointLight", {
            id: "vignette-pointlight",
            x: r.width / 2,
            y: r.height / 2,
            z: r.width >= r.height ? r.width * 4 : r.height * 4
          }, null, 8, _v)
        ]),
        Av
      ])
    ]),
    E("rect", {
      "data-border": "",
      x: "0",
      y: "0",
      width: a.totalWidth,
      height: a.totalHeight,
      fill: r.borderColor
    }, null, 8, Rv),
    (R(!0), M(ci, null, ui(r.panes, (o) => (R(), ht(s, {
      key: o.id,
      name: o.id,
      width: a.totalInnerWidth / 100 * o.width - a.borderDimensions + a.mgiOffset * 2,
      height: a.totalInnerHeight / 100 * o.height - a.borderDimensions + a.mgiOffset * 2,
      x: a.totalInnerWidth / 100 * o.left + a.borderOffset - a.mgiOffset,
      y: a.totalInnerHeight / 100 * o.top + a.borderOffset - a.mgiOffset,
      image: a.getImage(r.images[o.id]),
      events: r.events,
      placeholder: !r.uploadLater && !r.images[o.id] && !r.isArt,
      renderMode: r.renderMode,
      "product-slug": r.productSlug,
      selectedEditToolId: r.selectedEditToolId,
      "feature-flags": r.featureFlags,
      imageEditTrigger: r.imageEditTrigger,
      locale: r.locale,
      tileIndex: r.tileIndex,
      disableZoomCrop: r.disableZoomCrop,
      onClick: (l) => a.handleClick(o.id)
    }, null, 8, ["name", "width", "height", "x", "y", "image", "events", "placeholder", "renderMode", "product-slug", "selectedEditToolId", "feature-flags", "imageEditTrigger", "locale", "tileIndex", "disableZoomCrop", "onClick"]))), 128))
  ], 10, mv);
}
const Ef = /* @__PURE__ */ Ce(pv, [["render", Mv]]);
const Lv = {
  name: "Preview",
  props: {
    width: {
      type: Number,
      required: !0
    },
    isMobile: {
      type: Boolean,
      default: !1
    },
    height: {
      type: Number,
      required: !0
    },
    edge: {
      type: Number,
      required: !0
    },
    frame: {
      type: Number,
      required: !0,
      default: 0
    },
    frameType: {
      type: String,
      required: !1,
      default: ""
    },
    gap: {
      type: Number,
      required: !0,
      default: 0
    },
    mat: {
      type: Number,
      required: !0,
      default: 0
    },
    frameColor: {
      type: String,
      default: null
    },
    offset: {
      type: Number,
      default: 0
    },
    isArt: {
      type: Boolean,
      default: !1
    },
    panels: {
      type: Number,
      default: 1
    },
    preview: {
      type: Boolean,
      default: !1
    },
    frameWidth: {
      type: Number,
      default: 0
    },
    frameHeight: {
      type: Number,
      default: 0
    },
    cornerRadius: {
      type: String,
      default: null
    },
    matWidth: {
      type: Number,
      default: 0
    },
    matHeight: {
      type: Number,
      default: 0
    },
    productWidth: {
      type: Number,
      default: 0
    },
    productHeight: {
      type: Number,
      default: 0
    },
    gapWidth: {
      type: Number,
      default: 0
    },
    gapHeight: {
      type: Number,
      default: 0
    },
    tileIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {};
  },
  inject: {
    fullScale: {
      default: !1
    }
  },
  computed: {
    aspectRatio() {
      return this.width / this.height;
    },
    edgeWidth() {
      return this.edge / this.width * 100;
    },
    edgeHeight() {
      return this.edge / this.height * 100;
    },
    matDepthWidth() {
      return this.frame === 0 ? 0 : 0.25 / this.width * 100;
    },
    matDepthHeight() {
      return this.frame === 0 ? 0 : 0.25 / this.height * 100;
    },
    canvasWidth() {
      return this.width + 2 * this.edge;
    },
    canvasHeight() {
      return this.height + 2 * this.edge;
    },
    classList() {
      return [
        "flex-1 overflow-visible h-full max-w-full"
      ];
    },
    depthWidth() {
      return this.edge ? this.edgeWidth : this.frameWidth;
    },
    depthHeight() {
      return this.edge ? this.edgeHeight : this.frameHeight;
    },
    patternScale() {
      return ` ${this.productWidth * 72 / (548e3 / 1.5)} 0.0035`;
    },
    patternScaleVertical() {
      return `0.0035 ${0.585 / (this.productHeight ? this.productHeight : 1)}`;
    },
    styleListContainer() {
      let t = "scale(1)";
      return this.fullScale || (this.isArt && this.isMobile === !1 ? t = "scale(0.5)" : this.aspectRatio >= 1 ? t = `scale(${(this.width - 2) / this.productWidth})` : t = `scale(${(this.height - 2) / this.productHeight})`), {
        transform: t
      };
    },
    styleListBackground() {
      return {
        transform: `rotateX(90deg) translateY(${(this.edge ? this.edge : this.frame) / this.productHeight * -100}%) rotateX(-90deg)`,
        top: `-${this.gapHeight + this.matHeight + this.frameHeight}%`,
        right: `-${this.gapWidth + this.matWidth + this.frameWidth}%`,
        bottom: `-${this.gapHeight + this.matHeight + this.frameHeight}%`,
        left: `-${this.gapWidth + this.matWidth + this.frameWidth}%`,
        "background-color": Ni(this.frameColor, -30),
        "box-shadow": `0 0 ${(this.aspectRatio >= 1 ? this.depthWidth : this.depthHeight) * 8}px ${(this.aspectRatio >= 1 ? this.depthWidth : this.depthHeight) * 4}px rgba(0, 0, 0, 0.15), 0 0 ${(this.aspectRatio >= 1 ? this.depthWidth : this.depthHeight) * 2}px ${this.aspectRatio >= 1 ? this.depthWidth : this.depthHeight}px rgba(0, 0, 0, 0.25), inset 0 0 10000px rgba(0, 0, 0, .2)`
      };
    },
    styleListFrameTopInner() {
      return {
        left: `-${this.gapWidth + this.matWidth}%`,
        right: `-${this.gapWidth + this.matWidth}%`,
        height: `${this.frameHeight}%`,
        top: `-${this.gapHeight + this.matHeight}%`,
        "background-color": Ni(this.frameColor, -20)
      };
    },
    styleListFrameRightInner() {
      return {
        top: `-${this.gapHeight + this.matHeight}%`,
        bottom: `-${this.gapHeight + this.matHeight}%`,
        width: `${this.frameWidth}%`,
        right: `-${this.gapWidth + this.matWidth}%`,
        "background-color": Ni(this.frameColor, -10)
      };
    },
    styleListFrameBottomInner() {
      return {
        left: `-${this.gapWidth + this.matWidth}%`,
        right: `-${this.gapWidth + this.matWidth}%`,
        height: `${this.frameHeight}%`,
        bottom: `-${this.gapHeight + this.matHeight}%`,
        "background-color": Ni(this.frameColor, -10)
      };
    },
    styleListFrameLeftInner() {
      return {
        top: `-${this.gapHeight + this.matHeight}%`,
        bottom: `-${this.gapHeight + this.matHeight}%`,
        width: `${this.frameWidth}%`,
        left: `-${this.gapWidth + this.matWidth}%`,
        "background-color": Ni(this.frameColor, -10)
      };
    },
    styleListFrameTop() {
      return {
        left: `-${this.frameWidth + this.matWidth + this.gapWidth}%`,
        right: `-${this.frameWidth + this.matWidth + this.gapWidth}%`,
        height: `${this.frameHeight}%`,
        top: `-${this.frameHeight + this.matHeight + this.gapHeight}%`
      };
    },
    styleListFrameRight() {
      return {
        top: `-${this.frameHeight + this.matHeight + this.gapHeight}%`,
        bottom: `-${this.frameHeight + this.matHeight + this.gapHeight}%`,
        width: `${this.frameWidth}%`,
        right: `-${this.frameWidth + this.matWidth + this.gapWidth}%`
      };
    },
    styleListFrameBottom() {
      return {
        left: `-${this.frameWidth + this.matWidth + this.gapWidth}%`,
        right: `-${this.frameWidth + this.matWidth + this.gapWidth}%`,
        height: `${this.frameHeight}%`,
        bottom: `-${this.frameHeight + this.matHeight + this.gapHeight}%`
      };
    },
    styleListFrameLeft() {
      return {
        top: `-${this.frameHeight + this.matHeight + this.gapHeight}%`,
        bottom: `-${this.frameHeight + this.matHeight + this.gapHeight}%`,
        width: `${this.frameWidth}%`,
        left: `-${this.frameWidth + this.matWidth + this.gapWidth}%`
      };
    },
    styleListFrameTopOuter() {
      return {
        left: `-${this.gapWidth + this.matWidth + this.frameWidth}%`,
        right: `-${this.gapWidth + this.matWidth + this.frameWidth}%`,
        height: `${this.depthHeight}%`,
        top: `-${this.gapHeight + this.matHeight + this.depthHeight + this.frameHeight}%`,
        "background-color": this.frameColor
      };
    },
    styleListFrameRightOuter() {
      return {
        top: `-${this.gapHeight + this.matHeight + this.frameHeight}%`,
        bottom: `-${this.gapHeight + this.matHeight + this.frameHeight}%`,
        width: `${this.depthWidth}%`,
        right: `-${this.gapWidth + this.matWidth + this.depthWidth + this.frameWidth}%`,
        "background-color": this.frameColor
      };
    },
    styleListFrameBottomOuter() {
      return {
        left: `-${this.gapWidth + this.matWidth + this.frameWidth}%`,
        right: `-${this.gapWidth + this.matWidth + this.frameWidth}%`,
        height: `${this.depthHeight}%`,
        bottom: `-${this.gapHeight + this.matHeight + this.depthHeight + this.frameHeight}%`,
        "background-color": this.frameColor
      };
    },
    styleListFrameLeftOuter() {
      return {
        top: `-${this.gapHeight + this.matHeight + this.frameHeight}%`,
        bottom: `-${this.gapHeight + this.matHeight + this.frameHeight}%`,
        width: `${this.depthWidth}%`,
        left: `-${this.gapWidth + this.matWidth + this.depthWidth + this.frameWidth}%`,
        "background-color": this.frameColor
      };
    },
    styleListCanvas() {
      return {
        transform: `rotateX(90deg) translateY(${this.mat ? -1 : 0}%) rotateX(-90deg)`,
        "clip-path": this.cornerRadius ? `inset(0% 0% 0% 0% round ${this.cornerRadius})` : "none"
      };
    },
    styleListMatTop() {
      return {
        height: `${this.matDepthHeight}%`
      };
    },
    styleListMatRight() {
      return {
        width: `${this.matDepthWidth}%`
      };
    },
    styleListMatBottom() {
      return {
        height: `${this.matDepthHeight}%`
      };
    },
    styleListMatLeft() {
      return {
        width: `${this.matDepthWidth}%`
      };
    },
    styleListEdgeTop() {
      return {
        height: `${this.edgeHeight}%`
      };
    },
    styleListEdgeRight() {
      return {
        width: `${this.edgeWidth}%`
      };
    },
    styleListEdgeBottom() {
      return {
        height: `${this.edgeHeight}%`
      };
    },
    styleListEdgeLeft() {
      return {
        width: `${this.edgeWidth}%`
      };
    },
    styleListMat() {
      return {
        left: `-${this.matWidth + this.gapWidth}%`,
        right: `-${this.matWidth + this.gapWidth}%`,
        bottom: `-${this.matHeight + this.gapHeight}%`,
        top: `-${this.matHeight + this.gapHeight}%`
      };
    },
    isWoodFrame() {
      return ["BF", "WF", "EF", "NF", "GF", "SF"].includes(this.frameType);
    }
  }
}, cn = (t) => (b0("data-v-1b1b42df"), t = t(), x0(), t), Dv = {
  "data-wrapper": "",
  class: "absolute inset-0 pointer-events-none preserve-3d"
}, Nv = {
  "data-shadow": "",
  class: "absolute inset-0 preserve-3d"
}, jv = ["viewBox"], kv = ["x", "viewBox", "width", "height"], zv = /* @__PURE__ */ di('<linearGradient id="GradientTopDark" x1="0" x2="0" y1="0" y2="1" data-v-1b1b42df><stop class="stop1" offset="0%" stop-color="#000" stop-opacity="0.7" data-v-1b1b42df></stop><stop class="stop2" offset="100%" stop-color="#000" stop-opacity="0.4" data-v-1b1b42df></stop></linearGradient><linearGradient id="GradientTopLight" x1="0" x2="0" y1="0" y2="1" data-v-1b1b42df><stop class="stop1" offset="0%" stop-color="#000" stop-opacity="0.3" data-v-1b1b42df></stop><stop class="stop2" offset="100%" stop-color="#000" stop-opacity="0.15" data-v-1b1b42df></stop></linearGradient>', 2), Bv = ["id"], Fv = ["x", "width", "height"], $v = ["xlink:href", "clip-path"], Uv = ["x", "width", "height"], Vv = ["viewBox"], Hv = ["x", "y", "viewBox", "width", "height"], Wv = /* @__PURE__ */ di('<linearGradient id="GradientRightDark" x1="1" x2="0" y1="0" y2="0" data-v-1b1b42df><stop class="stop1" offset="0%" stop-color="#000" stop-opacity="0.8" data-v-1b1b42df></stop><stop class="stop2" offset="100%" stop-color="#000" stop-opacity="0.5" data-v-1b1b42df></stop></linearGradient><linearGradient id="GradientRightLight" x1="1" x2="0" y1="0" y2="0" data-v-1b1b42df><stop class="stop1" offset="0%" stop-color="#000" stop-opacity="0.4" data-v-1b1b42df></stop><stop class="stop2" offset="100%" stop-color="#000" stop-opacity="0.2" data-v-1b1b42df></stop></linearGradient>', 2), Gv = ["id"], Yv = ["x", "y", "width", "height"], Xv = ["xlink:href", "clip-path"], qv = ["x", "y", "width", "height"], Kv = ["viewBox"], Zv = ["x", "y", "viewBox", "width", "height"], Qv = /* @__PURE__ */ di('<linearGradient id="GradientBottomDark" x1="0" x2="0" y1="1" y2="0" data-v-1b1b42df><stop class="stop1" offset="0%" stop-color="#333" stop-opacity="0.9" data-v-1b1b42df></stop><stop class="stop2" offset="100%" stop-color="#000" stop-opacity="0.6" data-v-1b1b42df></stop></linearGradient><linearGradient id="GradientBottomLight" x1="0" x2="0" y1="1" y2="0" data-v-1b1b42df><stop class="stop1" offset="0%" stop-color="#000" stop-opacity="0.5" data-v-1b1b42df></stop><stop class="stop2" offset="100%" stop-color="#000" stop-opacity="0.25" data-v-1b1b42df></stop></linearGradient>', 2), Jv = ["id"], e2 = ["x", "y", "width", "height"], t2 = ["xlink:href", "clip-path"], r2 = ["x", "y", "width", "height"], i2 = ["viewBox"], n2 = ["x", "y", "viewBox", "width", "height"], a2 = /* @__PURE__ */ di('<linearGradient id="GradientLeftDark" data-v-1b1b42df><stop class="stop1" offset="0%" stop-color="#000" stop-opacity="0.8" data-v-1b1b42df></stop><stop class="stop2" offset="100%" stop-color="#000" stop-opacity="0.5" data-v-1b1b42df></stop></linearGradient><linearGradient id="GradientLeftLight" data-v-1b1b42df><stop class="stop1" offset="0%" stop-color="#000" stop-opacity="0.5" data-v-1b1b42df></stop><stop class="stop2" offset="100%" stop-color="#000" stop-opacity="0.2" data-v-1b1b42df></stop></linearGradient>', 2), s2 = ["id"], o2 = ["x", "y", "width", "height"], l2 = ["xlink:href", "clip-path"], c2 = ["x", "y", "width", "height"], u2 = ["viewBox"], d2 = ["id"], h2 = ["width", "height"], f2 = ["x", "y", "width", "height"], g2 = ["width", "height", "mask"], p2 = /* @__PURE__ */ cn(() => /* @__PURE__ */ E("div", {
  class: "absolute inset-0",
  style: { "box-shadow": "inset 0 0 40px 0 rgba(0, 0, 0, .2), inset 0 0 20px 0 rgba(0, 0, 0, .4)" }
}, null, -1)), m2 = ["viewBox"], v2 = /* @__PURE__ */ cn(() => /* @__PURE__ */ E("linearGradient", {
  id: "ShadingTop",
  x1: "0",
  x2: "0",
  y1: "0",
  y2: "1"
}, [
  /* @__PURE__ */ E("stop", {
    class: "stop1",
    offset: "0%",
    "stop-color": "#000",
    "stop-opacity": "0.03"
  }),
  /* @__PURE__ */ E("stop", {
    class: "stop2",
    offset: "100%",
    "stop-color": "#000",
    "stop-opacity": "0"
  })
], -1)), y2 = ["id"], b2 = ["d"], x2 = ["width", "height", "clip-path", "fill"], S2 = ["width", "height", "clip-path", "fill"], w2 = ["viewBox"], E2 = /* @__PURE__ */ cn(() => /* @__PURE__ */ E("linearGradient", {
  id: "ShadingRight",
  x1: "1",
  x2: "0",
  y1: "0",
  y2: "0"
}, [
  /* @__PURE__ */ E("stop", {
    class: "stop1",
    offset: "0%",
    "stop-color": "#000",
    "stop-opacity": "0.03"
  }),
  /* @__PURE__ */ E("stop", {
    class: "stop2",
    offset: "100%",
    "stop-color": "#000",
    "stop-opacity": "0"
  })
], -1)), T2 = ["id"], P2 = ["d"], O2 = ["width", "height", "clip-path", "fill"], C2 = ["width", "height", "clip-path", "fill"], I2 = ["viewBox"], _2 = /* @__PURE__ */ cn(() => /* @__PURE__ */ E("linearGradient", {
  id: "ShadingBottom",
  x1: "0",
  x2: "0",
  y1: "1",
  y2: "0"
}, [
  /* @__PURE__ */ E("stop", {
    class: "stop1",
    offset: "0%",
    "stop-color": "#000",
    "stop-opacity": "0.03"
  }),
  /* @__PURE__ */ E("stop", {
    class: "stop2",
    offset: "100%",
    "stop-color": "#000",
    "stop-opacity": "0"
  })
], -1)), A2 = ["id"], R2 = ["d"], M2 = ["id", "patternTransform"], L2 = ["href"], D2 = ["width", "height", "clip-path", "fill"], N2 = ["width", "height", "clip-path", "fill"], j2 = ["viewBox"], k2 = /* @__PURE__ */ cn(() => /* @__PURE__ */ E("linearGradient", {
  id: "ShadingLeft",
  x1: "0",
  x2: "1",
  y1: "0",
  y2: "0"
}, [
  /* @__PURE__ */ E("stop", {
    class: "stop1",
    offset: "0%",
    "stop-color": "#000",
    "stop-opacity": "0.03"
  }),
  /* @__PURE__ */ E("stop", {
    class: "stop2",
    offset: "100%",
    "stop-color": "#000",
    "stop-opacity": "0"
  })
], -1)), z2 = ["id"], B2 = ["d"], F2 = ["id", "patternTransform"], $2 = ["href"], U2 = ["width", "height", "clip-path", "fill"], V2 = ["width", "height", "clip-path", "fill"], H2 = ["viewBox"], W2 = ["x", "y", "viewBox", "width", "height"], G2 = ["id"], Y2 = ["x", "y", "width", "height"], X2 = ["xlink:href", "clip-path"];
function q2(t, e, r, i, n, a) {
  return R(), M("div", {
    "data-container": "",
    class: "flex relative w-full h-auto max-w-full preserve-3d",
    style: J(a.styleListContainer)
  }, [
    E("div", Dv, [
      he(E("div", Nv, null, 512), [
        [fe, r.mat]
      ]),
      he(E("div", {
        "data-background": "",
        class: "backface-hidden absolute preserve-3d",
        style: J(a.styleListBackground)
      }, null, 4), [
        [fe, r.edge || r.frame]
      ]),
      he(E("div", {
        "data-frame-top-inner": "",
        class: "backface-hidden absolute top-0 preserve-3d",
        style: J(a.styleListFrameTopInner)
      }, null, 4), [
        [fe, r.frame]
      ]),
      he(E("div", {
        "data-frame-right-inner": "",
        class: "backface-hidden absolute right-0 preserve-3d",
        style: J(a.styleListFrameRightInner)
      }, null, 4), [
        [fe, r.frame]
      ]),
      he(E("div", {
        "data-frame-bottom-inner": "",
        class: "backface-hidden absolute bottom-0 preserve-3d",
        style: J(a.styleListFrameBottomInner)
      }, null, 4), [
        [fe, r.frame]
      ]),
      he(E("div", {
        "data-frame-left-inner": "",
        class: "backface-hidden absolute left-0 preserve-3d",
        style: J(a.styleListFrameLeftInner)
      }, null, 4), [
        [fe, r.frame]
      ]),
      he(E("div", {
        "data-mat-top": "",
        class: "backface-hidden absolute inset-x-0 top-0 preserve-3d",
        style: J(a.styleListMatTop)
      }, null, 4), [
        [fe, r.mat]
      ]),
      he(E("div", {
        "data-mat-right": "",
        class: "backface-hidden absolute inset-y-0 right-0 preserve-3d",
        style: J(a.styleListMatRight)
      }, null, 4), [
        [fe, r.mat]
      ]),
      he(E("div", {
        "data-mat-bottom": "",
        class: "backface-hidden absolute inset-x-0 bottom-0 preserve-3d",
        style: J(a.styleListMatBottom)
      }, null, 4), [
        [fe, r.mat]
      ]),
      he(E("div", {
        "data-mat-left": "",
        class: "backface-hidden absolute inset-y-0 left-0 preserve-3d",
        style: J(a.styleListMatLeft)
      }, null, 4), [
        [fe, r.mat]
      ]),
      E("div", {
        "data-edge-top": "",
        class: "backface-hidden absolute inset-x-0 top-0 preserve-3d",
        style: J(a.styleListEdgeTop)
      }, [
        (R(), M("svg", {
          viewBox: `0 0 ${r.width} ${r.edge}`,
          preserveAspectRatio: "xMidYMid slice"
        }, [
          (R(), M("svg", {
            x: -r.edge - r.offset * (r.width + 2 * r.edge),
            y: 0,
            viewBox: `0 0 ${(r.width + 2 * r.edge) * r.panels} ${r.height + 2 * r.edge}`,
            width: (r.width + 2 * r.edge) * r.panels,
            height: r.height + 2 * r.edge,
            preserveAspectRatio: "xMidYMid slice"
          }, [
            E("defs", null, [
              zv,
              E("clipPath", {
                id: `clip-edge-top-${r.offset}-${r.tileIndex}`
              }, [
                E("rect", {
                  x: r.edge + r.offset * (r.width + 2 * r.edge),
                  y: 0,
                  width: r.width,
                  height: r.edge
                }, null, 8, Fv)
              ], 8, Bv)
            ]),
            E("use", {
              "xlink:href": `#printable-${r.offset}-${r.tileIndex}`,
              "clip-path": `url(#clip-edge-top-${r.offset}-${r.tileIndex})`,
              tabindex: "-1"
            }, null, 8, $v),
            E("rect", {
              x: r.edge + r.offset * (r.width + 2 * r.edge),
              y: 0,
              width: r.width,
              height: r.edge,
              fill: "url(#GradientTopLight)"
            }, null, 8, Uv)
          ], 8, kv))
        ], 8, jv))
      ], 4),
      E("div", {
        "data-edge-right": "",
        class: "backface-hidden absolute inset-y-0 right-0 preserve-3d",
        style: J(a.styleListEdgeRight)
      }, [
        (R(), M("svg", {
          viewBox: `0 0 ${r.edge} ${r.height}`,
          preserveAspectRatio: "xMidYMid slice"
        }, [
          (R(), M("svg", {
            x: -(r.edge + r.width + r.offset * (r.width + 2 * r.edge)),
            y: -r.edge,
            viewBox: `0 0 ${(r.width + 2 * r.edge) * r.panels} ${r.height + 2 * r.edge}`,
            width: (r.width + 2 * r.edge) * r.panels,
            height: r.height + 2 * r.edge,
            preserveAspectRatio: "xMidYMid slice"
          }, [
            E("defs", null, [
              Wv,
              E("clipPath", {
                id: `clip-edge-right-${r.offset}-${r.tileIndex}`
              }, [
                E("rect", {
                  x: r.edge + r.width + r.offset * (r.width + 2 * r.edge),
                  y: r.edge,
                  width: r.edge,
                  height: r.height
                }, null, 8, Yv)
              ], 8, Gv)
            ]),
            E("use", {
              "xlink:href": `#printable-${r.offset}-${r.tileIndex}`,
              "clip-path": `url(#clip-edge-right-${r.offset}-${r.tileIndex})`
            }, null, 8, Xv),
            E("rect", {
              x: r.edge + r.width + r.offset * (r.width + 2 * r.edge),
              y: r.edge,
              width: r.edge,
              height: r.height,
              fill: "url(#GradientRightLight)"
            }, null, 8, qv)
          ], 8, Hv))
        ], 8, Vv))
      ], 4),
      E("div", {
        "data-edge-bottom": "",
        class: "backface-hidden absolute inset-x-0 bottom-0 preserve-3d",
        style: J(a.styleListEdgeBottom)
      }, [
        (R(), M("svg", {
          viewBox: `0 0 ${r.width} ${r.edge}`,
          preserveAspectRatio: "xMidYMid slice"
        }, [
          (R(), M("svg", {
            x: -(r.edge + r.offset * (r.width + 2 * r.edge)),
            y: -(r.height + r.edge),
            viewBox: `0 0 ${(r.width + 2 * r.edge) * r.panels} ${r.height + 2 * r.edge}`,
            width: (r.width + 2 * r.edge) * r.panels,
            height: r.height + 2 * r.edge,
            preserveAspectRatio: "xMidYMid slice"
          }, [
            E("defs", null, [
              Qv,
              E("clipPath", {
                id: `clip-edge-bottom-${r.offset}-${r.tileIndex}`
              }, [
                E("rect", {
                  x: r.edge + r.offset * (r.width + 2 * r.edge),
                  y: r.height + r.edge,
                  width: r.width,
                  height: r.edge
                }, null, 8, e2)
              ], 8, Jv)
            ]),
            E("use", {
              "xlink:href": `#printable-${r.offset}-${r.tileIndex}`,
              "clip-path": `url(#clip-edge-bottom-${r.offset}-${r.tileIndex})`
            }, null, 8, t2),
            E("rect", {
              x: r.edge + r.offset * (r.width + 2 * r.edge),
              y: a.canvasHeight - r.edge,
              width: r.width,
              height: r.edge,
              fill: "url(#GradientBottomLight)"
            }, null, 8, r2)
          ], 8, Zv))
        ], 8, Kv))
      ], 4),
      E("div", {
        "data-edge-left": "",
        class: "backface-hidden absolute inset-y-0 left-0 preserve-3d",
        style: J(a.styleListEdgeLeft)
      }, [
        (R(), M("svg", {
          viewBox: `0 0 ${r.edge} ${r.height}`,
          preserveAspectRatio: "xMidYMid slice"
        }, [
          (R(), M("svg", {
            x: -(r.offset * (r.width + 2 * r.edge)),
            y: -r.edge,
            viewBox: `0 0 ${(r.width + 2 * r.edge) * r.panels} ${r.height + 2 * r.edge}`,
            width: (r.width + 2 * r.edge) * r.panels,
            height: r.height + 2 * r.edge,
            preserveAspectRatio: "xMidYMid slice"
          }, [
            E("defs", null, [
              a2,
              E("clipPath", {
                id: `clip-edge-left-${r.offset}-${r.tileIndex}`
              }, [
                E("rect", {
                  x: r.offset * (r.width + 2 * r.edge),
                  y: r.edge,
                  width: r.edge,
                  height: r.height
                }, null, 8, o2)
              ], 8, s2)
            ]),
            E("use", {
              "xlink:href": `#printable-${r.offset}-${r.tileIndex}`,
              "clip-path": `url(#clip-edge-left-${r.offset}-${r.tileIndex})`
            }, null, 8, l2),
            E("rect", {
              x: r.offset * (r.width + 2 * r.edge),
              y: r.edge,
              width: r.edge,
              height: r.height,
              fill: "url(#GradientLeftLight)"
            }, null, 8, c2)
          ], 8, n2))
        ], 8, i2))
      ], 4),
      he(E("div", {
        "data-mat": "",
        class: "backface-hidden absolute preserve-3d",
        style: J(a.styleListMat)
      }, [
        (R(), M("svg", {
          viewBox: `0 0 ${r.width + 2 * r.mat} ${r.height + 2 * r.mat}`,
          xmlns: "http://www.w3.org/2000/svg",
          preserveAspectRatio: "xMinYMid slice"
        }, [
          E("defs", null, [
            E("mask", {
              id: `mat-${r.tileIndex}`
            }, [
              E("rect", {
                x: 0,
                y: 0,
                width: r.productWidth,
                height: r.productHeight,
                fill: "#fff"
              }, null, 8, h2),
              E("rect", {
                x: r.mat,
                y: r.mat,
                width: r.width + 2 * r.gap,
                height: r.height + 2 * r.gap,
                fill: "#000"
              }, null, 8, f2)
            ], 8, d2)
          ]),
          E("rect", {
            x: 0,
            y: 0,
            width: r.width + 2 * r.mat,
            height: r.height + 2 * r.mat,
            fill: "#fff",
            mask: `url(#mat-${r.tileIndex})`
          }, null, 8, g2)
        ], 8, u2)),
        p2
      ], 4), [
        [fe, r.mat]
      ]),
      he(E("div", {
        class: "absolute top-0 preserve-3d",
        style: J(a.styleListFrameTop)
      }, [
        (R(), M("svg", {
          viewBox: `0 0 ${r.productWidth} ${r.frame}`,
          xmlns: "http://www.w3.org/2000/svg",
          preserveAspectRatio: "xMinYMid slice"
        }, [
          E("defs", null, [
            v2,
            E("clipPath", {
              id: `frame-top-${r.tileIndex}`
            }, [
              E("path", {
                d: `M 0 0 L ${r.productWidth} 0 L ${r.productWidth - r.frame} ${r.frame} L ${r.frame} ${r.frame} Z`
              }, null, 8, b2)
            ], 8, y2)
          ]),
          E("rect", {
            "data-frame-top": "",
            x: "0",
            y: "0",
            width: r.productWidth,
            height: r.frame,
            "clip-path": `url(#frame-top-${r.tileIndex})`,
            fill: r.frameColor
          }, null, 8, x2),
          E("rect", {
            x: "0",
            y: "0",
            width: r.productWidth,
            height: r.frame,
            "clip-path": `url(#frame-top-${r.tileIndex})`,
            fill: `url(#pattern-image-horizontal-${r.tileIndex})`
          }, null, 8, S2)
        ], 8, m2))
      ], 4), [
        [fe, r.frame]
      ]),
      he(E("div", {
        class: "absolute right-0 preserve-3d",
        style: J(a.styleListFrameRight)
      }, [
        (R(), M("svg", {
          viewBox: `0 0 ${r.frame} ${r.productHeight}`,
          xmlns: "http://www.w3.org/2000/svg",
          preserveAspectRatio: "xMinYMid slice"
        }, [
          E("defs", null, [
            E2,
            E("clipPath", {
              id: `frame-right-${r.tileIndex}`
            }, [
              E("path", {
                d: `M ${r.frame} 0 L ${r.frame} ${r.productHeight} L 0 ${r.productHeight - r.frame} L 0 ${r.frame} Z`
              }, null, 8, P2)
            ], 8, T2)
          ]),
          E("rect", {
            x: "0",
            y: "0",
            width: r.frame,
            height: r.productHeight,
            "clip-path": `url(#frame-right-${r.tileIndex})`,
            fill: r.frameColor
          }, null, 8, O2),
          E("rect", {
            x: "0",
            y: "0",
            width: r.frame,
            height: r.productHeight,
            "clip-path": `url(#frame-right-${r.tileIndex})`,
            fill: `url(#pattern-image-vertical-${r.tileIndex})`
          }, null, 8, C2)
        ], 8, w2))
      ], 4), [
        [fe, r.frame]
      ]),
      he(E("div", {
        class: "absolute bottom-0 preserve-3d",
        style: J(a.styleListFrameBottom)
      }, [
        (R(), M("svg", {
          viewBox: `0 0 ${r.productWidth} ${r.frame}`,
          xmlns: "http://www.w3.org/2000/svg",
          preserveAspectRatio: "xMinYMid slice"
        }, [
          E("defs", null, [
            _2,
            E("clipPath", {
              id: `frame-bottom-${r.tileIndex}`
            }, [
              E("path", {
                d: `M ${r.frame} 0 L ${r.productWidth - r.frame} 0 L ${r.productWidth} ${r.frame} L 0 ${r.frame} Z`
              }, null, 8, R2)
            ], 8, A2),
            E("pattern", {
              id: `pattern-image-horizontal-${r.tileIndex}`,
              x: "0",
              y: "0",
              width: "5480",
              height: "354",
              patternUnits: "objectBoundingBox",
              patternTransform: `scale(${a.patternScale})`
            }, [
              a.isWoodFrame ? (R(), M("image", {
                key: 0,
                href: `https://d14c5m7lr5jmwa.cloudfront.net/frame-textures/woodframex4-${r.frameType}.jpg`,
                x: "0",
                y: "0",
                width: "5480",
                height: "354"
              }, null, 8, L2)) : Q("", !0)
            ], 8, M2)
          ]),
          E("rect", {
            x: "0",
            y: "0",
            width: r.productWidth,
            height: r.frame,
            "clip-path": `url(#frame-bottom-${r.tileIndex})`,
            fill: r.frameColor
          }, null, 8, D2),
          E("rect", {
            x: "0",
            y: "0",
            width: r.productWidth,
            height: r.frame,
            "clip-path": `url(#frame-bottom-${r.tileIndex})`,
            fill: `url(#pattern-image-horizontal-${r.tileIndex})`
          }, null, 8, N2)
        ], 8, I2))
      ], 4), [
        [fe, r.frame]
      ]),
      he(E("div", {
        class: "absolute left-0 preserve-3d",
        style: J(a.styleListFrameLeft)
      }, [
        (R(), M("svg", {
          viewBox: `0 0 ${r.frame} ${r.productHeight}`,
          xmlns: "http://www.w3.org/2000/svg",
          preserveAspectRatio: "xMinYMid slice"
        }, [
          E("defs", null, [
            k2,
            E("clipPath", {
              id: `frame-left-${r.tileIndex}`
            }, [
              E("path", {
                d: `M 0 0 L ${r.frame} ${r.frame} L ${r.frame} ${r.productHeight - r.frame} L 0 ${r.productHeight} Z`
              }, null, 8, B2)
            ], 8, z2),
            E("pattern", {
              id: `pattern-image-vertical-${r.tileIndex}`,
              x: "0",
              y: "0",
              width: "577",
              height: "100",
              patternUnits: "objectBoundingBox",
              patternTransform: `scale(${a.patternScaleVertical}) rotate(270)`
            }, [
              a.isWoodFrame ? (R(), M("image", {
                key: 0,
                href: `https://d14c5m7lr5jmwa.cloudfront.net/frame-textures/woodframex4-${r.frameType}.jpg`,
                x: "0",
                y: "0",
                width: "5480",
                height: "354"
              }, null, 8, $2)) : Q("", !0)
            ], 8, F2)
          ]),
          E("rect", {
            x: "0",
            y: "0",
            width: r.frame,
            height: r.productHeight,
            "clip-path": `url(#frame-left-${r.tileIndex})`,
            fill: r.frameColor
          }, null, 8, U2),
          E("rect", {
            x: "0",
            y: "0",
            width: r.frame,
            height: r.productHeight,
            "clip-path": `url(#frame-left-${r.tileIndex})`,
            fill: `url(#pattern-image-vertical-${r.tileIndex})`
          }, null, 8, V2)
        ], 8, j2))
      ], 4), [
        [fe, r.frame]
      ]),
      he(E("div", {
        "data-frame-top-outer": "",
        class: "absolute top-0 preserve-3d",
        style: J(a.styleListFrameTopOuter)
      }, null, 4), [
        [fe, r.frame]
      ]),
      he(E("div", {
        "data-frame-right-outer": "",
        class: "absolute right-0 preserve-3d",
        style: J(a.styleListFrameRightOuter)
      }, null, 4), [
        [fe, r.frame]
      ]),
      he(E("div", {
        "data-frame-bottom-outer": "",
        class: "absolute bottom-0 preserve-3d",
        style: J(a.styleListFrameBottomOuter)
      }, null, 4), [
        [fe, r.frame]
      ]),
      he(E("div", {
        "data-frame-left-outer": "",
        class: "absolute left-0 preserve-3d",
        style: J(a.styleListFrameLeftOuter)
      }, null, 4), [
        [fe, r.frame]
      ])
    ]),
    (R(), M("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      "data-preview-svg": "",
      viewBox: `0 0 ${r.width} ${r.height}`,
      class: re(a.classList),
      style: J(a.styleListCanvas),
      preserveAspectRatio: "xMidYMid slice"
    }, [
      (R(), M("svg", {
        x: -r.edge - r.offset * (r.width + 2 * r.edge),
        y: -r.edge,
        viewBox: `0 0 ${(r.width + 2 * r.edge) * r.panels} ${r.height + 2 * r.edge}`,
        width: (r.width + 2 * r.edge) * r.panels,
        height: r.height + 2 * r.edge,
        preserveAspectRatio: "xMidYMid slice"
      }, [
        E("defs", null, [
          E("clipPath", {
            id: `clip-main-${r.offset}-${r.tileIndex}`
          }, [
            E("rect", {
              x: r.edge + r.offset * (r.width + 2 * r.edge),
              y: r.edge,
              width: r.width,
              height: r.height
            }, null, 8, Y2)
          ], 8, G2)
        ]),
        E("use", {
          "xlink:href": `#printable-${r.offset}-${r.tileIndex}`,
          "clip-path": `url(#clip-main-${r.offset}-${r.tileIndex})`
        }, null, 8, X2)
      ], 8, W2))
    ], 14, H2))
  ], 4);
}
const Tf = /* @__PURE__ */ Ce(Lv, [["render", q2], ["__scopeId", "data-v-1b1b42df"]]), K2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Tf
}, Symbol.toStringTag, { value: "Module" })), Z2 = {
  components: {
    VueFeather: Sl
  },
  props: {
    isMobile: {
      type: Boolean,
      default: !1
    },
    tileLabel: {
      type: String,
      default: ""
    },
    tileIndex: {
      type: Number,
      default: 0
    },
    canEdit: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      editToolIcons: wf
    };
  },
  computed: {
    ...vf({
      selectedEditToolId: "image/selectedEditToolId",
      hasEdits: "image/hasEdits"
    }),
    toolInstructions() {
      switch (this.selectedEditToolId) {
        case ti:
        case Al:
          return this.$t("message.builder.imageEditor.instructions.cropZoom.desktop");
      }
    }
  },
  methods: {
    ...Il({
      setEditTool: "image/setEditTool",
      resetImage: "image/resetImage",
      cancelEdit: "image/cancelEdit",
      setEditTile: "image/setEditTile"
    }),
    selectEditTool(t) {
      this.setEditTool(parseInt(t));
    },
    selectEditTile() {
      this.setEditTile(this.tileIndex);
    }
  }
}, Q2 = { class: "flex justify-center" }, J2 = { class: "flex items-center relative w-full justify-center" }, ey = {
  key: 0,
  "data-edit-tools": "",
  class: "flex items-center space-x-2 absolute top-0 w-full"
}, ty = ["onClick"], ry = ["innerHTML"], iy = { style: { marginLeft: "auto" } }, ny = {
  key: 0,
  class: "flex items-center justify-center space-x-2 absolute top-0 w-full cursor-pointer"
}, ay = {
  key: 0,
  class: "text-center w-full md:w-full md:text-left md:flex md:items-center md:absolute md:top-0"
}, sy = { class: "md:pb-0 md:mr-8 font-bold" }, oy = {
  key: 0,
  class: "py-3 md:pt-0 md:pb-0"
}, ly = { "data-tool-instructions": "" }, cy = { class: "flex justify-center pb-4 md:pb-0 md:justify-start md:items-center md:ml-auto" };
function uy(t, e, r, i, n, a) {
  return R(), M("div", Q2, [
    E("div", J2, [
      Ue(qt, { name: "transition-slide-fade-bottom-delay" }, {
        default: ft(() => [
          !t.selectedEditToolId && !r.tileLabel && r.canEdit ? (R(), M("div", ey, [
            (R(!0), M(ci, null, ui(n.editToolIcons, (s, o) => (R(), M("div", {
              onClick: (l) => a.selectEditTool(o),
              class: "cursor-pointer"
            }, [
              E("div", {
                innerHTML: s.svg
              }, null, 8, ry)
            ], 8, ty))), 256)),
            E("div", iy, [
              E("span", {
                onClick: e[0] || (e[0] = (...s) => t.resetImage && t.resetImage(...s)),
                class: "font-bold text-gray-600 cursor-pointer"
              }, me(t.$t("message.builder.imageEditor.reset")), 1)
            ])
          ])) : Q("", !0)
        ]),
        _: 1
      }),
      Ue(qt, { name: "transition-slide-fade-bottom-delay" }, {
        default: ft(() => [
          r.tileLabel ? (R(), M("div", ny, me(r.tileLabel), 1)) : Q("", !0)
        ]),
        _: 1
      }),
      Ue(qt, { name: "transition-slide-fade-bottom-delay" }, {
        default: ft(() => [
          t.selectedEditToolId && !r.isMobile ? (R(), M("div", ay, [
            E("div", sy, [
              E("p", null, me(t.$t("message.builder.imageEditor.tools." + n.editToolIcons[t.selectedEditToolId].name)), 1)
            ]),
            a.toolInstructions ? (R(), M("div", oy, [
              E("p", ly, me(a.toolInstructions), 1)
            ])) : Q("", !0),
            E("div", cy, [
              E("p", {
                onClick: e[1] || (e[1] = (s) => t.cancelEdit()),
                class: "hidden md:block cursor-pointer p-2 mr-2"
              }, me(t.$t("message.builder.imageEditor.cancel")), 1),
              E("button", {
                onClick: e[2] || (e[2] = (s) => t.cancelEdit()),
                class: "md:hidden w-auto btn border-gray-400 py-2 px-4 mr-2"
              }, me(t.$t("message.builder.imageEditor.cancel")), 1),
              E("button", {
                onClick: e[3] || (e[3] = (s) => t.setEditTool(null)),
                class: "w-auto btn btn--dark py-2 px-4"
              }, me(t.$t("message.builder.imageEditor.apply")), 1)
            ])
          ])) : Q("", !0)
        ]),
        _: 1
      })
    ])
  ]);
}
const dy = /* @__PURE__ */ Ce(Z2, [["render", uy]]), hy = {
  name: "Previews",
  components: {
    ImageEditTools: dy,
    Preview: Gh(() => Promise.resolve().then(() => K2))
  },
  props: {
    canManipulate: {
      type: Boolean,
      default: !0
    },
    canEdit: {
      type: Boolean,
      default: !1
    },
    width: {
      type: Number,
      required: !0
    },
    height: {
      type: Number,
      required: !0
    },
    visible: {
      type: Boolean,
      default: !1
    },
    events: {
      type: Boolean,
      default: !0
    },
    renderMode: {
      type: Boolean,
      default: !1
    },
    defaultRotateX: {
      type: Number
    },
    defaultRotateY: {
      type: Number
    },
    passiveMouseWheel: {
      type: Boolean,
      default: !0
    },
    featureFlags: {
      type: Object,
      default: () => {
      }
    },
    frame: {
      type: Number,
      required: !0,
      default: 0
    },
    frameType: {
      type: String,
      required: !1,
      default: ""
    },
    edge: {
      type: Number,
      required: !0
    },
    gap: {
      type: Number,
      required: !0,
      default: 0
    },
    mat: {
      type: Number,
      required: !0,
      default: 0
    },
    frameColor: {
      type: String,
      default: null
    },
    cornerRadius: {
      type: String,
      default: "0px"
    },
    isArt: {
      type: Boolean,
      default: !1
    },
    panels: {
      type: Number,
      default: 1
    },
    preview: {
      type: Boolean,
      default: !1
    },
    isMobile: {
      type: Boolean,
      default: !1
    },
    selectedEditToolId: {
      type: Number,
      default: null
    },
    enableScaleAnimation: {
      type: Boolean,
      default: !0
    },
    enableInitialAnimation: {
      type: Boolean,
      default: !1
    },
    tileIndex: {
      type: Number,
      default: 0
    },
    tileLabel: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      hammer: null,
      currentX: 0,
      currentY: 0,
      startX: 0,
      startY: 0,
      rotateX: 25,
      rotateY: 0,
      minRotation: -60,
      maxRotation: 60,
      rotateTimer: null,
      currentScale: 1,
      scaleStart: 1,
      minScale: 0.5,
      maxScale: 2,
      scaleTimer: null,
      clientWidth: 200,
      clientHeight: 200,
      timeout: null,
      isRotating: !1,
      isZooming: !1
    };
  },
  computed: {
    aspectRatio() {
      return this.width / this.height;
    },
    clientAspectRatio() {
      return this.clientWidth / this.clientHeight;
    },
    cssWidth() {
      return this.clientAspectRatio <= this.aspectRatio ? `${this.clientWidth}px` : `${this.clientHeight * this.aspectRatio}px`;
    },
    cssHeight() {
      return this.clientAspectRatio <= this.aspectRatio ? `${this.clientWidth / this.aspectRatio}px` : `${this.clientHeight}px`;
    },
    styleList() {
      return {
        transition: this.isZooming ? "none" : "transform 1s cubic-bezier(.49,.01,.2,.99)",
        perspective: `${100 + 100 / this.currentScale}vmin`,
        transform: this.visible ? `scale(${this.currentScale})` : "scale(1)"
      };
    },
    styleListContainer() {
      return {
        width: this.cssWidth,
        height: this.cssHeight,
        transition: this.isRotating || !this.enableScaleAnimation ? "none" : "all 1s cubic-bezier(.49,.01,.2,.99)",
        perspective: "500vmin",
        "transform-style": "preserve-3d",
        transform: this.visible ? `translateZ(-100px) rotateX(${this.rotateY}deg) rotateY(${this.rotateX}deg)` : "translateZ(0)"
      };
    },
    enableNewPreviewControls() {
      var t;
      return (t = this.featureFlags) == null ? void 0 : t.enableNewPreviewControls;
    },
    productWidth() {
      return this.width + 2 * this.gap + 2 * this.frame + 2 * this.mat;
    },
    productHeight() {
      return this.height + 2 * this.gap + 2 * this.frame + 2 * this.mat;
    },
    matWidth() {
      return this.frame === 0 ? 0 : this.mat / this.width * 100;
    },
    matHeight() {
      return this.frame === 0 ? 0 : this.mat / this.height * 100;
    },
    gapWidth() {
      return this.frame === 0 ? 0 : this.gap / this.width * 100;
    },
    gapHeight() {
      return this.frame === 0 ? 0 : this.gap / this.height * 100;
    },
    frameWidth() {
      return this.frame / this.width * 100;
    },
    frameHeight() {
      return this.frame / this.height * 100;
    },
    showImageEditor() {
      return !(this.selectedEditToolId && this.isMobile);
    },
    styleListImageEditor() {
      const t = (this.height - 2) / this.productHeight, e = (this.width - 2) / this.productWidth, r = this.gapHeight + this.matHeight + this.frameHeight, i = this.gapWidth + this.matWidth + this.frameWidth, n = r * (this.aspectRatio > 1 ? e : t), a = i * (this.aspectRatio > 1 ? e : t), s = this.aspectRatio > 1 ? 4 : 2, o = (100 - (this.aspectRatio > 1 ? e : t) * 100) / s, l = (100 - (this.aspectRatio > 1 ? e : t) * 100) / 2, c = this.aspectRatio >= 1 ? 10 : 0, u = o - n;
      let d = 0;
      return this.aspectRatio < 0.45 ? d = this.isMobile ? this.clientWidth : "450" : this.isMobile && this.selectedEditToolId && (d = this.clientWidth), {
        "margin-top": `calc(-${u > 0 ? u : 0}% + ${c}px)`,
        "margin-left": this.isMobile && this.selectedEditToolId ? "0px" : `${l - a}%`,
        "margin-right": this.isMobile && this.selectedEditToolId ? "0px" : `${l - a}%`,
        "min-width": d + "px",
        left: d ? "50%" : "",
        transform: d ? "translateX(-50%)" : "",
        position: d ? "absolute" : ""
      };
    },
    pointerEventsNone() {
      return this.preview ? "" : "pointer-events-none";
    }
  },
  watch: {
    visible: function(t, e) {
      t === !1 && (this.currentScale = 1);
    },
    width: function() {
      this.setClientDimensions();
    },
    height: function() {
      this.setClientDimensions();
    }
  },
  mounted() {
    this.rotateX = this.defaultRotateX != null ? this.defaultRotateX : this.rotateX, this.rotateY = this.defaultRotateY != null ? this.defaultRotateY : this.rotateY, this.enableInitialAnimation && this.animatePreview(), this.hammer = new vr.Manager(this.$el), this.hammer.options.domEvents = !0;
    const t = new vr.Pan({ threshold: 0, pointers: 0 });
    if (this.hammer.add(t), this.canManipulate === !0) {
      const r = new vr.Pinch({ threshold: 0 });
      this.hammer.add(r).recognizeWith([t]), this.$el.addEventListener("touchmove", (n) => this.preventEvent(n), { passive: !1 }), this.hammer.on("panstart panmove panend", (n) => this.handlePan(n)), this.hammer.on("pinchstart pinchmove", (n) => this.handlePinch(n));
      let i = !1;
      try {
        var e = Object.defineProperty({}, "passive", {
          get: () => {
            i = { passive: !0 };
          }
        });
        window.addEventListener("testPassive", null, e), window.removeEventListener("testPassive", null, e);
      } catch {
      }
      this.passiveMouseWheel || (i = { passive: !1 }), this.$el.addEventListener("wheel", (n) => this.handleWheel(n), i);
    }
    window.addEventListener("resize", this.setClientDimensions), this.setClientDimensions();
  },
  methods: {
    /**
     * Handles the pan event on the preview.
     *
     * @param {Event} event
     * @param {SVGElement} element
     */
    handlePan(t) {
      if (this.events)
        if (this.isRotating = !0, t.type === "panstart")
          this.startX = this.rotateX, this.startY = this.rotateY;
        else if (t.type === "panend")
          clearTimeout(this.rotateTimer), this.rotateTimer = setTimeout(() => {
            this.isRotating = !1;
          }, 100);
        else {
          let e = this.startX + t.deltaX / (this.clientWidth / 1.5) * this.maxRotation, r = this.startY + t.deltaY / (this.clientWidth / 1.5) * this.minRotation;
          e = Math.min(Math.max(e, this.minRotation), this.maxRotation), r = Math.min(Math.max(r, this.minRotation), this.maxRotation), this.rotateX = e, this.rotateY = r, t.preventDefault();
        }
    },
    handlePinch(t) {
      if (this.events) {
        if (this.isZooming = !0, t.type === "pinchstart")
          this.scaleStart = this.currentScale;
        else if (t.type === "pinchend")
          clearTimeout(this.scaleTimer), this.scaleTimer = setTimeout(() => {
            this.isZooming = !1;
          }, 100);
        else {
          let e = this.scaleStart * t.scale;
          this.currentScale = this.clampScale(e);
        }
        this.preventEvent(t);
      }
    },
    /**
     * Handles zooming with the mousewheel.
     *
     * @param {Event} event
     */
    handleWheel(t) {
      if (this.events) {
        this.isZooming = !0;
        let e = this.currentScale;
        e += e * (-t.deltaY / 200), this.currentScale = this.clampScale(e), clearTimeout(this.scaleTimer), this.scaleTimer = setTimeout(() => {
          this.isZooming = !1;
        }, 100), this.preventEvent(t);
      }
    },
    /**
     * Sets the clientWidth for the component so that we can accurately
     * calculate the rotation of the preview on a pan gesture.
     */
    setClientDimensions(t) {
      this.timeout && window.cancelAnimationFrame(this.timeout), this.timeout = window.requestAnimationFrame(() => {
        this.clientWidth = this.$el.clientWidth, this.clientHeight = this.$el.clientHeight;
      });
    },
    /**
     * Clamps the scale between a minimum and maximum.
     *
     * @param {Number} scale
     * @return {Number}
     */
    clampScale(t) {
      return Math.min(Math.max(t, this.minScale), this.maxScale);
    },
    /**
     * Prevents default on an event when possible.
     */
    preventEvent(t) {
      t.cancelable && t.preventDefault();
    },
    animatePreview() {
      let t = this;
      new Promise((e, r) => {
        setTimeout(() => {
          t.rotateX = 30, e();
        }, 750);
      }).then(
        () => new Promise((e, r) => {
          setTimeout(() => {
            t.rotateX = 1e-7, e();
          }, 1e3);
        })
      );
    }
  }
}, fy = { class: "relative w-full h-auto max-w-full preserve-3d pointer-events-none" }, gy = { class: "flex relative justify-center items-center preserve-3d" }, py = /* @__PURE__ */ E("div", { class: "clear-both float-left" }, null, -1);
function my(t, e, r, i, n, a) {
  const s = it("Preview"), o = it("ImageEditTools");
  return R(), M("div", {
    class: re(["flex flex-grow w-full justify-center items-center", [r.renderMode ? "z-10" : "z-0", a.pointerEventsNone]]),
    style: J(a.styleList)
  }, [
    E("div", {
      class: "flex relative justify-center items-center",
      style: J(a.styleListContainer)
    }, [
      E("div", fy, [
        E("div", gy, [
          (R(!0), M(ci, null, ui(r.panels, (l, c) => (R(), ht(s, {
            key: `preview-${c}-${r.tileIndex}`,
            offset: c,
            isMobile: r.isMobile,
            isArt: r.isArt,
            panels: r.panels,
            width: r.width / r.panels,
            height: r.height,
            edge: r.edge,
            frame: r.frame,
            gap: r.gap,
            mat: r.mat,
            "frame-color": r.frameColor,
            preview: r.preview,
            cornerRadius: r.cornerRadius,
            productWidth: a.productWidth / r.panels,
            productHeight: a.productHeight,
            matWidth: a.matWidth,
            matHeight: a.matHeight,
            gapWidth: a.gapWidth,
            gapHeight: a.gapHeight,
            frameWidth: a.frameWidth,
            frameHeight: a.frameHeight,
            frameType: r.frameType,
            tileIndex: r.tileIndex
          }, null, 8, ["offset", "isMobile", "isArt", "panels", "width", "height", "edge", "frame", "gap", "mat", "frame-color", "preview", "cornerRadius", "productWidth", "productHeight", "matWidth", "matHeight", "gapWidth", "gapHeight", "frameWidth", "frameHeight", "frameType", "tileIndex"]))), 128))
        ]),
        py,
        Ue(qt, { name: "transition-slide-fade-bottom-delay" }, {
          default: ft(() => [
            E("div", {
              "data-image-editor": "",
              style: J(a.styleListImageEditor),
              class: "pointer-events-auto"
            }, [
              Ue(o, {
                isMobile: r.isMobile,
                canEdit: r.canEdit && a.showImageEditor,
                tileLabel: r.tileLabel,
                tileIndex: r.tileIndex
              }, null, 8, ["isMobile", "canEdit", "tileLabel", "tileIndex"])
            ], 4)
          ]),
          _: 1
        })
      ])
    ], 4)
  ], 6);
}
const Pf = /* @__PURE__ */ Ce(hy, [["render", my]]), vy = {
  name: "Printable",
  props: {
    panels: {
      type: Number,
      default: 1
    },
    width: {
      type: Number,
      required: !0
    },
    height: {
      type: Number,
      required: !0
    },
    edgeDimension: {
      type: Number,
      required: !0
    },
    edgeColor: {
      type: String,
      default: ""
    },
    edgeType: {
      type: String,
      default: ""
    },
    renderMode: {
      type: Boolean,
      default: !1
    },
    frame: {
      type: Number,
      required: !0,
      default: 0
    },
    gap: {
      type: Number,
      required: !0,
      default: 0
    },
    mat: {
      type: Number,
      required: !0,
      default: 0
    },
    mgiPrintEdge: {
      type: Number,
      default: 0
    },
    mgiPhotoBorderBleed: {
      type: Number,
      default: 0
    },
    proofIndex: {
      type: Number,
      default: null
    },
    isMobile: {
      type: Boolean,
      default: !1
    },
    selectedEditToolId: {
      type: Number,
      default: null
    },
    wrapperPaddingClasslist: {
      type: String,
      default: ""
    },
    tileIndex: {
      type: Number,
      default: 0
    },
    featureFlags: {
      type: Object,
      default: () => {
      }
    },
    id: {
      type: String,
      default: "printable"
    }
  },
  data() {
    return {};
  },
  computed: {
    printableClasslist() {
      return [
        this.renderMode ? "z-0" : "z-10",
        "flex justify-center items-center",
        this.wrapperPaddingClasslist
      ];
    },
    hasPhotoBorder() {
      return (!this.edgeColor || this.mgiPrintEdge !== 0 || this.mgiPhotoBorderBleed !== 0) && !this.hasBlurBorder;
    },
    panelWidth() {
      return this.width / this.panels + 2 * this.edgeDimension;
    },
    panelHeight() {
      return this.height + 2 * this.edgeDimension;
    },
    totalWidth() {
      return this.panelWidth * this.panels;
    },
    edge() {
      return this.hasPhotoBorder ? 2 * this.edgeDimension : 0;
    },
    productWidth() {
      return this.width + 2 * this.gap + 2 * this.frame + 2 * this.mat;
    },
    productHeight() {
      return this.height + 2 * this.gap + 2 * this.frame + 2 * this.mat;
    },
    aspectRatio() {
      return this.width / this.height;
    },
    styleListContainer() {
      return {
        transform: this.aspectRatio >= 1 ? `scale(${(this.width - 2) / this.productWidth})` : `scale(${(this.height - 2) / this.productHeight})`
      };
    },
    sourceSelector() {
      return this.proofIndex !== null ? "#source-" + this.proofIndex : this.tileIndex !== null ? "#source-" + this.tileIndex : "#source";
    },
    hasBlurBorder() {
      var t;
      return ((t = this.featureFlags) == null ? void 0 : t.enableBlurBorder) && this.edgeType === "BLB";
    },
    enlargedPanelWidth() {
      return this.panelWidth + this.edgeDimension;
    },
    enlargedPanelHeight() {
      return this.panelHeight + this.edgeDimension;
    },
    blurBorderWidth() {
      return this.aspectRatio > 1 ? this.width / this.height * this.enlargedPanelHeight : this.enlargedPanelWidth;
    },
    blurBorderHeight() {
      return this.aspectRatio < 1 ? this.height / this.width * this.enlargedPanelWidth : this.enlargedPanelHeight;
    },
    blurBorderPositionX() {
      return this.aspectRatio > 1 ? (this.blurBorderWidth - this.enlargedPanelWidth) / 2 * -1 : this.edgeDimension / 2 * -1;
    },
    blurBorderPositionY() {
      return this.aspectRatio < 1 ? (this.blurBorderHeight - this.enlargedPanelHeight) / 2 * -1 : this.edgeDimension / 2 * -1;
    },
    blurEdgeStyleList() {
      return {
        filter: this.hasBlurBorder ? `blur(${0.25}px)` : "none"
      };
    }
  },
  mounted() {
    this.$el.addEventListener("wheel", () => {
    }, { passive: !0 });
  },
  methods: {
    getIndex(t) {
      return this.proofIndex ? this.proofIndex : t;
    }
  }
}, yy = ["id", "viewBox"], by = ["id", "viewBox", "width", "height", "x"], xy = ["width", "height", "fill"], Sy = ["viewBox", "width", "height", "x", "y"], wy = ["xlink:href"], Ey = ["xlink:href"], Ty = ["viewBox", "width", "height", "x", "y"], Py = ["id"], Oy = ["x", "width", "height"], Cy = ["xlink:href", "clip-path"];
function Iy(t, e, r, i, n, a) {
  return R(), M("div", {
    class: re(["m-auto max-h-full max-w-full absolute inset-0 opacity-0 pointer-events-none", a.printableClasslist])
  }, [
    (R(), M("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      id: r.id,
      viewBox: `0 0 ${a.totalWidth} ${a.panelHeight}`,
      style: J(a.styleListContainer),
      class: "pointer-events-auto flex-1 max-w-full max-h-full h-auto w-auto"
    }, [
      Tr(t.$slots, "default"),
      (R(!0), M(ci, null, ui(r.panels, (s, o) => (R(), M("svg", {
        id: `printable-${a.getIndex(o)}-${r.tileIndex}`,
        key: `panel-${a.getIndex(o)}-${r.tileIndex}`,
        class: "pointer-events-none",
        viewBox: `0 0 ${a.panelWidth} ${a.panelHeight}`,
        width: a.panelWidth,
        height: a.panelHeight,
        x: a.panelWidth * a.getIndex(o),
        "aria-hidden": "true",
        tabindex: "-1"
      }, [
        a.hasBlurBorder ? Q("", !0) : (R(), M("rect", {
          key: 0,
          x: "0",
          y: "0",
          width: a.panelWidth,
          height: a.panelHeight,
          fill: r.edgeColor
        }, null, 8, xy)),
        a.hasBlurBorder ? (R(), M("svg", {
          key: 1,
          "data-blur-edge": "",
          viewBox: `0 0 ${a.blurBorderWidth} ${a.blurBorderHeight}`,
          width: a.blurBorderWidth,
          height: a.blurBorderHeight,
          x: a.blurBorderPositionX,
          y: a.blurBorderPositionY
        }, [
          E("use", { "xlink:href": a.sourceSelector }, null, 8, wy),
          E("use", {
            style: J(a.blurEdgeStyleList),
            "xlink:href": a.sourceSelector
          }, null, 12, Ey)
        ], 8, Sy)) : Q("", !0),
        (R(), M("svg", {
          viewBox: `0 0 ${r.width + a.edge} ${r.height + a.edge}`,
          width: r.width + a.edge,
          height: r.height + a.edge,
          x: (a.hasPhotoBorder ? 0 : r.edgeDimension) - r.width / r.panels * o,
          y: a.hasPhotoBorder ? 0 : r.edgeDimension
        }, [
          E("defs", null, [
            E("clipPath", {
              id: `path-${a.getIndex(o)}-${r.tileIndex}`
            }, [
              E("rect", {
                x: r.width / r.panels * o,
                y: "0",
                width: r.width / r.panels + a.edge,
                height: r.height + a.edge,
                fill: "#fff"
              }, null, 8, Oy)
            ], 8, Py)
          ]),
          E("use", {
            "xlink:href": a.sourceSelector,
            "clip-path": `url(#path-${a.getIndex(o)}-${r.tileIndex})`,
            tabindex: "-1"
          }, null, 8, Cy)
        ], 8, Ty))
      ], 8, by))), 128))
    ], 12, yy))
  ], 2);
}
const Of = /* @__PURE__ */ Ce(vy, [["render", Iy]]), Cf = "proof-review", _y = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  PROOF_REVIEW_CONTEXT: Cf
}, Symbol.toStringTag, { value: "Module" }));
var If = globalThis && globalThis.__awaiter || function(t, e, r, i) {
  function n(a) {
    return a instanceof r ? a : new r(function(s) {
      s(a);
    });
  }
  return new (r || (r = Promise))(function(a, s) {
    function o(u) {
      try {
        c(i.next(u));
      } catch (d) {
        s(d);
      }
    }
    function l(u) {
      try {
        c(i.throw(u));
      } catch (d) {
        s(d);
      }
    }
    function c(u) {
      u.done ? a(u.value) : n(u.value).then(o, l);
    }
    c((i = i.apply(t, e || [])).next());
  });
};
const tu = "application/font-woff", ru = "image/jpeg", Ay = {
  woff: tu,
  woff2: tu,
  ttf: "application/font-truetype",
  eot: "application/vnd.ms-fontobject",
  png: "image/png",
  jpg: ru,
  jpeg: ru,
  gif: "image/gif",
  tiff: "image/tiff",
  svg: "image/svg+xml"
};
function Ry(t) {
  const e = /\.([^./]*?)$/g.exec(t);
  return e ? e[1] : "";
}
function la(t) {
  const e = Ry(t).toLowerCase();
  return Ay[e] || "";
}
function My(t, e) {
  if (t.match(/^[a-z]+:\/\//i))
    return t;
  if (t.match(/^\/\//))
    return window.location.protocol + t;
  if (t.match(/^[a-z]+:/i))
    return t;
  const r = document.implementation.createHTMLDocument(), i = r.createElement("base"), n = r.createElement("a");
  return r.head.appendChild(i), r.body.appendChild(n), e && (i.href = e), n.href = t, n.href;
}
function go(t) {
  return t.search(/^(data:)/) !== -1;
}
function ca(t, e) {
  return `data:${e};base64,${t}`;
}
function Ly(t) {
  return t.split(/,/)[1];
}
const Dy = function() {
  let e = 0;
  const r = () => (
    // eslint-disable-next-line no-bitwise
    `0000${(Math.random() * Math.pow(36, 4) << 0).toString(36)}`.slice(-4)
  );
  return () => (e += 1, `u${r()}${e}`);
}();
function Kt(t) {
  const e = [];
  for (let r = 0, i = t.length; r < i; r += 1)
    e.push(t[r]);
  return e;
}
function ua(t, e) {
  const r = window.getComputedStyle(t).getPropertyValue(e);
  return parseFloat(r.replace("px", ""));
}
function Ny(t) {
  const e = ua(t, "border-left-width"), r = ua(t, "border-right-width");
  return t.clientWidth + e + r;
}
function jy(t) {
  const e = ua(t, "border-top-width"), r = ua(t, "border-bottom-width");
  return t.clientHeight + e + r;
}
function ky() {
  let t, e;
  try {
    e = process;
  } catch {
  }
  const r = e && e.env ? e.env.devicePixelRatio : null;
  return r && (t = parseInt(r, 10), Number.isNaN(t) && (t = 1)), t || window.devicePixelRatio || 1;
}
function zy(t) {
  return t.toBlob ? new Promise((e) => t.toBlob(e)) : new Promise((e) => {
    const r = window.atob(t.toDataURL().split(",")[1]), i = r.length, n = new Uint8Array(i);
    for (let a = 0; a < i; a += 1)
      n[a] = r.charCodeAt(a);
    e(new Blob([n], { type: "image/png" }));
  });
}
function Rl(t) {
  return new Promise((e, r) => {
    const i = new Image();
    i.onload = () => e(i), i.onerror = r, i.crossOrigin = "anonymous", i.decoding = "sync", i.src = t;
  });
}
function By(t) {
  return If(this, void 0, void 0, function* () {
    return Promise.resolve().then(() => new XMLSerializer().serializeToString(t)).then(encodeURIComponent).then((e) => `data:image/svg+xml;charset=utf-8,${e}`);
  });
}
function Fy(t, e, r) {
  return If(this, void 0, void 0, function* () {
    const i = "http://www.w3.org/2000/svg", n = document.createElementNS(i, "svg"), a = document.createElementNS(i, "foreignObject");
    return n.setAttribute("width", `${e}`), n.setAttribute("height", `${r}`), n.setAttribute("viewBox", `0 0 ${e} ${r}`), a.setAttribute("width", "100%"), a.setAttribute("height", "100%"), a.setAttribute("x", "0"), a.setAttribute("y", "0"), a.setAttribute("externalResourcesRequired", "true"), n.appendChild(a), a.appendChild(t), By(n);
  });
}
const os = {};
function $y(t) {
  let e = t.replace(/\?.*/, "");
  return /ttf|otf|eot|woff2?/i.test(e) && (e = e.replace(/.*\//, "")), e;
}
function Ml(t, e) {
  const r = $y(t);
  if (os[r] != null)
    return os[r];
  e.cacheBust && (t += (/\?/.test(t) ? "&" : "?") + (/* @__PURE__ */ new Date()).getTime());
  const i = (a) => {
    let s = "";
    if (e.imagePlaceholder) {
      const l = e.imagePlaceholder.split(/,/);
      l && l[1] && (s = l[1]);
    }
    let o = `Failed to fetch resource: ${t}`;
    return a && (o = typeof a == "string" ? a : a.message), o && console.error(o), {
      blob: s,
      contentType: ""
    };
  }, n = window.fetch(t).then((a) => (
    // eslint-disable-next-line promise/no-nesting
    a.blob().then((s) => ({
      blob: s,
      contentType: a.headers.get("Content-Type") || ""
    }))
  )).then(({ blob: a, contentType: s }) => new Promise((o, l) => {
    const c = new FileReader();
    c.onloadend = () => o({
      contentType: s,
      blob: c.result
    }), c.onerror = l, c.readAsDataURL(a);
  })).then(({ blob: a, contentType: s }) => ({
    contentType: s,
    blob: Ly(a)
  })).catch(i);
  return os[r] = n, n;
}
function Uy(t) {
  const e = t.getPropertyValue("content");
  return `${t.cssText} content: '${e.replace(/'|"/g, "")}';`;
}
function Vy(t) {
  return Kt(t).map((e) => {
    const r = t.getPropertyValue(e), i = t.getPropertyPriority(e);
    return `${e}: ${r}${i ? " !important" : ""};`;
  }).join(" ");
}
function Hy(t, e, r) {
  const i = `.${t}:${e}`, n = r.cssText ? Uy(r) : Vy(r);
  return document.createTextNode(`${i}{${n}}`);
}
function iu(t, e, r) {
  const i = window.getComputedStyle(t, r), n = i.getPropertyValue("content");
  if (n === "" || n === "none")
    return;
  const a = Dy();
  try {
    e.className = `${e.className} ${a}`;
  } catch {
    return;
  }
  const s = document.createElement("style");
  s.appendChild(Hy(a, r, i)), e.appendChild(s);
}
function Wy(t, e) {
  iu(t, e, ":before"), iu(t, e, ":after");
}
var vi = globalThis && globalThis.__awaiter || function(t, e, r, i) {
  function n(a) {
    return a instanceof r ? a : new r(function(s) {
      s(a);
    });
  }
  return new (r || (r = Promise))(function(a, s) {
    function o(u) {
      try {
        c(i.next(u));
      } catch (d) {
        s(d);
      }
    }
    function l(u) {
      try {
        c(i.throw(u));
      } catch (d) {
        s(d);
      }
    }
    function c(u) {
      u.done ? a(u.value) : n(u.value).then(o, l);
    }
    c((i = i.apply(t, e || [])).next());
  });
};
function Gy(t) {
  return vi(this, void 0, void 0, function* () {
    const e = t.toDataURL();
    return e === "data:," ? Promise.resolve(t.cloneNode(!1)) : Rl(e);
  });
}
function Yy(t, e) {
  return vi(this, void 0, void 0, function* () {
    return Promise.resolve(t.poster).then((r) => Ml(r, e)).then((r) => ca(r.blob, la(t.poster) || r.contentType)).then((r) => Rl(r));
  });
}
function Xy(t, e) {
  return vi(this, void 0, void 0, function* () {
    return t instanceof HTMLCanvasElement ? Gy(t) : t instanceof HTMLVideoElement && t.poster ? Yy(t, e) : Promise.resolve(t.cloneNode(!1));
  });
}
const qy = (t) => t.tagName != null && t.tagName.toUpperCase() === "SLOT";
function Ky(t, e, r) {
  var i;
  return vi(this, void 0, void 0, function* () {
    const n = qy(t) && t.assignedNodes ? Kt(t.assignedNodes()) : Kt(((i = t.shadowRoot) !== null && i !== void 0 ? i : t).childNodes);
    return n.length === 0 || t instanceof HTMLVideoElement ? Promise.resolve(e) : n.reduce((a, s) => a.then(() => _f(s, r)).then((o) => {
      o && e.appendChild(o);
    }), Promise.resolve()).then(() => e);
  });
}
function Zy(t, e) {
  const r = window.getComputedStyle(t), i = e.style;
  i && (r.cssText ? i.cssText = r.cssText : Kt(r).forEach((n) => {
    i.setProperty(n, r.getPropertyValue(n), r.getPropertyPriority(n));
  }));
}
function Qy(t, e) {
  t instanceof HTMLTextAreaElement && (e.innerHTML = t.value), t instanceof HTMLInputElement && e.setAttribute("value", t.value);
}
function Jy(t, e) {
  return vi(this, void 0, void 0, function* () {
    return e instanceof Element ? Promise.resolve().then(() => Zy(t, e)).then(() => Wy(t, e)).then(() => Qy(t, e)).then(() => e) : Promise.resolve(e);
  });
}
function _f(t, e, r) {
  return vi(this, void 0, void 0, function* () {
    return !r && e.filter && !e.filter(t) ? Promise.resolve(null) : Promise.resolve(t).then((i) => Xy(i, e)).then((i) => Ky(t, i, e)).then((i) => Jy(t, i));
  });
}
var eb = globalThis && globalThis.__awaiter || function(t, e, r, i) {
  function n(a) {
    return a instanceof r ? a : new r(function(s) {
      s(a);
    });
  }
  return new (r || (r = Promise))(function(a, s) {
    function o(u) {
      try {
        c(i.next(u));
      } catch (d) {
        s(d);
      }
    }
    function l(u) {
      try {
        c(i.throw(u));
      } catch (d) {
        s(d);
      }
    }
    function c(u) {
      u.done ? a(u.value) : n(u.value).then(o, l);
    }
    c((i = i.apply(t, e || [])).next());
  });
};
const Af = /url\((['"]?)([^'"]+?)\1\)/g, tb = /url\([^)]+\)\s*format\((["'])([^"']+)\1\)/g, rb = /src:\s*(?:url\([^)]+\)\s*format\([^)]+\)[,;]\s*)+/g;
function ib(t) {
  const e = t.replace(/([.*+?^${}()|\[\]\/\\])/g, "\\$1");
  return new RegExp(`(url\\(['"]?)(${e})(['"]?\\))`, "g");
}
function nb(t) {
  const e = [];
  return t.replace(Af, (r, i, n) => (e.push(n), r)), e.filter((r) => !go(r));
}
function ab(t, e, r, i, n) {
  const a = r ? My(e, r) : e;
  return Promise.resolve(a).then((s) => n ? n(s) : Ml(s, i)).then((s) => typeof s == "string" ? ca(s, la(e)) : ca(s.blob, la(e) || s.contentType)).then((s) => t.replace(ib(e), `$1${s}$3`)).then((s) => s, () => a);
}
function sb(t, { preferredFontFormat: e }) {
  return e ? t.replace(rb, (r) => {
    for (; ; ) {
      const [i, , n] = tb.exec(r) || [];
      if (!n)
        return "";
      if (n === e)
        return `src: ${i};`;
    }
  }) : t;
}
function Rf(t) {
  return t.search(Af) !== -1;
}
function Mf(t, e, r) {
  return eb(this, void 0, void 0, function* () {
    if (!Rf(t))
      return Promise.resolve(t);
    const i = sb(t, r);
    return Promise.resolve(i).then(nb).then((n) => n.reduce((a, s) => (
      // eslint-disable-next-line promise/no-nesting
      a.then((o) => ab(o, s, e, r))
    ), Promise.resolve(i)));
  });
}
var Ca = globalThis && globalThis.__awaiter || function(t, e, r, i) {
  function n(a) {
    return a instanceof r ? a : new r(function(s) {
      s(a);
    });
  }
  return new (r || (r = Promise))(function(a, s) {
    function o(u) {
      try {
        c(i.next(u));
      } catch (d) {
        s(d);
      }
    }
    function l(u) {
      try {
        c(i.throw(u));
      } catch (d) {
        s(d);
      }
    }
    function c(u) {
      u.done ? a(u.value) : n(u.value).then(o, l);
    }
    c((i = i.apply(t, e || [])).next());
  });
};
function ob(t, e) {
  var r;
  return Ca(this, void 0, void 0, function* () {
    const i = (r = t.style) === null || r === void 0 ? void 0 : r.getPropertyValue("background");
    return i ? Promise.resolve(i).then((n) => Mf(n, null, e)).then((n) => (t.style.setProperty("background", n, t.style.getPropertyPriority("background")), t)) : Promise.resolve(t);
  });
}
function lb(t, e) {
  return Ca(this, void 0, void 0, function* () {
    if (!(t instanceof HTMLImageElement && !go(t.src)) && !(t instanceof SVGImageElement && !go(t.href.baseVal)))
      return Promise.resolve(t);
    const r = t instanceof HTMLImageElement ? t.src : t.href.baseVal;
    return Promise.resolve(r).then((i) => Ml(i, e)).then((i) => ca(i.blob, la(r) || i.contentType)).then((i) => new Promise((n, a) => {
      t.onload = n, t.onerror = a, t instanceof HTMLImageElement ? (t.srcset = "", t.src = i) : t.href.baseVal = i;
    })).then(() => t, () => t);
  });
}
function cb(t, e) {
  return Ca(this, void 0, void 0, function* () {
    const i = Kt(t.childNodes).map((n) => Lf(n, e));
    return Promise.all(i).then(() => t);
  });
}
function Lf(t, e) {
  return Ca(this, void 0, void 0, function* () {
    return t instanceof Element ? Promise.resolve(t).then((r) => ob(r, e)).then((r) => lb(r, e)).then((r) => cb(r, e)) : Promise.resolve(t);
  });
}
function ub(t, e) {
  const { style: r } = t;
  e.backgroundColor && (r.backgroundColor = e.backgroundColor), e.width && (r.width = `${e.width}px`), e.height && (r.height = `${e.height}px`);
  const i = e.style;
  return i != null && Object.keys(i).forEach((n) => {
    r[n] = i[n];
  }), t;
}
var un = globalThis && globalThis.__awaiter || function(t, e, r, i) {
  function n(a) {
    return a instanceof r ? a : new r(function(s) {
      s(a);
    });
  }
  return new (r || (r = Promise))(function(a, s) {
    function o(u) {
      try {
        c(i.next(u));
      } catch (d) {
        s(d);
      }
    }
    function l(u) {
      try {
        c(i.throw(u));
      } catch (d) {
        s(d);
      }
    }
    function c(u) {
      u.done ? a(u.value) : n(u.value).then(o, l);
    }
    c((i = i.apply(t, e || [])).next());
  });
};
const nu = {};
function au(t) {
  const e = nu[t];
  if (e != null)
    return e;
  const r = window.fetch(t).then((i) => ({
    url: t,
    cssText: i.text()
  }));
  return nu[t] = r, r;
}
function su(t) {
  return un(this, void 0, void 0, function* () {
    return t.cssText.then((e) => {
      let r = e;
      const i = /url\(["']?([^"')]+)["']?\)/g, a = (r.match(/url\([^)]+\)/g) || []).map((s) => {
        let o = s.replace(i, "$1");
        return o.startsWith("https://") || (o = new URL(o, t.url).href), window.fetch(o).then((l) => l.blob()).then((l) => new Promise((c, u) => {
          const d = new FileReader();
          d.onloadend = () => {
            r = r.replace(s, `url(${d.result})`), c([s, d.result]);
          }, d.onerror = u, d.readAsDataURL(l);
        }));
      });
      return Promise.all(a).then(() => r);
    });
  });
}
function ou(t) {
  if (t == null)
    return [];
  const e = [], r = /(\/\*[\s\S]*?\*\/)/gi;
  let i = t.replace(r, "");
  const n = new RegExp("((@.*?keyframes [\\s\\S]*?){([\\s\\S]*?}\\s*?)})", "gi");
  for (; ; ) {
    const l = n.exec(i);
    if (l === null)
      break;
    e.push(l[0]);
  }
  i = i.replace(n, "");
  const a = /@import[\s\S]*?url\([^)]*\)[\s\S]*?;/gi, s = "((\\s*?(?:\\/\\*[\\s\\S]*?\\*\\/)?\\s*?@media[\\s\\S]*?){([\\s\\S]*?)}\\s*?})|(([\\s\\S]*?){([\\s\\S]*?)})", o = new RegExp(s, "gi");
  for (; ; ) {
    let l = a.exec(i);
    if (l === null) {
      if (l = o.exec(i), l === null)
        break;
      a.lastIndex = o.lastIndex;
    } else
      o.lastIndex = a.lastIndex;
    e.push(l[0]);
  }
  return e;
}
function db(t) {
  return un(this, void 0, void 0, function* () {
    const e = [], r = [];
    return t.forEach((i) => {
      if ("cssRules" in i)
        try {
          Kt(i.cssRules).forEach((n, a) => {
            if (n.type === CSSRule.IMPORT_RULE) {
              let s = a + 1;
              const o = n.href, l = au(o).then((c) => c ? su(c) : "").then((c) => ou(c).forEach((u) => {
                try {
                  i.insertRule(u, u.startsWith("@import") ? s += 1 : i.cssRules.length);
                } catch (d) {
                  console.error("Error inserting rule from remote css", {
                    rule: u,
                    error: d
                  });
                }
              })).catch((c) => {
                console.error("Error loading remote css", c.toString());
              });
              r.push(l);
            }
          });
        } catch (n) {
          const a = t.find((s) => s.href == null) || document.styleSheets[0];
          i.href != null && r.push(au(i.href).then((s) => s ? su(s) : "").then((s) => ou(s).forEach((o) => {
            a.insertRule(o, i.cssRules.length);
          })).catch((s) => {
            console.error("Error loading remote stylesheet", s.toString());
          })), console.error("Error inlining remote css file", n.toString());
        }
    }), Promise.all(r).then(() => (t.forEach((i) => {
      if ("cssRules" in i)
        try {
          Kt(i.cssRules).forEach((n) => {
            e.push(n);
          });
        } catch (n) {
          console.error(`Error while reading CSS rules from ${i.href}`, n.toString());
        }
    }), e));
  });
}
function hb(t) {
  return t.filter((e) => e.type === CSSRule.FONT_FACE_RULE).filter((e) => Rf(e.style.getPropertyValue("src")));
}
function fb(t) {
  return un(this, void 0, void 0, function* () {
    return new Promise((e, r) => {
      t.ownerDocument == null && r(new Error("Provided element is not within a Document")), e(Kt(t.ownerDocument.styleSheets));
    }).then((e) => db(e)).then(hb);
  });
}
function gb(t, e) {
  return un(this, void 0, void 0, function* () {
    return fb(t).then((r) => Promise.all(r.map((i) => {
      const n = i.parentStyleSheet ? i.parentStyleSheet.href : null;
      return Mf(i.cssText, n, e);
    }))).then((r) => r.join(`
`));
  });
}
function pb(t, e) {
  return un(this, void 0, void 0, function* () {
    return (e.fontEmbedCSS != null ? Promise.resolve(e.fontEmbedCSS) : gb(t, e)).then((r) => {
      const i = document.createElement("style"), n = document.createTextNode(r);
      return i.appendChild(n), t.firstChild ? t.insertBefore(i, t.firstChild) : t.appendChild(i), t;
    });
  });
}
var Ll = globalThis && globalThis.__awaiter || function(t, e, r, i) {
  function n(a) {
    return a instanceof r ? a : new r(function(s) {
      s(a);
    });
  }
  return new (r || (r = Promise))(function(a, s) {
    function o(u) {
      try {
        c(i.next(u));
      } catch (d) {
        s(d);
      }
    }
    function l(u) {
      try {
        c(i.throw(u));
      } catch (d) {
        s(d);
      }
    }
    function c(u) {
      u.done ? a(u.value) : n(u.value).then(o, l);
    }
    c((i = i.apply(t, e || [])).next());
  });
};
function Df(t, e = {}) {
  const r = e.width || Ny(t), i = e.height || jy(t);
  return { width: r, height: i };
}
function mb(t, e = {}) {
  return Ll(this, void 0, void 0, function* () {
    const { width: r, height: i } = Df(t, e);
    return Promise.resolve(t).then((n) => _f(n, e, !0)).then((n) => pb(n, e)).then((n) => Lf(n, e)).then((n) => ub(n, e)).then((n) => Fy(n, r, i));
  });
}
const Ye = 16384;
function vb(t) {
  (t.width > Ye || t.height > Ye) && (t.width > Ye && t.height > Ye ? t.width > t.height ? (t.height *= Ye / t.width, t.width = Ye) : (t.width *= Ye / t.height, t.height = Ye) : t.width > Ye ? (t.height *= Ye / t.width, t.width = Ye) : (t.width *= Ye / t.height, t.height = Ye));
}
function yb(t, e = {}) {
  return Ll(this, void 0, void 0, function* () {
    return mb(t, e).then(Rl).then((r) => {
      const i = document.createElement("canvas"), n = i.getContext("2d"), a = e.pixelRatio || ky(), { width: s, height: o } = Df(t, e), l = e.canvasWidth || s, c = e.canvasHeight || o;
      return i.width = l * a, i.height = c * a, e.skipAutoScale || vb(i), i.style.width = `${l}`, i.style.height = `${c}`, e.backgroundColor && (n.fillStyle = e.backgroundColor, n.fillRect(0, 0, i.width, i.height)), n.drawImage(r, 0, 0, i.width, i.height), i;
    });
  });
}
function bb(t, e = {}) {
  return Ll(this, void 0, void 0, function* () {
    return yb(t, e).then(zy);
  });
}
var Nf = { exports: {} };
(function(t, e) {
  (function(r, i) {
    i();
  })(xt, function() {
    function r(c, u) {
      return typeof u > "u" ? u = { autoBom: !1 } : typeof u != "object" && (console.warn("Deprecated: Expected third argument to be a object"), u = { autoBom: !u }), u.autoBom && /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(c.type) ? new Blob(["\uFEFF", c], { type: c.type }) : c;
    }
    function i(c, u, d) {
      var h = new XMLHttpRequest();
      h.open("GET", c), h.responseType = "blob", h.onload = function() {
        l(h.response, u, d);
      }, h.onerror = function() {
        console.error("could not download file");
      }, h.send();
    }
    function n(c) {
      var u = new XMLHttpRequest();
      u.open("HEAD", c, !1);
      try {
        u.send();
      } catch {
      }
      return 200 <= u.status && 299 >= u.status;
    }
    function a(c) {
      try {
        c.dispatchEvent(new MouseEvent("click"));
      } catch {
        var u = document.createEvent("MouseEvents");
        u.initMouseEvent("click", !0, !0, window, 0, 0, 0, 80, 20, !1, !1, !1, !1, 0, null), c.dispatchEvent(u);
      }
    }
    var s = typeof window == "object" && window.window === window ? window : typeof self == "object" && self.self === self ? self : typeof xt == "object" && xt.global === xt ? xt : void 0, o = s.navigator && /Macintosh/.test(navigator.userAgent) && /AppleWebKit/.test(navigator.userAgent) && !/Safari/.test(navigator.userAgent), l = s.saveAs || (typeof window != "object" || window !== s ? function() {
    } : "download" in HTMLAnchorElement.prototype && !o ? function(c, u, d) {
      var h = s.URL || s.webkitURL, f = document.createElement("a");
      u = u || c.name || "download", f.download = u, f.rel = "noopener", typeof c == "string" ? (f.href = c, f.origin === location.origin ? a(f) : n(f.href) ? i(c, u, d) : a(f, f.target = "_blank")) : (f.href = h.createObjectURL(c), setTimeout(function() {
        h.revokeObjectURL(f.href);
      }, 4e4), setTimeout(function() {
        a(f);
      }, 0));
    } : "msSaveOrOpenBlob" in navigator ? function(c, u, d) {
      if (u = u || c.name || "download", typeof c != "string")
        navigator.msSaveOrOpenBlob(r(c, d), u);
      else if (n(c))
        i(c, u, d);
      else {
        var h = document.createElement("a");
        h.href = c, h.target = "_blank", setTimeout(function() {
          a(h);
        });
      }
    } : function(c, u, d, h) {
      if (h = h || open("", "_blank"), h && (h.document.title = h.document.body.innerText = "downloading..."), typeof c == "string")
        return i(c, u, d);
      var f = c.type === "application/octet-stream", v = /constructor/i.test(s.HTMLElement) || s.safari, p = /CriOS\/[\d]+/.test(navigator.userAgent);
      if ((p || f && v || o) && typeof FileReader < "u") {
        var b = new FileReader();
        b.onloadend = function() {
          var w = b.result;
          w = p ? w : w.replace(/^data:[^;]*;/, "data:attachment/file;"), h ? h.location.href = w : location = w, h = null;
        }, b.readAsDataURL(c);
      } else {
        var y = s.URL || s.webkitURL, x = y.createObjectURL(c);
        h ? h.location = x : location.href = x, h = null, setTimeout(function() {
          y.revokeObjectURL(x);
        }, 4e4);
      }
    });
    s.saveAs = l.saveAs = l, t.exports = l;
  });
})(Nf);
var xb = Nf.exports;
const Sb = {
  name: "Proof",
  components: {
    Printable: Of,
    Panes: Ef,
    Preview: Tf,
    Previews: Pf,
    Loader: xl
  },
  props: {
    productData: {
      type: Object,
      default: () => {
      }
    },
    fixedPixelHeight: {
      type: Number,
      default: 0
    },
    enableScaleAnimation: {
      type: Boolean,
      default: !0
    },
    fullScreenOnly: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      proofs: _y,
      isFullScreen: !1,
      isCapturing: !1,
      isMobile: !1
    };
  },
  emits: [
    "close"
  ],
  computed: {
    ...vf({
      featureFlags: "app/featureFlags",
      panes: "builder/panes",
      isArt: "builder/isArt",
      productSlug: "product/productSlug",
      images: "product/images",
      selectedWidth: "product/width",
      selectedHeight: "product/height",
      edgeDimension: "product/edgeDimension",
      borderDimension: "product/borderDimension",
      borderColorValue: "product/borderColorValue",
      gapDimension: "product/gapDimension",
      matDimension: "product/matDimension",
      frameDimension: "product/frameDimension",
      selectedFrame: "product/frame",
      frameColor: "product/frameColor",
      edgeColor: "product/edgeColor",
      panels: "product/panels",
      mgiImages: "product/mgiImages",
      mgiPrintEdge: "product/mgiPrintEdge",
      mgiPhotoBorderBleed: "product/mgiPhotoBorderBleed",
      imageEditTrigger: "image/imageEditTrigger"
    }),
    screenHeightStyle() {
      return this.fixedPixelHeight && !this.isFullScreen ? {
        height: this.fixedPixelHeight + "px"
      } : null;
    },
    screenHeightClassList() {
      if (!this.fixedPixelHeight || this.isFullScreen)
        return [
          "h-full",
          this.aspectRatio >= 1.5 && this.isFullScreen ? "py-32" : ""
        ];
    },
    proofContainerClassList() {
      return [
        this.isFullScreen ? "preview-container fixed h-full w-full top-0 left-0" : "relative rounded flex-1"
      ];
    },
    checkForMobile() {
      this.isMobile = !window.matchMedia("(min-width: 768px)").matches;
    },
    aspectRatio() {
      return this.selectedWidth / this.selectedHeight;
    }
  },
  mounted() {
    this.init(), document.addEventListener("keyup", this.handleKeyEventToggling);
  },
  beforeUnmount() {
    document.removeEventListener("keyup", this.handleKeyEventToggling);
  },
  methods: {
    ...Il({
      setProofOnlyProductData: "product/setProofOnlyProductData"
    }),
    async init() {
      this.fullScreenOnly && this.toggleFullScreen(!0), await this.setProofOnlyProductData(this.productData);
    },
    toggleFullScreen(t) {
      this.isFullScreen = t, this.$refs.previews.setClientDimensions(), t || this.$emit("close");
    },
    takeScreenshot() {
      this.isCapturing = !0;
      var t = this;
      const e = document.querySelectorAll("*");
      Array.from(e).filter(
        (n) => n.hasAttribute("xlink:href")
      ).forEach((n) => {
        const a = n.getAttribute("xlink:href");
        n.removeAttribute("xlink:href"), n.setAttribute("href", a);
      });
      const i = document.querySelector(".preview-container");
      bb(i, { scale: 3 }).then(function(n) {
        xb.saveAs(n, "proof-" + Date.now() + ".jpg"), t.isCapturing = !1;
      });
    },
    handleKeyEventToggling(t) {
      const e = "which" in t ? t.which : t.keyCode;
      e === 27 && this.toggleFullScreen(!1), t.altKey && e === 70 && this.toggleFullScreen(!0);
    }
  }
}, wb = {
  key: 0,
  class: "fixed top-0 right-0 m-5"
}, Eb = {
  key: 0,
  class: "-ml-1 mr-0 h-6 w-6 inline",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, Tb = /* @__PURE__ */ E("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
}, null, -1), Pb = [
  Tb
], Ob = {
  key: 1,
  class: "animate-spin -ml-1 mr-0 h-6 w-6 inline text-black",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, Cb = /* @__PURE__ */ E("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1), Ib = /* @__PURE__ */ E("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1), _b = [
  Cb,
  Ib
], Ab = /* @__PURE__ */ S0(" Take screenshot "), Rb = /* @__PURE__ */ di(' Exit full screen <svg class="inline w-6" viewBox="0 0 375 375" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M347 17H28C21.9249 17 17 21.9249 17 28V347C17 353.075 21.9249 358 28 358H347C353.075 358 358 353.075 358 347V28C358 21.9249 353.075 17 347 17ZM28 0C12.536 0 0 12.536 0 28V347C0 362.464 12.536 375 28 375H347C362.464 375 375 362.464 375 347V28C375 12.536 362.464 0 347 0H28Z" fill="black"></path><path d="M61.7916 245V134.455H136.28V153.724H85.1637V180.065H132.448V199.335H85.1637V225.73H136.496V245H61.7916Z" fill="black"></path><path d="M223.413 185.733L202.362 187.028C202.002 185.229 201.228 183.61 200.041 182.171C198.853 180.695 197.288 179.526 195.345 178.662C193.438 177.762 191.153 177.313 188.49 177.313C184.927 177.313 181.922 178.068 179.476 179.58C177.029 181.055 175.805 183.034 175.805 185.517C175.805 187.496 176.597 189.17 178.18 190.537C179.763 191.904 182.48 193.002 186.331 193.83L201.336 196.852C209.397 198.508 215.406 201.171 219.365 204.841C223.323 208.511 225.302 213.333 225.302 219.307C225.302 224.741 223.701 229.509 220.498 233.611C217.332 237.713 212.977 240.916 207.436 243.219C201.93 245.486 195.579 246.619 188.382 246.619C177.406 246.619 168.662 244.334 162.149 239.764C155.672 235.158 151.875 228.897 150.76 220.98L173.376 219.793C174.06 223.139 175.715 225.694 178.342 227.457C180.969 229.185 184.333 230.048 188.436 230.048C192.466 230.048 195.705 229.275 198.152 227.727C200.635 226.144 201.894 224.111 201.93 221.628C201.894 219.541 201.012 217.831 199.285 216.5C197.558 215.133 194.895 214.089 191.297 213.369L176.939 210.509C168.842 208.889 162.815 206.082 158.856 202.088C154.934 198.094 152.973 193.002 152.973 186.813C152.973 181.487 154.412 176.899 157.291 173.048C160.206 169.198 164.29 166.229 169.544 164.142C174.833 162.055 181.023 161.011 188.112 161.011C198.583 161.011 206.824 163.224 212.833 167.651C218.879 172.077 222.405 178.104 223.413 185.733Z" fill="black"></path><path d="M277.242 246.619C268.749 246.619 261.444 244.82 255.327 241.222C249.246 237.587 244.568 232.549 241.293 226.108C238.054 219.667 236.435 212.254 236.435 203.869C236.435 195.377 238.072 187.928 241.347 181.523C244.658 175.081 249.354 170.062 255.435 166.463C261.516 162.829 268.749 161.011 277.134 161.011C284.367 161.011 290.7 162.325 296.134 164.952C301.568 167.579 305.868 171.267 309.034 176.017C312.201 180.767 313.946 186.345 314.27 192.75H292.571C291.96 188.612 290.34 185.283 287.713 182.764C285.123 180.209 281.722 178.932 277.512 178.932C273.949 178.932 270.837 179.903 268.174 181.847C265.547 183.754 263.496 186.543 262.02 190.213C260.545 193.884 259.807 198.328 259.807 203.546C259.807 208.835 260.527 213.333 261.966 217.04C263.442 220.746 265.511 223.571 268.174 225.514C270.837 227.457 273.949 228.429 277.512 228.429C280.139 228.429 282.496 227.889 284.583 226.81C286.706 225.73 288.451 224.165 289.819 222.114C291.222 220.027 292.14 217.526 292.571 214.611H314.27C313.91 220.944 312.183 226.522 309.088 231.344C306.03 236.13 301.802 239.872 296.404 242.571C291.006 245.27 284.619 246.619 277.242 246.619Z" fill="black"></path></svg>', 2), Mb = [
  Rb
];
function Lb(t, e, r, i, n, a) {
  const s = it("Loader"), o = it("Panes"), l = it("Printable"), c = it("Previews");
  return R(), M("div", null, [
    E("div", {
      class: re(["bg-gray-50", a.proofContainerClassList])
    }, [
      Ue(s, {
        overlay: "",
        visible: !1,
        class: "absolute inset-0 text-blue-500"
      }),
      E("div", {
        class: re(["flex-grow relative flex overflow-hidden cursor-move", a.screenHeightClassList]),
        style: J(a.screenHeightStyle)
      }, [
        (R(!0), M(ci, null, ui(t.mgiImages, (u, d) => (R(), ht(l, {
          key: `printable-${u.id}`,
          panels: 1,
          width: t.selectedWidth / t.panels,
          height: t.selectedHeight,
          "edge-dimension": t.edgeDimension,
          "edge-color": t.edgeColor,
          "render-mode": !0,
          frame: t.frameDimension,
          gap: t.gapDimension,
          mat: t.matDimension,
          "mgi-print-edge": t.mgiPrintEdge,
          "proof-index": d
        }, {
          default: ft(() => [
            Ue(o, {
              panes: t.panes,
              width: t.selectedWidth / t.panels,
              height: t.selectedHeight,
              edge: t.edgeDimension,
              "edge-color": t.edgeColor,
              border: t.borderDimension,
              "border-color": t.borderColorValue,
              images: t.images,
              events: !1,
              "render-mode": !0,
              "product-slug": t.productSlug,
              "mgi-print-edge": t.mgiPrintEdge,
              "mgi-photo-border-bleed": t.mgiPhotoBorderBleed,
              "mgi-image": u,
              "proof-index": d,
              imageEditTrigger: t.imageEditTrigger
            }, null, 8, ["panes", "width", "height", "edge", "edge-color", "border", "border-color", "images", "product-slug", "mgi-print-edge", "mgi-photo-border-bleed", "mgi-image", "proof-index", "imageEditTrigger"])
          ]),
          _: 2
        }, 1032, ["width", "height", "edge-dimension", "edge-color", "frame", "gap", "mat", "mgi-print-edge", "proof-index"]))), 128)),
        Ue(c, {
          ref: "previews",
          visible: !0,
          width: t.selectedWidth,
          height: t.selectedHeight,
          "render-mode": !0,
          "default-rotate-x": 0,
          "default-rotate-y": 0,
          "passive-mouse-wheel": !1,
          enableScaleAnimation: r.enableScaleAnimation,
          frame: t.frameDimension,
          gap: t.gapDimension,
          mat: t.matDimension,
          edge: t.edgeDimension,
          frameType: t.selectedFrame,
          "frame-color": t.frameColor,
          preview: !0,
          isMobile: n.isMobile,
          isArt: t.isArt,
          panels: t.panels,
          "can-manipulate": !0,
          "feature-flags": t.featureFlags
        }, null, 8, ["width", "height", "enableScaleAnimation", "frame", "gap", "mat", "edge", "frameType", "frame-color", "isMobile", "isArt", "panels", "feature-flags"])
      ], 6)
    ], 2),
    n.isFullScreen ? (R(), M("div", wb, [
      E("div", {
        onClick: e[0] || (e[0] = (...u) => a.takeScreenshot && a.takeScreenshot(...u)),
        "data-take-screenshot": "true",
        class: "btn btn--secondary right-0 ml-5"
      }, [
        n.isCapturing ? Q("", !0) : (R(), M("svg", Eb, Pb)),
        n.isCapturing ? (R(), M("svg", Ob, _b)) : Q("", !0),
        Ab
      ]),
      E("div", {
        onClick: e[1] || (e[1] = (u) => a.toggleFullScreen(!1)),
        class: "btn btn--secondary ml-5"
      }, Mb)
    ])) : (R(), M("div", {
      key: 1,
      onClick: e[2] || (e[2] = (u) => a.toggleFullScreen(!0)),
      class: "btn btn--secondary"
    }, " View fullscreen (alt + f) "))
  ]);
}
const Db = /* @__PURE__ */ Ce(Sb, [["render", Lb]]), Bn = (t, e) => {
  for (; t; t = t.parentNode)
    if (typeof t.matches == "function" && t.nodeType === Node.ELEMENT_NODE && t.matches(e))
      return t;
  return null;
};
var Dl = { exports: {} }, jf = function(e, r) {
  return function() {
    for (var n = new Array(arguments.length), a = 0; a < n.length; a++)
      n[a] = arguments[a];
    return e.apply(r, n);
  };
}, Nb = jf, Nl = Object.prototype.toString, jl = function(t) {
  return function(e) {
    var r = Nl.call(e);
    return t[r] || (t[r] = r.slice(8, -1).toLowerCase());
  };
}(/* @__PURE__ */ Object.create(null));
function _r(t) {
  return t = t.toLowerCase(), function(r) {
    return jl(r) === t;
  };
}
function kl(t) {
  return Array.isArray(t);
}
function da(t) {
  return typeof t > "u";
}
function jb(t) {
  return t !== null && !da(t) && t.constructor !== null && !da(t.constructor) && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
}
var kf = _r("ArrayBuffer");
function kb(t) {
  var e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && kf(t.buffer), e;
}
function zb(t) {
  return typeof t == "string";
}
function Bb(t) {
  return typeof t == "number";
}
function zf(t) {
  return t !== null && typeof t == "object";
}
function Fn(t) {
  if (jl(t) !== "object")
    return !1;
  var e = Object.getPrototypeOf(t);
  return e === null || e === Object.prototype;
}
var Fb = _r("Date"), $b = _r("File"), Ub = _r("Blob"), Vb = _r("FileList");
function zl(t) {
  return Nl.call(t) === "[object Function]";
}
function Hb(t) {
  return zf(t) && zl(t.pipe);
}
function Wb(t) {
  var e = "[object FormData]";
  return t && (typeof FormData == "function" && t instanceof FormData || Nl.call(t) === e || zl(t.toString) && t.toString() === e);
}
var Gb = _r("URLSearchParams");
function Yb(t) {
  return t.trim ? t.trim() : t.replace(/^\s+|\s+$/g, "");
}
function Xb() {
  return typeof navigator < "u" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS") ? !1 : typeof window < "u" && typeof document < "u";
}
function Bl(t, e) {
  if (!(t === null || typeof t > "u"))
    if (typeof t != "object" && (t = [t]), kl(t))
      for (var r = 0, i = t.length; r < i; r++)
        e.call(null, t[r], r, t);
    else
      for (var n in t)
        Object.prototype.hasOwnProperty.call(t, n) && e.call(null, t[n], n, t);
}
function po() {
  var t = {};
  function e(n, a) {
    Fn(t[a]) && Fn(n) ? t[a] = po(t[a], n) : Fn(n) ? t[a] = po({}, n) : kl(n) ? t[a] = n.slice() : t[a] = n;
  }
  for (var r = 0, i = arguments.length; r < i; r++)
    Bl(arguments[r], e);
  return t;
}
function qb(t, e, r) {
  return Bl(e, function(n, a) {
    r && typeof n == "function" ? t[a] = Nb(n, r) : t[a] = n;
  }), t;
}
function Kb(t) {
  return t.charCodeAt(0) === 65279 && (t = t.slice(1)), t;
}
function Zb(t, e, r, i) {
  t.prototype = Object.create(e.prototype, i), t.prototype.constructor = t, r && Object.assign(t.prototype, r);
}
function Qb(t, e, r) {
  var i, n, a, s = {};
  e = e || {};
  do {
    for (i = Object.getOwnPropertyNames(t), n = i.length; n-- > 0; )
      a = i[n], s[a] || (e[a] = t[a], s[a] = !0);
    t = Object.getPrototypeOf(t);
  } while (t && (!r || r(t, e)) && t !== Object.prototype);
  return e;
}
function Jb(t, e, r) {
  t = String(t), (r === void 0 || r > t.length) && (r = t.length), r -= e.length;
  var i = t.indexOf(e, r);
  return i !== -1 && i === r;
}
function ex(t) {
  if (!t)
    return null;
  var e = t.length;
  if (da(e))
    return null;
  for (var r = new Array(e); e-- > 0; )
    r[e] = t[e];
  return r;
}
var tx = function(t) {
  return function(e) {
    return t && e instanceof t;
  };
}(typeof Uint8Array < "u" && Object.getPrototypeOf(Uint8Array)), Me = {
  isArray: kl,
  isArrayBuffer: kf,
  isBuffer: jb,
  isFormData: Wb,
  isArrayBufferView: kb,
  isString: zb,
  isNumber: Bb,
  isObject: zf,
  isPlainObject: Fn,
  isUndefined: da,
  isDate: Fb,
  isFile: $b,
  isBlob: Ub,
  isFunction: zl,
  isStream: Hb,
  isURLSearchParams: Gb,
  isStandardBrowserEnv: Xb,
  forEach: Bl,
  merge: po,
  extend: qb,
  trim: Yb,
  stripBOM: Kb,
  inherits: Zb,
  toFlatObject: Qb,
  kindOf: jl,
  kindOfTest: _r,
  endsWith: Jb,
  toArray: ex,
  isTypedArray: tx,
  isFileList: Vb
}, Ur = Me;
function lu(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
var Bf = function(e, r, i) {
  if (!r)
    return e;
  var n;
  if (i)
    n = i(r);
  else if (Ur.isURLSearchParams(r))
    n = r.toString();
  else {
    var a = [];
    Ur.forEach(r, function(l, c) {
      l === null || typeof l > "u" || (Ur.isArray(l) ? c = c + "[]" : l = [l], Ur.forEach(l, function(d) {
        Ur.isDate(d) ? d = d.toISOString() : Ur.isObject(d) && (d = JSON.stringify(d)), a.push(lu(c) + "=" + lu(d));
      }));
    }), n = a.join("&");
  }
  if (n) {
    var s = e.indexOf("#");
    s !== -1 && (e = e.slice(0, s)), e += (e.indexOf("?") === -1 ? "?" : "&") + n;
  }
  return e;
}, rx = Me;
function Ia() {
  this.handlers = [];
}
Ia.prototype.use = function(e, r, i) {
  return this.handlers.push({
    fulfilled: e,
    rejected: r,
    synchronous: i ? i.synchronous : !1,
    runWhen: i ? i.runWhen : null
  }), this.handlers.length - 1;
};
Ia.prototype.eject = function(e) {
  this.handlers[e] && (this.handlers[e] = null);
};
Ia.prototype.forEach = function(e) {
  rx.forEach(this.handlers, function(i) {
    i !== null && e(i);
  });
};
var ix = Ia, nx = Me, ax = function(e, r) {
  nx.forEach(e, function(n, a) {
    a !== r && a.toUpperCase() === r.toUpperCase() && (e[r] = n, delete e[a]);
  });
}, Ff = Me;
function ai(t, e, r, i, n) {
  Error.call(this), this.message = t, this.name = "AxiosError", e && (this.code = e), r && (this.config = r), i && (this.request = i), n && (this.response = n);
}
Ff.inherits(ai, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
var $f = ai.prototype, Uf = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED"
  // eslint-disable-next-line func-names
].forEach(function(t) {
  Uf[t] = { value: t };
});
Object.defineProperties(ai, Uf);
Object.defineProperty($f, "isAxiosError", { value: !0 });
ai.from = function(t, e, r, i, n, a) {
  var s = Object.create($f);
  return Ff.toFlatObject(t, s, function(l) {
    return l !== Error.prototype;
  }), ai.call(s, t.message, e, r, i, n), s.name = t.name, a && Object.assign(s, a), s;
};
var yi = ai, Vf = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, ot = Me;
function sx(t, e) {
  e = e || new FormData();
  var r = [];
  function i(a) {
    return a === null ? "" : ot.isDate(a) ? a.toISOString() : ot.isArrayBuffer(a) || ot.isTypedArray(a) ? typeof Blob == "function" ? new Blob([a]) : Buffer.from(a) : a;
  }
  function n(a, s) {
    if (ot.isPlainObject(a) || ot.isArray(a)) {
      if (r.indexOf(a) !== -1)
        throw Error("Circular reference detected in " + s);
      r.push(a), ot.forEach(a, function(l, c) {
        if (!ot.isUndefined(l)) {
          var u = s ? s + "." + c : c, d;
          if (l && !s && typeof l == "object") {
            if (ot.endsWith(c, "{}"))
              l = JSON.stringify(l);
            else if (ot.endsWith(c, "[]") && (d = ot.toArray(l))) {
              d.forEach(function(h) {
                !ot.isUndefined(h) && e.append(u, i(h));
              });
              return;
            }
          }
          n(l, u);
        }
      }), r.pop();
    } else
      e.append(s, i(a));
  }
  return n(t), e;
}
var Hf = sx, ls, cu;
function ox() {
  if (cu)
    return ls;
  cu = 1;
  var t = yi;
  return ls = function(r, i, n) {
    var a = n.config.validateStatus;
    !n.status || !a || a(n.status) ? r(n) : i(new t(
      "Request failed with status code " + n.status,
      [t.ERR_BAD_REQUEST, t.ERR_BAD_RESPONSE][Math.floor(n.status / 100) - 4],
      n.config,
      n.request,
      n
    ));
  }, ls;
}
var cs, uu;
function lx() {
  if (uu)
    return cs;
  uu = 1;
  var t = Me;
  return cs = t.isStandardBrowserEnv() ? (
    // Standard browser envs support document.cookie
    function() {
      return {
        write: function(i, n, a, s, o, l) {
          var c = [];
          c.push(i + "=" + encodeURIComponent(n)), t.isNumber(a) && c.push("expires=" + new Date(a).toGMTString()), t.isString(s) && c.push("path=" + s), t.isString(o) && c.push("domain=" + o), l === !0 && c.push("secure"), document.cookie = c.join("; ");
        },
        read: function(i) {
          var n = document.cookie.match(new RegExp("(^|;\\s*)(" + i + ")=([^;]*)"));
          return n ? decodeURIComponent(n[3]) : null;
        },
        remove: function(i) {
          this.write(i, "", Date.now() - 864e5);
        }
      };
    }()
  ) : (
    // Non standard browser env (web workers, react-native) lack needed support.
    function() {
      return {
        write: function() {
        },
        read: function() {
          return null;
        },
        remove: function() {
        }
      };
    }()
  ), cs;
}
var cx = function(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}, ux = function(e, r) {
  return r ? e.replace(/\/+$/, "") + "/" + r.replace(/^\/+/, "") : e;
}, dx = cx, hx = ux, Wf = function(e, r) {
  return e && !dx(r) ? hx(e, r) : r;
}, us, du;
function fx() {
  if (du)
    return us;
  du = 1;
  var t = Me, e = [
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
  ];
  return us = function(i) {
    var n = {}, a, s, o;
    return i && t.forEach(i.split(`
`), function(c) {
      if (o = c.indexOf(":"), a = t.trim(c.substr(0, o)).toLowerCase(), s = t.trim(c.substr(o + 1)), a) {
        if (n[a] && e.indexOf(a) >= 0)
          return;
        a === "set-cookie" ? n[a] = (n[a] ? n[a] : []).concat([s]) : n[a] = n[a] ? n[a] + ", " + s : s;
      }
    }), n;
  }, us;
}
var ds, hu;
function gx() {
  if (hu)
    return ds;
  hu = 1;
  var t = Me;
  return ds = t.isStandardBrowserEnv() ? (
    // Standard browser envs have full support of the APIs needed to test
    // whether the request URL is of the same origin as current location.
    function() {
      var r = /(msie|trident)/i.test(navigator.userAgent), i = document.createElement("a"), n;
      function a(s) {
        var o = s;
        return r && (i.setAttribute("href", o), o = i.href), i.setAttribute("href", o), {
          href: i.href,
          protocol: i.protocol ? i.protocol.replace(/:$/, "") : "",
          host: i.host,
          search: i.search ? i.search.replace(/^\?/, "") : "",
          hash: i.hash ? i.hash.replace(/^#/, "") : "",
          hostname: i.hostname,
          port: i.port,
          pathname: i.pathname.charAt(0) === "/" ? i.pathname : "/" + i.pathname
        };
      }
      return n = a(window.location.href), function(o) {
        var l = t.isString(o) ? a(o) : o;
        return l.protocol === n.protocol && l.host === n.host;
      };
    }()
  ) : (
    // Non standard browser envs (web workers, react-native) lack needed support.
    function() {
      return function() {
        return !0;
      };
    }()
  ), ds;
}
var hs, fu;
function _a() {
  if (fu)
    return hs;
  fu = 1;
  var t = yi, e = Me;
  function r(i) {
    t.call(this, i ?? "canceled", t.ERR_CANCELED), this.name = "CanceledError";
  }
  return e.inherits(r, t, {
    __CANCEL__: !0
  }), hs = r, hs;
}
var fs, gu;
function px() {
  return gu || (gu = 1, fs = function(e) {
    var r = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
    return r && r[1] || "";
  }), fs;
}
var gs, pu;
function mu() {
  if (pu)
    return gs;
  pu = 1;
  var t = Me, e = ox(), r = lx(), i = Bf, n = Wf, a = fx(), s = gx(), o = Vf, l = yi, c = _a(), u = px();
  return gs = function(h) {
    return new Promise(function(v, p) {
      var b = h.data, y = h.headers, x = h.responseType, w;
      function P() {
        h.cancelToken && h.cancelToken.unsubscribe(w), h.signal && h.signal.removeEventListener("abort", w);
      }
      t.isFormData(b) && t.isStandardBrowserEnv() && delete y["Content-Type"];
      var O = new XMLHttpRequest();
      if (h.auth) {
        var A = h.auth.username || "", I = h.auth.password ? unescape(encodeURIComponent(h.auth.password)) : "";
        y.Authorization = "Basic " + btoa(A + ":" + I);
      }
      var D = n(h.baseURL, h.url);
      O.open(h.method.toUpperCase(), i(D, h.params, h.paramsSerializer), !0), O.timeout = h.timeout;
      function k() {
        if (O) {
          var z = "getAllResponseHeaders" in O ? a(O.getAllResponseHeaders()) : null, X = !x || x === "text" || x === "json" ? O.responseText : O.response, U = {
            data: X,
            status: O.status,
            statusText: O.statusText,
            headers: z,
            config: h,
            request: O
          };
          e(function(q) {
            v(q), P();
          }, function(q) {
            p(q), P();
          }, U), O = null;
        }
      }
      if ("onloadend" in O ? O.onloadend = k : O.onreadystatechange = function() {
        !O || O.readyState !== 4 || O.status === 0 && !(O.responseURL && O.responseURL.indexOf("file:") === 0) || setTimeout(k);
      }, O.onabort = function() {
        O && (p(new l("Request aborted", l.ECONNABORTED, h, O)), O = null);
      }, O.onerror = function() {
        p(new l("Network Error", l.ERR_NETWORK, h, O, O)), O = null;
      }, O.ontimeout = function() {
        var X = h.timeout ? "timeout of " + h.timeout + "ms exceeded" : "timeout exceeded", U = h.transitional || o;
        h.timeoutErrorMessage && (X = h.timeoutErrorMessage), p(new l(
          X,
          U.clarifyTimeoutError ? l.ETIMEDOUT : l.ECONNABORTED,
          h,
          O
        )), O = null;
      }, t.isStandardBrowserEnv()) {
        var W = (h.withCredentials || s(D)) && h.xsrfCookieName ? r.read(h.xsrfCookieName) : void 0;
        W && (y[h.xsrfHeaderName] = W);
      }
      "setRequestHeader" in O && t.forEach(y, function(X, U) {
        typeof b > "u" && U.toLowerCase() === "content-type" ? delete y[U] : O.setRequestHeader(U, X);
      }), t.isUndefined(h.withCredentials) || (O.withCredentials = !!h.withCredentials), x && x !== "json" && (O.responseType = h.responseType), typeof h.onDownloadProgress == "function" && O.addEventListener("progress", h.onDownloadProgress), typeof h.onUploadProgress == "function" && O.upload && O.upload.addEventListener("progress", h.onUploadProgress), (h.cancelToken || h.signal) && (w = function(z) {
        O && (p(!z || z && z.type ? new c() : z), O.abort(), O = null);
      }, h.cancelToken && h.cancelToken.subscribe(w), h.signal && (h.signal.aborted ? w() : h.signal.addEventListener("abort", w))), b || (b = null);
      var $ = u(D);
      if ($ && ["http", "https", "file"].indexOf($) === -1) {
        p(new l("Unsupported protocol " + $ + ":", l.ERR_BAD_REQUEST, h));
        return;
      }
      O.send(b);
    });
  }, gs;
}
var ps, vu;
function mx() {
  return vu || (vu = 1, ps = null), ps;
}
var Pe = Me, yu = ax, bu = yi, vx = Vf, yx = Hf, bx = {
  "Content-Type": "application/x-www-form-urlencoded"
};
function xu(t, e) {
  !Pe.isUndefined(t) && Pe.isUndefined(t["Content-Type"]) && (t["Content-Type"] = e);
}
function xx() {
  var t;
  return (typeof XMLHttpRequest < "u" || typeof process < "u" && Object.prototype.toString.call(process) === "[object process]") && (t = mu()), t;
}
function Sx(t, e, r) {
  if (Pe.isString(t))
    try {
      return (e || JSON.parse)(t), Pe.trim(t);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (r || JSON.stringify)(t);
}
var Aa = {
  transitional: vx,
  adapter: xx(),
  transformRequest: [function(e, r) {
    if (yu(r, "Accept"), yu(r, "Content-Type"), Pe.isFormData(e) || Pe.isArrayBuffer(e) || Pe.isBuffer(e) || Pe.isStream(e) || Pe.isFile(e) || Pe.isBlob(e))
      return e;
    if (Pe.isArrayBufferView(e))
      return e.buffer;
    if (Pe.isURLSearchParams(e))
      return xu(r, "application/x-www-form-urlencoded;charset=utf-8"), e.toString();
    var i = Pe.isObject(e), n = r && r["Content-Type"], a;
    if ((a = Pe.isFileList(e)) || i && n === "multipart/form-data") {
      var s = this.env && this.env.FormData;
      return yx(a ? { "files[]": e } : e, s && new s());
    } else if (i || n === "application/json")
      return xu(r, "application/json"), Sx(e);
    return e;
  }],
  transformResponse: [function(e) {
    var r = this.transitional || Aa.transitional, i = r && r.silentJSONParsing, n = r && r.forcedJSONParsing, a = !i && this.responseType === "json";
    if (a || n && Pe.isString(e) && e.length)
      try {
        return JSON.parse(e);
      } catch (s) {
        if (a)
          throw s.name === "SyntaxError" ? bu.from(s, bu.ERR_BAD_RESPONSE, this, null, this.response) : s;
      }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: mx()
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*"
    }
  }
};
Pe.forEach(["delete", "get", "head"], function(e) {
  Aa.headers[e] = {};
});
Pe.forEach(["post", "put", "patch"], function(e) {
  Aa.headers[e] = Pe.merge(bx);
});
var Fl = Aa, wx = Me, Ex = Fl, Tx = function(e, r, i) {
  var n = this || Ex;
  return wx.forEach(i, function(s) {
    e = s.call(n, e, r);
  }), e;
}, ms, Su;
function Gf() {
  return Su || (Su = 1, ms = function(e) {
    return !!(e && e.__CANCEL__);
  }), ms;
}
var wu = Me, vs = Tx, Px = Gf(), Ox = Fl, Cx = _a();
function ys(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new Cx();
}
var Ix = function(e) {
  ys(e), e.headers = e.headers || {}, e.data = vs.call(
    e,
    e.data,
    e.headers,
    e.transformRequest
  ), e.headers = wu.merge(
    e.headers.common || {},
    e.headers[e.method] || {},
    e.headers
  ), wu.forEach(
    ["delete", "get", "head", "post", "put", "patch", "common"],
    function(n) {
      delete e.headers[n];
    }
  );
  var r = e.adapter || Ox.adapter;
  return r(e).then(function(n) {
    return ys(e), n.data = vs.call(
      e,
      n.data,
      n.headers,
      e.transformResponse
    ), n;
  }, function(n) {
    return Px(n) || (ys(e), n && n.response && (n.response.data = vs.call(
      e,
      n.response.data,
      n.response.headers,
      e.transformResponse
    ))), Promise.reject(n);
  });
}, Xe = Me, Yf = function(e, r) {
  r = r || {};
  var i = {};
  function n(u, d) {
    return Xe.isPlainObject(u) && Xe.isPlainObject(d) ? Xe.merge(u, d) : Xe.isPlainObject(d) ? Xe.merge({}, d) : Xe.isArray(d) ? d.slice() : d;
  }
  function a(u) {
    if (Xe.isUndefined(r[u])) {
      if (!Xe.isUndefined(e[u]))
        return n(void 0, e[u]);
    } else
      return n(e[u], r[u]);
  }
  function s(u) {
    if (!Xe.isUndefined(r[u]))
      return n(void 0, r[u]);
  }
  function o(u) {
    if (Xe.isUndefined(r[u])) {
      if (!Xe.isUndefined(e[u]))
        return n(void 0, e[u]);
    } else
      return n(void 0, r[u]);
  }
  function l(u) {
    if (u in r)
      return n(e[u], r[u]);
    if (u in e)
      return n(void 0, e[u]);
  }
  var c = {
    url: s,
    method: s,
    data: s,
    baseURL: o,
    transformRequest: o,
    transformResponse: o,
    paramsSerializer: o,
    timeout: o,
    timeoutMessage: o,
    withCredentials: o,
    adapter: o,
    responseType: o,
    xsrfCookieName: o,
    xsrfHeaderName: o,
    onUploadProgress: o,
    onDownloadProgress: o,
    decompress: o,
    maxContentLength: o,
    maxBodyLength: o,
    beforeRedirect: o,
    transport: o,
    httpAgent: o,
    httpsAgent: o,
    cancelToken: o,
    socketPath: o,
    responseEncoding: o,
    validateStatus: l
  };
  return Xe.forEach(Object.keys(e).concat(Object.keys(r)), function(d) {
    var h = c[d] || a, f = h(d);
    Xe.isUndefined(f) && h !== l || (i[d] = f);
  }), i;
}, bs, Eu;
function Xf() {
  return Eu || (Eu = 1, bs = {
    version: "0.27.2"
  }), bs;
}
var _x = Xf().version, Yt = yi, $l = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach(function(t, e) {
  $l[t] = function(i) {
    return typeof i === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
var Tu = {};
$l.transitional = function(e, r, i) {
  function n(a, s) {
    return "[Axios v" + _x + "] Transitional option '" + a + "'" + s + (i ? ". " + i : "");
  }
  return function(a, s, o) {
    if (e === !1)
      throw new Yt(
        n(s, " has been removed" + (r ? " in " + r : "")),
        Yt.ERR_DEPRECATED
      );
    return r && !Tu[s] && (Tu[s] = !0, console.warn(
      n(
        s,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), e ? e(a, s, o) : !0;
  };
};
function Ax(t, e, r) {
  if (typeof t != "object")
    throw new Yt("options must be an object", Yt.ERR_BAD_OPTION_VALUE);
  for (var i = Object.keys(t), n = i.length; n-- > 0; ) {
    var a = i[n], s = e[a];
    if (s) {
      var o = t[a], l = o === void 0 || s(o, a, t);
      if (l !== !0)
        throw new Yt("option " + a + " must be " + l, Yt.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new Yt("Unknown option " + a, Yt.ERR_BAD_OPTION);
  }
}
var Rx = {
  assertOptions: Ax,
  validators: $l
}, qf = Me, Mx = Bf, Pu = ix, Ou = Ix, Ra = Yf, Lx = Wf, Kf = Rx, Vr = Kf.validators;
function si(t) {
  this.defaults = t, this.interceptors = {
    request: new Pu(),
    response: new Pu()
  };
}
si.prototype.request = function(e, r) {
  typeof e == "string" ? (r = r || {}, r.url = e) : r = e || {}, r = Ra(this.defaults, r), r.method ? r.method = r.method.toLowerCase() : this.defaults.method ? r.method = this.defaults.method.toLowerCase() : r.method = "get";
  var i = r.transitional;
  i !== void 0 && Kf.assertOptions(i, {
    silentJSONParsing: Vr.transitional(Vr.boolean),
    forcedJSONParsing: Vr.transitional(Vr.boolean),
    clarifyTimeoutError: Vr.transitional(Vr.boolean)
  }, !1);
  var n = [], a = !0;
  this.interceptors.request.forEach(function(f) {
    typeof f.runWhen == "function" && f.runWhen(r) === !1 || (a = a && f.synchronous, n.unshift(f.fulfilled, f.rejected));
  });
  var s = [];
  this.interceptors.response.forEach(function(f) {
    s.push(f.fulfilled, f.rejected);
  });
  var o;
  if (!a) {
    var l = [Ou, void 0];
    for (Array.prototype.unshift.apply(l, n), l = l.concat(s), o = Promise.resolve(r); l.length; )
      o = o.then(l.shift(), l.shift());
    return o;
  }
  for (var c = r; n.length; ) {
    var u = n.shift(), d = n.shift();
    try {
      c = u(c);
    } catch (h) {
      d(h);
      break;
    }
  }
  try {
    o = Ou(c);
  } catch (h) {
    return Promise.reject(h);
  }
  for (; s.length; )
    o = o.then(s.shift(), s.shift());
  return o;
};
si.prototype.getUri = function(e) {
  e = Ra(this.defaults, e);
  var r = Lx(e.baseURL, e.url);
  return Mx(r, e.params, e.paramsSerializer);
};
qf.forEach(["delete", "get", "head", "options"], function(e) {
  si.prototype[e] = function(r, i) {
    return this.request(Ra(i || {}, {
      method: e,
      url: r,
      data: (i || {}).data
    }));
  };
});
qf.forEach(["post", "put", "patch"], function(e) {
  function r(i) {
    return function(a, s, o) {
      return this.request(Ra(o || {}, {
        method: e,
        headers: i ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: s
      }));
    };
  }
  si.prototype[e] = r(), si.prototype[e + "Form"] = r(!0);
});
var Dx = si, xs, Cu;
function Nx() {
  if (Cu)
    return xs;
  Cu = 1;
  var t = _a();
  function e(r) {
    if (typeof r != "function")
      throw new TypeError("executor must be a function.");
    var i;
    this.promise = new Promise(function(s) {
      i = s;
    });
    var n = this;
    this.promise.then(function(a) {
      if (n._listeners) {
        var s, o = n._listeners.length;
        for (s = 0; s < o; s++)
          n._listeners[s](a);
        n._listeners = null;
      }
    }), this.promise.then = function(a) {
      var s, o = new Promise(function(l) {
        n.subscribe(l), s = l;
      }).then(a);
      return o.cancel = function() {
        n.unsubscribe(s);
      }, o;
    }, r(function(s) {
      n.reason || (n.reason = new t(s), i(n.reason));
    });
  }
  return e.prototype.throwIfRequested = function() {
    if (this.reason)
      throw this.reason;
  }, e.prototype.subscribe = function(i) {
    if (this.reason) {
      i(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(i) : this._listeners = [i];
  }, e.prototype.unsubscribe = function(i) {
    if (this._listeners) {
      var n = this._listeners.indexOf(i);
      n !== -1 && this._listeners.splice(n, 1);
    }
  }, e.source = function() {
    var i, n = new e(function(s) {
      i = s;
    });
    return {
      token: n,
      cancel: i
    };
  }, xs = e, xs;
}
var Ss, Iu;
function jx() {
  return Iu || (Iu = 1, Ss = function(e) {
    return function(i) {
      return e.apply(null, i);
    };
  }), Ss;
}
var ws, _u;
function kx() {
  if (_u)
    return ws;
  _u = 1;
  var t = Me;
  return ws = function(r) {
    return t.isObject(r) && r.isAxiosError === !0;
  }, ws;
}
var Au = Me, zx = jf, $n = Dx, Bx = Yf, Fx = Fl;
function Zf(t) {
  var e = new $n(t), r = zx($n.prototype.request, e);
  return Au.extend(r, $n.prototype, e), Au.extend(r, e), r.create = function(n) {
    return Zf(Bx(t, n));
  }, r;
}
var We = Zf(Fx);
We.Axios = $n;
We.CanceledError = _a();
We.CancelToken = Nx();
We.isCancel = Gf();
We.VERSION = Xf().version;
We.toFormData = Hf;
We.AxiosError = yi;
We.Cancel = We.CanceledError;
We.all = function(e) {
  return Promise.all(e);
};
We.spread = jx();
We.isAxiosError = kx();
Dl.exports = We;
Dl.exports.default = We;
var $x = Dl.exports, Ux = $x;
const bi = /* @__PURE__ */ ln(Ux), Ul = "/customizer/api/product", Vx = "/customizer/api/bundle", Hx = "/customizer/api/v2/product", Wx = "/art/api/image", Gx = "/customizer/api/lineitem", Yx = "/customizer/api/bundle-instance", Xx = "/account/api/proofs/lineitem", Ru = "/customizer/api/upload", qx = "/customizer/api/add", Kx = "/customizer/api/update", Zx = "/customizer/api/add-bundle", Qx = "/customizer/api/update-bundle", Jx = "/manufacturing/design/preview/mgiid", Oe = bi.create({
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest"
  }
});
bi.create({
  baseURL: "/cart",
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest"
  }
});
const eS = async (t, e, r) => {
  const i = e && r ? `/${e}/${r}` : "";
  return Oe.get(`${Ul}/${t}/new${i}`);
}, tS = async (t) => Oe.get(`${Vx}/${t}/new`), rS = async (t, e) => Oe.get(`${Wx}/${t}/${e}`), iS = async (t) => Oe.get(`${Gx}/${t}`), nS = async (t) => Oe.get(`${Yx}/${t}`), aS = async (t, e) => Oe.get(`${Xx}/${t}/${e}`), sS = (t) => Oe.get(`${Ul}/${t}/sizes`), oS = async (t, e, r, i, n, a, s, o) => {
  let l = [];
  n ? l.push(`/api/orders/order/${n}/product/${t}`) : l.push(`${Hx}/${t}`), i && l.push(`/frame/${i}`), l.push(`/sizes/${e}/${r}`), a && s && o && l.push(`/${a}/${a}/${s}/${o}`);
  const c = l.join("");
  return Oe.get(c);
}, lS = (t, e, r) => Oe.get(`${Ul}/${t}/size/${e}/${r}`), cS = (t, e) => e ? Oe.post(Ru, t, e) : Oe.post(Ru, t), uS = (t) => Oe.post(qx, t), dS = (t) => Oe.post(Kx, t), hS = (t, e) => Oe.post(Zx, { bundleSlug: t, bundleItems: e }), fS = (t, e) => Oe.post(Qx, { bundleInstanceId: t, bundleItems: e }), gS = (t, e, r) => Oe.post(`${t}/usd`, e, r), pS = (t, e, r) => Oe.post(`${t}/v2/render`, e, r), mS = (t) => Oe.get(`${Jx}/${t}`), vS = {
  components: {
    Loader: xl,
    Proof: Db
  },
  data() {
    return {
      proofVisible: !1,
      productData: null
    };
  },
  mounted() {
    document.addEventListener("click", this.bindInterstitialTrigger), document.addEventListener("keypress", this.bindInterstitialTrigger);
  },
  unmounted() {
    document.removeEventListener("click", this.bindInterstitialTrigger), document.removeEventListener("keypress", this.bindInterstitialTrigger);
  },
  computed: {},
  methods: {
    bindInterstitialTrigger(t) {
      const e = t.target;
      if (Bn(e, "[data-proof-interstitial-trigger]")) {
        if (t.key && t.key !== "Enter")
          return;
        t.preventDefault();
        const i = e.closest("[data-proof-interstitial-trigger]").getAttribute("data-mgi-id");
        this.getProof(i);
      }
    },
    async getProof(t) {
      try {
        const e = await mS(t);
        this.showProof(e.data.message);
      } catch {
      }
    },
    showProof(t) {
      this.productData = t, this.proofVisible = !0;
    },
    hideProof() {
      this.proofVisible = !1, this.productData = null;
    }
  }
};
function yS(t, e, r, i, n, a) {
  const s = it("Proof");
  return n.proofVisible ? (R(), ht(s, {
    key: 0,
    productData: n.productData,
    fullScreenOnly: !0,
    enableScaleAnimation: !1,
    onClose: a.hideProof
  }, null, 8, ["productData", "onClose"])) : Q("", !0);
}
const t8 = /* @__PURE__ */ Ce(vS, [["render", yS]]);
const bS = {}, xS = {
  class: "spinner",
  viewBox: "0 0 50 50"
}, SS = /* @__PURE__ */ E("circle", {
  class: "path",
  cx: "25",
  cy: "25",
  r: "15",
  fill: "none",
  "stroke-width": "4"
}, null, -1), wS = [
  SS
];
function ES(t, e) {
  return R(), M("svg", xS, wS);
}
const TS = /* @__PURE__ */ Ce(bS, [["render", ES]]), PS = { class: "pt-8 px-10" }, OS = {
  key: 0,
  class: "italic text-white"
}, CS = {
  key: 1,
  class: "italic text-white"
}, IS = { class: "p-4 flex flex-col justify-center md:justify-between md:flex-row md:px-10 md:pb-6" }, _S = { class: "flex space-x-8 pb-10 justify-center md:pb-0 md:justify-normal" }, AS = /* @__PURE__ */ E("svg", {
  class: "w-8 h-8 md:w-6 md:h-6 text-white fill-current",
  viewBox: "0 0 503 512",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /* @__PURE__ */ E("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M30 359V30H217V265H134C122.954 265 114 273.954 114 285V359H30ZM483 265L247 265V20C247 8.95431 238.046 0 227 0H20C8.9543 0 0 8.95431 0 20V369C0 380.046 8.9543 389 20 389H114V492C114 503.046 122.954 512 134 512H483C494.046 512 503 503.046 503 492V285C503 273.954 494.046 265 483 265ZM473 295L144 295L144 482H473V295ZM398.374 217.225C402.243 221.094 408.468 221.094 412.337 217.225L454.225 175.337C458.094 171.468 458.094 165.243 454.225 161.374C450.356 157.505 444.131 157.505 440.262 161.374L431.07 170.566L430.954 170.682L415.216 186.42L415.246 156.08C415.246 134.496 406.664 113.813 391.393 98.5416C364.456 71.6051 324.982 64.8274 291.763 78.2084C286.701 80.2446 284.258 86.0042 286.294 91.0657C288.33 96.1272 294.09 98.5707 299.151 96.5344C325.273 86.0042 356.282 91.3566 377.43 112.504C388.978 124.053 395.465 139.732 395.494 156.109V186.42L379.757 170.682L370.448 161.374C366.58 157.505 360.355 157.505 356.486 161.374C352.617 165.243 352.617 171.468 356.486 175.337L365.794 184.645L398.374 217.225Z"
  })
], -1), RS = ["disabled"], MS = { key: 0 }, LS = /* @__PURE__ */ E("svg", {
  class: "w-8 h-8 md:w-6 md:h-6 text-white fill-current",
  viewBox: "0 0 512 512"
}, [
  /* @__PURE__ */ E("path", { d: "M371.2 122.9C340.3 96.2 300 80 256 80C158.8 80 80 158.8 80 256s78.8 176 176 176c39.7 0 76.2-13.1 105.6-35.2c10.6-8 25.6-5.8 33.6 4.8s5.8 25.6-4.8 33.6C353 463.3 306.4 480 256 480C132.3 480 32 379.7 32 256S132.3 32 256 32c57.3 0 109.6 21.5 149.2 56.9l30.5-30.5c6.6-6.6 15.6-10.3 25-10.3C480.2 48 496 63.8 496 83.3V200c0 13.3-10.7 24-24 24H355.3c-19.5 0-35.3-15.8-35.3-35.3c0-9.4 3.7-18.3 10.3-25l40.8-40.8zm76.8-9L385.9 176H448V113.9z" })
], -1), DS = [
  LS
], NS = {
  key: 1,
  "data-rotate-image-spinner": ""
}, jS = /* @__PURE__ */ E("svg", {
  "data-test-id": "replace-image-button",
  class: "w-8 h-8 md:w-6 md:h-6 text-white fill-current",
  viewBox: "0 0 512 512"
}, [
  /* @__PURE__ */ E("path", { d: "M448 80c8.8 0 16 7.2 16 16V415.8l-5-6.5-136-176c-4.5-5.9-11.6-9.3-19-9.3s-14.4 3.4-19 9.3L202 340.7l-30.5-42.7C167 291.7 159.8 288 152 288s-15 3.7-19.5 10.1l-80 112L48 416.3l0-.3V96c0-8.8 7.2-16 16-16H448zM64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm80 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z" })
], -1), kS = { class: "justify-center flex space-x-4 md:justify-normal" }, r8 = /* @__PURE__ */ Wh({
  __name: "StandaloneImageEditor",
  emits: ["paneClick", "applyImageEdits", "cancelImageEdits", "replaceImage", "changeOrientation", "rotateImage"],
  setup(t, { emit: e }) {
    const r = G("panels"), i = G("selectedWidth"), n = G("selectedHeight"), a = G("edgeDimension"), s = G("edgeColor"), o = G("selectedEdge"), l = G("renderMode"), c = G("frameDimension"), u = G("gapDimension"), d = G("matDimension"), h = G("isMobile");
    G("selectedEditToolId");
    const f = G("wrapperPaddingClasslist"), v = G("featureFlags"), p = G("panes"), b = G("borderDimension", 0), y = G("borderColorValue", ""), x = G("images"), w = G("uploadLater", !1), P = G("isArt", !1), O = G("productSlug"), A = G("disableCollageOuterBorder", !0), I = G("imageEditTrigger", null), D = G("locale"), k = G("cornerRadius", "0"), W = G("canEdit", !1), $ = G("frameColor", ""), z = G("filter", null), X = G("canManipulate"), U = G("pane", "pane_1"), ie = G("isCollageProduct", !1), q = G("showStandaloneImageEditor", Wi(!1)), Y = G("hidePrintable", !1), te = G("renderIsLoading", !1), V = Pr, K = hr(() => i.value > n.value ? wl : i.value < n.value ? El : Tl), ne = hr(() => [
      "fixed w-full h-full top-0 left-0 bg-gray-900",
      "flex flex-col flex-grow z-50"
    ]), oe = hr(() => [
      "flex-grow relative flex overflow-hidden px-4",
      Y.value ? "opacity-0" : ""
    ]), Se = (Z) => {
      e("paneClick", Z);
    }, ue = () => {
      e("applyImageEdits");
    }, Ge = () => {
      e("cancelImageEdits");
    }, Ut = () => {
      e("paneClick", U.value);
    }, ve = () => {
      e("changeOrientation");
    }, Qe = () => {
      e("rotateImage");
    }, le = hr(() => {
      let Z = JSON.parse(JSON.stringify(p.value)).filter((Le) => Le.id === U.value);
      return Z[0].width = 100, Z[0].height = 100, Z[0].top = 0, Z[0].left = 0, Z;
    }), ae = hr(() => {
      let Z = 0, Le = 0, De = p.value.filter((Ne) => Ne.id === U.value)[0];
      for (let Ne = 0; Ne < p.value.length; Ne++) {
        const vt = p.value[Ne], Vt = vt.width + vt.left, Ve = vt.height + vt.top;
        Vt > Z && (Z = Vt), Ve > Le && (Le = Ve);
      }
      const Je = De.width * (i.value / Z), Be = De.height * (n.value / Le);
      return {
        width: Je,
        height: Be
      };
    }), mt = hr(() => O.value === V);
    return bl(q, (Z) => {
      Z ? document.body.style.overflow = "hidden" : document.body.style.overflow = "";
    }), (Z, Le) => (R(), M("div", {
      class: re(N(ne))
    }, [
      E("div", PS, [
        N(h) ? Q("", !0) : (R(), M("p", OS, me(Z.$t("message.builder.standaloneImageEditor.instructions.desktop.editor")), 1)),
        N(h) ? (R(), M("p", CS, me(Z.$t("message.builder.standaloneImageEditor.instructions.mobile.editor")), 1)) : Q("", !0)
      ]),
      E("div", {
        class: re(N(oe))
      }, [
        (R(), ht(N(Of), {
          id: "imageEditorPrintable",
          key: "printable-" + JSON.stringify(N(x)) + N(q),
          panels: N(r),
          width: N(ae).width,
          height: N(ae).height,
          "edge-dimension": N(a),
          "edge-color": N(s),
          "edge-type": N(o),
          "render-mode": N(l),
          frame: N(c),
          gap: N(u),
          mat: N(d),
          isMobile: N(h),
          selectedEditToolId: ti,
          wrapperPaddingClasslist: N(f),
          featureFlags: N(v)
        }, {
          default: ft(() => [
            (R(), ht(N(Ef), {
              key: "panes-" + JSON.stringify(N(x)) + N(q),
              panes: N(le),
              width: N(ae).width,
              height: N(ae).height,
              edge: N(a),
              "edge-color": N(s),
              "edge-type": N(o),
              border: N(b),
              "border-color": N(y),
              images: N(x),
              events: !0,
              "upload-later": N(w),
              "render-mode": N(l),
              "is-art": N(P),
              "product-slug": N(O),
              "disable-collage-outer-border": N(A),
              filter: N(z),
              featureFlags: N(v),
              selectedEditToolId: ti,
              imageEditTrigger: N(I),
              locale: N(D),
              onPaneClick: Se
            }, null, 8, ["panes", "width", "height", "edge", "edge-color", "edge-type", "border", "border-color", "images", "upload-later", "render-mode", "is-art", "product-slug", "disable-collage-outer-border", "filter", "featureFlags", "selectedEditToolId", "imageEditTrigger", "locale"]))
          ]),
          _: 1
        }, 8, ["panels", "width", "height", "edge-dimension", "edge-color", "edge-type", "render-mode", "frame", "gap", "mat", "isMobile", "selectedEditToolId", "wrapperPaddingClasslist", "featureFlags"])),
        (R(), ht(N(Pf), {
          "aria-hidden": "true",
          tabindex: "-1",
          key: "previews-" + N(q),
          selectedEditToolId: ti,
          events: !1,
          visible: !1,
          width: N(ae).width,
          height: N(ae).height,
          frame: 0,
          gap: 0,
          mat: 0,
          "render-mode": N(l),
          cornerRadius: N(k),
          "can-manipulate": N(X),
          "feature-flags": N(v),
          "can-edit": N(W),
          "frame-color": N($),
          preview: !1,
          isMobile: N(h),
          isArt: N(P),
          panels: N(r),
          edge: N(a),
          frameType: null
        }, null, 8, ["selectedEditToolId", "width", "height", "render-mode", "cornerRadius", "can-manipulate", "feature-flags", "can-edit", "frame-color", "isMobile", "isArt", "panels", "edge"]))
      ], 2),
      E("div", IS, [
        E("div", _S, [
          N(K) !== "square" && !N(ie) && !N(mt) ? (R(), M("button", {
            key: 0,
            class: "flex-col text-white flex items-center font-bold space-y-2 md:space-y-0 md:space-x-3 md:flex-row md:text-left",
            "data-change-orientation": "",
            onClick: ve
          }, [
            AS,
            E("span", null, me(Z.$t("message.builder.standaloneImageEditor.buttons.flip")), 1)
          ])) : Q("", !0),
          E("button", {
            class: "flex-col text-white flex items-center font-bold space-y-2 md:space-y-0 md:space-x-3 md:flex-row md:text-left",
            "data-rotate-image": "",
            disabled: N(te),
            onClick: Qe
          }, [
            N(te) ? Q("", !0) : (R(), M("span", MS, DS)),
            N(te) ? (R(), M("span", NS, [
              Ue(N(TS), { class: "w-6 h-6" })
            ])) : Q("", !0),
            E("span", null, me(Z.$t("message.builder.standaloneImageEditor.buttons.rotate")), 1)
          ], 8, RS),
          E("button", {
            class: "flex-col text-white flex items-center font-bold space-y-2 md:space-y-0 md:space-x-3 md:flex-row md:text-left",
            "data-replace-image": "",
            onClick: Ut
          }, [
            jS,
            E("span", null, me(Z.$t("message.builder.standaloneImageEditor.buttons.replace")), 1)
          ])
        ]),
        E("div", kS, [
          E("button", {
            "data-cancel-btn": "",
            class: "btn btn--secondary grow text-base md:grow-0 md:w-40",
            onClick: Ge
          }, me(Z.$t("message.builder.standaloneImageEditor.buttons.cancel")), 1),
          E("button", {
            "data-apply-btn": "",
            class: "btn btn--primary grow text-base md:grow-0 md:w-40",
            onClick: ue
          }, me(Z.$t("message.builder.standaloneImageEditor.buttons.apply")), 1)
        ])
      ])
    ], 2));
  }
}), zS = {
  props: {
    id: {
      type: String,
      required: !0
    },
    name: {
      type: String,
      required: !0
    },
    label: {
      type: String,
      required: !0
    },
    placeholder: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: !1
    },
    errorText: {
      type: String,
      default: "(Required)"
    },
    successText: {
      type: String,
      default: "Thank you!"
    },
    disabled: {
      type: Boolean,
      required: !1
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    bgColor: {
      type: String,
      default: "bg-white text-xs"
    }
  },
  data() {
    return {
      text: ""
    };
  },
  computed: {
    bgColorClass() {
      return this.bgColor;
    },
    success() {
      return this.required ? this.text && this.text.length >= 5 : !0;
    },
    enableSuccessState() {
      return this.success && this.text && this.text.length >= 5;
    }
  },
  watch: {
    value(t) {
      this.text = t;
    },
    autofocus(t) {
      t && this.$refs.textarea.focus();
    }
  },
  mounted() {
    this.text = this.value;
  },
  methods: {
    handleInput(t) {
      this.text = t.target.value, this.$emit("inputEvent", this.text);
    }
  }
}, BS = { class: "relative" }, FS = ["for"], $S = {
  key: 0,
  "data-error-label": "",
  class: "text-red-500 italic ml-1"
}, US = {
  key: 1,
  "data-success-label": "",
  class: "text-green-500 italic ml-1"
}, VS = ["id", "name", "placeholder", "value", "required", "disabled"];
function HS(t, e, r, i, n, a) {
  return R(), M("div", BS, [
    E("label", {
      class: re(["absolute z-10 top-0 left-0 ml-4 text-black -translate-y-50 px-1 leading-none cursor-pointer", [a.bgColorClass]]),
      for: r.id
    }, [
      E("span", null, me(r.label), 1),
      a.success ? Q("", !0) : (R(), M("span", $S, me(r.errorText), 1)),
      a.enableSuccessState ? (R(), M("span", US, me(r.successText), 1)) : Q("", !0)
    ], 10, FS),
    E("textarea", {
      id: r.id,
      ref: "textarea",
      "data-text-area": "",
      name: r.name,
      class: re(["form-input block py-4", { "border-red-500": !a.success, "border-green-500": a.enableSuccessState }]),
      placeholder: r.placeholder,
      value: n.text,
      required: r.required,
      disabled: r.disabled,
      onInput: e[0] || (e[0] = (...s) => a.handleInput && a.handleInput(...s))
    }, null, 42, VS),
    a.success ? Q("", !0) : (R(), M("div", {
      key: 0,
      "data-error": "",
      class: re(["absolute bottom-0 left-0 text-xs ml-4 translate-y-50 font-bold rounded px-1 leading-none text-red-500 transition-opacity opacity-100", [a.bgColorClass]])
    }, me(t.$t("message.textField.requiredCharacterLength")), 3))
  ]);
}
const i8 = /* @__PURE__ */ Ce(zS, [["render", HS]]);
const WS = { class: "grid grid-cols-1 md:grid-cols-6 lg:grid-cols-9 gap-6" }, GS = ["draggable", "onDragstart", "onDragenter"], YS = {
  key: 0,
  class: "absolute top-2 left-2 bg-blue-500 text-white px-2 py-1 rounded-md text-sm font-medium z-10"
}, XS = {
  key: 1,
  class: "absolute top-2 right-2 bg-yellow-500 text-white px-2 py-1 rounded-md text-sm font-medium z-10"
}, qS = {
  __name: "Sorter",
  props: { items: { type: Array, required: !0 } },
  emits: ["update:items", "modifiedItems:items"],
  setup(t, { expose: e, emit: r }) {
    const i = t, n = Wi([]), a = Wi(!1);
    let s = Wi(null), o = Wi(null);
    const l = (y) => Object.keys(y).map((x) => ({ ...y[x], dragged: !1 }));
    w0(() => {
      n.value = l(i.items);
    });
    const c = (y) => y.dragged == !0, u = (y, x) => {
      if (o.value = null, x.pinned) {
        y.preventDefault(), s.value = null;
        return;
      }
      a.value = !0, s.value = x, y.dataTransfer.effectAllowed = "move";
    }, d = (y, x) => {
      !x || !s.value || s.value === x || s.value.pinned || x.pinned || o.value !== x && (o.value = x);
    }, h = (y) => {
      y.preventDefault(), y.stopPropagation(), a.value = !1;
      const x = p.value.findIndex((O) => O.id === s.value.id && O.productId === s.value.productId), w = p.value.findIndex((O) => O.id === o.value.id && O.productId === o.value.productId);
      if (x === -1 || w === -1)
        return;
      const P = n.value.findIndex(
        (O) => O.id === s.value.id && O.productId === s.value.productId
      );
      if (P !== -1 && (n.value[P] = { ...n.value[P], dragged: !0 }, n.value = [...n.value]), x !== -1) {
        const O = [...n.value], [A] = O.splice(x, 1), I = n.value.findIndex(
          (D) => D.id === o.value.id && D.productId === o.value.productId
        );
        O.splice(I, 0, A), v(O);
      }
      s.value = null, o.value = null;
    }, f = (y, x) => {
      x && x.pinned && (y.preventDefault(), y.stopPropagation());
    }, v = (y) => {
      n.value = [...y], r("update:items", [...n.value]), r("modifiedItems:items", n.value.filter((x) => c(x)));
    }, p = hr(() => [...n.value]);
    return e({
      resetModifiedItems: (y) => {
        n.value = y, n.value.forEach((x) => {
          x.dragged = !1;
        });
      },
      isModified: c
    }), (y, x) => (R(), M("div", WS, [
      Ue(E0, {
        name: "grid",
        tag: "div",
        class: "contents",
        "move-class": "grid-move",
        duration: { move: a.value ? 0 : 300 }
      }, {
        default: ft(() => [
          (R(!0), M(ci, null, ui(N(p), (w) => (R(), M("div", {
            key: `${w.productId}_${w.id}`,
            class: re(["relative bg-white rounded-lg shadow-md overflow-hidden", {
              "cursor-not-allowed ring-2 ring-blue-500": w.pinned,
              "cursor-move ring-2 ring-yellow-500": c(w) && !w.pinned,
              "cursor-move": !w.pinned
            }]),
            draggable: !w.pinned,
            onDragstart: (P) => u(P, w),
            onDragenter: zn((P) => d(P, w), ["prevent"]),
            onDragover: x[0] || (x[0] = zn((P) => f(P), ["prevent"])),
            onDrop: x[1] || (x[1] = zn((P) => h(P), ["prevent"]))
          }, [
            w.pinned ? (R(), M("div", YS, " Pinned ")) : Q("", !0),
            c(w) ? (R(), M("div", XS, " Modified ")) : Q("", !0),
            Tr(y.$slots, "default", { item: w }, void 0, !0)
          ], 42, GS))), 128))
        ]),
        _: 3
      }, 8, ["duration"])
    ]));
  }
}, n8 = /* @__PURE__ */ Ce(qS, [["__scopeId", "data-v-98d57ab0"]]), KS = "click", ZS = "change", QS = "mouseover";
class a8 {
  constructor(e) {
    this.handleEvent = this.handleEvent.bind(this), this.group = "[data-module-toggle-group]", this.toggle = "[data-module-toggle]", this.inverse = "[data-module-toggle-inverse]", this.target = "data-module-toggle-target", this.classes = "data-module-toggle-classes", this.attributes = "data-module-toggle-attributes", this.forceToggleCheckedRadio = "data-module-toggle-force-checked-radio", this.isHover = e.hasAttribute("data-module-toggle-hover"), this.isHover ? e.addEventListener(QS, this.handleEvent) : e.tagName === "SELECT" ? e.addEventListener(ZS, this.handleEvent) : e.addEventListener(KS, this.handleEvent);
  }
  /**
   * Handles an event.
   */
  handleEvent(e) {
    const r = e.target, i = Bn(r, this.group), n = Bn(r, this.inverse), a = Bn(r, this.toggle);
    if (!a)
      return;
    const s = a.getAttribute(this.target), o = a.getAttribute(this.classes), l = a.getAttribute(this.attributes), c = a.hasAttribute(this.forceToggleCheckedRadio);
    if (s)
      if (i) {
        if (!o)
          return;
        const u = i.querySelectorAll(this.toggle), d = i.querySelector(s);
        if (!d)
          return;
        n ? o.split(" ").forEach((h) => d.classList.remove(h)) : o.split(" ").forEach((h) => d.classList.add(h)), u.forEach((h) => {
          const f = h.getAttribute(this.target), v = document.querySelector(f);
          if (h !== d && v !== d && v) {
            n ? o.split(" ").forEach((b) => v.classList.add(b)) : o.split(" ").forEach((b) => v.classList.remove(b));
            const p = v.querySelector("input:not([type=hidden])");
            p && p.focus();
          }
        });
      } else {
        if (!o && !l)
          return;
        const u = s.split(","), d = o ? o.split(",") : null, h = l ? l.split(",") : null;
        u.forEach((f, v) => {
          const p = document.querySelector(f), b = d ? d.length > 1 ? d[v] : o : null, y = h ? h.length > 1 ? h[v] : l : null;
          if (p) {
            const x = p.querySelector("input:not([type=hidden])"), w = p.querySelector("input[type=radio]");
            w && c ? b && b.trim().split(" ").forEach((P) => p.classList.toggle(P, w.checked)) : (b && b.trim().split(" ").forEach((P) => p.classList.toggle(P)), y && y.trim().split(" ").forEach((P) => p.toggleAttribute(P))), x && x.focus();
          }
        });
      }
  }
}
const JS = {
  open: (t) => t.open,
  loading: (t) => t.loading,
  facebookClientId: (t) => t.facebookClientId,
  instagramClientId: (t) => t.instagramClientId,
  instagramRedirectUri: (t) => t.instagramRedirectUri,
  artkitToken: (t) => t.artkitToken,
  artkitUrl: (t) => t.artkitUrl,
  arPreviewUrl: (t) => t.arPreviewUrl,
  featureFlags: (t) => t.featureFlags ? t.featureFlags : {},
  remuxApiKey: (t) => t.remuxApiKey,
  remuxApiUrl: (t) => t.remuxApiUrl
}, Qf = "APP_OPEN_BUILDER", Jf = "APP_CLOSE_BUILDER", eg = "APP_LOAD_START", tg = "APP_LOAD_STOP", rg = "APP_SET_FACEBOOK_CLIENT_ID", ig = "APP_SET_INSTAGRAM_CLIENT_ID", ng = "APP_SET_INSTAGRAM_REDIRECT_URI", ag = "APP_SET_ARTKIT_TOKEN", sg = "APP_SET_ARTKIT_URL", og = "APP_SET_AR_PREVIEW_URL", lg = "APP_SET_FEATURE_FLAGS", cg = "APP_SET_REMUX_API_KEY", ug = "APP_SET_REMUX_API_URL", e3 = {
  open({ commit: t }) {
    t(Qf);
  },
  close({ commit: t }) {
    t(Jf);
  },
  loadStart({ commit: t }) {
    t(eg);
  },
  loadStop({ commit: t }) {
    t(tg);
  },
  setFacebookClientId({ commit: t }, e) {
    t(rg, e);
  },
  setInstagramClientId({ commit: t }, e) {
    t(ig, e);
  },
  setInstagramRedirectUri({ commit: t }, e) {
    t(ng, e);
  },
  setArtkitToken({ commit: t }, e) {
    t(ag, e);
  },
  setArtkitUrl({ commit: t }, e) {
    t(sg, e);
  },
  setArPreviewUrl({ commit: t }, e) {
    t(og, e);
  },
  setFeatureFlags({ commit: t }, e) {
    t(lg, e);
  },
  setRemuxApiKey({ commit: t }, e) {
    t(cg, e);
  },
  setRemuxApiUrl({ commit: t }, e) {
    t(ug, e);
  }
}, t3 = {
  [Qf](t) {
    t.open = !0;
  },
  [Jf](t) {
    t.open = !1;
  },
  [eg](t) {
    t.loading += 1;
  },
  [tg](t) {
    t.loading -= 1;
  },
  [rg](t, e) {
    t.facebookClientId = e;
  },
  [ig](t, e) {
    t.instagramClientId = e;
  },
  [ng](t, e) {
    t.instagramRedirectUri = e;
  },
  [ag](t, e) {
    t.artkitToken = e;
  },
  [sg](t, e) {
    t.artkitUrl = e;
  },
  [og](t, e) {
    t.arPreviewUrl = e;
  },
  [lg](t, e) {
    t.featureFlags = e;
  },
  [cg](t, e) {
    t.remuxApiKey = e;
  },
  [ug](t, e) {
    t.remuxApiUrl = e;
  }
}, r3 = {
  open: !1,
  loading: 1,
  instagramClientId: null,
  instagramRedirectUri: null,
  artkitToken: null,
  artkitUrl: null,
  arPreviewUrl: null,
  featureFlags: null,
  remuxApiKey: null,
  remuxApiUrl: null
}, i3 = Object.assign({}, r3), n3 = {
  namespaced: !0,
  state: i3,
  getters: JS,
  actions: e3,
  mutations: t3
}, a3 = {
  loading: (t) => t.loading,
  error: (t) => t.error,
  warning: (t) => t.warning,
  invalid: (t) => t.invalid,
  sizes: (t) => t.sizes,
  borders: (t) => t.borders,
  borderColors: (t) => t.borderColors,
  edges: (t) => t.edges,
  frames: (t) => t.frames,
  isSingleSize: (t) => t.isSingleSize,
  isArt: (t) => t.isArt,
  ratioMatchesOnly: (t, e, r, i) => i["product/productSlug"] === Sr || i["product/productSlug"] === fi,
  filters: (t) => t.filters,
  services: (t) => t.services,
  suggestedSizes: (t) => t.suggestedSizes,
  loadingMessage: (t) => t.loadingMessage,
  coupon: (t) => t.coupon,
  couponSizes: (t) => t.couponSizes,
  couponAmount: (t) => t.couponAmount,
  proofLineItems: (t) => t.proofLineItems,
  artkitFlow: (t) => t.artkitFlow,
  petPortraitColors: (t) => t.petPortraitColors,
  petPortraitStyles: (t) => t.petPortraitStyles,
  trackingMetrics: (t) => t.trackingMetrics,
  unitOfMeasure: (t) => t.unitOfMeasure,
  corners: (t) => t.corners,
  hangingHardware: (t) => t.hangingHardware,
  printSurfaces: (t) => t.printSurfaces,
  tiles: (t) => t.tiles,
  layouts: (t) => t.layouts ? Object.entries(t.layouts).sort((e, r) => e[1].panes.length - r[1].panes.length).reduce((e, [r, i]) => (e[r] = i, e), {}) : t.layouts,
  panes: (t, e, r, i) => {
    var a;
    const n = [
      {
        top: 0,
        left: 0,
        width: 100,
        height: 100,
        id: "pane_1"
      }
    ];
    return e.layouts && i["product/layout"] && ((a = e == null ? void 0 : e.layouts[i["product/layout"]]) == null ? void 0 : a.panes) || n;
  },
  supportedFrames: (t, e, r, i) => {
    const n = {};
    if (e.sizes && e.frames && Object.keys(e.frames).length !== 0 && i["product/size"] && e.sizes[i["product/size"]].frames) {
      const a = e.sizes[i["product/size"]].frames, s = {};
      return Object.keys(a).forEach((o) => {
        const l = e.frames[o];
        if (!l)
          return;
        const c = l.code !== mr && l.code !== ei;
        l && c && (s[o] = l);
      }), s;
    } else
      return n;
  },
  supportedCanvasDepths: (t, e, r, i) => {
    const n = {};
    if (e.sizes && e.frames && i["product/size"] && e.sizes[i["product/size"]].frames) {
      const a = e.sizes[i["product/size"]].frames, s = {};
      return Object.keys(a).forEach((o) => {
        e.frames[o] && (e.frames[o].code === mr || e.frames[o].code === ei) && (s[o] = e.frames[o]);
      }), s;
    } else
      return n;
  },
  filteredSuggestedSizes: (t) => t.suggestedSizes.reduce((e, r) => (e[r] = t.sizes[r], e), {}),
  customWidths: (t, e, r, i) => {
    if (t.customSizes && t.customSizes.width) {
      const n = i["product/productSlug"] === "T" ? 3 : 1;
      return t.customSizes.width.reduce((a, s, o) => {
        const l = i["product/height"] < t.customSizes.minSize, c = i["product/height"] > t.customSizes.maxSize, u = s.value / n < t.customSizes.minSize, d = s.value / n > t.customSizes.maxSize, h = l && u || c && d;
        return a.push({
          id: o,
          label: `${s.value / n}"`,
          value: s.value,
          disabled: h
        }), a;
      }, []);
    } else
      return null;
  },
  customHeights: (t, e, r, i) => {
    if (t.customSizes && t.customSizes.height) {
      const n = i["product/productSlug"] === "T" ? 3 : 1;
      return t.customSizes.height.reduce((a, s, o) => {
        const l = i["product/width"] / n < t.customSizes.minSize, c = i["product/width"] / n > t.customSizes.maxSize, u = s.value < t.customSizes.minSize, d = s.value > t.customSizes.maxSize, h = l && u || c && d;
        return a.push({
          id: o,
          label: s.label,
          value: s.value,
          disabled: h
        }), a;
      }, []);
    } else
      return null;
  },
  minMaxCustomSize: (t) => t.minMaxCustomSize,
  maxMaxCustomSize: (t) => t.maxMaxCustomSize,
  customSizesOptions: (t, e, r, i) => {
    const n = e.ratioMatchesOnly;
    if (t.customSizes && (Object.keys(t.customSizes).length > 0 || Array.isArray(t.customSizes)) && !n)
      return null;
    let a = [];
    if (i["product/productSlug"] === Sr) {
      let s = e.suggestedSizes;
      if (s && s.length > 0) {
        let o = s[s.length - 1];
        s.forEach((c) => {
          a.push({ id: null, value: c, label: t.sizes[c].label, disabled: !1 });
        });
        const l = fm(parseInt(o.split("|")[0], 10), parseInt(o.split("|")[1], 10), e.maxMaxCustomSize, e.minMaxCustomSize);
        a = a.concat(l);
      }
    } else {
      let s = [], o = [], l = [];
      Object.keys(t.sizes).map((c) => {
        const u = c.split("|"), d = parseInt(u[0], 10), h = parseInt(u[1], 10);
        if (!gm(
          i["product/width"],
          i["product/height"],
          d,
          h
        ) && n)
          return;
        const v = hm(d, h);
        v === Tl ? (s.length === 0 && s.push({ id: null, value: "Square", label: "Square", disabled: !0 }), s.push({ id: null, value: c, label: t.sizes[c].label, disabled: !1 })) : v === El ? (o.length === 0 && o.push({ id: null, value: "Portrait", label: "Portrait", disabled: !0 }), o.push({ id: null, value: c, label: t.sizes[c].label, disabled: !1 })) : v === wl && (l.length === 0 && l.push({ id: null, value: "Landscape", label: "Landscape", disabled: !0 }), l.push({ id: null, value: c, label: t.sizes[c].label, disabled: !1 }));
      }), a = s.concat(o, l).map((c, u) => (c.id = u, c));
    }
    return a;
  },
  allowedEdges: (t, e, r, i) => {
    const n = t.frames[i["product/frame"]] ?? t.frames[i["product/canvasDepth"]];
    return n ? (n.edges, Object.keys(t.edges).reduce((a, s) => (a[s] = t.edges[s], a), {})) : {};
  },
  currentEdges: (t, e, r, i) => {
    var n;
    return e.sizes && i["product/size"] ? ((n = e == null ? void 0 : e.sizes[i["product/size"]]) == null ? void 0 : n.edges) || {} : {};
  },
  currentFrames: (t, e, r, i) => {
    var n;
    return e.sizes && i["product/size"] ? ((n = e == null ? void 0 : e.sizes[i["product/size"]]) == null ? void 0 : n.frames) || {} : {};
  },
  sizePrice: (t, e, r, i) => {
    var n;
    return e.sizes && i["product/size"] && ((n = e == null ? void 0 : e.sizes[i["product/size"]]) == null ? void 0 : n.foreignPrice) || 0;
  },
  edgePrice: (t, e, r, i) => {
    var n, a;
    return e.sizes && e.edges && i["product/size"] && i["product/edge"] && ((a = (n = e == null ? void 0 : e.sizes[i["product/size"]]) == null ? void 0 : n.edges[i["product/edge"]]) == null ? void 0 : a.foreignPrice) || 0;
  },
  framePrice: (t, e, r, i) => {
    var n, a;
    return e.sizes && e.frames && i["product/size"] && i["product/frame"] && ((a = (n = e == null ? void 0 : e.sizes[i["product/size"]]) == null ? void 0 : n.frames[i["product/frame"]]) == null ? void 0 : a.foreignPrice) || 0;
  },
  filterPrice: (t, e, r, i) => {
    var n;
    return e.sizes && e.filters && i["product/filter"] && ((n = e == null ? void 0 : e.filters[i["product/filter"]]) == null ? void 0 : n.foreignPrice) || 0;
  },
  servicePrice: (t, e, r, i) => {
    var n;
    return e.sizes && e.services && i["product/service"] && ((n = e == null ? void 0 : e.services[i["product/service"]]) == null ? void 0 : n.foreignPrice) || 0;
  },
  totalPrice: (t, e) => e.sizePrice + e.edgePrice + e.framePrice + e.filterPrice + e.servicePrice,
  discountFactor: (t, e) => e.couponAmount ? (100 - e.couponAmount) / 100 : 1,
  snapshot: (t) => t.snapshot,
  disableSuggestedSizes: (t) => t.disableSuggestedSizes,
  totalPlusAdditionalAttributes: (t, e) => {
    const i = (e.sizePrice + e.edgePrice + e.framePrice) * e.discountFactor, n = e.filterPrice + e.servicePrice;
    return i + n;
  }
}, de = "BUILDER_SET_ERROR", mo = "BUILDER_SET_WARNING", dg = "BUILDER_SET_INVALID", $e = "BUILDER_SET_LOADING_MESSAGE", Un = "BUILDER_SET_DATA", qr = "BUILDER_SET_SIZES", Gi = "BUILDER_SET_SUGGESTED_SIZES", hg = "BUILDER_SET_COUPON", fg = "BUILDER_SET_COUPON_SIZES", Vn = "BUILDER_SET_COUPON_AMOUNT", gg = "BUILDER_SET_IS_SINGLE_SIZE", pg = "BUILDER_SET_IS_ART", Te = "BUILDER_START_LOADING", ce = "BUILDER_STOP_LOADING", mg = "BUILDER_RESET", vg = "BUILDER_SET_ARTKIT_FLOW", vo = "BUILDER_SET_TRACKING_METRICS", yo = "BUILDER_SET_TILES", yg = "BUILDER_SET_TILE_IMAGE", bg = "BUILDER_UNSET_TILE_IMAGE", xg = "BUILDER_SET_STATE_SNAPSHOT", Sg = "BUILDER_REVERT_TO_SNAPSHOT", wg = "BUILDER_DISABLE_SUGGESTED_SIZES", tt = "errorAPI", s3 = "errorArtCannotLoad", o3 = "errorPetNotDetected", l3 = "errorPetSystemError", Jt = "message.constants.messages.", c3 = Jt + "loading", Cn = Jt + "loadingProduct", u3 = Jt + "loadingSizes", d3 = Jt + "loadingSuggestedSizes", h3 = Jt + "loadingSize", f3 = Jt + "loadingARPreview", Mu = Jt + "loadingCartAdd", Es = Jt + "loadingCartUpdate", g3 = {
  async getProduct({ commit: t, dispatch: e }, r) {
    t($e, Cn), t(Te);
    try {
      const i = await eS(
        r.code,
        r.width,
        r.height
      );
      t(Un, i.data), e(
        "product/setProductData",
        i.data.productData,
        { root: !0 }
      );
    } catch (i) {
      t(de, i);
    }
    t(ce);
  },
  async getTileProduct({ commit: t, dispatch: e }, r) {
    t($e, Cn), t(Te), t(Un, r), e(
      "product/setProductData",
      r.productData,
      { root: !0 }
    ), t(ce);
  },
  async getLineitem({ commit: t, dispatch: e, getters: r, rootGetters: i }, n) {
    t(Te);
    let a = "", s = "", o = "";
    typeof n == "object" ? (a = n.id, s = n.context, o = n.nonce) : a = n;
    let l = null;
    try {
      s === Cf ? a in r.proofLineItems ? l = r.proofLineItems[a] : (l = await aS(o, a), r.proofLineItems[a] = l) : l = await iS(a), t(Un, l.data), e("setFlippedSizes", l.data.suggestedSizes), (i["product/productSlug"] === nt || i["product/productSlug"] === St) && (i["app/featureFlags"].enableOffline ? (l.data.productData.images.pane_1.originalPath = l.data.productData.image.originalPath, l.data.productData.images.pane_1.thumbPath = l.data.productData.image.originalPath) : e("product/setPetPortraitOriginalImage", l.data.productData.petPortraitSourceImage, { root: !0 }));
      const c = qc(l.data.productData);
      e("product/setProductData", c, { root: !0 });
    } catch (c) {
      e("cartRedirect", c);
    }
    t(ce);
  },
  async getArt({ commit: t, dispatch: e }, r) {
    t(Te);
    const { id: i, providerId: n } = r;
    try {
      const s = (await rS(i, n)).data;
      if (!s.thumbnails || Object.keys(s.thumbnails).length === 0) {
        t(dg, s3);
        return;
      }
      const o = {
        pane_1: {
          id: null,
          sourceId: s.id,
          width: s.width,
          height: s.height,
          originalPath: s.thumbnails.large.url,
          thumbPath: s.thumbnails.large.url
        }
      };
      e("product/setImage", o, { root: !0 }), e("setImage", { pane_1: o.pane_1 });
    } catch (a) {
      t(de, a);
    }
    t(ce);
  },
  async getSizes({ commit: t }, e) {
    t($e, u3), t(Te);
    try {
      const r = await sS(e);
      t(qr, r.data);
    } catch (r) {
      t(de, r);
    }
    t(ce);
  },
  async getSize({ commit: t, dispatch: e, getters: r }, i) {
    const { code: n, width: a, height: s } = i, o = `${a}|${s}`, l = `${s}|${a}`;
    if (r && r.sizes[o])
      e("image/setEditTool", null, { root: !0 }), e("product/setSize", o, { root: !0 });
    else {
      t($e, h3), t(Te);
      try {
        const u = await lS(n, a, s), d = Object.assign({}, u, {
          data: Object.assign({}, u.data, {
            width: s,
            height: a
          })
        });
        e("product/setSize", o, { root: !0 }), e("image/setEditTool", null, { root: !0 }), t(qr, { [o]: u.data }), t(qr, { [l]: d.data });
      } catch (c) {
        t(de, c);
      }
      t(ce);
    }
  },
  async cartAdd({ commit: t, dispatch: e, rootState: r, rootGetters: i }) {
    t($e, Mu), t(Te);
    let n = r.product;
    n.printSize = {
      width: i["product/totalWidth"],
      height: i["product/totalHeight"]
    }, i["product/productSlug"] === St && (n.remuxSeed = Number(localStorage.getItem("remuxSeed"))), i["builder/trackingMetrics"] && (n = Object.assign(n, i["builder/trackingMetrics"]));
    try {
      (await uS(n)).status === 201 ? window.location.assign("/cart") : (t(de, tt), t(ce));
    } catch {
      t(de, tt), t(ce);
    }
  },
  async cartAddTiles({ commit: t, dispatch: e, rootState: r, rootGetters: i }, n) {
    t($e, Mu), t(Te);
    let a = n, s = [];
    for (let o = 0; o < a.length; o++) {
      const l = {
        productCode: a[o].productData.productCode,
        productSlug: a[o].productData.productSlug,
        svg: a[o].svg,
        size: a[o].productData.size,
        options: a[o].productData.options,
        uploadLater: a[o].productData.uploadLater,
        note: a[o].productData.note,
        printSize: {
          width: a[o].totalWidth,
          height: a[o].totalHeight
        },
        images: a[o].productData.images,
        version: na,
        bundleItemId: a[o].bundleItemId
      };
      s.push(l);
    }
    try {
      (await hS(i["product/bundleSlug"], s)).status === 201 ? window.location.assign("/cart") : (t(de, tt), t(ce));
    } catch {
      t(de, tt), t(ce);
    }
  },
  async cartUpdateTiles({ commit: t, dispatch: e, rootState: r, rootGetters: i }, n) {
    t($e, Es), t(Te);
    let a = n.tiles, s = [];
    for (let o = 0; o < a.length; o++) {
      const l = {
        productCode: a[o].productData.productCode,
        productSlug: a[o].productData.productSlug,
        svg: a[o].svg,
        size: a[o].productData.size,
        options: a[o].productData.options,
        uploadLater: a[o].productData.uploadLater,
        lineitemId: a[o].productData.lineitemId,
        note: a[o].productData.note,
        printSize: {
          width: a[o].totalWidth,
          height: a[o].totalHeight
        },
        images: a[o].productData.images,
        version: na
      };
      s.push(l);
    }
    try {
      (await fS(n.bundleInstanceId, s)).status === 204 ? window.location.assign("/cart") : (t(de, tt), t(ce));
    } catch {
      t(de, tt), t(ce);
    }
  },
  async persistStockImage({ commit: t, dispatch: e, rootState: r, rootGetters: i }) {
    t($e, Es), t(Te);
    const n = r.product.images.pane_1;
    let a = new FormData();
    a.append("imgUrl", n.originalPath), a.append("providerId", "3"), a.append("sourceId", n.sourceId), a.append("width", n.width), a.append("height", n.height), a.append("persistable", !0);
    try {
      const s = await cS(a);
      if (s.status === 200) {
        let o = {
          pane_1: n
        };
        o.pane_1.id = s.data.id, e("product/setImage", o, { root: !0 });
      } else
        t(de, tt), t(ce);
    } catch {
      t(de, tt), t(ce);
    }
  },
  async cartUpdate({ commit: t, dispatch: e, rootState: r, rootGetters: i }, n) {
    t($e, Es), t(Te);
    let a = r.product;
    a.printSize = {
      width: i["product/totalWidth"],
      height: i["product/totalHeight"]
    }, i["product/productSlug"] === St && (a.remuxSeed = Number(localStorage.getItem("remuxSeed"))), i["builder/trackingMetrics"] && (a = Object.assign(a, i["builder/trackingMetrics"]));
    try {
      (await dS(a)).status === 204 ? window.location.assign("/cart") : (t(de, tt), t(ce));
    } catch {
      t(de, tt), t(ce);
    }
  },
  setLoadingMessage({ commit: t }, e) {
    t($e, e);
  },
  setStartLoading({ commit: t }) {
    t(Te);
  },
  setStopLoading({ commit: t }) {
    t(ce);
  },
  async setImage({ commit: t, dispatch: e, rootGetters: r, getters: i }, n) {
    const a = r["builder/isSingleSize"], s = ef[r["product/productSlug"]].suggestedSizes && !i.disableSuggestedSizes;
    if (!a && s) {
      t($e, d3), t(Te);
      try {
        const o = n[Object.keys(n)[0]].width, l = n[Object.keys(n)[0]].height, c = await oS(
          r["product/productSlug"],
          o,
          l
        );
        if (c.status === 200) {
          if (e("product/setImage", n, { root: !0 }), Object.keys(c.data.sizes).length > 0 && t(qr, c.data.sizes), c.data.sizingAlgorithm && t(vo, { sizingAlgorithmVersion: c.data.sizingAlgorithm }), c.data.suggestedSizes.length > 0) {
            t(
              Gi,
              c.data.suggestedSizes
            ), e("setFlippedSizes", c.data.suggestedSizes);
            const u = r["product/width"], d = r["product/height"], h = u * d, f = c.data.suggestedSizes.map(
              (p) => p.split("|")[0] * p.split("|")[1]
            ), v = Kc(f, h);
            e(
              "product/setSize",
              c.data.suggestedSizes[v],
              { root: !0 }
            );
          } else if (c.data.suggestedSizes.length == 0 && r["product/productSlug"] == "T") {
            let u = Object.keys(r["product/defaultSizes"]);
            u = u.filter((d, h) => h < 4), t(Gi, u), e("setFlippedSizes", u), e("product/setSize", u[0], { root: !0 });
          }
        } else
          t(de, tt);
      } catch {
        t(de, tt);
      }
      t(ce);
    } else {
      if (a || r["product/productSlug"] === ni) {
        const o = r["product/width"] / r["product/height"], l = n[Object.keys(n)[0]].width / n[Object.keys(n)[0]].height;
        (o > 1 && l < 1 || o < 1 && l > 1) && (e("product/setSize", r["product/height"] + "|" + r["product/width"], { root: !0 }), r["product/productSlug"] === ni && (e("setFlippedSizes", r["builder/suggestedSizes"]), e("flipSuggestedSizeOrientation")));
      }
      await e("product/setImage", n, { root: !0 });
    }
  },
  setCoupon({ commit: t }, e) {
    t(hg, e);
  },
  setCouponSizes({ commit: t }, e) {
    t(fg, e);
  },
  setCouponAmount({ commit: t }, e) {
    t(Vn, e);
  },
  setError({ commit: t }, e) {
    t(de, e);
  },
  setWarning({ commit: t }, e) {
    t(mo, e);
  },
  resetMessages({ commit: t }) {
    t(de, null), t(mo, null);
  },
  async previewInAr({ commit: t, getters: e, rootGetters: r }, i) {
    t($e, f3), t(Te);
    const n = r["product/width"], a = r["product/height"];
    let s = r["product/edgeDimension"];
    r["product/productSlug"] === nt && !r["app/featureFlags"].enableOffline && (s = 0.75);
    const o = {
      image: i,
      width: n,
      height: a,
      edge: s
    }, l = {
      auth: {
        username: r["app/artkitToken"]
      }
    }, c = r["app/arPreviewUrl"], u = await Promise.resolve().then(() => BA);
    try {
      const d = document.createElement("canvas");
      d.setAttribute("width", (n + s * 2) * sa), d.setAttribute("height", (a + s * 2) * sa);
      const h = d.getContext("2d");
      await (await u.default.fromString(h, i, {
        ignoreClear: !0,
        ignoreMouse: !0,
        forceRedraw: !0,
        anonymousCrossOrigin: !0
      })).render();
      const v = d.toDataURL("image/jpeg");
      o.image = v;
      let p, b, y = tf[r["product/productSlug"]];
      if (r["app/featureFlags"] && r["app/featureFlags"].enableARVersion3 && y) {
        const P = y.frame ? r["product/frame"] : null, O = y.edge ? r["product/edge"] : null, A = y.name, I = r["product/size"], D = {
          product: A,
          edge: O,
          format: "usdz",
          frame: P,
          size: I,
          image: o.image
        };
        p = await pS(c, D, l), b = p.data.url;
      } else
        l.responseType = "blob", p = await gS(c, o, l), b = window.URL.createObjectURL(
          new File([p.data], "preview.usdz", {
            type: "model/vnd.usdz+zip"
          })
        );
      const x = document.createElement("a"), w = document.createElement("img");
      x.appendChild(w), x.href = b, x.setAttribute("id", "ar-preview-link"), x.setAttribute("rel", "ar"), document.body.appendChild(x), x.click();
    } catch (d) {
      t(de, d);
    }
    t(ce);
  },
  setIsSingleSize({ commit: t }, e) {
    t(gg, e);
  },
  setIsArt({ commit: t }, e) {
    t(pg, e);
  },
  resetBuilder({ commit: t }) {
    t(mg, Eg());
  },
  setCollageSuggestedSizes({ commit: t, dispatch: e, rootGetters: r }, i) {
    if (i.suggestedSizes.length > 0 && (t(Gi, i.suggestedSizes), !i.fromLineItem)) {
      const n = r["product/width"], a = r["product/height"], s = n * a, o = i.suggestedSizes.map(
        (c) => c.split("|")[0] * c.split("|")[1]
      ), l = Kc(o, s);
      e(
        "product/setSize",
        i.suggestedSizes[l],
        { root: !0 }
      );
    }
  },
  setTrackingMetrics({ commit: t }, e) {
    t(vo, e);
  },
  setArtkitFlow({ commit: t, getters: e, dispatch: r }, i) {
    t(vg, i), e.artkitFlow.addEventListener("flow:start", (n) => n.detail.message ? r("setLoadingMessage", n.detail.message) : null), e.artkitFlow.addEventListener("node:custom", (n) => n.detail.message ? r("setLoadingMessage", n.detail.message) : null);
  },
  async processPetPortrait({ commit: t, rootGetters: e, getters: r, dispatch: i }, n) {
    const a = n && (n.recalculate === !0 || n.addToCart === !0), s = e["product/petPortraitSourceImage"];
    if (s) {
      a && t(Te);
      const o = 75, l = e["product/edgeDimension"], c = n.addToCart ? (parseInt(e["product/size"].split("|")[0], 10) + 2 * l) * o : 600, u = n.addToCart ? (parseInt(e["product/size"].split("|")[1], 10) + 2 * l) * o : 600, d = e["product/selectedPetPortraitColor"], h = e["product/selectedPetPortraitStyle"], f = e["product/petPortraitName"], v = parseInt(r.sizes[e["product/size"]].width, 10) + 2 * l, p = {
        image: s.originalPath,
        color: d,
        filter: h,
        text: f,
        width: c,
        height: u,
        margin: l / v * c
      };
      this.selectedStyle === "sketch2" ? p.textShadow = !0 : delete p.textShadow;
      try {
        const b = await r.artkitFlow.process(p, n.options);
        if (b && b.image) {
          const y = b.image;
          if (n.addToCart)
            return {
              id: s.id,
              width: c,
              height: u,
              originalPath: y,
              thumbPath: y
            };
          let x = document.querySelector("#canvas"), w = x.querySelector("canvas");
          w ? (w.width = c, w.height = u, w.getContext("2d").drawImage(y, 0, 0)) : x.appendChild(y);
          const P = x.querySelector("canvas").toDataURL("image/png");
          return a && t(ce), {
            id: s.id,
            width: c,
            height: u,
            originalPath: P,
            thumbPath: P
          };
        }
      } catch (b) {
        let y = "";
        return b && b.meta && b.meta.error && b.meta.error.code && b.meta.error.code === 100 ? y = o3 : y = l3, t(de, y), i("product/setPetPortraitOriginalImage", null, { root: !0 }), a && t(ce), null;
      }
    }
  },
  getPrintableData({ rootGetters: t }, e) {
    const i = t["product/edgeDimension"], n = e.defaultSizes, a = e.size, s = parseInt(n[a].width, 10) + 2 * i, o = (parseInt(a.split("|")[0], 10) + 2 * i) * 150, l = {
      artkit: {
        flowId: "58",
        inputs: {
          image: t["product/petPortraitSourceImage"].originalPath,
          color: t["product/selectedPetPortraitColor"],
          text: t["product/petPortraitName"],
          margin: i / s * o,
          width: o,
          height: (parseInt(a.split("|")[1], 10) + 2 * i) * 150,
          filter: t["product/selectedPetPortraitStyle"]
        }
      }
    };
    return JSON.stringify(l);
  },
  async getTiles({ commit: t }, e) {
    t($e, Cn), t(Te);
    try {
      const r = await tS(e.toString());
      t(yo, r.data.bundleItems);
      const i = r.data.reductionRate * 100;
      t(Vn, i);
    } catch (r) {
      t(de, r);
    }
    t(ce);
  },
  async getBundleInstanceTiles({ commit: t, dispatch: e, getters: r, rootGetters: i }, n) {
    t($e, Cn), t(Te);
    try {
      const a = await nS(n.toString());
      let s = a.data.bundleItems;
      for (let l = 0; l < s.length; l++)
        s[l].productData = qc(s[l].productData);
      t(yo, s);
      const o = a.data.reductionRate * 100;
      t(Vn, o);
    } catch (a) {
      e("cartRedirect", a);
    }
    t(ce);
  },
  setTileImage({ commit: t, rootGetters: e }, r) {
    t(yg, r);
  },
  unsetTileImage({ commit: t, rootGetters: e, dispatch: r }, i) {
    t(bg, i);
  },
  cartRedirect({ commit: t }, e) {
    e.response.status === 404 ? window.location.assign("/cart") : t(de, e);
  },
  flipSuggestedSizeOrientation({ commit: t, state: e }) {
    let r = [];
    for (let i = 0; i < e.suggestedSizes.length; i++) {
      const n = e.suggestedSizes[i], a = parseInt(n.split("|")[0], 10), s = parseInt(n.split("|")[1], 10);
      r.push(s + "|" + a);
    }
    t(Gi, r);
  },
  setSnapshot({ commit: t, state: e }) {
    let r = JSON.parse(JSON.stringify(e));
    delete r.snapshot, t(xg, r);
  },
  revertToSnapshot({ commit: t, state: e }) {
    t(Sg, e.snapshot);
  },
  disableSuggestedSizes({ commit: t }) {
    t(wg);
  },
  setFlippedSizes({ commit: t, state: e }, r) {
    const i = e.sizes, n = r, a = {};
    for (let s = 0; s < n.length; s++) {
      const o = n[s].split("|")[0], l = n[s].split("|")[1], c = l + "|" + o;
      i.hasOwnProperty(c) || (a[c] = JSON.parse(JSON.stringify(i[n[s]])), a[c].width = l, a[c].height = o, a[c].label = l + '" x ' + o + '"');
    }
    t(qr, a);
  }
}, p3 = {
  [Te](t) {
    t.loading += 1;
  },
  [ce](t) {
    t.loading -= 1;
  },
  [de](t, e) {
    t.error = e;
  },
  [mo](t, e) {
    t.warning = e;
  },
  [dg](t, e) {
    t.invalid = e;
  },
  [Un](t, e) {
    t.sizes = e.sizes, t.layouts = e.layouts, t.borders = e.borders, t.borderColors = e.borderColors, t.edges = e.edges, t.frames = e.frames, t.filters = e.filters, t.services = e.services, t.suggestedSizes = [...e.suggestedSizes], t.customSizes = e.customSizes, t.unitOfMeasure = e.unitOfMeasure, e.colors && (t.petPortraitColors = e.colors), e.corners && (t.corners = e.corners), e.hangingHardware && (t.hangingHardware = e.hangingHardware), e.printSurfaces && (t.printSurfaces = e.printSurfaces), e.maxDimension1 && e.maxDimension2 && (t.minMaxCustomSize = Math.min(e.maxDimension1, e.maxDimension2), t.maxMaxCustomSize = Math.max(e.maxDimension1, e.maxDimension2));
  },
  [qr](t, e) {
    t.sizes = Object.assign({}, t.sizes, e);
  },
  [Gi](t, e) {
    t.suggestedSizes = [...e];
  },
  [$e](t, e) {
    t.loadingMessage = e;
  },
  [hg](t, e) {
    t.coupon = e;
  },
  [fg](t, e) {
    t.couponSizes = [...e];
  },
  [Vn](t, e) {
    t.couponAmount = e;
  },
  [gg](t, e) {
    t.isSingleSize = e;
  },
  [pg](t, e) {
    t.isArt = e;
  },
  [mg](t, e) {
    Object.assign(t, e);
  },
  [vg](t, e) {
    t.artkitFlow = e;
  },
  [vo](t, e) {
    t.trackingMetrics = Object.assign(t.trackingMetrics, e);
  },
  [yo](t, e) {
    t.tiles = e;
  },
  [yg](t, e) {
    const r = t.tiles[e.tileIndex];
    r.productData.uploadLater = !1, r.productData.images = Object.assign({}, r.productData.images, { [e.paneId]: e.image });
  },
  [bg](t, e) {
    const r = t.tiles[e.tileIndex];
    r.productData.uploadLater = !0;
    let i = r.productData.images;
    i && i[e.paneId] && delete i[e.paneId];
  },
  [xg](t, e) {
    t.snapshot = e;
  },
  [Sg](t, e) {
    Object.assign(t, e);
  },
  [wg](t) {
    t.disableSuggestedSizes = !0;
  }
}, m3 = "in", Eg = () => ({
  loading: 0,
  error: null,
  warning: null,
  invalid: null,
  sizes: {},
  layouts: {},
  borders: {},
  borderColors: {},
  edges: {},
  frames: {},
  filters: {},
  services: {},
  suggestedSizes: [],
  customSizes: {},
  loadingMessage: c3,
  coupon: null,
  couponSizes: [],
  couponAmount: 0,
  artkitToken: null,
  artkitUrl: null,
  isSingleSize: !1,
  isArt: !1,
  proofLineItems: {},
  artkitFlow: null,
  petPortraitColors: {},
  petPortraitStyles: [
    {
      code: "oilpaint",
      description: "Oil Paint",
      foreignPrice: 0,
      id: 1,
      label: "Oil Paint",
      optionId: 78
    },
    {
      code: "sketch2",
      description: "Charcoal",
      foreignPrice: 0,
      id: 1,
      label: "Charcoal",
      optionId: 79
    },
    {
      code: "modern",
      description: "Modern",
      foreignPrice: 0,
      id: 1,
      label: "Modern",
      optionId: 77
    }
  ],
  trackingMetrics: {},
  unitOfMeasure: m3,
  corners: {},
  hangingHardware: {},
  printSurfaces: {},
  tiles: [],
  disableSuggestedSizes: !1
}), v3 = Object.assign({}, Eg()), y3 = {
  namespaced: !0,
  state: v3,
  getters: a3,
  actions: g3,
  mutations: p3
}, Vl = 1, Tg = 3, ha = 5, Hl = 6, rt = 8, fa = 12, Wl = 19, ga = 16, pa = 20, ma = 21, va = 22, b3 = "overlay", x3 = "text", Lu = 1800, S3 = 150, w3 = {
  productSlug: (t) => t.productSlug,
  productName: (t) => t.productName,
  lineitemId: (t) => t.lineitemId,
  images: (t) => t.images,
  svg: (t) => t.svg,
  size: (t) => t.size,
  note: (t) => t.note,
  uploadLater: (t) => t.uploadLater,
  defaultSizes: (t) => t.defaultSizes,
  mgiPhotoBorderBleed: (t) => t.mgiPhotoBorderBleed,
  mgiPrintEdge: (t) => t.mgiPrintEdge,
  mgiImages: (t) => t.mgiImages,
  selectedPetPortraitColor: (t) => t.selectedPetPortraitColor,
  selectedPetPortraitStyle: (t) => t.selectedPetPortraitStyle,
  petPortraitSourceImage: (t) => t.petPortraitSourceImage,
  petPortraitName: (t) => t.petPortraitName,
  customEdge: (t) => t.customEdge,
  width: (t) => t.size ? parseInt(t.size.split("|")[0], 10) * (t.productSlug === "T" ? 3 : 1) : 0,
  height: (t) => t.size ? parseInt(t.size.split("|")[1], 10) : 0,
  totalWidth: (t, e) => e.width + 2 * e.edgeDimension,
  totalHeight: (t, e) => e.height + 2 * e.edgeDimension,
  layout: (t) => t.options[Wl],
  border: (t) => t.options[fa],
  borderColor: (t) => t.options[ga],
  frame: (t) => t.options[rt],
  canvasDepth: (t) => t.canvasDepth,
  edge: (t) => t.options[ha],
  filter: (t) => t.options[Hl],
  service: (t) => t.options[Vl],
  edgeDimension: (t, e) => {
    var r, i;
    return t.customEdge ? t.customEdge : ((i = (r = fr[e == null ? void 0 : e.productSlug]) == null ? void 0 : r[e == null ? void 0 : e.frame]) == null ? void 0 : i.edge) || 0;
  },
  borderDimension: (t, e) => {
    var r, i;
    return ((i = (r = Qh[e == null ? void 0 : e.productSlug]) == null ? void 0 : r[e == null ? void 0 : e.border]) == null ? void 0 : i.size) || 0;
  },
  borderColorValue: (t, e) => {
    var r, i;
    return ((i = (r = Jh[e == null ? void 0 : e.productSlug]) == null ? void 0 : r[e == null ? void 0 : e.borderColor]) == null ? void 0 : i.color) || "";
  },
  gapDimension: (t, e) => e.productSlug && e.frame && fr[e.productSlug] ? fr[e.productSlug][e.frame].gap : 0,
  matDimension: (t, e) => {
    var r, i;
    return ((i = (r = fr[e == null ? void 0 : e.productSlug]) == null ? void 0 : r[e == null ? void 0 : e.edge]) == null ? void 0 : i.mat) || 0;
  },
  frameDimension: (t, e) => {
    var r, i;
    return ((i = (r = fr[e == null ? void 0 : e.productSlug]) == null ? void 0 : r[e == null ? void 0 : e.frame]) == null ? void 0 : i.frame) || 0;
  },
  frameColor: (t, e) => {
    var r, i;
    return ((i = (r = fr[e == null ? void 0 : e.productSlug]) == null ? void 0 : r[e == null ? void 0 : e.frame]) == null ? void 0 : i.color) || "";
  },
  cornerRadius: (t, e) => {
    var r;
    return ((r = Kh[e == null ? void 0 : e.productSlug]) == null ? void 0 : r.cornerRadius) || "0px";
  },
  edgeColor: (t, e) => {
    var r, i;
    return ((i = (r = Zh[e == null ? void 0 : e.productSlug]) == null ? void 0 : r[e == null ? void 0 : e.edge]) == null ? void 0 : i.color) || "";
  },
  supportsAr: (t, e, r, i) => {
    if (e.size && i["builder/sizes"] && i["builder/sizes"][e.size]) {
      let a = i["app/featureFlags"] && i["app/featureFlags"].enableARVersion3 ? !0 : i["builder/sizes"][e.size].supportsAr;
      if (e.productSlug === kt)
        return !0;
      switch (e.frame) {
        case "075DW":
        case "150DW":
        case "250DW":
        case "BF":
        case "WF":
        case "GF":
        case "EF":
        case "SF":
          return a;
        default:
          return !1;
      }
    } else
      return !1;
  },
  panels: (t, e) => e.productSlug && uo[e.productSlug] ? uo[e.productSlug] : 1,
  corner: (t) => t.options[ma],
  hangingHardware: (t) => t.options[va],
  printSurface: (t) => t.options[pa],
  bundleSlug: (t) => t.bundleSlug,
  options: (t) => t.options,
  snapshot: (t) => t.snapshot,
  remuxFilters: (t) => t.remuxFilters,
  remuxLoading: (t) => t.remuxLoading,
  remuxPayload: (t, e, r, i) => {
    const n = i["product/petPortraitSourceImage"] ? i["product/petPortraitSourceImage"].originalPath : null;
    let a = {};
    const l = JSON.parse(JSON.stringify(e.remuxFilters)).find((c) => c.name === e.selectedPetPortraitStyle).payload.filters;
    for (let c = 0; c < l.length; c++)
      switch (l[c].type) {
        case b3:
          l[c].background_color = e.selectedPetPortraitColor;
          break;
        case x3:
          l[c].text = e.petPortraitName, l[c].font_color = pm(e.selectedPetPortraitColor) ? "#000000" : "#ffffff";
          break;
      }
    return a.filters = l, a.target_size = e.width * 150, a.seed = Number(localStorage.getItem("remuxSeed")) ?? null, a.image_path = n, a.output = "json", a;
  }
}, Hn = "PRODUCT_SET_PRODUCT_CODE", Pg = "PRODUCT_SET_PRODUCT_NAME", Og = "PRODUCT_SET_LINEITEM_ID", bo = "PRODUCT_SET_IMAGES", xo = "PRODUCT_SET_IMAGE", So = "PRODUCT_UNSET_IMAGE", Cg = "PRODUCT_SET_TRANSFORMS", wo = "PRODUCT_SET_SVG", Wn = "PRODUCT_SET_SIZE", Ig = "PRODUCT_SET_PROOF", Eo = "PRODUCT_SET_LAYOUT", Gn = "PRODUCT_SET_BORDER", Yn = "PRODUCT_SET_BORDER_COLOR", Kr = "PRODUCT_SET_EDGE", Yi = "PRODUCT_SET_FRAME", To = "PRODUCT_SET_FILTER", Po = "PRODUCT_SET_SERVICE", Xn = "PRODUCT_SET_NOTE", Oo = "PRODUCT_SET_UPLOAD_LATER", _g = "PRODUCT_RESET", Co = "PRODUCT_SET_MGI_IMAGES", Io = "PRODUCT_SET_MGI_PHOTO_BORDER_BLEED", _o = "PRODUCT_SET_MGI_PRINT_EDGE", Ag = "PRODUCT_SET_DEFAULT_SIZES", qn = "PRODUCT_SET_PET_PORTRAIT_COLOR", Kn = "PRODUCT_SET_PET_PORTRAIT_STYLE", Ao = "PRODUCT_SET_PET_PORTRAIT_NAME", Zn = "PRODUCT_SET_CUSTOM_EDGE", Ro = "PRODUCT_SET_CORNER", Mo = "PRODUCT_SET_HANGING_HARDWARE", Lo = "PRODUCT_SET_PRINT_SURFACE", Rg = "PRODUCT_SET_BUNDLE_SLUG", Mg = "PRODUCT_SET_STATE_SNAPSHOT", Lg = "PRODUCT_REVERT_TO_SNAPSHOT", Xi = "PRODUCT_SET_CANVAS_DEPTH", Dg = "PRODUCT_SET_PET_PORTRAIT_SOURCE_IMAGE", Ng = "PRODUCT_SET_ROTATE", jg = "PRODUCT_SET_REMUX_FILTERS", Do = "PRODUCT_SET_REMUX_LOADING";
bi.create({
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest"
  }
});
bi.create({
  responseType: "json",
  headers: {
    "Content-Type": "application/json"
  }
});
bi.create({
  baseURL: "/cart",
  responseType: "json",
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest"
  }
});
const E3 = (t) => bi.create({
  responseType: "json",
  withCredentials: !0,
  headers: {
    "Content-Type": "application/json",
    "X-Requested-With": "XMLHttpRequest",
    "x-api-key": t
  }
}), T3 = async (t, e, r) => E3(t).post(e + "process", r), P3 = {
  setProductData({ commit: t, dispatch: e, rootGetters: r }, i) {
    if (t(Hn, i.productSlug), t(Pg, i.name), t(Og, i.lineitemId), t(Wn, i.size), t(Ig, i.options[Tg]), t(Eo, i.options[Wl]), t(Gn, i.options[fa]), t(Yn, i.options[ga]), t(Kr, i.options[ha]), i.options[rt] && (t(Yi, i.options[rt]), (i.options[rt] === mr || i.options[rt] === ei) && t(Xi, i.options[rt]), i.options[rt] !== mr && i.options[rt] !== ei)) {
      let n = null;
      switch (r["builder/frames"][i.options[rt]] && r["builder/frames"][i.options[rt]].dimension) {
        case "0.7500":
          n = mr;
          break;
        case "1.2500":
          n = ei;
          break;
      }
      n && t(Xi, n);
    }
    if (t(To, i.options[Hl]), t(Po, i.options[Vl]), t(Oo, i.uploadLater), t(Io, i.mgiPhotoBorderBleed), t(_o, i.mgiPrintEdge), i.mgiImages && i.mgiImages.length > 0) {
      const n = i.mgiImages.sort((a, s) => a.id - s.id);
      t(Co, n);
    }
    if (t(Zn, i.customEdge), (r["product/productSlug"] === nt || r["product/productSlug"] === St) && (i.selectedPetPortraitColor && t(qn, i.selectedPetPortraitColor), i.selectedPetPortraitStyle && t(Kn, i.selectedPetPortraitStyle), i.petPortraitName && t(Ao, i.petPortraitName), i.note)) {
      let n = i.note.split("||")[1];
      n = n === "null" ? "" : n, t(Xn, n);
    }
    if (r["product/productSlug"] === St) {
      if (t(jg, i.styles), i.remuxSeed)
        localStorage.setItem("remuxSeed", i.remuxSeed);
      else if (!Number(localStorage.getItem("remuxSeed"))) {
        const a = dm();
        localStorage.setItem("remuxSeed", a);
      }
    }
    if (r["product/productSlug"] === kt && (t(Ro, i.options[ma]), t(Mo, i.options[va]), t(Lo, i.options[pa]), t(Kr, 0), t(Zn, 0)), r["product/productSlug"] === nt && !r["app/featureFlags"].enableOffline)
      i.image && e("recalculatePetPortrait");
    else {
      if (i.images) {
        const n = sm(i.images);
        t(bo, n);
      }
      i.svg && (t(wo, i.svg), e("setTransforms", i.svg)), t(Xn, i.note);
    }
  },
  setProofOnlyProductData({ commit: t, dispatch: e, rootGetters: r }, i) {
    if (t(Hn, i.productSlug), t(Wn, i.size), t(Gn, i.options[fa]), t(Yn, i.options[ga]), t(Kr, i.options[ha]), t(Yi, i.options[rt]), t(Io, i.mgiPhotoBorderBleed), t(_o, i.mgiPrintEdge), t(Zn, i.customEdge), i.mgiImages && i.mgiImages.length > 0) {
      const n = i.mgiImages.sort((a, s) => a.id - s.id);
      t(Co, n);
    }
    r["product/productSlug"] === kt && (t(Ro, i.options[ma]), t(Mo, i.options[va]), t(Lo, i.options[pa]));
  },
  setproductSlug({ commit: t }, e) {
    t(Hn, e);
  },
  setImages({ commit: t }, e) {
    t(bo, e);
  },
  async setImage({ commit: t, getters: e, rootGetters: r, dispatch: i }, n) {
    var s, o, l, c, u, d;
    if (n && r["product/productSlug"] === nt && !r["app/featureFlags"].enableOffline) {
      const h = await i("builder/processPetPortrait", n, { root: !0 });
      h && (n.pane_1 = h), n.recalculate && delete n.recalculate, n.addToCart && delete n.addToCart, n.options && delete n.options;
    }
    let a = null;
    if (r["product/productSlug"] === St && !r["app/featureFlags"].enableOffline) {
      let h = JSON.parse(JSON.stringify(r["product/petPortraitSourceImage"]));
      if (h) {
        t(Do, !0);
        const f = e.remuxPayload, v = r["app/remuxApiKey"], p = r["app/remuxApiUrl"];
        let b, y = {};
        try {
          b = await T3(v, p, f);
          const x = b.data.path, w = b.data.thumbnail, P = S3 * 2;
          y.originalPath = x, y.thumbPath = w || x, y.id = h.id, y.width = Lu + P, y.height = Lu + P, a = {
            pane_1: y
          }, t(xo, a);
        } catch (x) {
          x.response.status === 422 && (((l = (o = (s = x.response) == null ? void 0 : s.data) == null ? void 0 : o.detail) == null ? void 0 : l.type) === "PetFaceNotDetected" || ((d = (u = (c = x.response) == null ? void 0 : c.data) == null ? void 0 : u.detail) == null ? void 0 : d.type) === "FaceNotDetected") ? i("builder/setError", "We couldn't detect any pets in your photo. Please try a different one.", { root: !0 }) : i("builder/setError", "Sorry, something went wrong on our end, please try again later!", { root: !0 });
        }
        t(Do, !1);
      }
    } else
      t(xo, n);
  },
  unsetImage({ commit: t }) {
    t(So);
  },
  setPetPortraitOriginalImage({ commit: t }, e) {
    t(Dg, e);
  },
  setSvg({ commit: t }, e) {
    t(wo, e);
  },
  setTransforms({ commit: t }, e) {
    let r = am(e);
    t(Cg, r);
  },
  async setSize({ commit: t, dispatch: e, rootGetters: r }, i) {
    t(Wn, i), e("recalculatePetPortrait");
  },
  setDefaultSizes({ commit: t }, e) {
    t(Ag, e);
  },
  setEdge({ commit: t }, e) {
    t(Kr, e);
  },
  setFrame({ commit: t, getters: e, rootGetters: r }, i) {
    t(Yi, i);
    const n = r["builder/frames"][i];
    n && t(Xi, mr), n && n.edges.indexOf(e.edge) === -1 && t(Kr, r["builder/edges"][n.edges[0]].code);
  },
  setCanvasDepth({ commit: t, getters: e, rootGetters: r }, i) {
    t(Xi, i), t(Yi, i);
  },
  setBorder({ commit: t }, e) {
    t(Gn, e);
  },
  setBorderColor({ commit: t }, e) {
    t(Yn, e);
  },
  setLayout({ commit: t }, e) {
    t(Eo, e);
  },
  setFilter({ commit: t }, e) {
    t(To, e);
  },
  setService({ commit: t }, e) {
    t(Po, e);
  },
  setNote({ commit: t }, e) {
    t(Xn, e);
  },
  setUploadLater({ commit: t }, e) {
    t(Oo, e), e === !0 && t(So);
  },
  setPetPortraitColor({ commit: t, dispatch: e }, r) {
    t(qn, r), e("recalculatePetPortrait");
  },
  setPetPortraitStyle({ commit: t, dispatch: e }, r) {
    t(Kn, r), e("recalculatePetPortrait");
  },
  setPetPortraitName({ commit: t, dispatch: e }, r) {
    t(Ao, r), e("recalculatePetPortrait");
  },
  setPetPortraitAttributes({ commit: t, dispatch: e }, r) {
    r.color && t(qn, r.color), r.style && t(Kn, r.style), e("recalculatePetPortrait");
  },
  resetProduct({ commit: t }, e) {
    t(_g, kg(e));
  },
  async recalculatePetPortrait({ dispatch: t, getters: e, state: r, rootGetters: i }) {
    i["product/productSlug"] === St && !i["app/featureFlags"].enableOffline && await t("setImage", null);
  },
  setBundleSlug({ commit: t }, e) {
    t(Rg, e);
  },
  setSnapshot({ commit: t, state: e }) {
    let r = JSON.parse(JSON.stringify(e));
    delete r.snapshot, t(Mg, r);
  },
  revertToSnapshot({ commit: t, state: e }) {
    t(Lg, e.snapshot);
  },
  setImageRotate({ getters: t, commit: e }, r) {
    var a, s;
    let i = 90, n = ((s = (a = t.images[r]) == null ? void 0 : a.transform) == null ? void 0 : s.rotate) || 0;
    n !== 270 ? n += i : n = 0, e(Ng, {
      rotate: n,
      pane: r
    });
  }
}, O3 = {
  [Hn](t, e) {
    t.productSlug = e;
  },
  [Pg](t, e) {
    t.productName = e;
  },
  [Og](t, e) {
    t.lineitemId = e;
  },
  [bo](t, e) {
    t.images = e;
  },
  [xo](t, e) {
    t.images = Object.assign({}, t.images, e);
  },
  [So](t) {
    t.images = {};
  },
  [Cg](t, e) {
    Object.keys(e).forEach((r) => {
      t.images[r] = Object.assign({}, t.images[r], e[r]);
    });
  },
  [wo](t, e) {
    t.svg = e;
  },
  [Wn](t, e) {
    t.size = e;
  },
  [Ag](t, e) {
    t.defaultSizes = e;
  },
  [Ig](t, e) {
    t.options = Object.assign({}, t.options, {
      [Tg]: e
    });
  },
  [Eo](t, e) {
    t.options = Object.assign({}, t.options, {
      [Wl]: e
    });
  },
  [Gn](t, e) {
    t.options = Object.assign({}, t.options, {
      [fa]: e
    });
  },
  [Yn](t, e) {
    t.options = Object.assign({}, t.options, {
      [ga]: e
    });
  },
  [Kr](t, e) {
    t.options = Object.assign({}, t.options, {
      [ha]: e
    });
  },
  [Yi](t, e) {
    t.options = Object.assign({}, t.options, {
      [rt]: e
    });
  },
  [To](t, e) {
    t.options = Object.assign({}, t.options, {
      [Hl]: e
    });
  },
  [Po](t, e) {
    t.options = Object.assign({}, t.options, {
      [Vl]: e
    });
  },
  [Xn](t, e) {
    t.note = e;
  },
  [Oo](t, e) {
    t.uploadLater = e;
  },
  [_g](t, e) {
    Object.assign(t, e);
  },
  [Co](t, e) {
    t.mgiImages = e;
  },
  [Io](t, e) {
    t.mgiPhotoBorderBleed = e;
  },
  [_o](t, e) {
    t.mgiPrintEdge = e;
  },
  [qn](t, e) {
    t.selectedPetPortraitColor = e;
  },
  [Kn](t, e) {
    t.selectedPetPortraitStyle = e;
  },
  [Ao](t, e) {
    t.petPortraitName = e;
  },
  [Zn](t, e) {
    t.customEdge = e;
  },
  [Ro](t, e) {
    t.options = Object.assign({}, t.options, {
      [ma]: e
    });
  },
  [Mo](t, e) {
    t.options = Object.assign({}, t.options, {
      [va]: e
    });
  },
  [Lo](t, e) {
    t.options = Object.assign({}, t.options, {
      [pa]: e
    });
  },
  [Rg](t, e) {
    t.bundleSlug = e;
  },
  [Mg](t, e) {
    t.snapshot = e;
  },
  [Lg](t, e) {
    Object.assign(t, e);
  },
  [Xi](t, e) {
    t.canvasDepth = e;
  },
  [Dg](t, e) {
    t.petPortraitSourceImage = e;
  },
  [Ng](t, e) {
    t.images && t.images[e.pane] && (t.images[e.pane].transform.rotate = e.rotate);
  },
  [jg](t, e) {
    t.remuxFilters = e;
  },
  [Do](t, e) {
    t.remuxLoading = e;
  }
}, kg = (t) => ({
  productSlug: t || "S",
  productName: "",
  lineitemId: null,
  size: null,
  canvasDepth: null,
  frame: null,
  images: {},
  svg: null,
  note: null,
  options: {},
  uploadLater: !1,
  version: na,
  mgiPhotoBorderBleed: 0,
  mgiPrintEdge: 0,
  mgiImages: [],
  defaultSizes: {},
  selectedPetPortraitColor: null,
  selectedPetPortraitStyle: null,
  petPortraitSourceImage: null,
  petPortraitName: "",
  customEdge: null
}), C3 = Object.assign({}, kg()), I3 = {
  namespaced: !0,
  state: C3,
  getters: w3,
  actions: P3,
  mutations: O3
}, _3 = {
  selectedEditToolId: (t) => t.selectedEditToolId,
  imageEditTrigger: (t) => t.imageEditTrigger,
  selectedEditToolName: (t) => t.selectedEditToolId ? wf[t.selectedEditToolId].name : null
}, zg = "IMAGE_SET_EDIT_TOOL", Qn = "IMAGE_SET_IMAGE_TRIGGER", A3 = {
  setEditTool({ commit: t, dispatch: e, getters: r, rootGetters: i }, n) {
    t(zg, n);
  },
  async cancelEdit({ commit: t, dispatch: e }) {
    await t(Qn, Qm), e("resetImageTrigger");
  },
  resetImage({ commit: t }) {
    t(Qn, Jm);
  },
  resetImageTrigger({ commit: t, dispatch: e }) {
    t(Qn, null), e("setEditTool", null);
  }
}, R3 = {
  [zg](t, e) {
    t.selectedEditToolId = e;
  },
  [Qn](t, e) {
    t.imageEditTrigger = e;
  }
}, M3 = () => Object.assign({
  selectedEditToolId: null,
  imageEditTrigger: null,
  hasEdits: !1
}, L3), L3 = {
  scale: 1,
  translateX: 0,
  translateY: 0
}, D3 = Object.assign({}, M3()), N3 = {
  namespaced: !0,
  state: D3,
  getters: _3,
  actions: A3,
  mutations: R3
}, s8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  app: n3,
  builder: y3,
  image: N3,
  product: I3
}, Symbol.toStringTag, { value: "Module" })), Bg = {
  dialog: {
    heading: "Attention!",
    cancelLabel: "Cancel",
    confirmLabel: "Confirm"
  },
  artDetail: {
    seeSimilar: "See similar",
    share: "Share",
    linkCopied: "Link copied",
    description: "Description",
    loadingContributor: "Loading contributor",
    customize: "Customize",
    creditWithContributor: "Image by {contributorName} / Shutterstock",
    creditNoContributor: "Image by Shutterstock",
    productLabels: {
      canvasPrint: "Canvas Print",
      framedPrint: "Framed Print"
    }
  },
  login: {
    defaultValidation: "This field has errors",
    existingCustomer: "Already a customer? Log in.",
    heading: "Log in",
    instructions: "Log in to your account.",
    emailLabel: "E-mail address",
    passwordLabel: "Password",
    cta: "Log in"
  },
  giftCard: {
    imageAlt: "A giftcard",
    amountLabel: "Select Amount",
    customAmountLabel: "Custom amount",
    foreignPrefix: "Approximately:",
    addToOrderButton: "Add to order",
    orSeparator: "or"
  },
  inspiration: {
    customSizeHeader: "Custom size {productName}",
    customSizeDescription: "We also offer many custom and large format sizes.",
    cta: "Create your {productName}",
    sizeTypes: {
      square: "Square",
      portrait: "Portrait",
      landscape: "Landscape",
      modern: "Modern",
      oil: "Oil",
      charcoal: "Charcoal"
    }
  },
  menu: {
    iconButtonLabel: "options"
  },
  textField: {
    requiredCharacterLength: "Must be at least 5 characters"
  },
  dropdown: {
    defaultOption: "Select..."
  },
  uploader: {
    mimeErrorMessage: "Sorry, something went wrong while uploading {fileName}"
  },
  regionSwitcher: {
    heading: "Change region",
    selectedLabel: "Region: {countryCode} ({currencyCode})",
    instructions: "Select your preferred country, language and currency.",
    countryLabel: "Country",
    currencyLabel: "Currency",
    languageLabel: "Language"
  },
  "3dProofReview": {
    title: "You have {titleProofCount} to review for order# {orderId}",
    titleProofCount: "{count} proof | {count} proofs",
    errorConfirmButton: "Okay",
    reviewComplete: "Review Complete",
    remainingCount: "{remainingCount} remaining",
    finishedTitle: "We’ll take it from here!",
    finishedDescriptionApproved: "All your proofs for this order have been approved. Your order will be heading to print shortly.",
    finishedDescriptionDeclined: "You requested changes to one or more proofs, keep your eyes peeled for an email with a new proof for you to review.",
    desktopInstructions: "Click and drag to rotate, scroll to zoom",
    mobileInstructions: "Swipe to rotate, pinch to zoom",
    designerNoteLabel: "Designer Notes:",
    requestChangesLabel: "Request Changes",
    requestChangesPlaceholder: "How can we make this proof better?",
    approveInsteadLink: "Approve instead!",
    requestChangesLink: "Request Changes",
    requestChangesButton: "Request Changes",
    approveButton: "Approve",
    youApproved: "You approved this proof",
    youRequestedChanges: "You requested changes on this proof",
    orSeparator: "or",
    errorMessage: "Sorry! Something went wrong on our end. Please try again later."
  },
  builder: {
    quit: "Are you sure you want to quit? Your changes will not be saved!",
    total: "Total",
    totalPriceLabel: "Price before discount: ",
    discountedPriceLabel: "Discounted price: ",
    selectImage: "Select image",
    customSizeButton: "Custom Size",
    customSizeTriptychSublabel: '3 x {width}" x {height}"',
    panelsLabel: "Three {size} Panels",
    finishedSize: "Finished Size:",
    apply: "Apply",
    cancel: "Cancel",
    dialogLabel: {
      quit: {
        cancelLabel: "Stay",
        confirmLabel: "Quit"
      },
      confirmLabel: "Okay"
    },
    header: {
      chat: "chat",
      closeAccessibility: "Close button"
    },
    notifications: {
      selectIn2D: "Select your images in 2D mode",
      provideImageLater: "You have chosen to provide your image later"
    },
    preview: {
      label: "View in",
      "2D": "2D",
      "3D": "3D",
      AR: "View in AR"
    },
    iconButtons: {
      layouts: "Layouts",
      image: "Image",
      sizes: "Sizes",
      borders: "Borders",
      edges: "Edges",
      frames: "Frames",
      filters: "Filters",
      services: "Services",
      styles: "Styles",
      notes: "Notes",
      name: "Name",
      personalize: "Personalize"
    },
    petPortraits: {
      notes: {
        heading: "Designer Notes",
        inputLabel: "Designer Notes (Optional)",
        inputPrompt: "Not {inputPromptEmphasis} what you were picturing?",
        inputPromptEmphasis: "exactly",
        inputPlaceholder: "Your message",
        inputInstructionsDesktop: "Our automated portrait process is usually pretty good, but sometimes produces results that aren't ideal. Just leave any desired edits in the comment box below and a human designer will retouch your pet into a beautiful masterpiece and send you a digital proof.",
        inputInstructionsMobile: "Leave us a note and one of our designers will create your masterpiece for you.",
        inputPromptOffline: "We can't wait to create your custom portrait.",
        inputInstructionsOffline: "Just leave any questions or desired edits in the comment box below and one of our designers will turn your pet's photo into a beautiful masterpiece and send you a digital proof to approve."
      },
      offlineNotification: "We’ll send you a free digital proof of your pet portrait within 24 hours of ordering.",
      name: {
        heading: "Name",
        inputLabel: "Add Your Pet's Name",
        optional: "(optional)",
        placeholder: "Enter Pet Name (Optional)"
      },
      colorPicker: {
        cancel: "Cancel",
        pickColor: "Pick color"
      },
      styles: {
        heading: "Styles"
      },
      colors: {
        heading: "Colors"
      }
    },
    flyout: {
      layouts: "Layouts",
      sizes: {
        heading: "Sizes",
        additionalLengthHeadingSuffix: "including frame",
        customSizes: {
          widthAndHeight: "Custom Size",
          width: "Width",
          height: "Height"
        }
      },
      borders: "Borders",
      edgesFrames: "Edges & Frames",
      edges: "Edges",
      frames: "Frames",
      framesAvailability: '(available with 0.75" deep canvas)',
      canvasDepth: "Canvas Depth",
      stylesAndColors: "Styles & Colors",
      styles: "Styles",
      colors: "Colors",
      filters: {
        heading: "Filters",
        blankOption: "None",
        previewsAvailable: "Previews available",
        noPreviewsAvailable: "No previews available"
      },
      services: {
        heading: "Services",
        inputLabel: "Instructions",
        adjustmentNotes: "Adjustment Notes",
        inputPlaceholder: "If you have any additional comments or instructions, just let us know!",
        describeChanges: "Describe the changes you'd like made to your image",
        noneOption: "None",
        noneOptionSubHeading: "Let us know if you have any requests outside of the services listed below. If your request requires additional charges, our design team will reach out.'"
      },
      name: "Name"
    },
    addToCartLabel: {
      new: "Add to cart",
      existing: "Save"
    },
    onboarding: {
      didYouKnow: "Did you know?",
      next: "Next",
      gotIt: "Got it",
      slide1: {
        header: "Zoom your image",
        body: "Use two fingers and pinch to zoom in or out to adjust the crop of your image.",
        bodyDesktop: "Scroll your mouse on top of the image to zoom in or out of your image to adjust the crop."
      },
      slide2: {
        header: "Position your image",
        body: "Once zoomed in, drag your image with your finger to position it.",
        bodyDesktop: "Once zoomed in, click and drag to move your image around to adjust your crop."
      }
    },
    standaloneImageEditor: {
      buttons: {
        editReplaceImage: "Edit or Replace image",
        viewInYourRoom: "View In Your Room",
        flip: "Flip Orientation",
        rotate: "Rotate Image",
        replace: "Replace Image",
        cancel: "Cancel",
        apply: "Apply"
      },
      instructions: {
        desktop: {
          editor: "Scroll to zoom; Drag to position",
          collage: "Click on image to edit or replace"
        },
        mobile: {
          editor: "Pinch to zoom; Swipe to position",
          collage: "Tap on image to edit or replace"
        }
      }
    },
    imageEditor: {
      reset: "Reset",
      apply: "Apply",
      cancel: "Cancel",
      tools: {
        crop: "Crop",
        zoom: "Zoom"
      },
      instructions: {
        cropZoom: {
          desktop: "Scroll to zoom and drag to pan",
          mobile: "Pinch to zoom and swipe to pan"
        }
      }
    }
  },
  tileBuilder: {
    backToBundle: "Back to bundle"
  },
  imageSelector: {
    selectAnImage: "Select an image",
    noUploadedImages: "You don't have any uploaded images yet.",
    uploadPhotosDirectly: "Upload photos directly from your device and use them in all of our builders.",
    loadMoreImages: "Load more images",
    provideImageLater: "I'll provide my image later",
    uploadLabel: "Upload",
    uploadFirstImage: "Upload your first images",
    facebook: {
      title: "You haven't connected your Facebook account yet.",
      description: "By logging in to Facebook, you can use any of your photos that have been uploaded to your account.",
      login: "Log in to Facebook"
    },
    instagram: {
      title: "You haven't connected your Instagram account yet.",
      description: "By logging in to Instagram, you can use any of your photos that have been uploaded to your account.",
      login: "Log in to Instagram"
    },
    nft: {
      title: "You haven't connected your wallet yet.",
      description: "By logging in to Metamask, you can use any of your assets that are in your wallet. If you were provided with hi-res versions not stored on chain you will need to upload those manually.",
      loading: {
        title: "Fetching NFTs",
        description: "Hang tight, this might take a few seconds."
      },
      installMetamask: "Please install Metamask or use a browser with it installed.",
      login: "Connect your wallet"
    },
    tabs: {
      upload: "Uploads",
      facebook: "Facebook",
      instagram: "Instagram",
      nft: "NFT"
    },
    removeUpload: {
      cancelLabel: "Cancel",
      confirmLabel: "Remove",
      heading: "Are you sure?",
      warning: "This image will be removed from your uploaded library."
    },
    supportedFormats: {
      label: "Supported image formats:",
      formats: "JPG, PNG, WEBP, TIFF, HEIC or HEIF",
      formatUnavailable: "Have a different format?",
      provideLater: "Provide image later"
    }
  },
  typesense: {
    sortBy: {
      label: "Sort:",
      popularity: "Popularity",
      priceAsc: "Price: Low to High",
      priceDesc: "Price: High to Low",
      bestMatch: "Best Match"
    },
    panel: {
      showMore: "show {quantity} more",
      showLess: "show less"
    },
    searchResults: "Search results for",
    searchSuggestions: "Search Suggestions",
    recommendedContent: "Recommended Content",
    categories: "Categories",
    products: "Products",
    recentSearches: "Recent Searches",
    viewMatchingProducts: "View {quantity} Matching Products",
    seeResults: "See {quantity} results",
    resultsQuantity: "{quantity} Results",
    loadMore: "Load More Results",
    buttons: {
      filters: "Filters",
      clearAllLower: "clear all",
      clearAllCamel: "Clear All",
      cancel: "Cancel"
    },
    noResults: {
      dropdownMessage: 'No results for "{query}"',
      sorryWeCouldntFind: 'Sorry, we couldn’t find any results for "{query}"',
      didYouMean: "Did you mean {suggestion1}, {suggestion2}, or {suggestion3}?",
      suggestionsBelow: "Try refining your search or browse suggestions below."
    }
  },
  constants: {
    messages: {
      loading: "Loading...",
      loadingProduct: "Loading your product... | Loading your products...",
      loadingInspiration: "Loading product inspiration...",
      loadingSizes: "Loading sizes...",
      loadingSuggestedSizes: "Loading suggested sizes...",
      loadingSize: "Loading selected size...",
      loadingProcessingImage: "Processing your image...",
      loadingARPreview: "Loading your AR preview...",
      loadingLogin: "Logging you in...",
      loadingCartAdd: "Adding your product to your cart... | Adding your products to your cart...",
      loadingCartUpdate: "Updating your product... | Updating your products...",
      loadingSavingRegion: "Saving your region settings...",
      loadingPetPortraitCartAdd: "Preparing your pet portrait..."
    },
    errors: {
      errorAPI: "Something went wrong",
      errorSaveRegion: "We couldn't save your region settings. Please try again!",
      errorGiftCart: "We could not add this giftcard to your cart.",
      errorLogin: "Please enter a valid e-mail address and password.",
      errorWrongProductCode: "We couldn't find the product you were looking for. We've loaded the default product instead.",
      errorArtCannotLoad: "Sorry, this art could not be loaded at this time.",
      errorCannotUpload: "Try saving in a different format (JPG, PNG, WEBP or TIFF) and try again.",
      errorPetNotDetected: "We couldn't detect any pets in your photo. Please try a different one.",
      errorPetSystemError: "Something went wrong. Please contact Customer Support if the issue persists."
    },
    warnings: {
      warningImageTooSmall: "This image is too small for us to print. You can still choose to continue and have our designers help you get the best result.",
      warningDeclinedFileNames: "Sorry, we could not upload: {declinedFileNames}"
    }
  },
  reviews: {
    verifiedPurchase: "Verified Purchase",
    reviewDate: "Review left on {date}",
    pagingLabel: "Page {currentPage} of {totalPageCount}",
    previousPageButton: "Previous",
    nextPageButton: "Next"
  },
  characterCount: {
    characterLimitReached: "Character limit reached",
    charactersRemaining: "{count} character | {count} characters",
    linesRemaining: "{count} line | {count} lines",
    lineLimitExceeded: "{count} line over | {count} lines over"
  },
  jsModules: {
    constants: {
      errors: {
        fieldHasErrors: "This field has errors",
        fieldIsRequired: "This field is required",
        fieldMustMatchAnotherField: "This field doesn't match another field",
        countryNotFound: "Country not found"
      }
    },
    applePay: {
      errorWithOrderId: "We're sorry, there was a problem with your payment. Please call customer service at {phoneNumber} and reference order #{orderId}.",
      errorGeneric: "There was an error processing your payment, but your payment may have gone through. Please contact customer service.",
      labels: {
        cartSubtotal: "Cart Subtotal",
        tax: "Tax",
        shipping: "Shipping"
      }
    },
    googlePay: {
      selectShippingOption: "Please select a shipping option to continue.",
      errorWithOrderId: "We're sorry, there was a problem with your payment. Please call customer service at {phoneNumber} and reference order #{orderId}.",
      errorGeneric: "Sorry, something went wrong on our end. Please contact customer service or try different payment method.",
      addressUnserviceable: "Sorry, we do not ship to that address.",
      addressInvalid: "Sorry, the shipping address entered is invalid.",
      addressError: "Sorry, something went wrong on our end. Please contact customer service or try different payment method.",
      labels: {
        subtotal: "Subtotal",
        tax: "Tax",
        total: "Total",
        shippingCost: "Shipping Cost"
      }
    },
    wxCheckout: {
      paypalUnauthorized: "Your Paypal authorization is no longer valid. Please re-authorize by returning to your cart.",
      error: "An error has occurred. Please try again.",
      selectValue: "Select a value",
      valueInvalid: "Enter a valid value.",
      noAMEX: "Sorry, AMEX is not available to Canadian billing addresses"
    }
  },
  dateFormat: "{month} {day}, {year}",
  debouncedInput: {
    errorMessage: "Enter {minLength} characters or more"
  },
  wordArt: {
    cta: "Add to cart",
    save: "Save Changes",
    error: {
      confirmLabel: "Okay",
      message: "Sorry, something went wrong on our end. Please try again later."
    }
  },
  progressLoader: {
    finishedLabel: "Done!",
    uploadingLabel: "Uploading"
  },
  unavailableParts: {
    outOfStock: "Out of Stock",
    notSizeCompatible: "Unavailable at Selected Size"
  },
  customizer: {
    buttons: {
      cancel: "Cancel",
      apply: "Apply",
      back: "Back",
      addToCart: "Add to Cart",
      save: "Save",
      outOfStock: "Out of Stock"
    },
    footer: {
      finishedSize: "Finished Size:",
      unassembled: "This frame arrives unassembled.",
      why: "Why?",
      approx: "(approx.)"
    },
    tooltip: "Make the changes above to proceed.",
    carousel: {
      image: {
        replace: "Replace Image",
        remove: "Remove Image",
        edit: "Edit",
        confirmRemove: "Are you sure you want to remove your image? Your image edits will not be saved.",
        confirmLabel: "Remove Image"
      },
      preview: "PREVIEW",
      only: "ONLY"
    },
    configurator: {
      uploadButton: {
        preview: "Upload a preview image",
        print: "Upload an Image"
      },
      attribute: {
        outOfStock: "Out of stock",
        unavailableAtSelectedSize: "Unavailable at selected size"
      },
      categories: {
        services: {
          label: "Choose Your Service",
          options: {
            printFrame: {
              label: "Print + Frame",
              description: "Printed, framed and ready to hang on your wall"
            },
            frameOnly: {
              label: "Frame Only",
              description: "Everything you need for do-it-yourself framing at home"
            }
          }
        },
        printOptions: {
          label: {
            printAndFrame: "Print Options",
            frameOnly: "Tell Us About Your Art"
          },
          paper: "Paper",
          canvas: "Canvas",
          wantToFrameYourPrint: "Want to frame your print?",
          startWithAFrame: "Start with a frame >"
        },
        imageSize: {
          label: "Image Size",
          popularSizes: "Popular Sizes",
          recommendedSizes: "Recommended Sizes",
          outOfStock: "Out of Stock",
          width: "Width",
          height: "Height",
          errorMessage: "Your image size is too large for Print + Frame. {chooseSmallerSize}",
          smallErrorMessage: "Your image is too small for the selected size. {chooseSmallerSize} {uploadNewImage}",
          chooseSmallerSize: "Choose a smaller image size",
          or: "or",
          uploadNewImage: "upload a new image"
        },
        frameSize: {
          label: "Frame Size",
          outOfStock: "Size out of stock; Select different size"
        },
        canvasMaterial: {
          label: "Canvas Material"
        },
        canvasEdge: {
          label: "Canvas Edge"
        },
        liner: {
          label: "Liner"
        },
        paperOptions: {
          label: "Paper Options"
        },
        finishingKit: {
          label: "Finishing Kit",
          acrylicFinishKit: "Acrylic Finish Kit",
          acrylicBacking: "Acrylic & Backing",
          mountingHardware: "Mounting Hardware"
        },
        additionalWhiteBorders: {
          label: "Additional White Borders"
        },
        canvasStyle: {
          label: "Canvas Style"
        },
        matOptions: {
          label: "Mat Options",
          mat: "Mat",
          outerMat: "Outer Mat",
          innerMat: "Inner Mat",
          matWidth: "Mat Width",
          outerWidth: "Outer Mat Width",
          innerWidth: "Inner Mat Width",
          errorMessage: 'Your image size is too large for mats. {textLink}, or change your mat option to "None".',
          errorMessageTextLink: "Select a smaller image size",
          warningMessage: "Your image size is too large for mats. Select a smaller image size if you'd like to add mat options.",
          warningMessageMatsUnavailable: "Mat options are currently unavailable."
        },
        errorMessages: {
          outOfStock: {
            substratePaper: "Paper type out of stock; Select different paper type",
            substrateCanvas: "Canvas type out of stock; Select different canvas type",
            finishKit: "Finish kit out of stock; Select different finish kit"
          }
        }
      }
    }
  }
}, j3 = {
  message: Bg
}, o8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: j3,
  message: Bg
}, Symbol.toStringTag, { value: "Module" })), Fg = {
  dialog: {
    heading: "Achtung!",
    cancelLabel: "Abbrechen",
    confirmLabel: "Bestätigen"
  },
  artDetail: {
    seeSimilar: "Ähnliche anzeigen",
    share: "Teilen",
    linkCopied: "Link kopiert",
    description: "Beschreibung",
    loadingContributor: "Mitwirkender wird geladen",
    customize: "Anpassen",
    creditWithContributor: "Bild von {contributorName}/Shutterstock",
    creditNoContributor: "Bild von Shutterstock",
    productLabels: {
      canvasPrint: "Leinwanddruck",
      framedPrint: "Gerahmter Druck"
    }
  },
  login: {
    defaultValidation: "Dieses Feld enthält Fehler",
    existingCustomer: "Schon Kunde? Anmelden.",
    heading: "Anmelden",
    instructions: "Melden Sie sich bei Ihrem Konto an.",
    emailLabel: "E-Mail-Adresse",
    passwordLabel: "Passwort",
    cta: "Anmelden"
  },
  giftCard: {
    imageAlt: "Eine Geschenkkarte",
    amountLabel: "Anzahl auswählen",
    customAmountLabel: "Benutzerdefinierte Anzahl",
    foreignPrefix: "Ungefähr:",
    addToOrderButton: "Zur Bestellung hinzufügen",
    orSeparator: "oder"
  },
  inspiration: {
    customSizeHeader: "Benutzerdefinierte Größe {productName}",
    customSizeDescription: "Wir bieten auch viele Sonder- und Großformate an.",
    cta: "Erstellen Sie Ihr/e/n {productName}",
    sizeTypes: {
      square: "Quadratisch",
      portrait: "Hochformat",
      landscape: "Querformat",
      modern: "Modern",
      oil: "Öl",
      charcoal: "Kohle"
    }
  },
  menu: {
    iconButtonLabel: "Optionen"
  },
  textField: {
    required: "Dieses Feld ist ein Pflichtfeld"
  },
  dropdown: {
    defaultOption: "Auswählen ..."
  },
  uploader: {
    mimeErrorMessage: "Beim Hochladen von {fileName} ist ein Fehler aufgetreten."
  },
  regionSwitcher: {
    heading: "Region ändern",
    selectedLabel: "Region: {countryCode} ({currencyCode})",
    instructions: "Wählen Sie Ihr bevorzugtes Land, Ihre Sprache und Ihre Währung.",
    countryLabel: "Land",
    currencyLabel: "Währung",
    languageLabel: "Sprache"
  },
  "3dProofReview": {
    title: "Sie müssen {titleProofCount} für die Bestellung mit der Nummer {orderId} überprüfen.",
    titleProofCount: "{count} Korrekturabzug | {count} Korrekturabzüge",
    errorConfirmButton: "Okay",
    reviewComplete: "Überprüfung abgeschlossen",
    remainingCount: "{remainingCount} verbleibend",
    finishedTitle: "Wir kümmern uns um den Rest!",
    finishedDescriptionApproved: "Alle Ihre Korrekturabzüge für diese Bestellung wurden genehmigt. Ihre Bestellung wird in Kürze gedruckt.",
    finishedDescriptionDeclined: "Sie haben Änderungen an einem oder mehreren Korrekturabzügen angefordert. Achten Sie auf eine E-Mail mit einem neuen Korrekturabzug zur Überprüfung.",
    desktopInstructions: "Klicken und ziehen zum Drehen, Scrollen zum Zoomen",
    mobileInstructions: "Wischen zum Drehen, Kneifen zum Zoomen",
    designerNoteLabel: "Designer-Anmerkungen:",
    requestChangesLabel: "Änderungen anfragen",
    requestChangesPlaceholder: "Wie können wir diesen Korrekturabzug verbessern?",
    approveInsteadLink: "Oder: Genehmigen Sie ihn!",
    requestChangesLink: "Änderungen anfragen",
    requestChangesButton: "Änderungen anfragen",
    approveButton: "Genehmigen",
    youApproved: "Sie haben diesen Korrekturabzug genehmigt",
    youRequestedChanges: "Sie haben Änderungen an diesem Korrekturabzug angefordert",
    orSeparator: "oder",
    errorMessage: "Es tut uns leid! Bei uns ist etwas schiefgelaufen. Bitte versuchen Sie es später noch einmal."
  },
  builder: {
    quit: "Möchten Sie diese Aktion wirklich abbrechen? Ihre Änderungen werden nicht gespeichert!",
    total: "Gesamt",
    selectImage: "Bild auswählen",
    customSizeButton: "Maßgeschneiderte Größe",
    customSizeTriptychSublabel: '3 x {Breite}" x {Höhe}"',
    dialogLabel: {
      quit: {
        cancelLabel: "Bleiben",
        confirmLabel: "Beenden"
      },
      confirmLabel: "Okay"
    },
    header: {
      chat: "Chat",
      closeAccessibility: "Schaltfläche „Schließen“"
    },
    notifications: {
      selectIn2D: "Wählen Sie Ihre Bilder im 2D-Modus aus",
      provideImageLater: "Sie haben sich entschieden, Ihr Bild später bereitzustellen"
    },
    preview: {
      "2D": "2D",
      "3D": "3D",
      AR: "In AR anzeigen"
    },
    iconButtons: {
      layouts: "Layouts",
      image: "Bild",
      sizes: "Größen",
      borders: "Umrandung",
      edges: "Ränder",
      filters: "Filter",
      services: "Services",
      styles: "Stile",
      notes: "Anmerkungen",
      name: "Name",
      personalize: "Personalisieren"
    },
    petPortraits: {
      notes: {
        heading: "Designer-Anmerkungen",
        inputLabel: "Designer-Anmerkungen (optional)",
        inputPrompt: "Nicht {inputPromptEmphasis}, was Sie sich vorgestellt haben?",
        inputPromptEmphasis: "genau",
        inputPlaceholder: "Ihre Nachricht",
        inputInstructionsDesktop: "Unser automatisiertes Porträtverfahren ist in der Regel recht gut, führt aber manchmal zu Ergebnissen, die nicht ganz ideal sind. Hinterlassen Sie einfach Ihre Änderungswünsche im Kommentarfeld unten, und ein menschlicher Designer wird Ihr Haustier in ein wunderschönes Meisterwerk retuschieren und Ihnen einen digitalen Korrekturabzug schicken.",
        inputInstructionsMobile: "Hinterlassen Sie uns eine Nachricht, und einer unserer Designer wird Ihr Meisterwerk für Sie entwerfen."
      },
      name: {
        heading: "Name",
        inputLabel: "Fügen Sie den Namen Ihres Haustieres hinzu",
        placeholder: "Name des Haustiers eingeben (optional)"
      },
      colorPicker: {
        cancel: "Abbrechen",
        pickColor: "Farbe auswählen"
      },
      styles: {
        heading: "Stile"
      },
      colors: {
        heading: "Farben"
      }
    },
    flyout: {
      layouts: "Layouts",
      sizes: {
        heading: "Größen",
        customSizes: {
          widthAndHeight: "Maßgeschneiderte Größe",
          width: "Breite",
          height: "Höhe"
        }
      },
      borders: "Umrandung",
      edgesFrames: "Ränder und Rahmen",
      stylesAndColors: "Stile und Farben",
      filters: {
        heading: "Filter",
        blankOption: "Keine"
      },
      services: {
        heading: "Services",
        inputLabel: "Anweisungen",
        inputPlaceholder: "Wenn Sie zusätzliche Kommentare oder Anweisungen haben, lassen Sie es uns einfach wissen!",
        noneOption: "Keine"
      },
      name: "Name"
    },
    addToCartLabel: {
      new: "In den Warenkorb",
      existing: "Speichern"
    },
    onboarding: {
      didYouKnow: "Schon gewusst?",
      next: "Weiter",
      gotIt: "Alles klar",
      slide1: {
        header: "Zoomen Sie Ihr Bild",
        body: "Vergrößern oder verkleinern Sie Ihr Bild mit zwei Fingern, um den Zuschnitt Ihres Bildes anzupassen.",
        bodyDesktop: "Scrollen Sie mit der Maus über das Bild, um das Bild zu vergrößern oder zu verkleinern und den Zuschnitt anzupassen."
      },
      slide2: {
        header: "Positionieren Sie Ihr Bild",
        body: "Ziehen Sie Ihr Bild nach dem Vergrößern mit dem Finger, um es zu positionieren.",
        bodyDesktop: "Klicken und ziehen Sie nach dem Vergrößern, um Ihr Bild zu verschieben und den Zuschnitt anzupassen."
      }
    }
  },
  imageSelector: {
    selectAnImage: "Wählen Sie ein Bild",
    noUploadedImages: "Sie haben noch keine hochgeladenen Bilder.",
    uploadPhotosDirectly: "Laden Sie Fotos direkt von Ihrem Gerät hoch und verwenden Sie sie in allen unseren Buildern.",
    loadMoreImages: "Mehr Bilder laden",
    provideImageLater: "Ich werde mein Bild später bereitstellen",
    uploadLabel: "Hochladen",
    uploadFirstImage: "Laden Sie Ihre ersten Bilder hoch",
    facebook: {
      title: "Sie haben Ihr Facebook-Konto noch nicht verknüpft.",
      description: "Wenn Sie sich bei Facebook anmelden, können Sie alle Ihre Fotos verwenden, die in Ihr Konto hochgeladen wurden.",
      login: "Melden Sie sich bei Facebook an"
    },
    instagram: {
      title: "Sie haben Ihr Instagram-Konto noch nicht verknüpft.",
      description: "Wenn Sie sich bei Instagram anmelden, können Sie alle Ihre Fotos verwenden, die in Ihr Konto hochgeladen wurden.",
      login: "Melden Sie sich bei Instagram an"
    },
    tabs: {
      upload: "Uploads",
      facebook: "Facebook",
      instagram: "Instagram"
    }
  },
  constants: {
    messages: {
      loading: "Wird geladen ...",
      loadingProduct: "Ihr Produkt wird geladen ...",
      loadingInspiration: "Produktinspiration wird geladen ...",
      loadingSizes: "Größen werden geladen ...",
      loadingSuggestedSizes: "Empfohlene Größen werden geladen ...",
      loadingSize: "Ausgewählte Größe wird geladen ...",
      loadingProcessingImage: "Ihr Bild wird bearbeitet ...",
      loadingARPreview: "Ihre AR-Vorschau wird geladen ...",
      loadingLogin: "Sie werden angemeldet ...",
      loadingCartAdd: "Ihr Produkt wird Ihrem Warenkorb hinzugefügt ...",
      loadingCartUpdate: "Ihr Produkt wird aktualisiert ...",
      loadingSavingRegion: "Ihre Regionseinstellungen werden gespeichert ...",
      loadingPetPortraitCartAdd: "Ihr Haustierporträt wird vorbereitet ..."
    },
    errors: {
      errorAPI: "Es ist etwas schiefgelaufen",
      errorSaveRegion: "Ihre Regionseinstellungen konnten nicht gespeichert werden. Bitte versuchen Sie es erneut!",
      errorGiftCart: "Wir konnten diese Geschenkkarte Ihrem Warenkorb nicht hinzufügen.",
      errorLogin: "Bitte geben Sie eine gültige E-Mail-Adresse und ein gültiges Passwort ein.",
      errorWrongProductCode: "Wir konnten das von Ihnen gesuchte Produkt nicht finden. Wir haben stattdessen das Standardprodukt geladen.",
      errorArtCannotLoad: "Dieses Kunstwerk konnte derzeit nicht geladen werden.",
      errorCannotUpload: "Versuchen Sie, es in einem anderen Format (JPG, PNG, WEBP oder TIFF) zu speichern, und versuchen Sie es dann erneut.",
      errorPetNotDetected: "Wir konnten keine Haustiere auf Ihrem Foto erkennen. Bitte versuchen Sie es mit einem anderen.",
      errorPetSystemError: "Es ist etwas schiefgelaufen. Bitte wenden Sie sich an den Kundensupport, wenn das Problem weiterhin besteht."
    },
    warnings: {
      warningImageTooSmall: "Dieses Bild ist zu klein, um es zu drucken. Sie können sich immer noch dafür entscheiden, fortzufahren. Unsere Designer helfen Ihnen gerne dabei, das beste Ergebnis zu erzielen.",
      warningDeclinedFileNames: "Leider konnten wir die folgenden Dateien nicht hochladen: {declinedFileNames}"
    }
  },
  reviews: {
    verifiedPurchase: "Verifizierter Kauf",
    reviewDate: "Bewertung am {date} abgegeben",
    pagingLabel: "Seite {currentPage} von {totalPageCount}",
    previousPageButton: "Zurück",
    nextPageButton: "Weiter"
  },
  characterCount: {
    characterLimitReached: "Zeichenlimit erreicht",
    charactersRemaining: "{count} Zeichen | {count} Zeichen",
    linesRemaining: "{count} Zeile | {count} Zeilen",
    lineLimitExceeded: "{count} Zeile zu viel | {count} Zeilen zu viel"
  },
  jsModules: {
    constants: {
      errors: {
        fieldHasErrors: "Dieses Feld enthält Fehler",
        fieldIsRequired: "Dieses Feld ist ein Pflichtfeld",
        fieldMustMatchAnotherField: "Dieses Feld stimmt mit keinem anderen Feld überein",
        countryNotFound: "Land nicht gefunden"
      }
    },
    applePay: {
      errorWithOrderId: "Es tut uns leid, bei Ihrer Zahlung ist ein Problem aufgetreten. Bitte rufen Sie den Kundenservice unter 1-866-619-9574 an und geben Sie die Bestellnummer {orderId} an.",
      errorGeneric: "Bei der Verarbeitung Ihrer Zahlung ist ein Fehler aufgetreten, aber Ihre Zahlung wurde möglicherweise trotzdem ausgeführt. Bitte wenden Sie sich an unseren Kundenservice.",
      labels: {
        cartSubtotal: "Warenkorb-Zwischensumme",
        tax: "Steuer",
        shipping: "Versand"
      }
    },
    googlePay: {
      selectShippingOption: "Bitte wählen Sie eine Versandoption aus, um fortzufahren.",
      errorWithOrderId: "Es tut uns leid, bei Ihrer Zahlung ist ein Problem aufgetreten. Bitte rufen Sie den Kundenservice unter 1-866-619-9574 an und geben Sie die Bestellnummer {orderId} an.",
      errorGeneric: "Bei uns ist etwas schiefgelaufen. Bitte kontaktieren Sie den Kundenservice oder versuchen Sie es mit einer anderen Zahlungsmethode.",
      addressUnserviceable: "Leider versenden wir nicht an diese Adresse.",
      addressInvalid: "Die eingegebene Versandadresse ist leider ungültig.",
      addressError: "Bei uns ist etwas schiefgelaufen. Bitte kontaktieren Sie den Kundenservice oder versuchen Sie es mit einer anderen Zahlungsmethode.",
      labels: {
        subtotal: "Zwischensumme",
        tax: "Steuer",
        total: "Gesamt",
        shippingCost: "Versandkosten"
      }
    },
    wxCheckout: {
      paypalUnauthorized: "Ihre PayPal-Autorisierung ist nicht mehr gültig. Bitte autorisieren Sie sich erneut, indem Sie zu Ihrem Warenkorb zurückkehren.",
      error: "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      selectValue: "Wählen Sie einen Wert aus",
      valueInvalid: "Bitte geben Sie einen gültigen Wert ein.",
      noAMEX: "AMEX ist für kanadische Rechnungsadressen leider nicht verfügbar"
    }
  },
  dateFormat: "{day} {month} {year}"
}, k3 = {
  message: Fg
}, l8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: k3,
  message: Fg
}, Symbol.toStringTag, { value: "Module" })), $g = {
  dialog: {
    heading: "Attention !",
    cancelLabel: "Annuler",
    confirmLabel: "Confirmer"
  },
  artDetail: {
    seeSimilar: "Voir similaire",
    share: "Partager",
    linkCopied: "Lien copié",
    description: "Description",
    loadingContributor: "Chargement du contributeur",
    customize: "Personnaliser",
    creditWithContributor: "Image de {contributorName} / Shutterstock",
    creditNoContributor: "Image de Shutterstock",
    productLabels: {
      canvasPrint: "Tirage sur toile",
      framedPrint: "Tirage encadré"
    }
  },
  login: {
    defaultValidation: "Ce champ contient des erreurs",
    existingCustomer: "Déjà client ? Se connecter.",
    heading: "Se connecter",
    instructions: "Connectez-vous à votre compte.",
    emailLabel: "Adresse e-mail",
    passwordLabel: "Mot de passe",
    cta: "Se connecter"
  },
  giftCard: {
    imageAlt: "Une carte-cadeau",
    amountLabel: "Sélectionnez le montant",
    customAmountLabel: "Montant personnalisé",
    foreignPrefix: "Environ :",
    addToOrderButton: "Ajouter à la commande",
    orSeparator: "ou"
  },
  inspiration: {
    customSizeHeader: "Format personnalisé {productName}",
    customSizeDescription: "Nous proposons également de nombreux formats personnalisés et grands formats.",
    cta: "Créez votre {productName}",
    sizeTypes: {
      square: "Carré",
      portrait: "Portrait",
      landscape: "Paysage",
      modern: "Moderne",
      oil: "Huile",
      charcoal: "Fusain"
    }
  },
  menu: {
    iconButtonLabel: "options"
  },
  textField: {
    required: "Ce champ est obligatoire"
  },
  dropdown: {
    defaultOption: "Sélectionner…"
  },
  uploader: {
    mimeErrorMessage: "Désolé, une erreur s’est produite lors du chargement de {fileName}"
  },
  regionSwitcher: {
    heading: "Changer de région",
    selectedLabel: "Région : {countryCode} ({currencyCode})",
    instructions: "Sélectionnez votre pays, langue et devise préférés.",
    countryLabel: "Pays",
    currencyLabel: "Devise",
    languageLabel: "Langue"
  },
  "3dProofReview": {
    title: "Vous avez {titleProofCount} à examiner pour la commande n° {orderId}",
    titleProofCount: "{count} épreuve | {count} épreuves",
    errorConfirmButton: "Ok",
    reviewComplete: "Examen terminé",
    remainingCount: "{remainingCount} restant",
    finishedTitle: "C’est à nous de jouer !",
    finishedDescriptionApproved: "Toutes vos épreuves pour cette commande ont été approuvées. Votre commande sera bientôt mise à l’impression.",
    finishedDescriptionDeclined: "Vous avez demandé des modifications sur un ou plusieurs bons à tirer. Vous recevrez un e-mail contenant un nouveau bon à tirer que vous pourrez vérifier.",
    desktopInstructions: "Cliquez et faites glisser pour faire pivoter, faites défiler pour zoomer",
    mobileInstructions: "Balayez pour faire pivoter, pincez pour zoomer",
    designerNoteLabel: "Notes du concepteur :",
    requestChangesLabel: "Demander des modifications",
    requestChangesPlaceholder: "Comment améliorer cette épreuve ?",
    approveInsteadLink: "Approuvez plutôt !",
    requestChangesLink: "Demander des modifications",
    requestChangesButton: "Demander des modifications",
    approveButton: "Approuver",
    youApproved: "Vous avez approuvé ce bon à tirer",
    youRequestedChanges: "Vous avez demandé des modifications sur ce bon à tirer",
    orSeparator: "ou",
    errorMessage: "Désolé ! Un problème est survenu de notre côté. Veuillez réessayer plus tard."
  },
  builder: {
    quit: "Êtes-vous sûr(e) de vouloir quitter ? Vos modifications ne seront pas enregistrées !",
    total: "Total",
    selectImage: "Sélectionner l’image",
    customSizeButton: "Format personnalisé",
    customSizeTriptychSublabel: '3 x {largeur}" x {hauteur}"',
    dialogLabel: {
      quit: {
        cancelLabel: "Rester",
        confirmLabel: "Quitter"
      },
      confirmLabel: "Ok"
    },
    header: {
      chat: "discussion",
      closeAccessibility: "Fermer le bouton"
    },
    notifications: {
      selectIn2D: "Sélectionnez vos images en mode 2D",
      provideImageLater: "Vous avez choisi de fournir votre image plus tard"
    },
    preview: {
      "2D": "2D",
      "3D": "3D",
      AR: "Affichage en réalité augmentée"
    },
    iconButtons: {
      layouts: "Mises en forme",
      image: "Image",
      sizes: "Formats",
      borders: "Bordures",
      edges: "Bords",
      filters: "Filtres",
      services: "Services",
      styles: "Styles",
      notes: "Notes",
      name: "Nom",
      personalize: "Personnaliser"
    },
    petPortraits: {
      notes: {
        heading: "Notes du concepteur",
        inputLabel: "Notes du concepteur (facultatif)",
        inputPrompt: "Ce n’est pas {inputPromptEmphasis} ce que vous imaginiez ?",
        inputPromptEmphasis: "exactement",
        inputPlaceholder: "Votre message",
        inputInstructionsDesktop: "Notre processus de portrait automatisé est généralement assez bon, mais produit parfois des résultats qui ne sont pas idéaux. Il suffit de laisser les modifications souhaitées dans le champ de commentaires ci-dessous et un concepteur humain retouchera votre animal de compagnie pour en faire un magnifique chef-d’œuvre, puis vous enverra un bon à tirer numérique.",
        inputInstructionsMobile: "Envoyez-nous un message et l’un de nos concepteurs se chargera de créer ce chef-d’œuvre pour vous."
      },
      name: {
        heading: "Nom",
        inputLabel: "Ajoutez le nom de votre animal de compagnie",
        placeholder: "Saisissez le nom de l’animal de compagnie (facultatif)"
      },
      colorPicker: {
        cancel: "Annuler",
        pickColor: "Choisir une couleur"
      },
      styles: {
        heading: "Styles"
      },
      colors: {
        heading: "Couleurs"
      }
    },
    flyout: {
      layouts: "Mises en forme",
      sizes: {
        heading: "Formats",
        customSizes: {
          widthAndHeight: "Format personnalisé",
          width: "Largeur",
          height: "Hauteur"
        }
      },
      borders: "Bordures",
      edgesFrames: "Bords et cadres",
      stylesAndColors: "Styles et couleurs",
      filters: {
        heading: "Filtres",
        blankOption: "Aucun"
      },
      services: {
        heading: "Services",
        inputLabel: "Instructions",
        inputPlaceholder: "Si vous avez des commentaires ou des instructions supplémentaires, faites-le nous savoir !",
        noneOption: "Aucun"
      },
      name: "Nom"
    },
    addToCartLabel: {
      new: "Ajouter au panier",
      existing: "Enregistrer"
    },
    onboarding: {
      didYouKnow: "Le saviez-vous ?",
      next: "Suivant",
      gotIt: "J’ai compris",
      slide1: {
        header: "Zoomez votre image",
        body: "Utilisez deux doigts et pincez pour effectuer un zoom avant ou arrière afin d’ajuster le recadrage de votre image.",
        bodyDesktop: "Faites défiler votre souris au-dessus de l’image pour faire un zoom avant ou arrière et ajuster le recadrage."
      },
      slide2: {
        header: "Positionnez votre image",
        body: "Une fois le zoom avant effectué, faites glisser votre image avec votre doigt pour la positionner.",
        bodyDesktop: "Une fois le zoom avant effectué, cliquez et faites glisser votre image pour la déplacer et ajuster le cadrage."
      }
    }
  },
  imageSelector: {
    selectAnImage: "Sélectionner une image",
    noUploadedImages: "Vous n’avez pas encore chargé d’images.",
    uploadPhotosDirectly: "Chargez des photos directement depuis votre appareil et utilisez-les dans tous nos constructeurs.",
    loadMoreImages: "Télécharger plus d’images",
    provideImageLater: "Je fournirai mon image plus tard",
    uploadLabel: "télécharger",
    uploadFirstImage: "Téléchargez vos premières images",
    facebook: {
      title: "Vous ne vous êtes pas encore connecté à votre compte Facebook.",
      description: "En vous connectant à Facebook, vous pouvez utiliser toutes vos photos qui ont été chargées sur votre compte.",
      login: "Se connecter à Facebook"
    },
    instagram: {
      title: "Vous ne vous êtes pas encore connecté à votre compte Instagram.",
      description: "En vous connectant à Instagram, vous pouvez utiliser toutes vos photos qui ont été chargées sur votre compte.",
      login: "Se connecter à Instagram"
    },
    tabs: {
      upload: "Chargements",
      facebook: "Facebook",
      instagram: "Instagram"
    }
  },
  constants: {
    messages: {
      loading: "Chargement en cours…",
      loadingProduct: "Chargement de votre produit en cours...",
      loadingInspiration: "Chargement de l’inspiration du produit en cours...",
      loadingSizes: "Chargement des formats en cours...",
      loadingSuggestedSizes: "Chargement des formats suggérés en cours...",
      loadingSize: "Chargement du format sélectionné en cours...",
      loadingProcessingImage: "Traitement de votre image en cours...",
      loadingARPreview: "Chargement de votre aperçu de réalité augmentée en cours...",
      loadingLogin: "Votre connexion est en cours...",
      loadingCartAdd: "Ajout de votre produit au panier en cours...",
      loadingCartUpdate: "Mise à jour de votre produit en cours...",
      loadingSavingRegion: "Enregistrement de vos paramètres de région en cours...",
      loadingPetPortraitCartAdd: "Préparation du portrait de votre animal de compagnie en cours..."
    },
    errors: {
      errorAPI: "Une erreur s’est produite",
      errorSaveRegion: "Nous n’avons pas pu enregistrer vos paramètres de région. Veuillez réessayer !",
      errorGiftCart: "Nous n’avons pas pu ajouter cette carte-cadeau à votre panier.",
      errorLogin: "Veuillez saisir une adresse e-mail et un mot de passe valides.",
      errorWrongProductCode: "Nous n’avons pas pu trouver le produit que vous recherchez. Nous avons téléchargé le produit par défaut à la place.",
      errorArtCannotLoad: "Désolé, cet art n’a pas pu être téléchargé pour le moment.",
      errorCannotUpload: "Essayez d’enregistrer dans un autre format (JPG, PNG, WEBP ou TIFF), puis réessayez.",
      errorPetNotDetected: "Nous n’avons détecté aucun animal de compagnie sur votre photo. Veuillez en essayer un(e) autre !",
      errorPetSystemError: "Un problème est survenu. Veuillez contacter le service clients si le problème persiste."
    },
    warnings: {
      warningImageTooSmall: "Cette image est trop petite pour que nous puissions l’imprimer. Vous pouvez toujours choisir de continuer et demander à nos concepteurs de vous aider à obtenir le meilleur résultat.",
      warningDeclinedFileNames: "Désolé, nous n’avons pas pu télécharger : {declinedFileNames}"
    }
  },
  reviews: {
    verifiedPurchase: "Achat vérifié",
    reviewDate: "Avis laissé le {date}",
    pagingLabel: "Page {currentPage} sur {totalPageCount}",
    previousPageButton: "Précédent",
    nextPageButton: "Suivant"
  },
  characterCount: {
    characterLimitReached: "Limite de caractères atteinte",
    charactersRemaining: "{count} caractère | {count} caractères",
    linesRemaining: "{count} ligne | {count} lignes",
    lineLimitExceeded: "{count} ligne de plus | {count} lignes de plus"
  },
  jsModules: {
    constants: {
      errors: {
        fieldHasErrors: "Ce champ contient des erreurs",
        fieldIsRequired: "Ce champ est obligatoire",
        fieldMustMatchAnotherField: "Ce champ ne correspond à aucun autre champ",
        countryNotFound: "Pays introuvable"
      }
    },
    applePay: {
      errorWithOrderId: "Nous sommes désolés, il y a eu un problème avec votre paiement. Veuillez appeler le service à la clientèle au 1-866-619-9574 et indiquer la commande de référence n° {orderId}.",
      errorGeneric: "Une erreur s’est produite lors du traitement de votre paiement, mais celui-ci a peut-être été effectué. Veuillez contacter le service à la clientèle.",
      labels: {
        cartSubtotal: "Sous-total du panier",
        tax: "Taxe",
        shipping: "Expédition"
      }
    },
    googlePay: {
      selectShippingOption: "Veuillez sélectionner une option d’expédition pour continuer.",
      errorWithOrderId: "Nous sommes désolés, il y a eu un problème avec votre paiement. Veuillez appeler le service à la clientèle au 1-866-619-9574 et indiquer la commande de référence n° {orderId}.",
      errorGeneric: "Désolé, un problème est survenu de notre côté. Veuillez contacter le service à la clientèle ou essayer un autre mode de paiement.",
      addressUnserviceable: "Désolé, nous ne livrons pas à cette adresse.",
      addressInvalid: "Désolé, l’adresse de livraison saisie n’est pas valide.",
      addressError: "Désolé, un problème est survenu de notre côté. Veuillez contacter le service à la clientèle ou essayer un autre mode de paiement.",
      labels: {
        subtotal: "Sous-total",
        tax: "Taxe",
        total: "Total",
        shippingCost: "Frais d’expédition"
      }
    },
    wxCheckout: {
      paypalUnauthorized: "Votre autorisation Paypal n’est plus valide. Veuillez réautoriser en retournant à votre panier.",
      error: "Une erreur s’est produite. Veuillez réessayer.",
      selectValue: "Sélectionnez une valeur",
      valueInvalid: "Saisissez une valeur valide.",
      noAMEX: "Désolé, AMEX n’est pas disponible pour les adresses de facturation canadiennes"
    }
  },
  dateFormat: "{mois} {jour}, {année}"
}, z3 = {
  message: $g
}, c8 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: z3,
  message: $g
}, Symbol.toStringTag, { value: "Module" }));
var In = function(t) {
  return t && t.Math == Math && t;
}, F = (
  // eslint-disable-next-line es/no-global-this -- safe
  In(typeof globalThis == "object" && globalThis) || In(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  In(typeof self == "object" && self) || In(typeof xt == "object" && xt) || // eslint-disable-next-line no-new-func -- fallback
  function() {
    return this;
  }() || Function("return this")()
), xi = {}, Ie = function(t) {
  try {
    return !!t();
  } catch {
    return !0;
  }
}, B3 = Ie, Ar = !B3(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] != 7;
}), ji = Function.prototype.call, Ze = ji.bind ? ji.bind(ji) : function() {
  return ji.apply(ji, arguments);
}, Ug = {}, Vg = {}.propertyIsEnumerable, Hg = Object.getOwnPropertyDescriptor, F3 = Hg && !Vg.call({ 1: 2 }, 1);
Ug.f = F3 ? function(e) {
  var r = Hg(this, e);
  return !!r && r.enumerable;
} : Vg;
var Ma = function(t, e) {
  return {
    enumerable: !(t & 1),
    configurable: !(t & 2),
    writable: !(t & 4),
    value: e
  };
}, Wg = Function.prototype, No = Wg.bind, jo = Wg.call, $3 = No && No.bind(jo), se = No ? function(t) {
  return t && $3(jo, t);
} : function(t) {
  return t && function() {
    return jo.apply(t, arguments);
  };
}, Gg = se, U3 = Gg({}.toString), V3 = Gg("".slice), Si = function(t) {
  return V3(U3(t), 8, -1);
}, H3 = F, W3 = se, G3 = Ie, Y3 = Si, Ts = H3.Object, X3 = W3("".split), Yg = G3(function() {
  return !Ts("z").propertyIsEnumerable(0);
}) ? function(t) {
  return Y3(t) == "String" ? X3(t, "") : Ts(t);
} : Ts, q3 = F, K3 = q3.TypeError, wt = function(t) {
  if (t == null)
    throw K3("Can't call method on " + t);
  return t;
}, Z3 = Yg, Q3 = wt, dn = function(t) {
  return Z3(Q3(t));
}, we = function(t) {
  return typeof t == "function";
}, J3 = we, er = function(t) {
  return typeof t == "object" ? t !== null : J3(t);
}, Ps = F, ew = we, tw = function(t) {
  return ew(t) ? t : void 0;
}, Rr = function(t, e) {
  return arguments.length < 2 ? tw(Ps[t]) : Ps[t] && Ps[t][e];
}, rw = se, La = rw({}.isPrototypeOf), iw = Rr, Da = iw("navigator", "userAgent") || "", Xg = F, Os = Da, Du = Xg.process, Nu = Xg.Deno, ju = Du && Du.versions || Nu && Nu.version, ku = ju && ju.v8, ut, ya;
ku && (ut = ku.split("."), ya = ut[0] > 0 && ut[0] < 4 ? 1 : +(ut[0] + ut[1]));
!ya && Os && (ut = Os.match(/Edge\/(\d+)/), (!ut || ut[1] >= 74) && (ut = Os.match(/Chrome\/(\d+)/), ut && (ya = +ut[1])));
var Gl = ya, zu = Gl, nw = Ie, qg = !!Object.getOwnPropertySymbols && !nw(function() {
  var t = Symbol();
  return !String(t) || !(Object(t) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && zu && zu < 41;
}), aw = qg, Kg = aw && !Symbol.sham && typeof Symbol.iterator == "symbol", sw = F, ow = Rr, lw = we, cw = La, uw = Kg, dw = sw.Object, Zg = uw ? function(t) {
  return typeof t == "symbol";
} : function(t) {
  var e = ow("Symbol");
  return lw(e) && cw(e.prototype, dw(t));
}, hw = F, fw = hw.String, Na = function(t) {
  try {
    return fw(t);
  } catch {
    return "Object";
  }
}, gw = F, pw = we, mw = Na, vw = gw.TypeError, wi = function(t) {
  if (pw(t))
    return t;
  throw vw(mw(t) + " is not a function");
}, yw = wi, Ei = function(t, e) {
  var r = t[e];
  return r == null ? void 0 : yw(r);
}, bw = F, Cs = Ze, Is = we, _s = er, xw = bw.TypeError, Sw = function(t, e) {
  var r, i;
  if (e === "string" && Is(r = t.toString) && !_s(i = Cs(r, t)) || Is(r = t.valueOf) && !_s(i = Cs(r, t)) || e !== "string" && Is(r = t.toString) && !_s(i = Cs(r, t)))
    return i;
  throw xw("Can't convert object to primitive value");
}, Qg = { exports: {} }, Bu = F, ww = Object.defineProperty, Yl = function(t, e) {
  try {
    ww(Bu, t, { value: e, configurable: !0, writable: !0 });
  } catch {
    Bu[t] = e;
  }
  return e;
}, Ew = F, Tw = Yl, Fu = "__core-js_shared__", Pw = Ew[Fu] || Tw(Fu, {}), Xl = Pw, $u = Xl;
(Qg.exports = function(t, e) {
  return $u[t] || ($u[t] = e !== void 0 ? e : {});
})("versions", []).push({
  version: "3.19.3",
  mode: "global",
  copyright: "© 2021 Denis Pushkarev (zloirock.ru)"
});
var ql = Qg.exports, Ow = F, Cw = wt, Iw = Ow.Object, ja = function(t) {
  return Iw(Cw(t));
}, _w = se, Aw = ja, Rw = _w({}.hasOwnProperty), Et = Object.hasOwn || function(e, r) {
  return Rw(Aw(e), r);
}, Mw = se, Lw = 0, Dw = Math.random(), Nw = Mw(1 .toString), Jg = function(t) {
  return "Symbol(" + (t === void 0 ? "" : t) + ")_" + Nw(++Lw + Dw, 36);
}, jw = F, kw = ql, Uu = Et, zw = Jg, Vu = qg, e1 = Kg, Hr = kw("wks"), br = jw.Symbol, Hu = br && br.for, Bw = e1 ? br : br && br.withoutSetter || zw, _e = function(t) {
  if (!Uu(Hr, t) || !(Vu || typeof Hr[t] == "string")) {
    var e = "Symbol." + t;
    Vu && Uu(br, t) ? Hr[t] = br[t] : e1 && Hu ? Hr[t] = Hu(e) : Hr[t] = Bw(e);
  }
  return Hr[t];
}, Fw = F, $w = Ze, Wu = er, Gu = Zg, Uw = Ei, Vw = Sw, Hw = _e, Ww = Fw.TypeError, Gw = Hw("toPrimitive"), Yw = function(t, e) {
  if (!Wu(t) || Gu(t))
    return t;
  var r = Uw(t, Gw), i;
  if (r) {
    if (e === void 0 && (e = "default"), i = $w(r, t, e), !Wu(i) || Gu(i))
      return i;
    throw Ww("Can't convert object to primitive value");
  }
  return e === void 0 && (e = "number"), Vw(t, e);
}, Xw = Yw, qw = Zg, Kl = function(t) {
  var e = Xw(t, "string");
  return qw(e) ? e : e + "";
}, Kw = F, Yu = er, ko = Kw.document, Zw = Yu(ko) && Yu(ko.createElement), ka = function(t) {
  return Zw ? ko.createElement(t) : {};
}, Qw = Ar, Jw = Ie, eE = ka, t1 = !Qw && !Jw(function() {
  return Object.defineProperty(eE("div"), "a", {
    get: function() {
      return 7;
    }
  }).a != 7;
}), tE = Ar, rE = Ze, iE = Ug, nE = Ma, aE = dn, sE = Kl, oE = Et, lE = t1, Xu = Object.getOwnPropertyDescriptor;
xi.f = tE ? Xu : function(e, r) {
  if (e = aE(e), r = sE(r), lE)
    try {
      return Xu(e, r);
    } catch {
    }
  if (oE(e, r))
    return nE(!rE(iE.f, e, r), e[r]);
};
var tr = {}, r1 = F, cE = er, uE = r1.String, dE = r1.TypeError, ze = function(t) {
  if (cE(t))
    return t;
  throw dE(uE(t) + " is not an object");
}, hE = F, fE = Ar, gE = t1, qu = ze, pE = Kl, mE = hE.TypeError, Ku = Object.defineProperty;
tr.f = fE ? Ku : function(e, r, i) {
  if (qu(e), r = pE(r), qu(i), gE)
    try {
      return Ku(e, r, i);
    } catch {
    }
  if ("get" in i || "set" in i)
    throw mE("Accessors not supported");
  return "value" in i && (e[r] = i.value), e;
};
var vE = Ar, yE = tr, bE = Ma, Ti = vE ? function(t, e, r) {
  return yE.f(t, e, bE(1, r));
} : function(t, e, r) {
  return t[e] = r, t;
}, i1 = { exports: {} }, xE = se, SE = we, zo = Xl, wE = xE(Function.toString);
SE(zo.inspectSource) || (zo.inspectSource = function(t) {
  return wE(t);
});
var za = zo.inspectSource, EE = F, TE = we, PE = za, Zu = EE.WeakMap, OE = TE(Zu) && /native code/.test(PE(Zu)), CE = ql, IE = Jg, Qu = CE("keys"), Zl = function(t) {
  return Qu[t] || (Qu[t] = IE(t));
}, Ql = {}, _E = OE, n1 = F, As = se, AE = er, RE = Ti, Rs = Et, Ms = Xl, ME = Zl, LE = Ql, Ju = "Object already initialized", Bo = n1.TypeError, DE = n1.WeakMap, ba, en, xa, NE = function(t) {
  return xa(t) ? en(t) : ba(t, {});
}, jE = function(t) {
  return function(e) {
    var r;
    if (!AE(e) || (r = en(e)).type !== t)
      throw Bo("Incompatible receiver, " + t + " required");
    return r;
  };
};
if (_E || Ms.state) {
  var or = Ms.state || (Ms.state = new DE()), kE = As(or.get), ed = As(or.has), zE = As(or.set);
  ba = function(t, e) {
    if (ed(or, t))
      throw new Bo(Ju);
    return e.facade = t, zE(or, t, e), e;
  }, en = function(t) {
    return kE(or, t) || {};
  }, xa = function(t) {
    return ed(or, t);
  };
} else {
  var Wr = ME("state");
  LE[Wr] = !0, ba = function(t, e) {
    if (Rs(t, Wr))
      throw new Bo(Ju);
    return e.facade = t, RE(t, Wr, e), e;
  }, en = function(t) {
    return Rs(t, Wr) ? t[Wr] : {};
  }, xa = function(t) {
    return Rs(t, Wr);
  };
}
var Ba = {
  set: ba,
  get: en,
  has: xa,
  enforce: NE,
  getterFor: jE
}, Fo = Ar, BE = Et, a1 = Function.prototype, FE = Fo && Object.getOwnPropertyDescriptor, Jl = BE(a1, "name"), $E = Jl && (function() {
}).name === "something", UE = Jl && (!Fo || Fo && FE(a1, "name").configurable), Fa = {
  EXISTS: Jl,
  PROPER: $E,
  CONFIGURABLE: UE
}, VE = F, td = we, HE = Et, rd = Ti, WE = Yl, GE = za, s1 = Ba, YE = Fa.CONFIGURABLE, XE = s1.get, qE = s1.enforce, KE = String(String).split("String");
(i1.exports = function(t, e, r, i) {
  var n = i ? !!i.unsafe : !1, a = i ? !!i.enumerable : !1, s = i ? !!i.noTargetGet : !1, o = i && i.name !== void 0 ? i.name : e, l;
  if (td(r) && (String(o).slice(0, 7) === "Symbol(" && (o = "[" + String(o).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), (!HE(r, "name") || YE && r.name !== o) && rd(r, "name", o), l = qE(r), l.source || (l.source = KE.join(typeof o == "string" ? o : ""))), t === VE) {
    a ? t[e] = r : WE(e, r);
    return;
  } else
    n ? !s && t[e] && (a = !0) : delete t[e];
  a ? t[e] = r : rd(t, e, r);
})(Function.prototype, "toString", function() {
  return td(this) && XE(this).source || GE(this);
});
var Mr = i1.exports, o1 = {}, ZE = Math.ceil, QE = Math.floor, $a = function(t) {
  var e = +t;
  return e !== e || e === 0 ? 0 : (e > 0 ? QE : ZE)(e);
}, JE = $a, eT = Math.max, tT = Math.min, l1 = function(t, e) {
  var r = JE(t);
  return r < 0 ? eT(r + e, 0) : tT(r, e);
}, rT = $a, iT = Math.min, Pi = function(t) {
  return t > 0 ? iT(rT(t), 9007199254740991) : 0;
}, nT = Pi, Ua = function(t) {
  return nT(t.length);
}, aT = dn, sT = l1, oT = Ua, id = function(t) {
  return function(e, r, i) {
    var n = aT(e), a = oT(n), s = sT(i, a), o;
    if (t && r != r) {
      for (; a > s; )
        if (o = n[s++], o != o)
          return !0;
    } else
      for (; a > s; s++)
        if ((t || s in n) && n[s] === r)
          return t || s || 0;
    return !t && -1;
  };
}, c1 = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: id(!0),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: id(!1)
}, lT = se, Ls = Et, cT = dn, uT = c1.indexOf, dT = Ql, nd = lT([].push), u1 = function(t, e) {
  var r = cT(t), i = 0, n = [], a;
  for (a in r)
    !Ls(dT, a) && Ls(r, a) && nd(n, a);
  for (; e.length > i; )
    Ls(r, a = e[i++]) && (~uT(n, a) || nd(n, a));
  return n;
}, ec = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], hT = u1, fT = ec, gT = fT.concat("length", "prototype");
o1.f = Object.getOwnPropertyNames || function(e) {
  return hT(e, gT);
};
var d1 = {};
d1.f = Object.getOwnPropertySymbols;
var pT = Rr, mT = se, vT = o1, yT = d1, bT = ze, xT = mT([].concat), ST = pT("Reflect", "ownKeys") || function(e) {
  var r = vT.f(bT(e)), i = yT.f;
  return i ? xT(r, i(e)) : r;
}, wT = Et, ET = ST, TT = xi, PT = tr, OT = function(t, e) {
  for (var r = ET(e), i = PT.f, n = TT.f, a = 0; a < r.length; a++) {
    var s = r[a];
    wT(t, s) || i(t, s, n(e, s));
  }
}, CT = Ie, IT = we, _T = /#|\.prototype\./, hn = function(t, e) {
  var r = RT[AT(t)];
  return r == LT ? !0 : r == MT ? !1 : IT(e) ? CT(e) : !!e;
}, AT = hn.normalize = function(t) {
  return String(t).replace(_T, ".").toLowerCase();
}, RT = hn.data = {}, MT = hn.NATIVE = "N", LT = hn.POLYFILL = "P", h1 = hn, Ds = F, DT = xi.f, NT = Ti, jT = Mr, kT = Yl, zT = OT, BT = h1, Tt = function(t, e) {
  var r = t.target, i = t.global, n = t.stat, a, s, o, l, c, u;
  if (i ? s = Ds : n ? s = Ds[r] || kT(r, {}) : s = (Ds[r] || {}).prototype, s)
    for (o in e) {
      if (c = e[o], t.noTargetGet ? (u = DT(s, o), l = u && u.value) : l = s[o], a = BT(i ? o : r + (n ? "." : "#") + o, t.forced), !a && l !== void 0) {
        if (typeof c == typeof l)
          continue;
        zT(c, l);
      }
      (t.sham || l && l.sham) && NT(c, "sham", !0), jT(s, o, c, t);
    }
}, FT = F, $T = FT.Promise, UT = Mr, VT = function(t, e, r) {
  for (var i in e)
    UT(t, i, e[i], r);
  return t;
}, f1 = F, HT = we, WT = f1.String, GT = f1.TypeError, YT = function(t) {
  if (typeof t == "object" || HT(t))
    return t;
  throw GT("Can't set " + WT(t) + " as a prototype");
}, XT = se, qT = ze, KT = YT, g1 = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var t = !1, e = {}, r;
  try {
    r = XT(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set), r(e, []), t = e instanceof Array;
  } catch {
  }
  return function(n, a) {
    return qT(n), KT(a), t ? r(n, a) : n.__proto__ = a, n;
  };
}() : void 0), ZT = tr.f, QT = Et, JT = _e, ad = JT("toStringTag"), tc = function(t, e, r) {
  t && !QT(t = r ? t : t.prototype, ad) && ZT(t, ad, { configurable: !0, value: e });
}, e5 = Rr, t5 = tr, r5 = _e, i5 = Ar, sd = r5("species"), n5 = function(t) {
  var e = e5(t), r = t5.f;
  i5 && e && !e[sd] && r(e, sd, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
}, a5 = F, s5 = La, o5 = a5.TypeError, l5 = function(t, e) {
  if (s5(e, t))
    return t;
  throw o5("Incorrect invocation");
}, od = se, c5 = wi, ld = od(od.bind), rc = function(t, e) {
  return c5(t), e === void 0 ? t : ld ? ld(t, e) : function() {
    return t.apply(e, arguments);
  };
}, fn = {}, u5 = _e, d5 = fn, h5 = u5("iterator"), f5 = Array.prototype, g5 = function(t) {
  return t !== void 0 && (d5.Array === t || f5[h5] === t);
}, p5 = _e, m5 = p5("toStringTag"), p1 = {};
p1[m5] = "z";
var v5 = String(p1) === "[object z]", y5 = F, b5 = v5, x5 = we, Jn = Si, S5 = _e, w5 = S5("toStringTag"), E5 = y5.Object, T5 = Jn(function() {
  return arguments;
}()) == "Arguments", P5 = function(t, e) {
  try {
    return t[e];
  } catch {
  }
}, ic = b5 ? Jn : function(t) {
  var e, r, i;
  return t === void 0 ? "Undefined" : t === null ? "Null" : typeof (r = P5(e = E5(t), w5)) == "string" ? r : T5 ? Jn(e) : (i = Jn(e)) == "Object" && x5(e.callee) ? "Arguments" : i;
}, O5 = ic, cd = Ei, C5 = fn, I5 = _e, _5 = I5("iterator"), m1 = function(t) {
  if (t != null)
    return cd(t, _5) || cd(t, "@@iterator") || C5[O5(t)];
}, A5 = F, R5 = Ze, M5 = wi, L5 = ze, D5 = Na, N5 = m1, j5 = A5.TypeError, k5 = function(t, e) {
  var r = arguments.length < 2 ? N5(t) : e;
  if (M5(r))
    return L5(R5(r, t));
  throw j5(D5(t) + " is not iterable");
}, z5 = Ze, ud = ze, B5 = Ei, F5 = function(t, e, r) {
  var i, n;
  ud(t);
  try {
    if (i = B5(t, "return"), !i) {
      if (e === "throw")
        throw r;
      return r;
    }
    i = z5(i, t);
  } catch (a) {
    n = !0, i = a;
  }
  if (e === "throw")
    throw r;
  if (n)
    throw i;
  return ud(i), r;
}, $5 = F, U5 = rc, V5 = Ze, H5 = ze, W5 = Na, G5 = g5, Y5 = Ua, dd = La, X5 = k5, q5 = m1, hd = F5, K5 = $5.TypeError, ea = function(t, e) {
  this.stopped = t, this.result = e;
}, fd = ea.prototype, Z5 = function(t, e, r) {
  var i = r && r.that, n = !!(r && r.AS_ENTRIES), a = !!(r && r.IS_ITERATOR), s = !!(r && r.INTERRUPTED), o = U5(e, i), l, c, u, d, h, f, v, p = function(y) {
    return l && hd(l, "normal", y), new ea(!0, y);
  }, b = function(y) {
    return n ? (H5(y), s ? o(y[0], y[1], p) : o(y[0], y[1])) : s ? o(y, p) : o(y);
  };
  if (a)
    l = t;
  else {
    if (c = q5(t), !c)
      throw K5(W5(t) + " is not iterable");
    if (G5(c)) {
      for (u = 0, d = Y5(t); d > u; u++)
        if (h = b(t[u]), h && dd(fd, h))
          return h;
      return new ea(!1);
    }
    l = X5(t, c);
  }
  for (f = l.next; !(v = V5(f, l)).done; ) {
    try {
      h = b(v.value);
    } catch (y) {
      hd(l, "throw", y);
    }
    if (typeof h == "object" && h && dd(fd, h))
      return h;
  }
  return new ea(!1);
}, Q5 = _e, v1 = Q5("iterator"), y1 = !1;
try {
  var J5 = 0, gd = {
    next: function() {
      return { done: !!J5++ };
    },
    return: function() {
      y1 = !0;
    }
  };
  gd[v1] = function() {
    return this;
  }, Array.from(gd, function() {
    throw 2;
  });
} catch {
}
var eP = function(t, e) {
  if (!e && !y1)
    return !1;
  var r = !1;
  try {
    var i = {};
    i[v1] = function() {
      return {
        next: function() {
          return { done: r = !0 };
        }
      };
    }, t(i);
  } catch {
  }
  return r;
}, tP = se, rP = Ie, b1 = we, iP = ic, nP = Rr, aP = za, x1 = function() {
}, sP = [], S1 = nP("Reflect", "construct"), nc = /^\s*(?:class|function)\b/, oP = tP(nc.exec), lP = !nc.exec(x1), ki = function(t) {
  if (!b1(t))
    return !1;
  try {
    return S1(x1, sP, t), !0;
  } catch {
    return !1;
  }
}, cP = function(t) {
  if (!b1(t))
    return !1;
  switch (iP(t)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  return lP || !!oP(nc, aP(t));
}, uP = !S1 || rP(function() {
  var t;
  return ki(ki.call) || !ki(Object) || !ki(function() {
    t = !0;
  }) || t;
}) ? cP : ki, dP = F, hP = uP, fP = Na, gP = dP.TypeError, pP = function(t) {
  if (hP(t))
    return t;
  throw gP(fP(t) + " is not a constructor");
}, pd = ze, mP = pP, vP = _e, yP = vP("species"), w1 = function(t, e) {
  var r = pd(t).constructor, i;
  return r === void 0 || (i = pd(r)[yP]) == null ? e : mP(i);
}, ac = Function.prototype, md = ac.apply, bP = ac.bind, vd = ac.call, sc = typeof Reflect == "object" && Reflect.apply || (bP ? vd.bind(md) : function() {
  return vd.apply(md, arguments);
}), xP = Rr, E1 = xP("document", "documentElement"), SP = se, wP = SP([].slice), EP = Da, T1 = /(?:ipad|iphone|ipod).*applewebkit/i.test(EP), TP = Si, PP = F, Va = TP(PP.process) == "process", qe = F, OP = sc, CP = rc, yd = we, IP = Et, _P = Ie, bd = E1, AP = wP, xd = ka, RP = T1, MP = Va, $o = qe.setImmediate, Uo = qe.clearImmediate, LP = qe.process, Ns = qe.Dispatch, DP = qe.Function, Sd = qe.MessageChannel, NP = qe.String, js = 0, Zi = {}, wd = "onreadystatechange", tn, lr, ks, zs;
try {
  tn = qe.location;
} catch {
}
var oc = function(t) {
  if (IP(Zi, t)) {
    var e = Zi[t];
    delete Zi[t], e();
  }
}, Bs = function(t) {
  return function() {
    oc(t);
  };
}, Ed = function(t) {
  oc(t.data);
}, Td = function(t) {
  qe.postMessage(NP(t), tn.protocol + "//" + tn.host);
};
(!$o || !Uo) && ($o = function(e) {
  var r = AP(arguments, 1);
  return Zi[++js] = function() {
    OP(yd(e) ? e : DP(e), void 0, r);
  }, lr(js), js;
}, Uo = function(e) {
  delete Zi[e];
}, MP ? lr = function(t) {
  LP.nextTick(Bs(t));
} : Ns && Ns.now ? lr = function(t) {
  Ns.now(Bs(t));
} : Sd && !RP ? (ks = new Sd(), zs = ks.port2, ks.port1.onmessage = Ed, lr = CP(zs.postMessage, zs)) : qe.addEventListener && yd(qe.postMessage) && !qe.importScripts && tn && tn.protocol !== "file:" && !_P(Td) ? (lr = Td, qe.addEventListener("message", Ed, !1)) : wd in xd("script") ? lr = function(t) {
  bd.appendChild(xd("script"))[wd] = function() {
    bd.removeChild(this), oc(t);
  };
} : lr = function(t) {
  setTimeout(Bs(t), 0);
});
var P1 = {
  set: $o,
  clear: Uo
}, jP = Da, kP = F, zP = /ipad|iphone|ipod/i.test(jP) && kP.Pebble !== void 0, BP = Da, FP = /web0s(?!.*chrome)/i.test(BP), wr = F, Pd = rc, $P = xi.f, Fs = P1.set, UP = T1, VP = zP, HP = FP, $s = Va, Od = wr.MutationObserver || wr.WebKitMutationObserver, Cd = wr.document, Id = wr.process, _n = wr.Promise, _d = $P(wr, "queueMicrotask"), O1 = _d && _d.value, zi, pr, Qi, Zr, Us, Vs, An, Ad;
O1 || (zi = function() {
  var t, e;
  for ($s && (t = Id.domain) && t.exit(); pr; ) {
    e = pr.fn, pr = pr.next;
    try {
      e();
    } catch (r) {
      throw pr ? Zr() : Qi = void 0, r;
    }
  }
  Qi = void 0, t && t.enter();
}, !UP && !$s && !HP && Od && Cd ? (Us = !0, Vs = Cd.createTextNode(""), new Od(zi).observe(Vs, { characterData: !0 }), Zr = function() {
  Vs.data = Us = !Us;
}) : !VP && _n && _n.resolve ? (An = _n.resolve(void 0), An.constructor = _n, Ad = Pd(An.then, An), Zr = function() {
  Ad(zi);
}) : $s ? Zr = function() {
  Id.nextTick(zi);
} : (Fs = Pd(Fs, wr), Zr = function() {
  Fs(zi);
}));
var WP = O1 || function(t) {
  var e = { fn: t, next: void 0 };
  Qi && (Qi.next = e), pr || (pr = e, Zr()), Qi = e;
}, lc = {}, Rd = wi, GP = function(t) {
  var e, r;
  this.promise = new t(function(i, n) {
    if (e !== void 0 || r !== void 0)
      throw TypeError("Bad Promise constructor");
    e = i, r = n;
  }), this.resolve = Rd(e), this.reject = Rd(r);
};
lc.f = function(t) {
  return new GP(t);
};
var YP = ze, XP = er, qP = lc, KP = function(t, e) {
  if (YP(t), XP(e) && e.constructor === t)
    return e;
  var r = qP.f(t), i = r.resolve;
  return i(e), r.promise;
}, ZP = F, QP = function(t, e) {
  var r = ZP.console;
  r && r.error && (arguments.length == 1 ? r.error(t) : r.error(t, e));
}, JP = function(t) {
  try {
    return { error: !1, value: t() };
  } catch (e) {
    return { error: !0, value: e };
  }
}, e4 = typeof window == "object", Ha = Tt, zt = F, t4 = Rr, Bt = Ze, Sa = $T, Md = Mr, r4 = VT, Ld = g1, i4 = tc, n4 = n5, Vo = wi, Ji = we, a4 = er, s4 = l5, o4 = za, Dd = Z5, l4 = eP, c4 = w1, C1 = P1.set, I1 = WP, u4 = KP, d4 = QP, _1 = lc, Ho = JP, cc = Ba, h4 = h1, f4 = _e, g4 = e4, wa = Va, Nd = Gl, p4 = f4("species"), Pt = "Promise", jd = cc.getterFor(Pt), m4 = cc.set, v4 = cc.getterFor(Pt), gr = Sa && Sa.prototype, dt = Sa, Bi = gr, A1 = zt.TypeError, Wo = zt.document, uc = zt.process, oi = _1.f, y4 = oi, b4 = !!(Wo && Wo.createEvent && zt.dispatchEvent), R1 = Ji(zt.PromiseRejectionEvent), M1 = "unhandledrejection", x4 = "rejectionhandled", kd = 0, L1 = 1, S4 = 2, dc = 1, D1 = 2, Go = !1, Rn, zd, N1, Bd, gn = h4(Pt, function() {
  var t = o4(dt), e = t !== String(dt);
  if (!e && Nd === 66)
    return !0;
  if (Nd >= 51 && /native code/.test(t))
    return !1;
  var r = new dt(function(a) {
    a(1);
  }), i = function(a) {
    a(function() {
    }, function() {
    });
  }, n = r.constructor = {};
  return n[p4] = i, Go = r.then(function() {
  }) instanceof i, Go ? !e && g4 && !R1 : !0;
}), w4 = gn || !l4(function(t) {
  dt.all(t).catch(function() {
  });
}), j1 = function(t) {
  var e;
  return a4(t) && Ji(e = t.then) ? e : !1;
}, hc = function(t, e) {
  if (!t.notified) {
    t.notified = !0;
    var r = t.reactions;
    I1(function() {
      for (var i = t.value, n = t.state == L1, a = 0; r.length > a; ) {
        var s = r[a++], o = n ? s.ok : s.fail, l = s.resolve, c = s.reject, u = s.domain, d, h, f;
        try {
          o ? (n || (t.rejection === D1 && T4(t), t.rejection = dc), o === !0 ? d = i : (u && u.enter(), d = o(i), u && (u.exit(), f = !0)), d === s.promise ? c(A1("Promise-chain cycle")) : (h = j1(d)) ? Bt(h, d, l, c) : l(d)) : c(i);
        } catch (v) {
          u && !f && u.exit(), c(v);
        }
      }
      t.reactions = [], t.notified = !1, e && !t.rejection && E4(t);
    });
  }
}, k1 = function(t, e, r) {
  var i, n;
  b4 ? (i = Wo.createEvent("Event"), i.promise = e, i.reason = r, i.initEvent(t, !1, !0), zt.dispatchEvent(i)) : i = { promise: e, reason: r }, !R1 && (n = zt["on" + t]) ? n(i) : t === M1 && d4("Unhandled promise rejection", r);
}, E4 = function(t) {
  Bt(C1, zt, function() {
    var e = t.facade, r = t.value, i = Fd(t), n;
    if (i && (n = Ho(function() {
      wa ? uc.emit("unhandledRejection", r, e) : k1(M1, e, r);
    }), t.rejection = wa || Fd(t) ? D1 : dc, n.error))
      throw n.value;
  });
}, Fd = function(t) {
  return t.rejection !== dc && !t.parent;
}, T4 = function(t) {
  Bt(C1, zt, function() {
    var e = t.facade;
    wa ? uc.emit("rejectionHandled", e) : k1(x4, e, t.value);
  });
}, Qr = function(t, e, r) {
  return function(i) {
    t(e, i, r);
  };
}, ri = function(t, e, r) {
  t.done || (t.done = !0, r && (t = r), t.value = e, t.state = S4, hc(t, !0));
}, Yo = function(t, e, r) {
  if (!t.done) {
    t.done = !0, r && (t = r);
    try {
      if (t.facade === e)
        throw A1("Promise can't be resolved itself");
      var i = j1(e);
      i ? I1(function() {
        var n = { done: !1 };
        try {
          Bt(
            i,
            e,
            Qr(Yo, n, t),
            Qr(ri, n, t)
          );
        } catch (a) {
          ri(n, a, t);
        }
      }) : (t.value = e, t.state = L1, hc(t, !1));
    } catch (n) {
      ri({ done: !1 }, n, t);
    }
  }
};
if (gn && (dt = function(e) {
  s4(this, Bi), Vo(e), Bt(Rn, this);
  var r = jd(this);
  try {
    e(Qr(Yo, r), Qr(ri, r));
  } catch (i) {
    ri(r, i);
  }
}, Bi = dt.prototype, Rn = function(e) {
  m4(this, {
    type: Pt,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: [],
    rejection: !1,
    state: kd,
    value: void 0
  });
}, Rn.prototype = r4(Bi, {
  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  then: function(e, r) {
    var i = v4(this), n = i.reactions, a = oi(c4(this, dt));
    return a.ok = Ji(e) ? e : !0, a.fail = Ji(r) && r, a.domain = wa ? uc.domain : void 0, i.parent = !0, n[n.length] = a, i.state != kd && hc(i, !1), a.promise;
  },
  // `Promise.prototype.catch` method
  // https://tc39.es/ecma262/#sec-promise.prototype.catch
  catch: function(t) {
    return this.then(void 0, t);
  }
}), zd = function() {
  var t = new Rn(), e = jd(t);
  this.promise = t, this.resolve = Qr(Yo, e), this.reject = Qr(ri, e);
}, _1.f = oi = function(t) {
  return t === dt || t === N1 ? new zd(t) : y4(t);
}, Ji(Sa) && gr !== Object.prototype)) {
  Bd = gr.then, Go || (Md(gr, "then", function(e, r) {
    var i = this;
    return new dt(function(n, a) {
      Bt(Bd, i, n, a);
    }).then(e, r);
  }, { unsafe: !0 }), Md(gr, "catch", Bi.catch, { unsafe: !0 }));
  try {
    delete gr.constructor;
  } catch {
  }
  Ld && Ld(gr, Bi);
}
Ha({ global: !0, wrap: !0, forced: gn }, {
  Promise: dt
});
i4(dt, Pt, !1);
n4(Pt);
N1 = t4(Pt);
Ha({ target: Pt, stat: !0, forced: gn }, {
  // `Promise.reject` method
  // https://tc39.es/ecma262/#sec-promise.reject
  reject: function(e) {
    var r = oi(this);
    return Bt(r.reject, void 0, e), r.promise;
  }
});
Ha({ target: Pt, stat: !0, forced: gn }, {
  // `Promise.resolve` method
  // https://tc39.es/ecma262/#sec-promise.resolve
  resolve: function(e) {
    return u4(this, e);
  }
});
Ha({ target: Pt, stat: !0, forced: w4 }, {
  // `Promise.all` method
  // https://tc39.es/ecma262/#sec-promise.all
  all: function(e) {
    var r = this, i = oi(r), n = i.resolve, a = i.reject, s = Ho(function() {
      var o = Vo(r.resolve), l = [], c = 0, u = 1;
      Dd(e, function(d) {
        var h = c++, f = !1;
        u++, Bt(o, r, d).then(function(v) {
          f || (f = !0, l[h] = v, --u || n(l));
        }, a);
      }), --u || n(l);
    });
    return s.error && a(s.value), i.promise;
  },
  // `Promise.race` method
  // https://tc39.es/ecma262/#sec-promise.race
  race: function(e) {
    var r = this, i = oi(r), n = i.reject, a = Ho(function() {
      var s = Vo(r.resolve);
      Dd(e, function(o) {
        Bt(s, r, o).then(i.resolve, n);
      });
    });
    return a.error && n(a.value), i.promise;
  }
});
function $d(t, e, r, i, n, a, s) {
  try {
    var o = t[a](s), l = o.value;
  } catch (c) {
    r(c);
    return;
  }
  o.done ? e(l) : Promise.resolve(l).then(i, n);
}
function Ft(t) {
  return function() {
    var e = this, r = arguments;
    return new Promise(function(i, n) {
      var a = t.apply(e, r);
      function s(l) {
        $d(a, i, n, s, o, "next", l);
      }
      function o(l) {
        $d(a, i, n, s, o, "throw", l);
      }
      s(void 0);
    });
  };
}
var P4 = F, O4 = ic, C4 = P4.String, Ot = function(t) {
  if (O4(t) === "Symbol")
    throw TypeError("Cannot convert a Symbol value to a string");
  return C4(t);
}, I4 = ze, z1 = function() {
  var t = I4(this), e = "";
  return t.global && (e += "g"), t.ignoreCase && (e += "i"), t.multiline && (e += "m"), t.dotAll && (e += "s"), t.unicode && (e += "u"), t.sticky && (e += "y"), e;
}, fc = Ie, _4 = F, gc = _4.RegExp, pc = fc(function() {
  var t = gc("a", "y");
  return t.lastIndex = 2, t.exec("abcd") != null;
}), A4 = pc || fc(function() {
  return !gc("a", "y").sticky;
}), R4 = pc || fc(function() {
  var t = gc("^r", "gy");
  return t.lastIndex = 2, t.exec("str") != null;
}), B1 = {
  BROKEN_CARET: R4,
  MISSED_STICKY: A4,
  UNSUPPORTED_Y: pc
}, M4 = u1, L4 = ec, D4 = Object.keys || function(e) {
  return M4(e, L4);
}, N4 = Ar, j4 = tr, k4 = ze, z4 = dn, B4 = D4, F4 = N4 ? Object.defineProperties : function(e, r) {
  k4(e);
  for (var i = z4(r), n = B4(r), a = n.length, s = 0, o; a > s; )
    j4.f(e, o = n[s++], i[o]);
  return e;
}, $4 = ze, U4 = F4, Ud = ec, V4 = Ql, H4 = E1, W4 = ka, G4 = Zl, Vd = ">", Hd = "<", Xo = "prototype", qo = "script", F1 = G4("IE_PROTO"), Hs = function() {
}, $1 = function(t) {
  return Hd + qo + Vd + t + Hd + "/" + qo + Vd;
}, Wd = function(t) {
  t.write($1("")), t.close();
  var e = t.parentWindow.Object;
  return t = null, e;
}, Y4 = function() {
  var t = W4("iframe"), e = "java" + qo + ":", r;
  return t.style.display = "none", H4.appendChild(t), t.src = String(e), r = t.contentWindow.document, r.open(), r.write($1("document.F=Object")), r.close(), r.F;
}, Mn, ta = function() {
  try {
    Mn = new ActiveXObject("htmlfile");
  } catch {
  }
  ta = typeof document < "u" ? document.domain && Mn ? Wd(Mn) : Y4() : Wd(Mn);
  for (var t = Ud.length; t--; )
    delete ta[Xo][Ud[t]];
  return ta();
};
V4[F1] = !0;
var mc = Object.create || function(e, r) {
  var i;
  return e !== null ? (Hs[Xo] = $4(e), i = new Hs(), Hs[Xo] = null, i[F1] = e) : i = ta(), r === void 0 ? i : U4(i, r);
}, X4 = Ie, q4 = F, K4 = q4.RegExp, Z4 = X4(function() {
  var t = K4(".", "s");
  return !(t.dotAll && t.exec(`
`) && t.flags === "s");
}), Q4 = Ie, J4 = F, eO = J4.RegExp, tO = Q4(function() {
  var t = eO("(?<a>b)", "g");
  return t.exec("b").groups.a !== "b" || "b".replace(t, "$<a>c") !== "bc";
}), Jr = Ze, Wa = se, rO = Ot, iO = z1, nO = B1, aO = ql, sO = mc, oO = Ba.get, lO = Z4, cO = tO, uO = aO("native-string-replace", String.prototype.replace), Ea = RegExp.prototype.exec, Ko = Ea, dO = Wa("".charAt), hO = Wa("".indexOf), fO = Wa("".replace), Ws = Wa("".slice), Zo = function() {
  var t = /a/, e = /b*/g;
  return Jr(Ea, t, "a"), Jr(Ea, e, "a"), t.lastIndex !== 0 || e.lastIndex !== 0;
}(), U1 = nO.BROKEN_CARET, Qo = /()??/.exec("")[1] !== void 0, gO = Zo || Qo || U1 || lO || cO;
gO && (Ko = function(e) {
  var r = this, i = oO(r), n = rO(e), a = i.raw, s, o, l, c, u, d, h;
  if (a)
    return a.lastIndex = r.lastIndex, s = Jr(Ko, a, n), r.lastIndex = a.lastIndex, s;
  var f = i.groups, v = U1 && r.sticky, p = Jr(iO, r), b = r.source, y = 0, x = n;
  if (v && (p = fO(p, "y", ""), hO(p, "g") === -1 && (p += "g"), x = Ws(n, r.lastIndex), r.lastIndex > 0 && (!r.multiline || r.multiline && dO(n, r.lastIndex - 1) !== `
`) && (b = "(?: " + b + ")", x = " " + x, y++), o = new RegExp("^(?:" + b + ")", p)), Qo && (o = new RegExp("^" + b + "$(?!\\s)", p)), Zo && (l = r.lastIndex), c = Jr(Ea, v ? o : r, x), v ? c ? (c.input = Ws(c.input, y), c[0] = Ws(c[0], y), c.index = r.lastIndex, r.lastIndex += c[0].length) : r.lastIndex = 0 : Zo && c && (r.lastIndex = r.global ? c.index + c[0].length : l), Qo && c && c.length > 1 && Jr(uO, c[0], o, function() {
    for (u = 1; u < arguments.length - 2; u++)
      arguments[u] === void 0 && (c[u] = void 0);
  }), c && f)
    for (c.groups = d = sO(null), u = 0; u < f.length; u++)
      h = f[u], d[h[0]] = c[h[1]];
  return c;
});
var Ga = Ko, pO = Tt, Gd = Ga;
pO({ target: "RegExp", proto: !0, forced: /./.exec !== Gd }, {
  exec: Gd
});
var Yd = se, Xd = Mr, mO = Ga, qd = Ie, V1 = _e, vO = Ti, yO = V1("species"), Gs = RegExp.prototype, vc = function(t, e, r, i) {
  var n = V1(t), a = !qd(function() {
    var c = {};
    return c[n] = function() {
      return 7;
    }, ""[t](c) != 7;
  }), s = a && !qd(function() {
    var c = !1, u = /a/;
    return t === "split" && (u = {}, u.constructor = {}, u.constructor[yO] = function() {
      return u;
    }, u.flags = "", u[n] = /./[n]), u.exec = function() {
      return c = !0, null;
    }, u[n](""), !c;
  });
  if (!a || !s || r) {
    var o = Yd(/./[n]), l = e(n, ""[t], function(c, u, d, h, f) {
      var v = Yd(c), p = u.exec;
      return p === mO || p === Gs.exec ? a && !f ? { done: !0, value: o(u, d, h) } : { done: !0, value: v(d, u, h) } : { done: !1 };
    });
    Xd(String.prototype, t, l[0]), Xd(Gs, n, l[1]);
  }
  i && vO(Gs[n], "sham", !0);
}, yc = se, bO = $a, xO = Ot, SO = wt, wO = yc("".charAt), Kd = yc("".charCodeAt), EO = yc("".slice), Zd = function(t) {
  return function(e, r) {
    var i = xO(SO(e)), n = bO(r), a = i.length, s, o;
    return n < 0 || n >= a ? t ? "" : void 0 : (s = Kd(i, n), s < 55296 || s > 56319 || n + 1 === a || (o = Kd(i, n + 1)) < 56320 || o > 57343 ? t ? wO(i, n) : s : t ? EO(i, n, n + 2) : (s - 55296 << 10) + (o - 56320) + 65536);
  };
}, TO = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: Zd(!1),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: Zd(!0)
}, PO = TO.charAt, bc = function(t, e, r) {
  return e + (r ? PO(t, e).length : 1);
}, OO = F, Qd = Ze, CO = ze, IO = we, _O = Si, AO = Ga, RO = OO.TypeError, xc = function(t, e) {
  var r = t.exec;
  if (IO(r)) {
    var i = Qd(r, t, e);
    return i !== null && CO(i), i;
  }
  if (_O(t) === "RegExp")
    return Qd(AO, t, e);
  throw RO("RegExp#exec called on incompatible receiver");
}, MO = Ze, LO = vc, DO = ze, NO = Pi, Ys = Ot, jO = wt, kO = Ei, zO = bc, Jd = xc;
LO("match", function(t, e, r) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function(n) {
      var a = jO(this), s = n == null ? void 0 : kO(n, t);
      return s ? MO(s, n, a) : new RegExp(n)[t](Ys(a));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function(i) {
      var n = DO(this), a = Ys(i), s = r(e, n, a);
      if (s.done)
        return s.value;
      if (!n.global)
        return Jd(n, a);
      var o = n.unicode;
      n.lastIndex = 0;
      for (var l = [], c = 0, u; (u = Jd(n, a)) !== null; ) {
        var d = Ys(u[0]);
        l[c] = d, d === "" && (n.lastIndex = zO(a, NO(n.lastIndex), o)), c++;
      }
      return c === 0 ? null : l;
    }
  ];
});
var Sc = se, BO = ja, FO = Math.floor, Xs = Sc("".charAt), $O = Sc("".replace), qs = Sc("".slice), UO = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, VO = /\$([$&'`]|\d{1,2})/g, HO = function(t, e, r, i, n, a) {
  var s = r + t.length, o = i.length, l = VO;
  return n !== void 0 && (n = BO(n), l = UO), $O(a, l, function(c, u) {
    var d;
    switch (Xs(u, 0)) {
      case "$":
        return "$";
      case "&":
        return t;
      case "`":
        return qs(e, 0, r);
      case "'":
        return qs(e, s);
      case "<":
        d = n[qs(u, 1, -1)];
        break;
      default:
        var h = +u;
        if (h === 0)
          return c;
        if (h > o) {
          var f = FO(h / 10);
          return f === 0 ? c : f <= o ? i[f - 1] === void 0 ? Xs(u, 1) : i[f - 1] + Xs(u, 1) : c;
        }
        d = i[h - 1];
    }
    return d === void 0 ? "" : d;
  });
}, WO = sc, eh = Ze, Ya = se, GO = vc, YO = Ie, XO = ze, qO = we, KO = $a, ZO = Pi, Gr = Ot, QO = wt, JO = bc, eC = Ei, tC = HO, rC = xc, iC = _e, Jo = iC("replace"), nC = Math.max, aC = Math.min, sC = Ya([].concat), Ks = Ya([].push), th = Ya("".indexOf), rh = Ya("".slice), oC = function(t) {
  return t === void 0 ? t : String(t);
}, lC = function() {
  return "a".replace(/./, "$0") === "$0";
}(), ih = function() {
  return /./[Jo] ? /./[Jo]("a", "$0") === "" : !1;
}(), cC = !YO(function() {
  var t = /./;
  return t.exec = function() {
    var e = [];
    return e.groups = { a: "7" }, e;
  }, "".replace(t, "$<a>") !== "7";
});
GO("replace", function(t, e, r) {
  var i = ih ? "$" : "$0";
  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function(a, s) {
      var o = QO(this), l = a == null ? void 0 : eC(a, Jo);
      return l ? eh(l, a, o, s) : eh(e, Gr(o), a, s);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function(n, a) {
      var s = XO(this), o = Gr(n);
      if (typeof a == "string" && th(a, i) === -1 && th(a, "$<") === -1) {
        var l = r(e, s, o, a);
        if (l.done)
          return l.value;
      }
      var c = qO(a);
      c || (a = Gr(a));
      var u = s.global;
      if (u) {
        var d = s.unicode;
        s.lastIndex = 0;
      }
      for (var h = []; ; ) {
        var f = rC(s, o);
        if (f === null || (Ks(h, f), !u))
          break;
        var v = Gr(f[0]);
        v === "" && (s.lastIndex = JO(o, ZO(s.lastIndex), d));
      }
      for (var p = "", b = 0, y = 0; y < h.length; y++) {
        f = h[y];
        for (var x = Gr(f[0]), w = nC(aC(KO(f.index), o.length), 0), P = [], O = 1; O < f.length; O++)
          Ks(P, oC(f[O]));
        var A = f.groups;
        if (c) {
          var I = sC([x], P, w, o);
          A !== void 0 && Ks(I, A);
          var D = Gr(WO(a, void 0, I));
        } else
          D = tC(x, o, w, P, A, a);
        w >= b && (p += rh(o, b, w) + D, b = w + x.length);
      }
      return p + rh(o, b);
    }
  ];
}, !cC || !lC || ih);
var uC = er, dC = Si, hC = _e, fC = hC("match"), H1 = function(t) {
  var e;
  return uC(t) && ((e = t[fC]) !== void 0 ? !!e : dC(t) == "RegExp");
}, gC = F, pC = H1, mC = gC.TypeError, wc = function(t) {
  if (pC(t))
    throw mC("The method doesn't accept regular expressions");
  return t;
}, vC = _e, yC = vC("match"), Ec = function(t) {
  var e = /./;
  try {
    "/./"[t](e);
  } catch {
    try {
      return e[yC] = !1, "/./"[t](e);
    } catch {
    }
  }
  return !1;
}, bC = Tt, W1 = se, xC = xi.f, SC = Pi, nh = Ot, wC = wc, EC = wt, TC = Ec, ah = W1("".startsWith), PC = W1("".slice), OC = Math.min, G1 = TC("startsWith"), CC = !G1 && !!function() {
  var t = xC(String.prototype, "startsWith");
  return t && !t.writable;
}();
bC({ target: "String", proto: !0, forced: !CC && !G1 }, {
  startsWith: function(e) {
    var r = nh(EC(this));
    wC(e);
    var i = SC(OC(arguments.length > 1 ? arguments[1] : void 0, r.length)), n = nh(e);
    return ah ? ah(r, n, i) : PC(r, i, i + n.length) === n;
  }
});
var IC = _e, _C = mc, AC = tr, el = IC("unscopables"), tl = Array.prototype;
tl[el] == null && AC.f(tl, el, {
  configurable: !0,
  value: _C(null)
});
var RC = function(t) {
  tl[el][t] = !0;
}, MC = Ie, LC = !MC(function() {
  function t() {
  }
  return t.prototype.constructor = null, Object.getPrototypeOf(new t()) !== t.prototype;
}), DC = F, NC = Et, jC = we, kC = ja, zC = Zl, BC = LC, sh = zC("IE_PROTO"), rl = DC.Object, FC = rl.prototype, Y1 = BC ? rl.getPrototypeOf : function(t) {
  var e = kC(t);
  if (NC(e, sh))
    return e[sh];
  var r = e.constructor;
  return jC(r) && e instanceof r ? r.prototype : e instanceof rl ? FC : null;
}, $C = Ie, UC = we, oh = Y1, VC = Mr, HC = _e, il = HC("iterator"), X1 = !1, Er, Zs, Qs;
[].keys && (Qs = [].keys(), "next" in Qs ? (Zs = oh(oh(Qs)), Zs !== Object.prototype && (Er = Zs)) : X1 = !0);
var WC = Er == null || $C(function() {
  var t = {};
  return Er[il].call(t) !== t;
});
WC && (Er = {});
UC(Er[il]) || VC(Er, il, function() {
  return this;
});
var q1 = {
  IteratorPrototype: Er,
  BUGGY_SAFARI_ITERATORS: X1
}, GC = q1.IteratorPrototype, YC = mc, XC = Ma, qC = tc, KC = fn, ZC = function() {
  return this;
}, QC = function(t, e, r, i) {
  var n = e + " Iterator";
  return t.prototype = YC(GC, { next: XC(+!i, r) }), qC(t, n, !1), KC[n] = ZC, t;
}, JC = Tt, eI = Ze, K1 = Fa, tI = we, rI = QC, lh = Y1, ch = g1, iI = tc, nI = Ti, Js = Mr, aI = _e, sI = fn, Z1 = q1, oI = K1.PROPER, lI = K1.CONFIGURABLE, uh = Z1.IteratorPrototype, Ln = Z1.BUGGY_SAFARI_ITERATORS, Fi = aI("iterator"), dh = "keys", $i = "values", hh = "entries", cI = function() {
  return this;
}, uI = function(t, e, r, i, n, a, s) {
  rI(r, e, i);
  var o = function(y) {
    if (y === n && h)
      return h;
    if (!Ln && y in u)
      return u[y];
    switch (y) {
      case dh:
        return function() {
          return new r(this, y);
        };
      case $i:
        return function() {
          return new r(this, y);
        };
      case hh:
        return function() {
          return new r(this, y);
        };
    }
    return function() {
      return new r(this);
    };
  }, l = e + " Iterator", c = !1, u = t.prototype, d = u[Fi] || u["@@iterator"] || n && u[n], h = !Ln && d || o(n), f = e == "Array" && u.entries || d, v, p, b;
  if (f && (v = lh(f.call(new t())), v !== Object.prototype && v.next && (lh(v) !== uh && (ch ? ch(v, uh) : tI(v[Fi]) || Js(v, Fi, cI)), iI(v, l, !0))), oI && n == $i && d && d.name !== $i && (lI ? nI(u, "name", $i) : (c = !0, h = function() {
    return eI(d, this);
  })), n)
    if (p = {
      values: o($i),
      keys: a ? h : o(dh),
      entries: o(hh)
    }, s)
      for (b in p)
        (Ln || c || !(b in u)) && Js(u, b, p[b]);
    else
      JC({ target: e, proto: !0, forced: Ln || c }, p);
  return u[Fi] !== h && Js(u, Fi, h, { name: n }), sI[e] = h, p;
}, dI = dn, Tc = RC, fh = fn, Q1 = Ba, hI = uI, J1 = "Array Iterator", fI = Q1.set, gI = Q1.getterFor(J1), pI = hI(Array, "Array", function(t, e) {
  fI(this, {
    type: J1,
    target: dI(t),
    // target
    index: 0,
    // next index
    kind: e
    // kind
  });
}, function() {
  var t = gI(this), e = t.target, r = t.kind, i = t.index++;
  return !e || i >= e.length ? (t.target = void 0, { value: void 0, done: !0 }) : r == "keys" ? { value: i, done: !1 } : r == "values" ? { value: e[i], done: !1 } : { value: [i, e[i]], done: !1 };
}, "values");
fh.Arguments = fh.Array;
Tc("keys");
Tc("values");
Tc("entries");
var mI = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, vI = ka, eo = vI("span").classList, gh = eo && eo.constructor && eo.constructor.prototype, yI = gh === Object.prototype ? void 0 : gh, ph = F, ep = mI, bI = yI, qi = pI, to = Ti, tp = _e, ro = tp("iterator"), mh = tp("toStringTag"), io = qi.values, rp = function(t, e) {
  if (t) {
    if (t[ro] !== io)
      try {
        to(t, ro, io);
      } catch {
        t[ro] = io;
      }
    if (t[mh] || to(t, mh, e), ep[e]) {
      for (var r in qi)
        if (t[r] !== qi[r])
          try {
            to(t, r, qi[r]);
          } catch {
            t[r] = qi[r];
          }
    }
  }
};
for (var no in ep)
  rp(ph[no] && ph[no].prototype, no);
rp(bI, "DOMTokenList");
function Pc(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
var xI = F, SI = wi, wI = ja, EI = Yg, TI = Ua, PI = xI.TypeError, vh = function(t) {
  return function(e, r, i, n) {
    SI(r);
    var a = wI(e), s = EI(a), o = TI(a), l = t ? o - 1 : 0, c = t ? -1 : 1;
    if (i < 2)
      for (; ; ) {
        if (l in s) {
          n = s[l], l += c;
          break;
        }
        if (l += c, t ? l < 0 : o <= l)
          throw PI("Reduce of empty array with no initial value");
      }
    for (; t ? l >= 0 : o > l; l += c)
      l in s && (n = r(n, s[l], l, a));
    return n;
  };
}, OI = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: vh(!1),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: vh(!0)
}, CI = Ie, ip = function(t, e) {
  var r = [][t];
  return !!r && CI(function() {
    r.call(null, e || function() {
      throw 1;
    }, 1);
  });
}, II = Tt, _I = OI.left, AI = ip, yh = Gl, RI = Va, MI = AI("reduce"), LI = !RI && yh > 79 && yh < 83;
II({ target: "Array", proto: !0, forced: !MI || LI }, {
  reduce: function(e) {
    var r = arguments.length;
    return _I(this, e, r, r > 1 ? arguments[1] : void 0);
  }
});
var DI = Tt, np = se, NI = xi.f, jI = Pi, bh = Ot, kI = wc, zI = wt, BI = Ec, xh = np("".endsWith), FI = np("".slice), $I = Math.min, ap = BI("endsWith"), UI = !ap && !!function() {
  var t = NI(String.prototype, "endsWith");
  return t && !t.writable;
}();
DI({ target: "String", proto: !0, forced: !UI && !ap }, {
  endsWith: function(e) {
    var r = bh(zI(this));
    kI(e);
    var i = arguments.length > 1 ? arguments[1] : void 0, n = r.length, a = i === void 0 ? n : $I(jI(i), n), s = bh(e);
    return xh ? xh(r, s, a) : FI(r, a - s.length, a) === s;
  }
});
var VI = Kl, HI = tr, WI = Ma, GI = function(t, e, r) {
  var i = VI(e);
  i in t ? HI.f(t, i, WI(0, r)) : t[i] = r;
}, YI = F, Sh = l1, XI = Ua, qI = GI, KI = YI.Array, ZI = Math.max, QI = function(t, e, r) {
  for (var i = XI(t), n = Sh(e, i), a = Sh(r === void 0 ? i : r, i), s = KI(ZI(a - n, 0)), o = 0; n < a; n++, o++)
    qI(s, o, t[n]);
  return s.length = o, s;
}, JI = sc, Ui = Ze, Oc = se, e_ = vc, t_ = H1, r_ = ze, wh = wt, i_ = w1, n_ = bc, a_ = Pi, ao = Ot, s_ = Ei, Eh = QI, Th = xc, o_ = Ga, l_ = B1, c_ = Ie, Yr = l_.UNSUPPORTED_Y, Ph = 4294967295, u_ = Math.min, sp = [].push, d_ = Oc(/./.exec), Xr = Oc(sp), Vi = Oc("".slice), h_ = !c_(function() {
  var t = /(?:)/, e = t.exec;
  t.exec = function() {
    return e.apply(this, arguments);
  };
  var r = "ab".split(t);
  return r.length !== 2 || r[0] !== "a" || r[1] !== "b";
});
e_("split", function(t, e, r) {
  var i;
  return "abbc".split(/(b)*/)[1] == "c" || // eslint-disable-next-line regexp/no-empty-group -- required for testing
  "test".split(/(?:)/, -1).length != 4 || "ab".split(/(?:ab)*/).length != 2 || ".".split(/(.?)(.?)/).length != 4 || // eslint-disable-next-line regexp/no-empty-capturing-group, regexp/no-empty-group -- required for testing
  ".".split(/()()/).length > 1 || "".split(/.?/).length ? i = function(n, a) {
    var s = ao(wh(this)), o = a === void 0 ? Ph : a >>> 0;
    if (o === 0)
      return [];
    if (n === void 0)
      return [s];
    if (!t_(n))
      return Ui(e, s, n, o);
    for (var l = [], c = (n.ignoreCase ? "i" : "") + (n.multiline ? "m" : "") + (n.unicode ? "u" : "") + (n.sticky ? "y" : ""), u = 0, d = new RegExp(n.source, c + "g"), h, f, v; (h = Ui(o_, d, s)) && (f = d.lastIndex, !(f > u && (Xr(l, Vi(s, u, h.index)), h.length > 1 && h.index < s.length && JI(sp, l, Eh(h, 1)), v = h[0].length, u = f, l.length >= o))); )
      d.lastIndex === h.index && d.lastIndex++;
    return u === s.length ? (v || !d_(d, "")) && Xr(l, "") : Xr(l, Vi(s, u)), l.length > o ? Eh(l, 0, o) : l;
  } : "0".split(void 0, 0).length ? i = function(n, a) {
    return n === void 0 && a === 0 ? [] : Ui(e, this, n, a);
  } : i = e, [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function(a, s) {
      var o = wh(this), l = a == null ? void 0 : s_(a, t);
      return l ? Ui(l, a, o, s) : Ui(i, ao(o), a, s);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function(n, a) {
      var s = r_(this), o = ao(n), l = r(i, s, o, a, i !== e);
      if (l.done)
        return l.value;
      var c = i_(s, RegExp), u = s.unicode, d = (s.ignoreCase ? "i" : "") + (s.multiline ? "m" : "") + (s.unicode ? "u" : "") + (Yr ? "g" : "y"), h = new c(Yr ? "^(?:" + s.source + ")" : s, d), f = a === void 0 ? Ph : a >>> 0;
      if (f === 0)
        return [];
      if (o.length === 0)
        return Th(h, o) === null ? [o] : [];
      for (var v = 0, p = 0, b = []; p < o.length; ) {
        h.lastIndex = Yr ? 0 : p;
        var y = Th(h, Yr ? Vi(o, p) : o), x;
        if (y === null || (x = u_(a_(h.lastIndex + (Yr ? p : 0)), o.length)) === v)
          p = n_(o, p, u);
        else {
          if (Xr(b, Vi(o, v, p)), b.length === f)
            return b;
          for (var w = 1; w <= y.length - 1; w++)
            if (Xr(b, y[w]), b.length === f)
              return b;
          p = v = x;
        }
      }
      return Xr(b, Vi(o, v)), b;
    }
  ];
}, !h_, Yr);
var Xa = { exports: {} }, Ki = { exports: {} };
(function() {
  var t, e, r, i, n, a;
  typeof performance < "u" && performance !== null && performance.now ? Ki.exports = function() {
    return performance.now();
  } : typeof process < "u" && process !== null && process.hrtime ? (Ki.exports = function() {
    return (t() - n) / 1e6;
  }, e = process.hrtime, t = function() {
    var s;
    return s = e(), s[0] * 1e9 + s[1];
  }, i = t(), a = process.uptime() * 1e9, n = i - a) : Date.now ? (Ki.exports = function() {
    return Date.now() - r;
  }, r = Date.now()) : (Ki.exports = function() {
    return (/* @__PURE__ */ new Date()).getTime() - r;
  }, r = (/* @__PURE__ */ new Date()).getTime());
}).call(xt);
var f_ = Ki.exports, g_ = f_, Nt = typeof window > "u" ? xt : window, Dn = ["moz", "webkit"], ii = "AnimationFrame", li = Nt["request" + ii], rn = Nt["cancel" + ii] || Nt["cancelRequest" + ii];
for (var Hi = 0; !li && Hi < Dn.length; Hi++)
  li = Nt[Dn[Hi] + "Request" + ii], rn = Nt[Dn[Hi] + "Cancel" + ii] || Nt[Dn[Hi] + "CancelRequest" + ii];
if (!li || !rn) {
  var so = 0, Oh = 0, cr = [], p_ = 1e3 / 60;
  li = function(t) {
    if (cr.length === 0) {
      var e = g_(), r = Math.max(0, p_ - (e - so));
      so = r + e, setTimeout(function() {
        var i = cr.slice(0);
        cr.length = 0;
        for (var n = 0; n < i.length; n++)
          if (!i[n].cancelled)
            try {
              i[n].callback(so);
            } catch (a) {
              setTimeout(function() {
                throw a;
              }, 0);
            }
      }, Math.round(r));
    }
    return cr.push({
      handle: ++Oh,
      callback: t,
      cancelled: !1
    }), Oh;
  }, rn = function(t) {
    for (var e = 0; e < cr.length; e++)
      cr[e].handle === t && (cr[e].cancelled = !0);
  };
}
Xa.exports = function(t) {
  return li.call(Nt, t);
};
Xa.exports.cancel = function() {
  rn.apply(Nt, arguments);
};
Xa.exports.polyfill = function(t) {
  t || (t = Nt), t.requestAnimationFrame = li, t.cancelAnimationFrame = rn;
};
var m_ = Xa.exports;
const oo = /* @__PURE__ */ ln(m_);
var op = `	
\v\f\r                　\u2028\u2029\uFEFF`, v_ = se, y_ = wt, b_ = Ot, x_ = op, Ch = v_("".replace), Ta = "[" + x_ + "]", S_ = RegExp("^" + Ta + Ta + "*"), w_ = RegExp(Ta + Ta + "*$"), lo = function(t) {
  return function(e) {
    var r = b_(y_(e));
    return t & 1 && (r = Ch(r, S_, "")), t & 2 && (r = Ch(r, w_, "")), r;
  };
}, E_ = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: lo(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: lo(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: lo(3)
}, T_ = Fa.PROPER, P_ = Ie, Ih = op, _h = "​᠎", O_ = function(t) {
  return P_(function() {
    return !!Ih[t]() || _h[t]() !== _h || T_ && Ih[t].name !== t;
  });
}, C_ = Tt, I_ = E_.trim, __ = O_;
C_({ target: "String", proto: !0, forced: __("trim") }, {
  trim: function() {
    return I_(this);
  }
});
var A_ = function(t) {
  this.ok = !1, this.alpha = 1, t.charAt(0) == "#" && (t = t.substr(1, 6)), t = t.replace(/ /g, ""), t = t.toLowerCase();
  var e = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "00ffff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000000",
    blanchedalmond: "ffebcd",
    blue: "0000ff",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "00ffff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dodgerblue: "1e90ff",
    feldspar: "d19275",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "ff00ff",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgrey: "d3d3d3",
    lightgreen: "90ee90",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslateblue: "8470ff",
    lightslategray: "778899",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "00ff00",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "ff00ff",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370d8",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "d87093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "ff0000",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    violetred: "d02090",
    wheat: "f5deb3",
    white: "ffffff",
    whitesmoke: "f5f5f5",
    yellow: "ffff00",
    yellowgreen: "9acd32"
  };
  t = e[t] || t;
  for (var r = [
    {
      re: /^rgba\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3}),\s*((?:\d?\.)?\d)\)$/,
      example: ["rgba(123, 234, 45, 0.8)", "rgba(255,234,245,1.0)"],
      process: function(l) {
        return [
          parseInt(l[1]),
          parseInt(l[2]),
          parseInt(l[3]),
          parseFloat(l[4])
        ];
      }
    },
    {
      re: /^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,
      example: ["rgb(123, 234, 45)", "rgb(255,234,245)"],
      process: function(l) {
        return [
          parseInt(l[1]),
          parseInt(l[2]),
          parseInt(l[3])
        ];
      }
    },
    {
      re: /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
      example: ["#00ff00", "336699"],
      process: function(l) {
        return [
          parseInt(l[1], 16),
          parseInt(l[2], 16),
          parseInt(l[3], 16)
        ];
      }
    },
    {
      re: /^([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      example: ["#fb0", "f0f"],
      process: function(l) {
        return [
          parseInt(l[1] + l[1], 16),
          parseInt(l[2] + l[2], 16),
          parseInt(l[3] + l[3], 16)
        ];
      }
    }
  ], i = 0; i < r.length; i++) {
    var n = r[i].re, a = r[i].process, s = n.exec(t);
    if (s) {
      var o = a(s);
      this.r = o[0], this.g = o[1], this.b = o[2], o.length > 3 && (this.alpha = o[3]), this.ok = !0;
    }
  }
  this.r = this.r < 0 || isNaN(this.r) ? 0 : this.r > 255 ? 255 : this.r, this.g = this.g < 0 || isNaN(this.g) ? 0 : this.g > 255 ? 255 : this.g, this.b = this.b < 0 || isNaN(this.b) ? 0 : this.b > 255 ? 255 : this.b, this.alpha = this.alpha < 0 ? 0 : this.alpha > 1 || isNaN(this.alpha) ? 1 : this.alpha, this.toRGB = function() {
    return "rgb(" + this.r + ", " + this.g + ", " + this.b + ")";
  }, this.toRGBA = function() {
    return "rgba(" + this.r + ", " + this.g + ", " + this.b + ", " + this.alpha + ")";
  }, this.toHex = function() {
    var l = this.r.toString(16), c = this.g.toString(16), u = this.b.toString(16);
    return l.length == 1 && (l = "0" + l), c.length == 1 && (c = "0" + c), u.length == 1 && (u = "0" + u), "#" + l + c + u;
  }, this.getHelpXML = function() {
    for (var l = new Array(), c = 0; c < r.length; c++)
      for (var u = r[c].example, d = 0; d < u.length; d++)
        l[l.length] = u[d];
    for (var h in e)
      l[l.length] = h;
    var f = document.createElement("ul");
    f.setAttribute("id", "rgbcolor-examples");
    for (var c = 0; c < l.length; c++)
      try {
        var v = document.createElement("li"), p = new RGBColor(l[c]), b = document.createElement("div");
        b.style.cssText = "margin: 3px; border: 1px solid black; background:" + p.toHex() + "; color:" + p.toHex(), b.appendChild(document.createTextNode("test"));
        var y = document.createTextNode(
          " " + l[c] + " -> " + p.toRGB() + " -> " + p.toHex()
        );
        v.appendChild(b), v.appendChild(y), f.appendChild(v);
      } catch {
      }
    return f;
  };
};
const nl = /* @__PURE__ */ ln(A_);
var R_ = Tt, M_ = se, L_ = wc, D_ = wt, Ah = Ot, N_ = Ec, j_ = M_("".indexOf);
R_({ target: "String", proto: !0, forced: !N_("includes") }, {
  includes: function(e) {
    return !!~j_(
      Ah(D_(this)),
      Ah(L_(e)),
      arguments.length > 1 ? arguments[1] : void 0
    );
  }
});
var k_ = Tt, z_ = se, B_ = c1.indexOf, F_ = ip, al = z_([].indexOf), Rh = !!al && 1 / al([1], 1, -0) < 0, $_ = F_("indexOf");
k_({ target: "Array", proto: !0, forced: Rh || !$_ }, {
  indexOf: function(e) {
    var r = arguments.length > 1 ? arguments[1] : void 0;
    return Rh ? al(this, e, r) || 0 : B_(this, e, r);
  }
});
var U_ = Si, V_ = Array.isArray || function(e) {
  return U_(e) == "Array";
}, H_ = Tt, W_ = se, G_ = V_, Y_ = W_([].reverse), Mh = [1, 2];
H_({ target: "Array", proto: !0, forced: String(Mh) === String(Mh.reverse()) }, {
  reverse: function() {
    return G_(this) && (this.length = this.length), Y_(this);
  }
});
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var lp = function(t, e) {
  return (lp = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
    r.__proto__ = i;
  } || function(r, i) {
    for (var n in i)
      Object.prototype.hasOwnProperty.call(i, n) && (r[n] = i[n]);
  })(t, e);
};
function cp(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  function r() {
    this.constructor = t;
  }
  lp(t, e), t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
function X_(t) {
  var e = "";
  Array.isArray(t) || (t = [t]);
  for (var r = 0; r < t.length; r++) {
    var i = t[r];
    if (i.type === C.CLOSE_PATH)
      e += "z";
    else if (i.type === C.HORIZ_LINE_TO)
      e += (i.relative ? "h" : "H") + i.x;
    else if (i.type === C.VERT_LINE_TO)
      e += (i.relative ? "v" : "V") + i.y;
    else if (i.type === C.MOVE_TO)
      e += (i.relative ? "m" : "M") + i.x + " " + i.y;
    else if (i.type === C.LINE_TO)
      e += (i.relative ? "l" : "L") + i.x + " " + i.y;
    else if (i.type === C.CURVE_TO)
      e += (i.relative ? "c" : "C") + i.x1 + " " + i.y1 + " " + i.x2 + " " + i.y2 + " " + i.x + " " + i.y;
    else if (i.type === C.SMOOTH_CURVE_TO)
      e += (i.relative ? "s" : "S") + i.x2 + " " + i.y2 + " " + i.x + " " + i.y;
    else if (i.type === C.QUAD_TO)
      e += (i.relative ? "q" : "Q") + i.x1 + " " + i.y1 + " " + i.x + " " + i.y;
    else if (i.type === C.SMOOTH_QUAD_TO)
      e += (i.relative ? "t" : "T") + i.x + " " + i.y;
    else {
      if (i.type !== C.ARC)
        throw new Error('Unexpected command type "' + i.type + '" at index ' + r + ".");
      e += (i.relative ? "a" : "A") + i.rX + " " + i.rY + " " + i.xRot + " " + +i.lArcFlag + " " + +i.sweepFlag + " " + i.x + " " + i.y;
    }
  }
  return e;
}
function sl(t, e) {
  var r = t[0], i = t[1];
  return [r * Math.cos(e) - i * Math.sin(e), r * Math.sin(e) + i * Math.cos(e)];
}
function ct() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  for (var r = 0; r < t.length; r++)
    if (typeof t[r] != "number")
      throw new Error("assertNumbers arguments[" + r + "] is not a number. " + typeof t[r] + " == typeof " + t[r]);
  return !0;
}
var Xt = Math.PI;
function co(t, e, r) {
  t.lArcFlag = t.lArcFlag === 0 ? 0 : 1, t.sweepFlag = t.sweepFlag === 0 ? 0 : 1;
  var i = t.rX, n = t.rY, a = t.x, s = t.y;
  i = Math.abs(t.rX), n = Math.abs(t.rY);
  var o = sl([(e - a) / 2, (r - s) / 2], -t.xRot / 180 * Xt), l = o[0], c = o[1], u = Math.pow(l, 2) / Math.pow(i, 2) + Math.pow(c, 2) / Math.pow(n, 2);
  1 < u && (i *= Math.sqrt(u), n *= Math.sqrt(u)), t.rX = i, t.rY = n;
  var d = Math.pow(i, 2) * Math.pow(c, 2) + Math.pow(n, 2) * Math.pow(l, 2), h = (t.lArcFlag !== t.sweepFlag ? 1 : -1) * Math.sqrt(Math.max(0, (Math.pow(i, 2) * Math.pow(n, 2) - d) / d)), f = i * c / n * h, v = -n * l / i * h, p = sl([f, v], t.xRot / 180 * Xt);
  t.cX = p[0] + (e + a) / 2, t.cY = p[1] + (r + s) / 2, t.phi1 = Math.atan2((c - v) / n, (l - f) / i), t.phi2 = Math.atan2((-c - v) / n, (-l - f) / i), t.sweepFlag === 0 && t.phi2 > t.phi1 && (t.phi2 -= 2 * Xt), t.sweepFlag === 1 && t.phi2 < t.phi1 && (t.phi2 += 2 * Xt), t.phi1 *= 180 / Xt, t.phi2 *= 180 / Xt;
}
function Lh(t, e, r) {
  ct(t, e, r);
  var i = t * t + e * e - r * r;
  if (0 > i)
    return [];
  if (i === 0)
    return [[t * r / (t * t + e * e), e * r / (t * t + e * e)]];
  var n = Math.sqrt(i);
  return [[(t * r + e * n) / (t * t + e * e), (e * r - t * n) / (t * t + e * e)], [(t * r - e * n) / (t * t + e * e), (e * r + t * n) / (t * t + e * e)]];
}
var xe, Lt = Math.PI / 180;
function Dh(t, e, r) {
  return (1 - r) * t + r * e;
}
function Nh(t, e, r, i) {
  return t + Math.cos(i / 180 * Xt) * e + Math.sin(i / 180 * Xt) * r;
}
function jh(t, e, r, i) {
  var n = 1e-6, a = e - t, s = r - e, o = 3 * a + 3 * (i - r) - 6 * s, l = 6 * (s - a), c = 3 * a;
  return Math.abs(o) < n ? [-c / l] : function(u, d, h) {
    h === void 0 && (h = 1e-6);
    var f = u * u / 4 - d;
    if (f < -h)
      return [];
    if (f <= h)
      return [-u / 2];
    var v = Math.sqrt(f);
    return [-u / 2 - v, -u / 2 + v];
  }(l / o, c / o, n);
}
function kh(t, e, r, i, n) {
  var a = 1 - n;
  return t * (a * a * a) + e * (3 * a * a * n) + r * (3 * a * n * n) + i * (n * n * n);
}
(function(t) {
  function e() {
    return n(function(o, l, c) {
      return o.relative && (o.x1 !== void 0 && (o.x1 += l), o.y1 !== void 0 && (o.y1 += c), o.x2 !== void 0 && (o.x2 += l), o.y2 !== void 0 && (o.y2 += c), o.x !== void 0 && (o.x += l), o.y !== void 0 && (o.y += c), o.relative = !1), o;
    });
  }
  function r() {
    var o = NaN, l = NaN, c = NaN, u = NaN;
    return n(function(d, h, f) {
      return d.type & C.SMOOTH_CURVE_TO && (d.type = C.CURVE_TO, o = isNaN(o) ? h : o, l = isNaN(l) ? f : l, d.x1 = d.relative ? h - o : 2 * h - o, d.y1 = d.relative ? f - l : 2 * f - l), d.type & C.CURVE_TO ? (o = d.relative ? h + d.x2 : d.x2, l = d.relative ? f + d.y2 : d.y2) : (o = NaN, l = NaN), d.type & C.SMOOTH_QUAD_TO && (d.type = C.QUAD_TO, c = isNaN(c) ? h : c, u = isNaN(u) ? f : u, d.x1 = d.relative ? h - c : 2 * h - c, d.y1 = d.relative ? f - u : 2 * f - u), d.type & C.QUAD_TO ? (c = d.relative ? h + d.x1 : d.x1, u = d.relative ? f + d.y1 : d.y1) : (c = NaN, u = NaN), d;
    });
  }
  function i() {
    var o = NaN, l = NaN;
    return n(function(c, u, d) {
      if (c.type & C.SMOOTH_QUAD_TO && (c.type = C.QUAD_TO, o = isNaN(o) ? u : o, l = isNaN(l) ? d : l, c.x1 = c.relative ? u - o : 2 * u - o, c.y1 = c.relative ? d - l : 2 * d - l), c.type & C.QUAD_TO) {
        o = c.relative ? u + c.x1 : c.x1, l = c.relative ? d + c.y1 : c.y1;
        var h = c.x1, f = c.y1;
        c.type = C.CURVE_TO, c.x1 = ((c.relative ? 0 : u) + 2 * h) / 3, c.y1 = ((c.relative ? 0 : d) + 2 * f) / 3, c.x2 = (c.x + 2 * h) / 3, c.y2 = (c.y + 2 * f) / 3;
      } else
        o = NaN, l = NaN;
      return c;
    });
  }
  function n(o) {
    var l = 0, c = 0, u = NaN, d = NaN;
    return function(h) {
      if (isNaN(u) && !(h.type & C.MOVE_TO))
        throw new Error("path must start with moveto");
      var f = o(h, l, c, u, d);
      return h.type & C.CLOSE_PATH && (l = u, c = d), h.x !== void 0 && (l = h.relative ? l + h.x : h.x), h.y !== void 0 && (c = h.relative ? c + h.y : h.y), h.type & C.MOVE_TO && (u = l, d = c), f;
    };
  }
  function a(o, l, c, u, d, h) {
    return ct(o, l, c, u, d, h), n(function(f, v, p, b) {
      var y = f.x1, x = f.x2, w = f.relative && !isNaN(b), P = f.x !== void 0 ? f.x : w ? 0 : v, O = f.y !== void 0 ? f.y : w ? 0 : p;
      function A(oe) {
        return oe * oe;
      }
      f.type & C.HORIZ_LINE_TO && l !== 0 && (f.type = C.LINE_TO, f.y = f.relative ? 0 : p), f.type & C.VERT_LINE_TO && c !== 0 && (f.type = C.LINE_TO, f.x = f.relative ? 0 : v), f.x !== void 0 && (f.x = f.x * o + O * c + (w ? 0 : d)), f.y !== void 0 && (f.y = P * l + f.y * u + (w ? 0 : h)), f.x1 !== void 0 && (f.x1 = f.x1 * o + f.y1 * c + (w ? 0 : d)), f.y1 !== void 0 && (f.y1 = y * l + f.y1 * u + (w ? 0 : h)), f.x2 !== void 0 && (f.x2 = f.x2 * o + f.y2 * c + (w ? 0 : d)), f.y2 !== void 0 && (f.y2 = x * l + f.y2 * u + (w ? 0 : h));
      var I = o * u - l * c;
      if (f.xRot !== void 0 && (o !== 1 || l !== 0 || c !== 0 || u !== 1))
        if (I === 0)
          delete f.rX, delete f.rY, delete f.xRot, delete f.lArcFlag, delete f.sweepFlag, f.type = C.LINE_TO;
        else {
          var D = f.xRot * Math.PI / 180, k = Math.sin(D), W = Math.cos(D), $ = 1 / A(f.rX), z = 1 / A(f.rY), X = A(W) * $ + A(k) * z, U = 2 * k * W * ($ - z), ie = A(k) * $ + A(W) * z, q = X * u * u - U * l * u + ie * l * l, Y = U * (o * u + l * c) - 2 * (X * c * u + ie * o * l), te = X * c * c - U * o * c + ie * o * o, V = (Math.atan2(Y, q - te) + Math.PI) % Math.PI / 2, K = Math.sin(V), ne = Math.cos(V);
          f.rX = Math.abs(I) / Math.sqrt(q * A(ne) + Y * K * ne + te * A(K)), f.rY = Math.abs(I) / Math.sqrt(q * A(K) - Y * K * ne + te * A(ne)), f.xRot = 180 * V / Math.PI;
        }
      return f.sweepFlag !== void 0 && 0 > I && (f.sweepFlag = +!f.sweepFlag), f;
    });
  }
  function s() {
    return function(o) {
      var l = {};
      for (var c in o)
        l[c] = o[c];
      return l;
    };
  }
  t.ROUND = function(o) {
    function l(c) {
      return Math.round(c * o) / o;
    }
    return o === void 0 && (o = 1e13), ct(o), function(c) {
      return c.x1 !== void 0 && (c.x1 = l(c.x1)), c.y1 !== void 0 && (c.y1 = l(c.y1)), c.x2 !== void 0 && (c.x2 = l(c.x2)), c.y2 !== void 0 && (c.y2 = l(c.y2)), c.x !== void 0 && (c.x = l(c.x)), c.y !== void 0 && (c.y = l(c.y)), c.rX !== void 0 && (c.rX = l(c.rX)), c.rY !== void 0 && (c.rY = l(c.rY)), c;
    };
  }, t.TO_ABS = e, t.TO_REL = function() {
    return n(function(o, l, c) {
      return o.relative || (o.x1 !== void 0 && (o.x1 -= l), o.y1 !== void 0 && (o.y1 -= c), o.x2 !== void 0 && (o.x2 -= l), o.y2 !== void 0 && (o.y2 -= c), o.x !== void 0 && (o.x -= l), o.y !== void 0 && (o.y -= c), o.relative = !0), o;
    });
  }, t.NORMALIZE_HVZ = function(o, l, c) {
    return o === void 0 && (o = !0), l === void 0 && (l = !0), c === void 0 && (c = !0), n(function(u, d, h, f, v) {
      if (isNaN(f) && !(u.type & C.MOVE_TO))
        throw new Error("path must start with moveto");
      return l && u.type & C.HORIZ_LINE_TO && (u.type = C.LINE_TO, u.y = u.relative ? 0 : h), c && u.type & C.VERT_LINE_TO && (u.type = C.LINE_TO, u.x = u.relative ? 0 : d), o && u.type & C.CLOSE_PATH && (u.type = C.LINE_TO, u.x = u.relative ? f - d : f, u.y = u.relative ? v - h : v), u.type & C.ARC && (u.rX === 0 || u.rY === 0) && (u.type = C.LINE_TO, delete u.rX, delete u.rY, delete u.xRot, delete u.lArcFlag, delete u.sweepFlag), u;
    });
  }, t.NORMALIZE_ST = r, t.QT_TO_C = i, t.INFO = n, t.SANITIZE = function(o) {
    o === void 0 && (o = 0), ct(o);
    var l = NaN, c = NaN, u = NaN, d = NaN;
    return n(function(h, f, v, p, b) {
      var y = Math.abs, x = !1, w = 0, P = 0;
      if (h.type & C.SMOOTH_CURVE_TO && (w = isNaN(l) ? 0 : f - l, P = isNaN(c) ? 0 : v - c), h.type & (C.CURVE_TO | C.SMOOTH_CURVE_TO) ? (l = h.relative ? f + h.x2 : h.x2, c = h.relative ? v + h.y2 : h.y2) : (l = NaN, c = NaN), h.type & C.SMOOTH_QUAD_TO ? (u = isNaN(u) ? f : 2 * f - u, d = isNaN(d) ? v : 2 * v - d) : h.type & C.QUAD_TO ? (u = h.relative ? f + h.x1 : h.x1, d = h.relative ? v + h.y1 : h.y2) : (u = NaN, d = NaN), h.type & C.LINE_COMMANDS || h.type & C.ARC && (h.rX === 0 || h.rY === 0 || !h.lArcFlag) || h.type & C.CURVE_TO || h.type & C.SMOOTH_CURVE_TO || h.type & C.QUAD_TO || h.type & C.SMOOTH_QUAD_TO) {
        var O = h.x === void 0 ? 0 : h.relative ? h.x : h.x - f, A = h.y === void 0 ? 0 : h.relative ? h.y : h.y - v;
        w = isNaN(u) ? h.x1 === void 0 ? w : h.relative ? h.x : h.x1 - f : u - f, P = isNaN(d) ? h.y1 === void 0 ? P : h.relative ? h.y : h.y1 - v : d - v;
        var I = h.x2 === void 0 ? 0 : h.relative ? h.x : h.x2 - f, D = h.y2 === void 0 ? 0 : h.relative ? h.y : h.y2 - v;
        y(O) <= o && y(A) <= o && y(w) <= o && y(P) <= o && y(I) <= o && y(D) <= o && (x = !0);
      }
      return h.type & C.CLOSE_PATH && y(f - p) <= o && y(v - b) <= o && (x = !0), x ? [] : h;
    });
  }, t.MATRIX = a, t.ROTATE = function(o, l, c) {
    l === void 0 && (l = 0), c === void 0 && (c = 0), ct(o, l, c);
    var u = Math.sin(o), d = Math.cos(o);
    return a(d, u, -u, d, l - l * d + c * u, c - l * u - c * d);
  }, t.TRANSLATE = function(o, l) {
    return l === void 0 && (l = 0), ct(o, l), a(1, 0, 0, 1, o, l);
  }, t.SCALE = function(o, l) {
    return l === void 0 && (l = o), ct(o, l), a(o, 0, 0, l, 0, 0);
  }, t.SKEW_X = function(o) {
    return ct(o), a(1, 0, Math.atan(o), 1, 0, 0);
  }, t.SKEW_Y = function(o) {
    return ct(o), a(1, Math.atan(o), 0, 1, 0, 0);
  }, t.X_AXIS_SYMMETRY = function(o) {
    return o === void 0 && (o = 0), ct(o), a(-1, 0, 0, 1, o, 0);
  }, t.Y_AXIS_SYMMETRY = function(o) {
    return o === void 0 && (o = 0), ct(o), a(1, 0, 0, -1, 0, o);
  }, t.A_TO_C = function() {
    return n(function(o, l, c) {
      return C.ARC === o.type ? function(u, d, h) {
        var f, v, p, b;
        u.cX || co(u, d, h);
        for (var y = Math.min(u.phi1, u.phi2), x = Math.max(u.phi1, u.phi2) - y, w = Math.ceil(x / 90), P = new Array(w), O = d, A = h, I = 0; I < w; I++) {
          var D = Dh(u.phi1, u.phi2, I / w), k = Dh(u.phi1, u.phi2, (I + 1) / w), W = k - D, $ = 4 / 3 * Math.tan(W * Lt / 4), z = [Math.cos(D * Lt) - $ * Math.sin(D * Lt), Math.sin(D * Lt) + $ * Math.cos(D * Lt)], X = z[0], U = z[1], ie = [Math.cos(k * Lt), Math.sin(k * Lt)], q = ie[0], Y = ie[1], te = [q + $ * Math.sin(k * Lt), Y - $ * Math.cos(k * Lt)], V = te[0], K = te[1];
          P[I] = { relative: u.relative, type: C.CURVE_TO };
          var ne = function(oe, Se) {
            var ue = sl([oe * u.rX, Se * u.rY], u.xRot), Ge = ue[0], Ut = ue[1];
            return [u.cX + Ge, u.cY + Ut];
          };
          f = ne(X, U), P[I].x1 = f[0], P[I].y1 = f[1], v = ne(V, K), P[I].x2 = v[0], P[I].y2 = v[1], p = ne(q, Y), P[I].x = p[0], P[I].y = p[1], u.relative && (P[I].x1 -= O, P[I].y1 -= A, P[I].x2 -= O, P[I].y2 -= A, P[I].x -= O, P[I].y -= A), O = (b = [P[I].x, P[I].y])[0], A = b[1];
        }
        return P;
      }(o, o.relative ? 0 : l, o.relative ? 0 : c) : o;
    });
  }, t.ANNOTATE_ARCS = function() {
    return n(function(o, l, c) {
      return o.relative && (l = 0, c = 0), C.ARC === o.type && co(o, l, c), o;
    });
  }, t.CLONE = s, t.CALCULATE_BOUNDS = function() {
    var o = function(h) {
      var f = {};
      for (var v in h)
        f[v] = h[v];
      return f;
    }, l = e(), c = i(), u = r(), d = n(function(h, f, v) {
      var p = u(c(l(o(h))));
      function b(K) {
        K > d.maxX && (d.maxX = K), K < d.minX && (d.minX = K);
      }
      function y(K) {
        K > d.maxY && (d.maxY = K), K < d.minY && (d.minY = K);
      }
      if (p.type & C.DRAWING_COMMANDS && (b(f), y(v)), p.type & C.HORIZ_LINE_TO && b(p.x), p.type & C.VERT_LINE_TO && y(p.y), p.type & C.LINE_TO && (b(p.x), y(p.y)), p.type & C.CURVE_TO) {
        b(p.x), y(p.y);
        for (var x = 0, w = jh(f, p.x1, p.x2, p.x); x < w.length; x++)
          0 < (V = w[x]) && 1 > V && b(kh(f, p.x1, p.x2, p.x, V));
        for (var P = 0, O = jh(v, p.y1, p.y2, p.y); P < O.length; P++)
          0 < (V = O[P]) && 1 > V && y(kh(v, p.y1, p.y2, p.y, V));
      }
      if (p.type & C.ARC) {
        b(p.x), y(p.y), co(p, f, v);
        for (var A = p.xRot / 180 * Math.PI, I = Math.cos(A) * p.rX, D = Math.sin(A) * p.rX, k = -Math.sin(A) * p.rY, W = Math.cos(A) * p.rY, $ = p.phi1 < p.phi2 ? [p.phi1, p.phi2] : -180 > p.phi2 ? [p.phi2 + 360, p.phi1 + 360] : [p.phi2, p.phi1], z = $[0], X = $[1], U = function(K) {
          var ne = K[0], oe = K[1], Se = 180 * Math.atan2(oe, ne) / Math.PI;
          return Se < z ? Se + 360 : Se;
        }, ie = 0, q = Lh(k, -I, 0).map(U); ie < q.length; ie++)
          (V = q[ie]) > z && V < X && b(Nh(p.cX, I, k, V));
        for (var Y = 0, te = Lh(W, -D, 0).map(U); Y < te.length; Y++) {
          var V;
          (V = te[Y]) > z && V < X && y(Nh(p.cY, D, W, V));
        }
      }
      return h;
    });
    return d.minX = 1 / 0, d.maxX = -1 / 0, d.minY = 1 / 0, d.maxY = -1 / 0, d;
  };
})(xe || (xe = {}));
var lt, up = function() {
  function t() {
  }
  return t.prototype.round = function(e) {
    return this.transform(xe.ROUND(e));
  }, t.prototype.toAbs = function() {
    return this.transform(xe.TO_ABS());
  }, t.prototype.toRel = function() {
    return this.transform(xe.TO_REL());
  }, t.prototype.normalizeHVZ = function(e, r, i) {
    return this.transform(xe.NORMALIZE_HVZ(e, r, i));
  }, t.prototype.normalizeST = function() {
    return this.transform(xe.NORMALIZE_ST());
  }, t.prototype.qtToC = function() {
    return this.transform(xe.QT_TO_C());
  }, t.prototype.aToC = function() {
    return this.transform(xe.A_TO_C());
  }, t.prototype.sanitize = function(e) {
    return this.transform(xe.SANITIZE(e));
  }, t.prototype.translate = function(e, r) {
    return this.transform(xe.TRANSLATE(e, r));
  }, t.prototype.scale = function(e, r) {
    return this.transform(xe.SCALE(e, r));
  }, t.prototype.rotate = function(e, r, i) {
    return this.transform(xe.ROTATE(e, r, i));
  }, t.prototype.matrix = function(e, r, i, n, a, s) {
    return this.transform(xe.MATRIX(e, r, i, n, a, s));
  }, t.prototype.skewX = function(e) {
    return this.transform(xe.SKEW_X(e));
  }, t.prototype.skewY = function(e) {
    return this.transform(xe.SKEW_Y(e));
  }, t.prototype.xSymmetry = function(e) {
    return this.transform(xe.X_AXIS_SYMMETRY(e));
  }, t.prototype.ySymmetry = function(e) {
    return this.transform(xe.Y_AXIS_SYMMETRY(e));
  }, t.prototype.annotateArcs = function() {
    return this.transform(xe.ANNOTATE_ARCS());
  }, t;
}(), q_ = function(t) {
  return t === " " || t === "	" || t === "\r" || t === `
`;
}, zh = function(t) {
  return "0".charCodeAt(0) <= t.charCodeAt(0) && t.charCodeAt(0) <= "9".charCodeAt(0);
}, K_ = function(t) {
  function e() {
    var r = t.call(this) || this;
    return r.curNumber = "", r.curCommandType = -1, r.curCommandRelative = !1, r.canParseCommandOrComma = !0, r.curNumberHasExp = !1, r.curNumberHasExpDigits = !1, r.curNumberHasDecimal = !1, r.curArgs = [], r;
  }
  return cp(e, t), e.prototype.finish = function(r) {
    if (r === void 0 && (r = []), this.parse(" ", r), this.curArgs.length !== 0 || !this.canParseCommandOrComma)
      throw new SyntaxError("Unterminated command at the path end.");
    return r;
  }, e.prototype.parse = function(r, i) {
    var n = this;
    i === void 0 && (i = []);
    for (var a = function(d) {
      i.push(d), n.curArgs.length = 0, n.canParseCommandOrComma = !0;
    }, s = 0; s < r.length; s++) {
      var o = r[s], l = !(this.curCommandType !== C.ARC || this.curArgs.length !== 3 && this.curArgs.length !== 4 || this.curNumber.length !== 1 || this.curNumber !== "0" && this.curNumber !== "1"), c = zh(o) && (this.curNumber === "0" && o === "0" || l);
      if (!zh(o) || c)
        if (o !== "e" && o !== "E")
          if (o !== "-" && o !== "+" || !this.curNumberHasExp || this.curNumberHasExpDigits)
            if (o !== "." || this.curNumberHasExp || this.curNumberHasDecimal || l) {
              if (this.curNumber && this.curCommandType !== -1) {
                var u = Number(this.curNumber);
                if (isNaN(u))
                  throw new SyntaxError("Invalid number ending at " + s);
                if (this.curCommandType === C.ARC) {
                  if (this.curArgs.length === 0 || this.curArgs.length === 1) {
                    if (0 > u)
                      throw new SyntaxError('Expected positive number, got "' + u + '" at index "' + s + '"');
                  } else if ((this.curArgs.length === 3 || this.curArgs.length === 4) && this.curNumber !== "0" && this.curNumber !== "1")
                    throw new SyntaxError('Expected a flag, got "' + this.curNumber + '" at index "' + s + '"');
                }
                this.curArgs.push(u), this.curArgs.length === Z_[this.curCommandType] && (C.HORIZ_LINE_TO === this.curCommandType ? a({ type: C.HORIZ_LINE_TO, relative: this.curCommandRelative, x: u }) : C.VERT_LINE_TO === this.curCommandType ? a({ type: C.VERT_LINE_TO, relative: this.curCommandRelative, y: u }) : this.curCommandType === C.MOVE_TO || this.curCommandType === C.LINE_TO || this.curCommandType === C.SMOOTH_QUAD_TO ? (a({ type: this.curCommandType, relative: this.curCommandRelative, x: this.curArgs[0], y: this.curArgs[1] }), C.MOVE_TO === this.curCommandType && (this.curCommandType = C.LINE_TO)) : this.curCommandType === C.CURVE_TO ? a({ type: C.CURVE_TO, relative: this.curCommandRelative, x1: this.curArgs[0], y1: this.curArgs[1], x2: this.curArgs[2], y2: this.curArgs[3], x: this.curArgs[4], y: this.curArgs[5] }) : this.curCommandType === C.SMOOTH_CURVE_TO ? a({ type: C.SMOOTH_CURVE_TO, relative: this.curCommandRelative, x2: this.curArgs[0], y2: this.curArgs[1], x: this.curArgs[2], y: this.curArgs[3] }) : this.curCommandType === C.QUAD_TO ? a({ type: C.QUAD_TO, relative: this.curCommandRelative, x1: this.curArgs[0], y1: this.curArgs[1], x: this.curArgs[2], y: this.curArgs[3] }) : this.curCommandType === C.ARC && a({ type: C.ARC, relative: this.curCommandRelative, rX: this.curArgs[0], rY: this.curArgs[1], xRot: this.curArgs[2], lArcFlag: this.curArgs[3], sweepFlag: this.curArgs[4], x: this.curArgs[5], y: this.curArgs[6] })), this.curNumber = "", this.curNumberHasExpDigits = !1, this.curNumberHasExp = !1, this.curNumberHasDecimal = !1, this.canParseCommandOrComma = !0;
              }
              if (!q_(o))
                if (o === "," && this.canParseCommandOrComma)
                  this.canParseCommandOrComma = !1;
                else if (o !== "+" && o !== "-" && o !== ".")
                  if (c)
                    this.curNumber = o, this.curNumberHasDecimal = !1;
                  else {
                    if (this.curArgs.length !== 0)
                      throw new SyntaxError("Unterminated command at index " + s + ".");
                    if (!this.canParseCommandOrComma)
                      throw new SyntaxError('Unexpected character "' + o + '" at index ' + s + ". Command cannot follow comma");
                    if (this.canParseCommandOrComma = !1, o !== "z" && o !== "Z")
                      if (o === "h" || o === "H")
                        this.curCommandType = C.HORIZ_LINE_TO, this.curCommandRelative = o === "h";
                      else if (o === "v" || o === "V")
                        this.curCommandType = C.VERT_LINE_TO, this.curCommandRelative = o === "v";
                      else if (o === "m" || o === "M")
                        this.curCommandType = C.MOVE_TO, this.curCommandRelative = o === "m";
                      else if (o === "l" || o === "L")
                        this.curCommandType = C.LINE_TO, this.curCommandRelative = o === "l";
                      else if (o === "c" || o === "C")
                        this.curCommandType = C.CURVE_TO, this.curCommandRelative = o === "c";
                      else if (o === "s" || o === "S")
                        this.curCommandType = C.SMOOTH_CURVE_TO, this.curCommandRelative = o === "s";
                      else if (o === "q" || o === "Q")
                        this.curCommandType = C.QUAD_TO, this.curCommandRelative = o === "q";
                      else if (o === "t" || o === "T")
                        this.curCommandType = C.SMOOTH_QUAD_TO, this.curCommandRelative = o === "t";
                      else {
                        if (o !== "a" && o !== "A")
                          throw new SyntaxError('Unexpected character "' + o + '" at index ' + s + ".");
                        this.curCommandType = C.ARC, this.curCommandRelative = o === "a";
                      }
                    else
                      i.push({ type: C.CLOSE_PATH }), this.canParseCommandOrComma = !0, this.curCommandType = -1;
                  }
                else
                  this.curNumber = o, this.curNumberHasDecimal = o === ".";
            } else
              this.curNumber += o, this.curNumberHasDecimal = !0;
          else
            this.curNumber += o;
        else
          this.curNumber += o, this.curNumberHasExp = !0;
      else
        this.curNumber += o, this.curNumberHasExpDigits = this.curNumberHasExp;
    }
    return i;
  }, e.prototype.transform = function(r) {
    return Object.create(this, { parse: { value: function(i, n) {
      n === void 0 && (n = []);
      for (var a = 0, s = Object.getPrototypeOf(this).parse.call(this, i); a < s.length; a++) {
        var o = s[a], l = r(o);
        Array.isArray(l) ? n.push.apply(n, l) : n.push(l);
      }
      return n;
    } } });
  }, e;
}(up), C = function(t) {
  function e(r) {
    var i = t.call(this) || this;
    return i.commands = typeof r == "string" ? e.parse(r) : r, i;
  }
  return cp(e, t), e.prototype.encode = function() {
    return e.encode(this.commands);
  }, e.prototype.getBounds = function() {
    var r = xe.CALCULATE_BOUNDS();
    return this.transform(r), r;
  }, e.prototype.transform = function(r) {
    for (var i = [], n = 0, a = this.commands; n < a.length; n++) {
      var s = r(a[n]);
      Array.isArray(s) ? i.push.apply(i, s) : i.push(s);
    }
    return this.commands = i, this;
  }, e.encode = function(r) {
    return X_(r);
  }, e.parse = function(r) {
    var i = new K_(), n = [];
    return i.parse(r, n), i.finish(n), n;
  }, e.CLOSE_PATH = 1, e.MOVE_TO = 2, e.HORIZ_LINE_TO = 4, e.VERT_LINE_TO = 8, e.LINE_TO = 16, e.CURVE_TO = 32, e.SMOOTH_CURVE_TO = 64, e.QUAD_TO = 128, e.SMOOTH_QUAD_TO = 256, e.ARC = 512, e.LINE_COMMANDS = e.LINE_TO | e.HORIZ_LINE_TO | e.VERT_LINE_TO, e.DRAWING_COMMANDS = e.HORIZ_LINE_TO | e.VERT_LINE_TO | e.LINE_TO | e.CURVE_TO | e.SMOOTH_CURVE_TO | e.QUAD_TO | e.SMOOTH_QUAD_TO | e.ARC, e;
}(up), Z_ = ((lt = {})[C.MOVE_TO] = 2, lt[C.LINE_TO] = 2, lt[C.HORIZ_LINE_TO] = 1, lt[C.VERT_LINE_TO] = 1, lt[C.CLOSE_PATH] = 0, lt[C.QUAD_TO] = 4, lt[C.SMOOTH_QUAD_TO] = 2, lt[C.CURVE_TO] = 6, lt[C.SMOOTH_CURVE_TO] = 4, lt[C.ARC] = 7, lt), Q_ = se, J_ = Fa.PROPER, eA = Mr, tA = ze, rA = La, Bh = Ot, iA = Ie, nA = z1, Cc = "toString", ol = RegExp.prototype, dp = ol[Cc], aA = Q_(nA), sA = iA(function() {
  return dp.call({ source: "a", flags: "b" }) != "/a/b";
}), oA = J_ && dp.name != Cc;
(sA || oA) && eA(RegExp.prototype, Cc, function() {
  var e = tA(this), r = Bh(e.source), i = e.flags, n = Bh(i === void 0 && rA(ol, e) && !("flags" in ol) ? aA(e) : i);
  return "/" + r + "/" + n;
}, { unsafe: !0 });
function ra(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? ra = function(e) {
    return typeof e;
  } : ra = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, ra(t);
}
function lA(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var cA = [512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512, 454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512, 497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335, 329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388, 385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292, 289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259], uA = [9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];
function dA(t, e, r, i, n) {
  if (typeof t == "string" && (t = document.getElementById(t)), !t || ra(t) !== "object" || !("getContext" in t))
    throw new TypeError("Expecting canvas with `getContext` method in processCanvasRGB(A) calls!");
  var a = t.getContext("2d");
  try {
    return a.getImageData(e, r, i, n);
  } catch (s) {
    throw new Error("unable to access image data: " + s);
  }
}
function hA(t, e, r, i, n, a) {
  if (!(isNaN(a) || a < 1)) {
    a |= 0;
    var s = dA(t, e, r, i, n);
    s = fA(s, e, r, i, n, a), t.getContext("2d").putImageData(s, e, r);
  }
}
function fA(t, e, r, i, n, a) {
  for (var s = t.data, o = 2 * a + 1, l = i - 1, c = n - 1, u = a + 1, d = u * (u + 1) / 2, h = new Fh(), f = h, v, p = 1; p < o; p++)
    f = f.next = new Fh(), p === u && (v = f);
  f.next = h;
  for (var b = null, y = null, x = 0, w = 0, P = cA[a], O = uA[a], A = 0; A < n; A++) {
    f = h;
    for (var I = s[w], D = s[w + 1], k = s[w + 2], W = s[w + 3], $ = 0; $ < u; $++)
      f.r = I, f.g = D, f.b = k, f.a = W, f = f.next;
    for (var z = 0, X = 0, U = 0, ie = 0, q = u * I, Y = u * D, te = u * k, V = u * W, K = d * I, ne = d * D, oe = d * k, Se = d * W, ue = 1; ue < u; ue++) {
      var Ge = w + ((l < ue ? l : ue) << 2), Ut = s[Ge], ve = s[Ge + 1], Qe = s[Ge + 2], le = s[Ge + 3], ae = u - ue;
      K += (f.r = Ut) * ae, ne += (f.g = ve) * ae, oe += (f.b = Qe) * ae, Se += (f.a = le) * ae, z += Ut, X += ve, U += Qe, ie += le, f = f.next;
    }
    b = h, y = v;
    for (var mt = 0; mt < i; mt++) {
      var Z = Se * P >> O;
      if (s[w + 3] = Z, Z !== 0) {
        var Le = 255 / Z;
        s[w] = (K * P >> O) * Le, s[w + 1] = (ne * P >> O) * Le, s[w + 2] = (oe * P >> O) * Le;
      } else
        s[w] = s[w + 1] = s[w + 2] = 0;
      K -= q, ne -= Y, oe -= te, Se -= V, q -= b.r, Y -= b.g, te -= b.b, V -= b.a;
      var De = mt + a + 1;
      De = x + (De < l ? De : l) << 2, z += b.r = s[De], X += b.g = s[De + 1], U += b.b = s[De + 2], ie += b.a = s[De + 3], K += z, ne += X, oe += U, Se += ie, b = b.next;
      var Je = y, Be = Je.r, Ne = Je.g, vt = Je.b, Vt = Je.a;
      q += Be, Y += Ne, te += vt, V += Vt, z -= Be, X -= Ne, U -= vt, ie -= Vt, y = y.next, w += 4;
    }
    x += i;
  }
  for (var Ve = 0; Ve < i; Ve++) {
    w = Ve << 2;
    var ye = s[w], Ct = s[w + 1], It = s[w + 2], je = s[w + 3], Ci = u * ye, Ii = u * Ct, Dr = u * It, Nr = u * je, nr = d * ye, ar = d * Ct, _t = d * It, Ht = d * je;
    f = h;
    for (var bn = 0; bn < u; bn++)
      f.r = ye, f.g = Ct, f.b = It, f.a = je, f = f.next;
    for (var xn = i, _i = 0, Ai = 0, Ri = 0, Wt = 0, jr = 1; jr <= a; jr++) {
      w = xn + Ve << 2;
      var kr = u - jr;
      nr += (f.r = ye = s[w]) * kr, ar += (f.g = Ct = s[w + 1]) * kr, _t += (f.b = It = s[w + 2]) * kr, Ht += (f.a = je = s[w + 3]) * kr, Wt += ye, _i += Ct, Ai += It, Ri += je, f = f.next, jr < c && (xn += i);
    }
    w = Ve, b = h, y = v;
    for (var zr = 0; zr < n; zr++) {
      var Ae = w << 2;
      s[Ae + 3] = je = Ht * P >> O, je > 0 ? (je = 255 / je, s[Ae] = (nr * P >> O) * je, s[Ae + 1] = (ar * P >> O) * je, s[Ae + 2] = (_t * P >> O) * je) : s[Ae] = s[Ae + 1] = s[Ae + 2] = 0, nr -= Ci, ar -= Ii, _t -= Dr, Ht -= Nr, Ci -= b.r, Ii -= b.g, Dr -= b.b, Nr -= b.a, Ae = Ve + ((Ae = zr + u) < c ? Ae : c) * i << 2, nr += Wt += b.r = s[Ae], ar += _i += b.g = s[Ae + 1], _t += Ai += b.b = s[Ae + 2], Ht += Ri += b.a = s[Ae + 3], b = b.next, Ci += ye = y.r, Ii += Ct = y.g, Dr += It = y.b, Nr += je = y.a, Wt -= ye, _i -= Ct, Ai -= It, Ri -= je, y = y.next, w += i;
    }
  }
  return t;
}
var Fh = (
  /**
   * Set properties.
   */
  function t() {
    lA(this, t), this.r = 0, this.g = 0, this.b = 0, this.a = 0, this.next = null;
  }
);
function gA() {
  var {
    DOMParser: t
  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = {
    window: null,
    ignoreAnimation: !0,
    ignoreMouse: !0,
    DOMParser: t,
    createCanvas(r, i) {
      return new OffscreenCanvas(r, i);
    },
    createImage(r) {
      return Ft(function* () {
        var i = yield fetch(r), n = yield i.blob(), a = yield createImageBitmap(n);
        return a;
      })();
    }
  };
  return (typeof DOMParser < "u" || typeof t > "u") && Reflect.deleteProperty(e, "DOMParser"), e;
}
function pA(t) {
  var {
    DOMParser: e,
    canvas: r,
    fetch: i
  } = t;
  return {
    window: null,
    ignoreAnimation: !0,
    ignoreMouse: !0,
    DOMParser: e,
    fetch: i,
    createCanvas: r.createCanvas,
    createImage: r.loadImage
  };
}
var mA = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  offscreen: gA,
  node: pA
});
function Lr(t) {
  return t.replace(/(?!\u3000)\s+/gm, " ");
}
function hp(t) {
  return t.replace(/^[\n \t]+/, "");
}
function fp(t) {
  return t.replace(/[\n \t]+$/, "");
}
function He(t) {
  var e = (t || "").match(/-?(\d+(?:\.\d*(?:[eE][+-]?\d+)?)?|\.\d+)(?=\D|$)/gm) || [];
  return e.map(parseFloat);
}
var vA = /^[A-Z-]+$/;
function gp(t) {
  return vA.test(t) ? t.toLowerCase() : t;
}
function Ic(t) {
  var e = /url\(('([^']+)'|"([^"]+)"|([^'")]+))\)/.exec(t) || [];
  return e[2] || e[3] || e[4];
}
function pp(t) {
  if (!t.startsWith("rgb"))
    return t;
  var e = 3, r = t.replace(/\d+(\.\d+)?/g, (i, n) => e-- && n ? String(Math.round(parseFloat(i))) : i);
  return r;
}
var yA = /(\[[^\]]+\])/g, bA = /(#[^\s+>~.[:]+)/g, xA = /(\.[^\s+>~.[:]+)/g, SA = /(::[^\s+>~.[:]+|:first-line|:first-letter|:before|:after)/gi, wA = /(:[\w-]+\([^)]*\))/gi, EA = /(:[^\s+>~.[:]+)/g, TA = /([^\s+>~.[:]+)/g;
function ur(t, e) {
  var r = e.exec(t);
  return r ? [t.replace(e, " "), r.length] : [t, 0];
}
function mp(t) {
  var e = [0, 0, 0], r = t.replace(/:not\(([^)]*)\)/g, "     $1 ").replace(/{[\s\S]*/gm, " "), i = 0;
  return [r, i] = ur(r, yA), e[1] += i, [r, i] = ur(r, bA), e[0] += i, [r, i] = ur(r, xA), e[1] += i, [r, i] = ur(r, SA), e[2] += i, [r, i] = ur(r, wA), e[1] += i, [r, i] = ur(r, EA), e[1] += i, r = r.replace(/[*\s+>~]/g, " ").replace(/[#.]/g, " "), [r, i] = ur(r, TA), e[2] += i, e.join("");
}
var xr = 1e-8;
function ll(t) {
  return Math.sqrt(Math.pow(t[0], 2) + Math.pow(t[1], 2));
}
function Pa(t, e) {
  return (t[0] * e[0] + t[1] * e[1]) / (ll(t) * ll(e));
}
function cl(t, e) {
  return (t[0] * e[1] < t[1] * e[0] ? -1 : 1) * Math.acos(Pa(t, e));
}
function ul(t) {
  return t * t * t;
}
function dl(t) {
  return 3 * t * t * (1 - t);
}
function hl(t) {
  return 3 * t * (1 - t) * (1 - t);
}
function fl(t) {
  return (1 - t) * (1 - t) * (1 - t);
}
function gl(t) {
  return t * t;
}
function pl(t) {
  return 2 * t * (1 - t);
}
function ml(t) {
  return (1 - t) * (1 - t);
}
class j {
  constructor(e, r, i) {
    this.document = e, this.name = r, this.value = i, this.isNormalizedColor = !1;
  }
  static empty(e) {
    return new j(e, "EMPTY", "");
  }
  split() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : " ", {
      document: r,
      name: i
    } = this;
    return Lr(this.getString()).trim().split(e).map((n) => new j(r, i, n));
  }
  hasValue(e) {
    var {
      value: r
    } = this;
    return r !== null && r !== "" && (e || r !== 0) && typeof r < "u";
  }
  isString(e) {
    var {
      value: r
    } = this, i = typeof r == "string";
    return !i || !e ? i : e.test(r);
  }
  isUrlDefinition() {
    return this.isString(/^url\(/);
  }
  isPixels() {
    if (!this.hasValue())
      return !1;
    var e = this.getString();
    switch (!0) {
      case e.endsWith("px"):
      case /^[0-9]+$/.test(e):
        return !0;
      default:
        return !1;
    }
  }
  setValue(e) {
    return this.value = e, this;
  }
  getValue(e) {
    return typeof e > "u" || this.hasValue() ? this.value : e;
  }
  getNumber(e) {
    if (!this.hasValue())
      return typeof e > "u" ? 0 : parseFloat(e);
    var {
      value: r
    } = this, i = parseFloat(r);
    return this.isString(/%$/) && (i /= 100), i;
  }
  getString(e) {
    return typeof e > "u" || this.hasValue() ? typeof this.value > "u" ? "" : String(this.value) : String(e);
  }
  getColor(e) {
    var r = this.getString(e);
    return this.isNormalizedColor || (this.isNormalizedColor = !0, r = pp(r), this.value = r), r;
  }
  getDpi() {
    return 96;
  }
  getRem() {
    return this.document.rootEmSize;
  }
  getEm() {
    return this.document.emSize;
  }
  getUnits() {
    return this.getString().replace(/[0-9.-]/g, "");
  }
  getPixels(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (!this.hasValue())
      return 0;
    var [i, n] = typeof e == "boolean" ? [void 0, e] : [e], {
      viewPort: a
    } = this.document.screen;
    switch (!0) {
      case this.isString(/vmin$/):
        return this.getNumber() / 100 * Math.min(a.computeSize("x"), a.computeSize("y"));
      case this.isString(/vmax$/):
        return this.getNumber() / 100 * Math.max(a.computeSize("x"), a.computeSize("y"));
      case this.isString(/vw$/):
        return this.getNumber() / 100 * a.computeSize("x");
      case this.isString(/vh$/):
        return this.getNumber() / 100 * a.computeSize("y");
      case this.isString(/rem$/):
        return this.getNumber() * this.getRem();
      case this.isString(/em$/):
        return this.getNumber() * this.getEm();
      case this.isString(/ex$/):
        return this.getNumber() * this.getEm() / 2;
      case this.isString(/px$/):
        return this.getNumber();
      case this.isString(/pt$/):
        return this.getNumber() * this.getDpi() * (1 / 72);
      case this.isString(/pc$/):
        return this.getNumber() * 15;
      case this.isString(/cm$/):
        return this.getNumber() * this.getDpi() / 2.54;
      case this.isString(/mm$/):
        return this.getNumber() * this.getDpi() / 25.4;
      case this.isString(/in$/):
        return this.getNumber() * this.getDpi();
      case (this.isString(/%$/) && n):
        return this.getNumber() * this.getEm();
      case this.isString(/%$/):
        return this.getNumber() * a.computeSize(i);
      default: {
        var s = this.getNumber();
        return r && s < 1 ? s * a.computeSize(i) : s;
      }
    }
  }
  getMilliseconds() {
    return this.hasValue() ? this.isString(/ms$/) ? this.getNumber() : this.getNumber() * 1e3 : 0;
  }
  getRadians() {
    if (!this.hasValue())
      return 0;
    switch (!0) {
      case this.isString(/deg$/):
        return this.getNumber() * (Math.PI / 180);
      case this.isString(/grad$/):
        return this.getNumber() * (Math.PI / 200);
      case this.isString(/rad$/):
        return this.getNumber();
      default:
        return this.getNumber() * (Math.PI / 180);
    }
  }
  getDefinition() {
    var e = this.getString(), r = /#([^)'"]+)/.exec(e);
    return r && (r = r[1]), r || (r = e), this.document.definitions[r];
  }
  getFillStyleDefinition(e, r) {
    var i = this.getDefinition();
    if (!i)
      return null;
    if (typeof i.createGradient == "function")
      return i.createGradient(this.document.ctx, e, r);
    if (typeof i.createPattern == "function") {
      if (i.getHrefAttribute().hasValue()) {
        var n = i.getAttribute("patternTransform");
        i = i.getHrefAttribute().getDefinition(), n.hasValue() && i.getAttribute("patternTransform", !0).setValue(n.value);
      }
      return i.createPattern(this.document.ctx, e, r);
    }
    return null;
  }
  getTextBaseline() {
    return this.hasValue() ? j.textBaselineMapping[this.getString()] : null;
  }
  addOpacity(e) {
    for (var r = this.getColor(), i = r.length, n = 0, a = 0; a < i && (r[a] === "," && n++, n !== 3); a++)
      ;
    if (e.hasValue() && this.isString() && n !== 3) {
      var s = new nl(r);
      s.ok && (s.alpha = e.getNumber(), r = s.toRGBA());
    }
    return new j(this.document, this.name, r);
  }
}
j.textBaselineMapping = {
  baseline: "alphabetic",
  "before-edge": "top",
  "text-before-edge": "top",
  middle: "middle",
  central: "middle",
  "after-edge": "bottom",
  "text-after-edge": "bottom",
  ideographic: "ideographic",
  alphabetic: "alphabetic",
  hanging: "hanging",
  mathematical: "alphabetic"
};
class vp {
  constructor() {
    this.viewPorts = [];
  }
  clear() {
    this.viewPorts = [];
  }
  setCurrent(e, r) {
    this.viewPorts.push({
      width: e,
      height: r
    });
  }
  removeCurrent() {
    this.viewPorts.pop();
  }
  getCurrent() {
    var {
      viewPorts: e
    } = this;
    return e[e.length - 1];
  }
  get width() {
    return this.getCurrent().width;
  }
  get height() {
    return this.getCurrent().height;
  }
  computeSize(e) {
    return typeof e == "number" ? e : e === "x" ? this.width : e === "y" ? this.height : Math.sqrt(Math.pow(this.width, 2) + Math.pow(this.height, 2)) / Math.sqrt(2);
  }
}
class pe {
  constructor(e, r) {
    this.x = e, this.y = r;
  }
  static parse(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, [i = r, n = r] = He(e);
    return new pe(i, n);
  }
  static parseScale(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, [i = r, n = i] = He(e);
    return new pe(i, n);
  }
  static parsePath(e) {
    for (var r = He(e), i = r.length, n = [], a = 0; a < i; a += 2)
      n.push(new pe(r[a], r[a + 1]));
    return n;
  }
  angleTo(e) {
    return Math.atan2(e.y - this.y, e.x - this.x);
  }
  applyTransform(e) {
    var {
      x: r,
      y: i
    } = this, n = r * e[0] + i * e[2] + e[4], a = r * e[1] + i * e[3] + e[5];
    this.x = n, this.y = a;
  }
}
class yp {
  constructor(e) {
    this.screen = e, this.working = !1, this.events = [], this.eventElements = [], this.onClick = this.onClick.bind(this), this.onMouseMove = this.onMouseMove.bind(this);
  }
  isWorking() {
    return this.working;
  }
  start() {
    if (!this.working) {
      var {
        screen: e,
        onClick: r,
        onMouseMove: i
      } = this, n = e.ctx.canvas;
      n.onclick = r, n.onmousemove = i, this.working = !0;
    }
  }
  stop() {
    if (this.working) {
      var e = this.screen.ctx.canvas;
      this.working = !1, e.onclick = null, e.onmousemove = null;
    }
  }
  hasEvents() {
    return this.working && this.events.length > 0;
  }
  runEvents() {
    if (this.working) {
      var {
        screen: e,
        events: r,
        eventElements: i
      } = this, {
        style: n
      } = e.ctx.canvas;
      n && (n.cursor = ""), r.forEach((a, s) => {
        for (var {
          run: o
        } = a, l = i[s]; l; )
          o(l), l = l.parent;
      }), this.events = [], this.eventElements = [];
    }
  }
  checkPath(e, r) {
    if (!(!this.working || !r)) {
      var {
        events: i,
        eventElements: n
      } = this;
      i.forEach((a, s) => {
        var {
          x: o,
          y: l
        } = a;
        !n[s] && r.isPointInPath && r.isPointInPath(o, l) && (n[s] = e);
      });
    }
  }
  checkBoundingBox(e, r) {
    if (!(!this.working || !r)) {
      var {
        events: i,
        eventElements: n
      } = this;
      i.forEach((a, s) => {
        var {
          x: o,
          y: l
        } = a;
        !n[s] && r.isPointInBox(o, l) && (n[s] = e);
      });
    }
  }
  mapXY(e, r) {
    for (var {
      window: i,
      ctx: n
    } = this.screen, a = new pe(e, r), s = n.canvas; s; )
      a.x -= s.offsetLeft, a.y -= s.offsetTop, s = s.offsetParent;
    return i.scrollX && (a.x += i.scrollX), i.scrollY && (a.y += i.scrollY), a;
  }
  onClick(e) {
    var {
      x: r,
      y: i
    } = this.mapXY(e.clientX, e.clientY);
    this.events.push({
      type: "onclick",
      x: r,
      y: i,
      run(n) {
        n.onClick && n.onClick();
      }
    });
  }
  onMouseMove(e) {
    var {
      x: r,
      y: i
    } = this.mapXY(e.clientX, e.clientY);
    this.events.push({
      type: "onmousemove",
      x: r,
      y: i,
      run(n) {
        n.onMouseMove && n.onMouseMove();
      }
    });
  }
}
var bp = typeof window < "u" ? window : null, xp = typeof fetch < "u" ? fetch.bind(void 0) : null;
class pn {
  constructor(e) {
    var {
      fetch: r = xp,
      window: i = bp
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.ctx = e, this.FRAMERATE = 30, this.MAX_VIRTUAL_PIXELS = 3e4, this.CLIENT_WIDTH = 800, this.CLIENT_HEIGHT = 600, this.viewPort = new vp(), this.mouse = new yp(this), this.animations = [], this.waits = [], this.frameDuration = 0, this.isReadyLock = !1, this.isFirstRender = !0, this.intervalId = null, this.window = i, this.fetch = r;
  }
  wait(e) {
    this.waits.push(e);
  }
  ready() {
    return this.readyPromise ? this.readyPromise : Promise.resolve();
  }
  isReady() {
    if (this.isReadyLock)
      return !0;
    var e = this.waits.every((r) => r());
    return e && (this.waits = [], this.resolveReady && this.resolveReady()), this.isReadyLock = e, e;
  }
  setDefaults(e) {
    e.strokeStyle = "rgba(0,0,0,0)", e.lineCap = "butt", e.lineJoin = "miter", e.miterLimit = 4;
  }
  setViewBox(e) {
    var {
      document: r,
      ctx: i,
      aspectRatio: n,
      width: a,
      desiredWidth: s,
      height: o,
      desiredHeight: l,
      minX: c = 0,
      minY: u = 0,
      refX: d,
      refY: h,
      clip: f = !1,
      clipX: v = 0,
      clipY: p = 0
    } = e, b = Lr(n).replace(/^defer\s/, ""), [y, x] = b.split(" "), w = y || "xMidYMid", P = x || "meet", O = a / s, A = o / l, I = Math.min(O, A), D = Math.max(O, A), k = s, W = l;
    P === "meet" && (k *= I, W *= I), P === "slice" && (k *= D, W *= D);
    var $ = new j(r, "refX", d), z = new j(r, "refY", h), X = $.hasValue() && z.hasValue();
    if (X && i.translate(-I * $.getPixels("x"), -I * z.getPixels("y")), f) {
      var U = I * v, ie = I * p;
      i.beginPath(), i.moveTo(U, ie), i.lineTo(a, ie), i.lineTo(a, o), i.lineTo(U, o), i.closePath(), i.clip();
    }
    if (!X) {
      var q = P === "meet" && I === A, Y = P === "slice" && D === A, te = P === "meet" && I === O, V = P === "slice" && D === O;
      w.startsWith("xMid") && (q || Y) && i.translate(a / 2 - k / 2, 0), w.endsWith("YMid") && (te || V) && i.translate(0, o / 2 - W / 2), w.startsWith("xMax") && (q || Y) && i.translate(a - k, 0), w.endsWith("YMax") && (te || V) && i.translate(0, o - W);
    }
    switch (!0) {
      case w === "none":
        i.scale(O, A);
        break;
      case P === "meet":
        i.scale(I, I);
        break;
      case P === "slice":
        i.scale(D, D);
        break;
    }
    i.translate(-c, -u);
  }
  start(e) {
    var {
      enableRedraw: r = !1,
      ignoreMouse: i = !1,
      ignoreAnimation: n = !1,
      ignoreDimensions: a = !1,
      ignoreClear: s = !1,
      forceRedraw: o,
      scaleWidth: l,
      scaleHeight: c,
      offsetX: u,
      offsetY: d
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, {
      FRAMERATE: h,
      mouse: f
    } = this, v = 1e3 / h;
    if (this.frameDuration = v, this.readyPromise = new Promise((w) => {
      this.resolveReady = w;
    }), this.isReady() && this.render(e, a, s, l, c, u, d), !!r) {
      var p = Date.now(), b = p, y = 0, x = () => {
        p = Date.now(), y = p - b, y >= v && (b = p - y % v, this.shouldUpdate(n, o) && (this.render(e, a, s, l, c, u, d), f.runEvents())), this.intervalId = oo(x);
      };
      i || f.start(), this.intervalId = oo(x);
    }
  }
  stop() {
    this.intervalId && (oo.cancel(this.intervalId), this.intervalId = null), this.mouse.stop();
  }
  shouldUpdate(e, r) {
    if (!e) {
      var {
        frameDuration: i
      } = this, n = this.animations.reduce((a, s) => s.update(i) || a, !1);
      if (n)
        return !0;
    }
    return !!(typeof r == "function" && r() || !this.isReadyLock && this.isReady() || this.mouse.hasEvents());
  }
  render(e, r, i, n, a, s, o) {
    var {
      CLIENT_WIDTH: l,
      CLIENT_HEIGHT: c,
      viewPort: u,
      ctx: d,
      isFirstRender: h
    } = this, f = d.canvas;
    u.clear(), f.width && f.height ? u.setCurrent(f.width, f.height) : u.setCurrent(l, c);
    var v = e.getStyle("width"), p = e.getStyle("height");
    !r && (h || typeof n != "number" && typeof a != "number") && (v.hasValue() && (f.width = v.getPixels("x"), f.style && (f.style.width = "".concat(f.width, "px"))), p.hasValue() && (f.height = p.getPixels("y"), f.style && (f.style.height = "".concat(f.height, "px"))));
    var b = f.clientWidth || f.width, y = f.clientHeight || f.height;
    if (r && v.hasValue() && p.hasValue() && (b = v.getPixels("x"), y = p.getPixels("y")), u.setCurrent(b, y), typeof s == "number" && e.getAttribute("x", !0).setValue(s), typeof o == "number" && e.getAttribute("y", !0).setValue(o), typeof n == "number" || typeof a == "number") {
      var x = He(e.getAttribute("viewBox").getString()), w = 0, P = 0;
      if (typeof n == "number") {
        var O = e.getStyle("width");
        O.hasValue() ? w = O.getPixels("x") / n : isNaN(x[2]) || (w = x[2] / n);
      }
      if (typeof a == "number") {
        var A = e.getStyle("height");
        A.hasValue() ? P = A.getPixels("y") / a : isNaN(x[3]) || (P = x[3] / a);
      }
      w || (w = P), P || (P = w), e.getAttribute("width", !0).setValue(n), e.getAttribute("height", !0).setValue(a);
      var I = e.getStyle("transform", !0, !0);
      I.setValue("".concat(I.getString(), " scale(").concat(1 / w, ", ").concat(1 / P, ")"));
    }
    i || d.clearRect(0, 0, b, y), e.render(d), h && (this.isFirstRender = !1);
  }
}
pn.defaultWindow = bp;
pn.defaultFetch = xp;
var {
  defaultFetch: PA
} = pn, OA = typeof DOMParser < "u" ? DOMParser : null;
class ia {
  constructor() {
    var {
      fetch: e = PA,
      DOMParser: r = OA
    } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    this.fetch = e, this.DOMParser = r;
  }
  parse(e) {
    var r = this;
    return Ft(function* () {
      return e.startsWith("<") ? r.parseFromString(e) : r.load(e);
    })();
  }
  parseFromString(e) {
    var r = new this.DOMParser();
    try {
      return this.checkDocument(r.parseFromString(e, "image/svg+xml"));
    } catch {
      return this.checkDocument(r.parseFromString(e, "text/xml"));
    }
  }
  checkDocument(e) {
    var r = e.getElementsByTagName("parsererror")[0];
    if (r)
      throw new Error(r.textContent);
    return e;
  }
  load(e) {
    var r = this;
    return Ft(function* () {
      var i = yield r.fetch(e), n = yield i.text();
      return r.parseFromString(n);
    })();
  }
}
class Sp {
  constructor(e, r) {
    this.type = "translate", this.point = null, this.point = pe.parse(r);
  }
  apply(e) {
    var {
      x: r,
      y: i
    } = this.point;
    e.translate(r || 0, i || 0);
  }
  unapply(e) {
    var {
      x: r,
      y: i
    } = this.point;
    e.translate(-1 * r || 0, -1 * i || 0);
  }
  applyToPoint(e) {
    var {
      x: r,
      y: i
    } = this.point;
    e.applyTransform([1, 0, 0, 1, r || 0, i || 0]);
  }
}
class wp {
  constructor(e, r, i) {
    this.type = "rotate", this.angle = null, this.originX = null, this.originY = null, this.cx = 0, this.cy = 0;
    var n = He(r);
    this.angle = new j(e, "angle", n[0]), this.originX = i[0], this.originY = i[1], this.cx = n[1] || 0, this.cy = n[2] || 0;
  }
  apply(e) {
    var {
      cx: r,
      cy: i,
      originX: n,
      originY: a,
      angle: s
    } = this, o = r + n.getPixels("x"), l = i + a.getPixels("y");
    e.translate(o, l), e.rotate(s.getRadians()), e.translate(-o, -l);
  }
  unapply(e) {
    var {
      cx: r,
      cy: i,
      originX: n,
      originY: a,
      angle: s
    } = this, o = r + n.getPixels("x"), l = i + a.getPixels("y");
    e.translate(o, l), e.rotate(-1 * s.getRadians()), e.translate(-o, -l);
  }
  applyToPoint(e) {
    var {
      cx: r,
      cy: i,
      angle: n
    } = this, a = n.getRadians();
    e.applyTransform([
      1,
      0,
      0,
      1,
      r || 0,
      i || 0
      // this.p.y
    ]), e.applyTransform([Math.cos(a), Math.sin(a), -Math.sin(a), Math.cos(a), 0, 0]), e.applyTransform([
      1,
      0,
      0,
      1,
      -r || 0,
      -i || 0
      // -this.p.y
    ]);
  }
}
class Ep {
  constructor(e, r, i) {
    this.type = "scale", this.scale = null, this.originX = null, this.originY = null;
    var n = pe.parseScale(r);
    (n.x === 0 || n.y === 0) && (n.x = xr, n.y = xr), this.scale = n, this.originX = i[0], this.originY = i[1];
  }
  apply(e) {
    var {
      scale: {
        x: r,
        y: i
      },
      originX: n,
      originY: a
    } = this, s = n.getPixels("x"), o = a.getPixels("y");
    e.translate(s, o), e.scale(r, i || r), e.translate(-s, -o);
  }
  unapply(e) {
    var {
      scale: {
        x: r,
        y: i
      },
      originX: n,
      originY: a
    } = this, s = n.getPixels("x"), o = a.getPixels("y");
    e.translate(s, o), e.scale(1 / r, 1 / i || r), e.translate(-s, -o);
  }
  applyToPoint(e) {
    var {
      x: r,
      y: i
    } = this.scale;
    e.applyTransform([r || 0, 0, 0, i || 0, 0, 0]);
  }
}
class _c {
  constructor(e, r, i) {
    this.type = "matrix", this.matrix = [], this.originX = null, this.originY = null, this.matrix = He(r), this.originX = i[0], this.originY = i[1];
  }
  apply(e) {
    var {
      originX: r,
      originY: i,
      matrix: n
    } = this, a = r.getPixels("x"), s = i.getPixels("y");
    e.translate(a, s), e.transform(n[0], n[1], n[2], n[3], n[4], n[5]), e.translate(-a, -s);
  }
  unapply(e) {
    var {
      originX: r,
      originY: i,
      matrix: n
    } = this, a = n[0], s = n[2], o = n[4], l = n[1], c = n[3], u = n[5], d = 0, h = 0, f = 1, v = 1 / (a * (c * f - u * h) - s * (l * f - u * d) + o * (l * h - c * d)), p = r.getPixels("x"), b = i.getPixels("y");
    e.translate(p, b), e.transform(v * (c * f - u * h), v * (u * d - l * f), v * (o * h - s * f), v * (a * f - o * d), v * (s * u - o * c), v * (o * l - a * u)), e.translate(-p, -b);
  }
  applyToPoint(e) {
    e.applyTransform(this.matrix);
  }
}
class Ac extends _c {
  constructor(e, r, i) {
    super(e, r, i), this.type = "skew", this.angle = null, this.angle = new j(e, "angle", r);
  }
}
class Tp extends Ac {
  constructor(e, r, i) {
    super(e, r, i), this.type = "skewX", this.matrix = [1, 0, Math.tan(this.angle.getRadians()), 1, 0, 0];
  }
}
class Pp extends Ac {
  constructor(e, r, i) {
    super(e, r, i), this.type = "skewY", this.matrix = [1, Math.tan(this.angle.getRadians()), 0, 1, 0, 0];
  }
}
function CA(t) {
  return Lr(t).trim().replace(/\)([a-zA-Z])/g, ") $1").replace(/\)(\s?,\s?)/g, ") ").split(/\s(?=[a-z])/);
}
function IA(t) {
  var [e, r] = t.split("(");
  return [e.trim(), r.trim().replace(")", "")];
}
class Zt {
  constructor(e, r, i) {
    this.document = e, this.transforms = [];
    var n = CA(r);
    n.forEach((a) => {
      if (a !== "none") {
        var [s, o] = IA(a), l = Zt.transformTypes[s];
        typeof l < "u" && this.transforms.push(new l(this.document, o, i));
      }
    });
  }
  static fromElement(e, r) {
    var i = r.getStyle("transform", !1, !0), [n, a = n] = r.getStyle("transform-origin", !1, !0).split(), s = [n, a];
    return i.hasValue() ? new Zt(e, i.getString(), s) : null;
  }
  apply(e) {
    for (var {
      transforms: r
    } = this, i = r.length, n = 0; n < i; n++)
      r[n].apply(e);
  }
  unapply(e) {
    for (var {
      transforms: r
    } = this, i = r.length, n = i - 1; n >= 0; n--)
      r[n].unapply(e);
  }
  // TODO: applyToPoint unused ... remove?
  applyToPoint(e) {
    for (var {
      transforms: r
    } = this, i = r.length, n = 0; n < i; n++)
      r[n].applyToPoint(e);
  }
}
Zt.transformTypes = {
  translate: Sp,
  rotate: wp,
  scale: Ep,
  matrix: _c,
  skewX: Tp,
  skewY: Pp
};
let ge = class vl {
  constructor(e, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    if (this.document = e, this.node = r, this.captureTextNodes = i, this.attributes = {}, this.styles = {}, this.stylesSpecificity = {}, this.animationFrozen = !1, this.animationFrozenValue = "", this.parent = null, this.children = [], !(!r || r.nodeType !== 1)) {
      if (Array.from(r.attributes).forEach((o) => {
        var l = gp(o.nodeName);
        this.attributes[l] = new j(e, l, o.value);
      }), this.addStylesFromStyleDefinition(), this.getAttribute("style").hasValue()) {
        var n = this.getAttribute("style").getString().split(";").map((o) => o.trim());
        n.forEach((o) => {
          if (o) {
            var [l, c] = o.split(":").map((u) => u.trim());
            this.styles[l] = new j(e, l, c);
          }
        });
      }
      var {
        definitions: a
      } = e, s = this.getAttribute("id");
      s.hasValue() && (a[s.getString()] || (a[s.getString()] = this)), Array.from(r.childNodes).forEach((o) => {
        if (o.nodeType === 1)
          this.addChild(o);
        else if (i && (o.nodeType === 3 || o.nodeType === 4)) {
          var l = e.createTextNode(o);
          l.getText().length > 0 && this.addChild(l);
        }
      });
    }
  }
  getAttribute(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, i = this.attributes[e];
    if (!i && r) {
      var n = new j(this.document, e, "");
      return this.attributes[e] = n, n;
    }
    return i || j.empty(this.document);
  }
  getHrefAttribute() {
    for (var e in this.attributes)
      if (e === "href" || e.endsWith(":href"))
        return this.attributes[e];
    return j.empty(this.document);
  }
  getStyle(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = this.styles[e];
    if (n)
      return n;
    var a = this.getAttribute(e);
    if (a != null && a.hasValue())
      return this.styles[e] = a, a;
    if (!i) {
      var {
        parent: s
      } = this;
      if (s) {
        var o = s.getStyle(e);
        if (o != null && o.hasValue())
          return o;
      }
    }
    if (r) {
      var l = new j(this.document, e, "");
      return this.styles[e] = l, l;
    }
    return n || j.empty(this.document);
  }
  render(e) {
    if (!(this.getStyle("display").getString() === "none" || this.getStyle("visibility").getString() === "hidden")) {
      if (e.save(), this.getStyle("mask").hasValue()) {
        var r = this.getStyle("mask").getDefinition();
        r && (this.applyEffects(e), r.apply(e, this));
      } else if (this.getStyle("filter").getValue("none") !== "none") {
        var i = this.getStyle("filter").getDefinition();
        i && (this.applyEffects(e), i.apply(e, this));
      } else
        this.setContext(e), this.renderChildren(e), this.clearContext(e);
      e.restore();
    }
  }
  setContext(e) {
  }
  applyEffects(e) {
    var r = Zt.fromElement(this.document, this);
    r && r.apply(e);
    var i = this.getStyle("clip-path", !1, !0);
    if (i.hasValue()) {
      var n = i.getDefinition();
      n && n.apply(e);
    }
  }
  clearContext(e) {
  }
  renderChildren(e) {
    this.children.forEach((r) => {
      r.render(e);
    });
  }
  addChild(e) {
    var r = e instanceof vl ? e : this.document.createElement(e);
    r.parent = this, vl.ignoreChildTypes.includes(r.type) || this.children.push(r);
  }
  matchesSelector(e) {
    var {
      node: r
    } = this;
    if (typeof r.matches == "function")
      return r.matches(e);
    var i = r.getAttribute("class");
    return !i || i === "" ? !1 : i.split(" ").some((n) => ".".concat(n) === e);
  }
  addStylesFromStyleDefinition() {
    var {
      styles: e,
      stylesSpecificity: r
    } = this.document;
    for (var i in e)
      if (!i.startsWith("@") && this.matchesSelector(i)) {
        var n = e[i], a = r[i];
        if (n)
          for (var s in n) {
            var o = this.stylesSpecificity[s];
            typeof o > "u" && (o = "000"), a >= o && (this.styles[s] = n[s], this.stylesSpecificity[s] = a);
          }
      }
  }
  removeStyles(e, r) {
    var i = r.reduce((n, a) => {
      var s = e.getStyle(a);
      if (!s.hasValue())
        return n;
      var o = s.getString();
      return s.setValue(""), [...n, [a, o]];
    }, []);
    return i;
  }
  restoreStyles(e, r) {
    r.forEach((i) => {
      var [n, a] = i;
      e.getStyle(n, !0).setValue(a);
    });
  }
};
ge.ignoreChildTypes = ["title"];
class Op extends ge {
  constructor(e, r, i) {
    super(e, r, i);
  }
}
function _A(t) {
  var e = t.trim();
  return /^('|")/.test(e) ? e : '"'.concat(e, '"');
}
function AA(t) {
  return typeof process > "u" ? t : t.trim().split(",").map(_A).join(",");
}
function RA(t) {
  if (!t)
    return "";
  var e = t.trim().toLowerCase();
  switch (e) {
    case "normal":
    case "italic":
    case "oblique":
    case "inherit":
    case "initial":
    case "unset":
      return e;
    default:
      return /^oblique\s+(-|)\d+deg$/.test(e) ? e : "";
  }
}
function MA(t) {
  if (!t)
    return "";
  var e = t.trim().toLowerCase();
  switch (e) {
    case "normal":
    case "bold":
    case "lighter":
    case "bolder":
    case "inherit":
    case "initial":
    case "unset":
      return e;
    default:
      return /^[\d.]+$/.test(e) ? e : "";
  }
}
class ke {
  constructor(e, r, i, n, a, s) {
    var o = s ? typeof s == "string" ? ke.parse(s) : s : {};
    this.fontFamily = a || o.fontFamily, this.fontSize = n || o.fontSize, this.fontStyle = e || o.fontStyle, this.fontWeight = i || o.fontWeight, this.fontVariant = r || o.fontVariant;
  }
  static parse() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", r = arguments.length > 1 ? arguments[1] : void 0, i = "", n = "", a = "", s = "", o = "", l = Lr(e).trim().split(" "), c = {
      fontSize: !1,
      fontStyle: !1,
      fontWeight: !1,
      fontVariant: !1
    };
    return l.forEach((u) => {
      switch (!0) {
        case (!c.fontStyle && ke.styles.includes(u)):
          u !== "inherit" && (i = u), c.fontStyle = !0;
          break;
        case (!c.fontVariant && ke.variants.includes(u)):
          u !== "inherit" && (n = u), c.fontStyle = !0, c.fontVariant = !0;
          break;
        case (!c.fontWeight && ke.weights.includes(u)):
          u !== "inherit" && (a = u), c.fontStyle = !0, c.fontVariant = !0, c.fontWeight = !0;
          break;
        case !c.fontSize:
          u !== "inherit" && ([s] = u.split("/")), c.fontStyle = !0, c.fontVariant = !0, c.fontWeight = !0, c.fontSize = !0;
          break;
        default:
          u !== "inherit" && (o += u);
      }
    }), new ke(i, n, a, s, o, r);
  }
  toString() {
    return [
      RA(this.fontStyle),
      this.fontVariant,
      MA(this.fontWeight),
      this.fontSize,
      // Wrap fontFamily only on nodejs and only for canvas.ctx
      AA(this.fontFamily)
    ].join(" ").trim();
  }
}
ke.styles = "normal|italic|oblique|inherit";
ke.variants = "normal|small-caps|inherit";
ke.weights = "normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900|inherit";
class at {
  constructor() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Number.NaN, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Number.NaN, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Number.NaN, n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : Number.NaN;
    this.x1 = e, this.y1 = r, this.x2 = i, this.y2 = n, this.addPoint(e, r), this.addPoint(i, n);
  }
  get x() {
    return this.x1;
  }
  get y() {
    return this.y1;
  }
  get width() {
    return this.x2 - this.x1;
  }
  get height() {
    return this.y2 - this.y1;
  }
  addPoint(e, r) {
    typeof e < "u" && ((isNaN(this.x1) || isNaN(this.x2)) && (this.x1 = e, this.x2 = e), e < this.x1 && (this.x1 = e), e > this.x2 && (this.x2 = e)), typeof r < "u" && ((isNaN(this.y1) || isNaN(this.y2)) && (this.y1 = r, this.y2 = r), r < this.y1 && (this.y1 = r), r > this.y2 && (this.y2 = r));
  }
  addX(e) {
    this.addPoint(e, null);
  }
  addY(e) {
    this.addPoint(null, e);
  }
  addBoundingBox(e) {
    if (e) {
      var {
        x1: r,
        y1: i,
        x2: n,
        y2: a
      } = e;
      this.addPoint(r, i), this.addPoint(n, a);
    }
  }
  sumCubic(e, r, i, n, a) {
    return Math.pow(1 - e, 3) * r + 3 * Math.pow(1 - e, 2) * e * i + 3 * (1 - e) * Math.pow(e, 2) * n + Math.pow(e, 3) * a;
  }
  bezierCurveAdd(e, r, i, n, a) {
    var s = 6 * r - 12 * i + 6 * n, o = -3 * r + 9 * i - 9 * n + 3 * a, l = 3 * i - 3 * r;
    if (o === 0) {
      if (s === 0)
        return;
      var c = -l / s;
      0 < c && c < 1 && (e ? this.addX(this.sumCubic(c, r, i, n, a)) : this.addY(this.sumCubic(c, r, i, n, a)));
      return;
    }
    var u = Math.pow(s, 2) - 4 * l * o;
    if (!(u < 0)) {
      var d = (-s + Math.sqrt(u)) / (2 * o);
      0 < d && d < 1 && (e ? this.addX(this.sumCubic(d, r, i, n, a)) : this.addY(this.sumCubic(d, r, i, n, a)));
      var h = (-s - Math.sqrt(u)) / (2 * o);
      0 < h && h < 1 && (e ? this.addX(this.sumCubic(h, r, i, n, a)) : this.addY(this.sumCubic(h, r, i, n, a)));
    }
  }
  // from http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
  addBezierCurve(e, r, i, n, a, s, o, l) {
    this.addPoint(e, r), this.addPoint(o, l), this.bezierCurveAdd(!0, e, i, a, o), this.bezierCurveAdd(!1, r, n, s, l);
  }
  addQuadraticCurve(e, r, i, n, a, s) {
    var o = e + 0.6666666666666666 * (i - e), l = r + 2 / 3 * (n - r), c = o + 1 / 3 * (a - e), u = l + 1 / 3 * (s - r);
    this.addBezierCurve(e, r, o, c, l, u, a, s);
  }
  isPointInBox(e, r) {
    var {
      x1: i,
      y1: n,
      x2: a,
      y2: s
    } = this;
    return i <= e && e <= a && n <= r && r <= s;
  }
}
class B extends C {
  constructor(e) {
    super(e.replace(/([+\-.])\s+/gm, "$1").replace(/[^MmZzLlHhVvCcSsQqTtAae\d\s.,+-].*/g, "")), this.control = null, this.start = null, this.current = null, this.command = null, this.commands = this.commands, this.i = -1, this.previousCommand = null, this.points = [], this.angles = [];
  }
  reset() {
    this.i = -1, this.command = null, this.previousCommand = null, this.start = new pe(0, 0), this.control = new pe(0, 0), this.current = new pe(0, 0), this.points = [], this.angles = [];
  }
  isEnd() {
    var {
      i: e,
      commands: r
    } = this;
    return e >= r.length - 1;
  }
  next() {
    var e = this.commands[++this.i];
    return this.previousCommand = this.command, this.command = e, e;
  }
  getPoint() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "x", r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "y", i = new pe(this.command[e], this.command[r]);
    return this.makeAbsolute(i);
  }
  getAsControlPoint(e, r) {
    var i = this.getPoint(e, r);
    return this.control = i, i;
  }
  getAsCurrentPoint(e, r) {
    var i = this.getPoint(e, r);
    return this.current = i, i;
  }
  getReflectedControlPoint() {
    var e = this.previousCommand.type;
    if (e !== C.CURVE_TO && e !== C.SMOOTH_CURVE_TO && e !== C.QUAD_TO && e !== C.SMOOTH_QUAD_TO)
      return this.current;
    var {
      current: {
        x: r,
        y: i
      },
      control: {
        x: n,
        y: a
      }
    } = this, s = new pe(2 * r - n, 2 * i - a);
    return s;
  }
  makeAbsolute(e) {
    if (this.command.relative) {
      var {
        x: r,
        y: i
      } = this.current;
      e.x += r, e.y += i;
    }
    return e;
  }
  addMarker(e, r, i) {
    var {
      points: n,
      angles: a
    } = this;
    i && a.length > 0 && !a[a.length - 1] && (a[a.length - 1] = n[n.length - 1].angleTo(i)), this.addMarkerAngle(e, r ? r.angleTo(e) : null);
  }
  addMarkerAngle(e, r) {
    this.points.push(e), this.angles.push(r);
  }
  getMarkerPoints() {
    return this.points;
  }
  getMarkerAngles() {
    for (var {
      angles: e
    } = this, r = e.length, i = 0; i < r; i++)
      if (!e[i]) {
        for (var n = i + 1; n < r; n++)
          if (e[n]) {
            e[i] = e[n];
            break;
          }
      }
    return e;
  }
}
class rr extends ge {
  constructor() {
    super(...arguments), this.modifiedEmSizeStack = !1;
  }
  calculateOpacity() {
    for (var e = 1, r = this; r; ) {
      var i = r.getStyle("opacity", !1, !0);
      i.hasValue(!0) && (e *= i.getNumber()), r = r.parent;
    }
    return e;
  }
  setContext(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    if (!r) {
      var i = this.getStyle("fill"), n = this.getStyle("fill-opacity"), a = this.getStyle("stroke"), s = this.getStyle("stroke-opacity");
      if (i.isUrlDefinition()) {
        var o = i.getFillStyleDefinition(this, n);
        o && (e.fillStyle = o);
      } else if (i.hasValue()) {
        i.getString() === "currentColor" && i.setValue(this.getStyle("color").getColor());
        var l = i.getColor();
        l !== "inherit" && (e.fillStyle = l === "none" ? "rgba(0,0,0,0)" : l);
      }
      if (n.hasValue()) {
        var c = new j(this.document, "fill", e.fillStyle).addOpacity(n).getColor();
        e.fillStyle = c;
      }
      if (a.isUrlDefinition()) {
        var u = a.getFillStyleDefinition(this, s);
        u && (e.strokeStyle = u);
      } else if (a.hasValue()) {
        a.getString() === "currentColor" && a.setValue(this.getStyle("color").getColor());
        var d = a.getString();
        d !== "inherit" && (e.strokeStyle = d === "none" ? "rgba(0,0,0,0)" : d);
      }
      if (s.hasValue()) {
        var h = new j(this.document, "stroke", e.strokeStyle).addOpacity(s).getString();
        e.strokeStyle = h;
      }
      var f = this.getStyle("stroke-width");
      if (f.hasValue()) {
        var v = f.getPixels();
        e.lineWidth = v || xr;
      }
      var p = this.getStyle("stroke-linecap"), b = this.getStyle("stroke-linejoin"), y = this.getStyle("stroke-miterlimit"), x = this.getStyle("stroke-dasharray"), w = this.getStyle("stroke-dashoffset");
      if (p.hasValue() && (e.lineCap = p.getString()), b.hasValue() && (e.lineJoin = b.getString()), y.hasValue() && (e.miterLimit = y.getNumber()), x.hasValue() && x.getString() !== "none") {
        var P = He(x.getString());
        typeof e.setLineDash < "u" ? e.setLineDash(P) : typeof e.webkitLineDash < "u" ? e.webkitLineDash = P : typeof e.mozDash < "u" && !(P.length === 1 && P[0] === 0) && (e.mozDash = P);
        var O = w.getPixels();
        typeof e.lineDashOffset < "u" ? e.lineDashOffset = O : typeof e.webkitLineDashOffset < "u" ? e.webkitLineDashOffset = O : typeof e.mozDashOffset < "u" && (e.mozDashOffset = O);
      }
    }
    if (this.modifiedEmSizeStack = !1, typeof e.font < "u") {
      var A = this.getStyle("font"), I = this.getStyle("font-style"), D = this.getStyle("font-variant"), k = this.getStyle("font-weight"), W = this.getStyle("font-size"), $ = this.getStyle("font-family"), z = new ke(I.getString(), D.getString(), k.getString(), W.hasValue() ? "".concat(W.getPixels(!0), "px") : "", $.getString(), ke.parse(A.getString(), e.font));
      I.setValue(z.fontStyle), D.setValue(z.fontVariant), k.setValue(z.fontWeight), W.setValue(z.fontSize), $.setValue(z.fontFamily), e.font = z.toString(), W.isPixels() && (this.document.emSize = W.getPixels(), this.modifiedEmSizeStack = !0);
    }
    r || (this.applyEffects(e), e.globalAlpha = this.calculateOpacity());
  }
  clearContext(e) {
    super.clearContext(e), this.modifiedEmSizeStack && this.document.popEmSize();
  }
}
class ee extends rr {
  constructor(e, r, i) {
    super(e, r, i), this.type = "path", this.pathParser = null, this.pathParser = new B(this.getAttribute("d").getString());
  }
  path(e) {
    var {
      pathParser: r
    } = this, i = new at();
    for (r.reset(), e && e.beginPath(); !r.isEnd(); )
      switch (r.next().type) {
        case B.MOVE_TO:
          this.pathM(e, i);
          break;
        case B.LINE_TO:
          this.pathL(e, i);
          break;
        case B.HORIZ_LINE_TO:
          this.pathH(e, i);
          break;
        case B.VERT_LINE_TO:
          this.pathV(e, i);
          break;
        case B.CURVE_TO:
          this.pathC(e, i);
          break;
        case B.SMOOTH_CURVE_TO:
          this.pathS(e, i);
          break;
        case B.QUAD_TO:
          this.pathQ(e, i);
          break;
        case B.SMOOTH_QUAD_TO:
          this.pathT(e, i);
          break;
        case B.ARC:
          this.pathA(e, i);
          break;
        case B.CLOSE_PATH:
          this.pathZ(e, i);
          break;
      }
    return i;
  }
  getBoundingBox(e) {
    return this.path();
  }
  getMarkers() {
    var {
      pathParser: e
    } = this, r = e.getMarkerPoints(), i = e.getMarkerAngles(), n = r.map((a, s) => [a, i[s]]);
    return n;
  }
  renderChildren(e) {
    this.path(e), this.document.screen.mouse.checkPath(this, e);
    var r = this.getStyle("fill-rule");
    e.fillStyle !== "" && (r.getString("inherit") !== "inherit" ? e.fill(r.getString()) : e.fill()), e.strokeStyle !== "" && (this.getAttribute("vector-effect").getString() === "non-scaling-stroke" ? (e.save(), e.setTransform(1, 0, 0, 1, 0, 0), e.stroke(), e.restore()) : e.stroke());
    var i = this.getMarkers();
    if (i) {
      var n = i.length - 1, a = this.getStyle("marker-start"), s = this.getStyle("marker-mid"), o = this.getStyle("marker-end");
      if (a.isUrlDefinition()) {
        var l = a.getDefinition(), [c, u] = i[0];
        l.render(e, c, u);
      }
      if (s.isUrlDefinition())
        for (var d = s.getDefinition(), h = 1; h < n; h++) {
          var [f, v] = i[h];
          d.render(e, f, v);
        }
      if (o.isUrlDefinition()) {
        var p = o.getDefinition(), [b, y] = i[n];
        p.render(e, b, y);
      }
    }
  }
  static pathM(e) {
    var r = e.getAsCurrentPoint();
    return e.start = e.current, {
      point: r
    };
  }
  pathM(e, r) {
    var {
      pathParser: i
    } = this, {
      point: n
    } = ee.pathM(i), {
      x: a,
      y: s
    } = n;
    i.addMarker(n), r.addPoint(a, s), e && e.moveTo(a, s);
  }
  static pathL(e) {
    var {
      current: r
    } = e, i = e.getAsCurrentPoint();
    return {
      current: r,
      point: i
    };
  }
  pathL(e, r) {
    var {
      pathParser: i
    } = this, {
      current: n,
      point: a
    } = ee.pathL(i), {
      x: s,
      y: o
    } = a;
    i.addMarker(a, n), r.addPoint(s, o), e && e.lineTo(s, o);
  }
  static pathH(e) {
    var {
      current: r,
      command: i
    } = e, n = new pe((i.relative ? r.x : 0) + i.x, r.y);
    return e.current = n, {
      current: r,
      point: n
    };
  }
  pathH(e, r) {
    var {
      pathParser: i
    } = this, {
      current: n,
      point: a
    } = ee.pathH(i), {
      x: s,
      y: o
    } = a;
    i.addMarker(a, n), r.addPoint(s, o), e && e.lineTo(s, o);
  }
  static pathV(e) {
    var {
      current: r,
      command: i
    } = e, n = new pe(r.x, (i.relative ? r.y : 0) + i.y);
    return e.current = n, {
      current: r,
      point: n
    };
  }
  pathV(e, r) {
    var {
      pathParser: i
    } = this, {
      current: n,
      point: a
    } = ee.pathV(i), {
      x: s,
      y: o
    } = a;
    i.addMarker(a, n), r.addPoint(s, o), e && e.lineTo(s, o);
  }
  static pathC(e) {
    var {
      current: r
    } = e, i = e.getPoint("x1", "y1"), n = e.getAsControlPoint("x2", "y2"), a = e.getAsCurrentPoint();
    return {
      current: r,
      point: i,
      controlPoint: n,
      currentPoint: a
    };
  }
  pathC(e, r) {
    var {
      pathParser: i
    } = this, {
      current: n,
      point: a,
      controlPoint: s,
      currentPoint: o
    } = ee.pathC(i);
    i.addMarker(o, s, a), r.addBezierCurve(n.x, n.y, a.x, a.y, s.x, s.y, o.x, o.y), e && e.bezierCurveTo(a.x, a.y, s.x, s.y, o.x, o.y);
  }
  static pathS(e) {
    var {
      current: r
    } = e, i = e.getReflectedControlPoint(), n = e.getAsControlPoint("x2", "y2"), a = e.getAsCurrentPoint();
    return {
      current: r,
      point: i,
      controlPoint: n,
      currentPoint: a
    };
  }
  pathS(e, r) {
    var {
      pathParser: i
    } = this, {
      current: n,
      point: a,
      controlPoint: s,
      currentPoint: o
    } = ee.pathS(i);
    i.addMarker(o, s, a), r.addBezierCurve(n.x, n.y, a.x, a.y, s.x, s.y, o.x, o.y), e && e.bezierCurveTo(a.x, a.y, s.x, s.y, o.x, o.y);
  }
  static pathQ(e) {
    var {
      current: r
    } = e, i = e.getAsControlPoint("x1", "y1"), n = e.getAsCurrentPoint();
    return {
      current: r,
      controlPoint: i,
      currentPoint: n
    };
  }
  pathQ(e, r) {
    var {
      pathParser: i
    } = this, {
      current: n,
      controlPoint: a,
      currentPoint: s
    } = ee.pathQ(i);
    i.addMarker(s, a, a), r.addQuadraticCurve(n.x, n.y, a.x, a.y, s.x, s.y), e && e.quadraticCurveTo(a.x, a.y, s.x, s.y);
  }
  static pathT(e) {
    var {
      current: r
    } = e, i = e.getReflectedControlPoint();
    e.control = i;
    var n = e.getAsCurrentPoint();
    return {
      current: r,
      controlPoint: i,
      currentPoint: n
    };
  }
  pathT(e, r) {
    var {
      pathParser: i
    } = this, {
      current: n,
      controlPoint: a,
      currentPoint: s
    } = ee.pathT(i);
    i.addMarker(s, a, a), r.addQuadraticCurve(n.x, n.y, a.x, a.y, s.x, s.y), e && e.quadraticCurveTo(a.x, a.y, s.x, s.y);
  }
  static pathA(e) {
    var {
      current: r,
      command: i
    } = e, {
      rX: n,
      rY: a,
      xRot: s,
      lArcFlag: o,
      sweepFlag: l
    } = i, c = s * (Math.PI / 180), u = e.getAsCurrentPoint(), d = new pe(Math.cos(c) * (r.x - u.x) / 2 + Math.sin(c) * (r.y - u.y) / 2, -Math.sin(c) * (r.x - u.x) / 2 + Math.cos(c) * (r.y - u.y) / 2), h = Math.pow(d.x, 2) / Math.pow(n, 2) + Math.pow(d.y, 2) / Math.pow(a, 2);
    h > 1 && (n *= Math.sqrt(h), a *= Math.sqrt(h));
    var f = (o === l ? -1 : 1) * Math.sqrt((Math.pow(n, 2) * Math.pow(a, 2) - Math.pow(n, 2) * Math.pow(d.y, 2) - Math.pow(a, 2) * Math.pow(d.x, 2)) / (Math.pow(n, 2) * Math.pow(d.y, 2) + Math.pow(a, 2) * Math.pow(d.x, 2)));
    isNaN(f) && (f = 0);
    var v = new pe(f * n * d.y / a, f * -a * d.x / n), p = new pe((r.x + u.x) / 2 + Math.cos(c) * v.x - Math.sin(c) * v.y, (r.y + u.y) / 2 + Math.sin(c) * v.x + Math.cos(c) * v.y), b = cl([1, 0], [(d.x - v.x) / n, (d.y - v.y) / a]), y = [(d.x - v.x) / n, (d.y - v.y) / a], x = [(-d.x - v.x) / n, (-d.y - v.y) / a], w = cl(y, x);
    return Pa(y, x) <= -1 && (w = Math.PI), Pa(y, x) >= 1 && (w = 0), {
      currentPoint: u,
      rX: n,
      rY: a,
      sweepFlag: l,
      xAxisRotation: c,
      centp: p,
      a1: b,
      ad: w
    };
  }
  pathA(e, r) {
    var {
      pathParser: i
    } = this, {
      currentPoint: n,
      rX: a,
      rY: s,
      sweepFlag: o,
      xAxisRotation: l,
      centp: c,
      a1: u,
      ad: d
    } = ee.pathA(i), h = 1 - o ? 1 : -1, f = u + h * (d / 2), v = new pe(c.x + a * Math.cos(f), c.y + s * Math.sin(f));
    if (i.addMarkerAngle(v, f - h * Math.PI / 2), i.addMarkerAngle(n, f - h * Math.PI), r.addPoint(n.x, n.y), e && !isNaN(u) && !isNaN(d)) {
      var p = a > s ? a : s, b = a > s ? 1 : a / s, y = a > s ? s / a : 1;
      e.translate(c.x, c.y), e.rotate(l), e.scale(b, y), e.arc(0, 0, p, u, u + d, !!(1 - o)), e.scale(1 / b, 1 / y), e.rotate(-l), e.translate(-c.x, -c.y);
    }
  }
  static pathZ(e) {
    e.current = e.start;
  }
  pathZ(e, r) {
    ee.pathZ(this.pathParser), e && r.x1 !== r.x2 && r.y1 !== r.y2 && e.closePath();
  }
}
class Rc extends ee {
  constructor(e, r, i) {
    super(e, r, i), this.type = "glyph", this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber(), this.unicode = this.getAttribute("unicode").getString(), this.arabicForm = this.getAttribute("arabic-form").getString();
  }
}
class ir extends rr {
  constructor(e, r, i) {
    super(e, r, new.target === ir ? !0 : i), this.type = "text", this.x = 0, this.y = 0, this.measureCache = -1;
  }
  setContext(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
    super.setContext(e, r);
    var i = this.getStyle("dominant-baseline").getTextBaseline() || this.getStyle("alignment-baseline").getTextBaseline();
    i && (e.textBaseline = i);
  }
  initializeCoordinates(e) {
    this.x = this.getAttribute("x").getPixels("x"), this.y = this.getAttribute("y").getPixels("y");
    var r = this.getAttribute("dx"), i = this.getAttribute("dy");
    r.hasValue() && (this.x += r.getPixels("x")), i.hasValue() && (this.y += i.getPixels("y")), this.x += this.getAnchorDelta(e, this, 0);
  }
  getBoundingBox(e) {
    if (this.type !== "text")
      return this.getTElementBoundingBox(e);
    this.initializeCoordinates(e);
    var r = null;
    return this.children.forEach((i, n) => {
      var a = this.getChildBoundingBox(e, this, this, n);
      r ? r.addBoundingBox(a) : r = a;
    }), r;
  }
  getFontSize() {
    var {
      document: e,
      parent: r
    } = this, i = ke.parse(e.ctx.font).fontSize, n = r.getStyle("font-size").getNumber(i);
    return n;
  }
  getTElementBoundingBox(e) {
    var r = this.getFontSize();
    return new at(this.x, this.y - r, this.x + this.measureText(e), this.y);
  }
  getGlyph(e, r, i) {
    var n = r[i], a = null;
    if (e.isArabic) {
      var s = r.length, o = r[i - 1], l = r[i + 1], c = "isolated";
      if ((i === 0 || o === " ") && i < s - 2 && l !== " " && (c = "terminal"), i > 0 && o !== " " && i < s - 2 && l !== " " && (c = "medial"), i > 0 && o !== " " && (i === s - 1 || l === " ") && (c = "initial"), typeof e.glyphs[n] < "u") {
        var u = e.glyphs[n];
        a = u instanceof Rc ? u : u[c];
      }
    } else
      a = e.glyphs[n];
    return a || (a = e.missingGlyph), a;
  }
  getText() {
    return "";
  }
  getTextFromNode(e) {
    var r = e || this.node, i = Array.from(r.parentNode.childNodes), n = i.indexOf(r), a = i.length - 1, s = Lr(
      // textNode.value
      // || textNode.text
      r.textContent || ""
    );
    return n === 0 && (s = hp(s)), n === a && (s = fp(s)), s;
  }
  renderChildren(e) {
    if (this.type !== "text") {
      this.renderTElementChildren(e);
      return;
    }
    this.initializeCoordinates(e), this.children.forEach((i, n) => {
      this.renderChild(e, this, this, n);
    });
    var {
      mouse: r
    } = this.document.screen;
    r.isWorking() && r.checkBoundingBox(this, this.getBoundingBox(e));
  }
  renderTElementChildren(e) {
    var {
      document: r,
      parent: i
    } = this, n = this.getText(), a = i.getStyle("font-family").getDefinition();
    if (a) {
      for (var {
        unitsPerEm: s
      } = a.fontFace, o = ke.parse(r.ctx.font), l = i.getStyle("font-size").getNumber(o.fontSize), c = i.getStyle("font-style").getString(o.fontStyle), u = l / s, d = a.isRTL ? n.split("").reverse().join("") : n, h = He(i.getAttribute("dx").getString()), f = d.length, v = 0; v < f; v++) {
        var p = this.getGlyph(a, d, v);
        e.translate(this.x, this.y), e.scale(u, -u);
        var b = e.lineWidth;
        e.lineWidth = e.lineWidth * s / l, c === "italic" && e.transform(1, 0, 0.4, 1, 0, 0), p.render(e), c === "italic" && e.transform(1, 0, -0.4, 1, 0, 0), e.lineWidth = b, e.scale(1 / u, -1 / u), e.translate(-this.x, -this.y), this.x += l * (p.horizAdvX || a.horizAdvX) / s, typeof h[v] < "u" && !isNaN(h[v]) && (this.x += h[v]);
      }
      return;
    }
    var {
      x: y,
      y: x
    } = this;
    e.fillStyle && e.fillText(n, y, x), e.strokeStyle && e.strokeText(n, y, x);
  }
  getAnchorDelta(e, r, i) {
    var n = this.getStyle("text-anchor").getString("start");
    if (n !== "start") {
      for (var {
        children: a
      } = r, s = a.length, o = null, l = 0, c = i; c < s && (o = a[c], !(c > i && o.getAttribute("x").hasValue() || o.getAttribute("text-anchor").hasValue())); c++)
        l += o.measureTextRecursive(e);
      return -1 * (n === "end" ? l : l / 2);
    }
    return 0;
  }
  adjustChildCoordinates(e, r, i, n) {
    var a = i.children[n];
    if (typeof a.measureText != "function")
      return a;
    e.save(), a.setContext(e, !0);
    var s = a.getAttribute("x"), o = a.getAttribute("y"), l = a.getAttribute("dx"), c = a.getAttribute("dy"), u = a.getAttribute("text-anchor").getString("start");
    if (n === 0 && a.type !== "textNode" && (s.hasValue() || s.setValue(r.getAttribute("x").getValue("0")), o.hasValue() || o.setValue(r.getAttribute("y").getValue("0")), l.hasValue() || l.setValue(r.getAttribute("dx").getValue("0")), c.hasValue() || c.setValue(r.getAttribute("dy").getValue("0"))), s.hasValue()) {
      if (a.x = s.getPixels("x") + r.getAnchorDelta(e, i, n), u !== "start") {
        var d = a.measureTextRecursive(e);
        a.x += -1 * (u === "end" ? d : d / 2);
      }
      l.hasValue() && (a.x += l.getPixels("x"));
    } else {
      if (u !== "start") {
        var h = a.measureTextRecursive(e);
        r.x += -1 * (u === "end" ? h : h / 2);
      }
      l.hasValue() && (r.x += l.getPixels("x")), a.x = r.x;
    }
    return r.x = a.x + a.measureText(e), o.hasValue() ? (a.y = o.getPixels("y"), c.hasValue() && (a.y += c.getPixels("y"))) : (c.hasValue() && (r.y += c.getPixels("y")), a.y = r.y), r.y = a.y, a.clearContext(e), e.restore(), a;
  }
  getChildBoundingBox(e, r, i, n) {
    var a = this.adjustChildCoordinates(e, r, i, n);
    if (typeof a.getBoundingBox != "function")
      return null;
    var s = a.getBoundingBox(e);
    return s ? (a.children.forEach((o, l) => {
      var c = r.getChildBoundingBox(e, r, a, l);
      s.addBoundingBox(c);
    }), s) : null;
  }
  renderChild(e, r, i, n) {
    var a = this.adjustChildCoordinates(e, r, i, n);
    a.render(e), a.children.forEach((s, o) => {
      r.renderChild(e, r, a, o);
    });
  }
  measureTextRecursive(e) {
    var r = this.children.reduce((i, n) => i + n.measureTextRecursive(e), this.measureText(e));
    return r;
  }
  measureText(e) {
    var {
      measureCache: r
    } = this;
    if (~r)
      return r;
    var i = this.getText(), n = this.measureTargetText(e, i);
    return this.measureCache = n, n;
  }
  measureTargetText(e, r) {
    if (!r.length)
      return 0;
    var {
      parent: i
    } = this, n = i.getStyle("font-family").getDefinition();
    if (n) {
      for (var a = this.getFontSize(), s = n.isRTL ? r.split("").reverse().join("") : r, o = He(i.getAttribute("dx").getString()), l = s.length, c = 0, u = 0; u < l; u++) {
        var d = this.getGlyph(n, s, u);
        c += (d.horizAdvX || n.horizAdvX) * a / n.fontFace.unitsPerEm, typeof o[u] < "u" && !isNaN(o[u]) && (c += o[u]);
      }
      return c;
    }
    if (!e.measureText)
      return r.length * 10;
    e.save(), this.setContext(e, !0);
    var {
      width: h
    } = e.measureText(r);
    return this.clearContext(e), e.restore(), h;
  }
}
class mn extends ir {
  constructor(e, r, i) {
    super(e, r, new.target === mn ? !0 : i), this.type = "tspan", this.text = this.children.length > 0 ? "" : this.getTextFromNode();
  }
  getText() {
    return this.text;
  }
}
class LA extends mn {
  constructor() {
    super(...arguments), this.type = "textNode";
  }
}
class Oi extends rr {
  constructor() {
    super(...arguments), this.type = "svg", this.root = !1;
  }
  setContext(e) {
    var r, {
      document: i
    } = this, {
      screen: n,
      window: a
    } = i, s = e.canvas;
    if (n.setDefaults(e), s.style && typeof e.font < "u" && a && typeof a.getComputedStyle < "u") {
      e.font = a.getComputedStyle(s).getPropertyValue("font");
      var o = new j(i, "fontSize", ke.parse(e.font).fontSize);
      o.hasValue() && (i.rootEmSize = o.getPixels("y"), i.emSize = i.rootEmSize);
    }
    this.getAttribute("x").hasValue() || this.getAttribute("x", !0).setValue(0), this.getAttribute("y").hasValue() || this.getAttribute("y", !0).setValue(0);
    var {
      width: l,
      height: c
    } = n.viewPort;
    this.getStyle("width").hasValue() || this.getStyle("width", !0).setValue("100%"), this.getStyle("height").hasValue() || this.getStyle("height", !0).setValue("100%"), this.getStyle("color").hasValue() || this.getStyle("color", !0).setValue("black");
    var u = this.getAttribute("refX"), d = this.getAttribute("refY"), h = this.getAttribute("viewBox"), f = h.hasValue() ? He(h.getString()) : null, v = !this.root && this.getStyle("overflow").getValue("hidden") !== "visible", p = 0, b = 0, y = 0, x = 0;
    f && (p = f[0], b = f[1]), this.root || (l = this.getStyle("width").getPixels("x"), c = this.getStyle("height").getPixels("y"), this.type === "marker" && (y = p, x = b, p = 0, b = 0)), n.viewPort.setCurrent(l, c), this.node && (!this.parent || ((r = this.node.parentNode) === null || r === void 0 ? void 0 : r.nodeName) === "foreignObject") && this.getStyle("transform", !1, !0).hasValue() && !this.getStyle("transform-origin", !1, !0).hasValue() && this.getStyle("transform-origin", !0, !0).setValue("50% 50%"), super.setContext(e), e.translate(this.getAttribute("x").getPixels("x"), this.getAttribute("y").getPixels("y")), f && (l = f[2], c = f[3]), i.setViewBox({
      ctx: e,
      aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
      width: n.viewPort.width,
      desiredWidth: l,
      height: n.viewPort.height,
      desiredHeight: c,
      minX: p,
      minY: b,
      refX: u.getValue(),
      refY: d.getValue(),
      clip: v,
      clipX: y,
      clipY: x
    }), f && (n.viewPort.removeCurrent(), n.viewPort.setCurrent(l, c));
  }
  clearContext(e) {
    super.clearContext(e), this.document.screen.viewPort.removeCurrent();
  }
  /**
   * Resize SVG to fit in given size.
   * @param width
   * @param height
   * @param preserveAspectRatio
   */
  resize(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, n = this.getAttribute("width", !0), a = this.getAttribute("height", !0), s = this.getAttribute("viewBox"), o = this.getAttribute("style"), l = n.getNumber(0), c = a.getNumber(0);
    if (i)
      if (typeof i == "string")
        this.getAttribute("preserveAspectRatio", !0).setValue(i);
      else {
        var u = this.getAttribute("preserveAspectRatio");
        u.hasValue() && u.setValue(u.getString().replace(/^\s*(\S.*\S)\s*$/, "$1"));
      }
    if (n.setValue(e), a.setValue(r), s.hasValue() || s.setValue("0 0 ".concat(l || e, " ").concat(c || r)), o.hasValue()) {
      var d = this.getStyle("width"), h = this.getStyle("height");
      d.hasValue() && d.setValue("".concat(e, "px")), h.hasValue() && h.setValue("".concat(r, "px"));
    }
  }
}
class Mc extends ee {
  constructor() {
    super(...arguments), this.type = "rect";
  }
  path(e) {
    var r = this.getAttribute("x").getPixels("x"), i = this.getAttribute("y").getPixels("y"), n = this.getStyle("width", !1, !0).getPixels("x"), a = this.getStyle("height", !1, !0).getPixels("y"), s = this.getAttribute("rx"), o = this.getAttribute("ry"), l = s.getPixels("x"), c = o.getPixels("y");
    if (s.hasValue() && !o.hasValue() && (c = l), o.hasValue() && !s.hasValue() && (l = c), l = Math.min(l, n / 2), c = Math.min(c, a / 2), e) {
      var u = 4 * ((Math.sqrt(2) - 1) / 3);
      e.beginPath(), a > 0 && n > 0 && (e.moveTo(r + l, i), e.lineTo(r + n - l, i), e.bezierCurveTo(r + n - l + u * l, i, r + n, i + c - u * c, r + n, i + c), e.lineTo(r + n, i + a - c), e.bezierCurveTo(r + n, i + a - c + u * c, r + n - l + u * l, i + a, r + n - l, i + a), e.lineTo(r + l, i + a), e.bezierCurveTo(r + l - u * l, i + a, r, i + a - c + u * c, r, i + a - c), e.lineTo(r, i + c), e.bezierCurveTo(r, i + c - u * c, r + l - u * l, i, r + l, i), e.closePath());
    }
    return new at(r, i, r + n, i + a);
  }
  getMarkers() {
    return null;
  }
}
class Cp extends ee {
  constructor() {
    super(...arguments), this.type = "circle";
  }
  path(e) {
    var r = this.getAttribute("cx").getPixels("x"), i = this.getAttribute("cy").getPixels("y"), n = this.getAttribute("r").getPixels();
    return e && n > 0 && (e.beginPath(), e.arc(r, i, n, 0, Math.PI * 2, !1), e.closePath()), new at(r - n, i - n, r + n, i + n);
  }
  getMarkers() {
    return null;
  }
}
class Ip extends ee {
  constructor() {
    super(...arguments), this.type = "ellipse";
  }
  path(e) {
    var r = 4 * ((Math.sqrt(2) - 1) / 3), i = this.getAttribute("rx").getPixels("x"), n = this.getAttribute("ry").getPixels("y"), a = this.getAttribute("cx").getPixels("x"), s = this.getAttribute("cy").getPixels("y");
    return e && i > 0 && n > 0 && (e.beginPath(), e.moveTo(a + i, s), e.bezierCurveTo(a + i, s + r * n, a + r * i, s + n, a, s + n), e.bezierCurveTo(a - r * i, s + n, a - i, s + r * n, a - i, s), e.bezierCurveTo(a - i, s - r * n, a - r * i, s - n, a, s - n), e.bezierCurveTo(a + r * i, s - n, a + i, s - r * n, a + i, s), e.closePath()), new at(a - i, s - n, a + i, s + n);
  }
  getMarkers() {
    return null;
  }
}
class _p extends ee {
  constructor() {
    super(...arguments), this.type = "line";
  }
  getPoints() {
    return [new pe(this.getAttribute("x1").getPixels("x"), this.getAttribute("y1").getPixels("y")), new pe(this.getAttribute("x2").getPixels("x"), this.getAttribute("y2").getPixels("y"))];
  }
  path(e) {
    var [{
      x: r,
      y: i
    }, {
      x: n,
      y: a
    }] = this.getPoints();
    return e && (e.beginPath(), e.moveTo(r, i), e.lineTo(n, a)), new at(r, i, n, a);
  }
  getMarkers() {
    var [e, r] = this.getPoints(), i = e.angleTo(r);
    return [[e, i], [r, i]];
  }
}
class Lc extends ee {
  constructor(e, r, i) {
    super(e, r, i), this.type = "polyline", this.points = [], this.points = pe.parsePath(this.getAttribute("points").getString());
  }
  path(e) {
    var {
      points: r
    } = this, [{
      x: i,
      y: n
    }] = r, a = new at(i, n);
    return e && (e.beginPath(), e.moveTo(i, n)), r.forEach((s) => {
      var {
        x: o,
        y: l
      } = s;
      a.addPoint(o, l), e && e.lineTo(o, l);
    }), a;
  }
  getMarkers() {
    var {
      points: e
    } = this, r = e.length - 1, i = [];
    return e.forEach((n, a) => {
      a !== r && i.push([n, n.angleTo(e[a + 1])]);
    }), i.length > 0 && i.push([e[e.length - 1], i[i.length - 1][1]]), i;
  }
}
class Ap extends Lc {
  constructor() {
    super(...arguments), this.type = "polygon";
  }
  path(e) {
    var r = super.path(e), [{
      x: i,
      y: n
    }] = this.points;
    return e && (e.lineTo(i, n), e.closePath()), r;
  }
}
class Rp extends ge {
  constructor() {
    super(...arguments), this.type = "pattern";
  }
  createPattern(e, r, i) {
    var n = this.getStyle("width").getPixels("x", !0), a = this.getStyle("height").getPixels("y", !0), s = new Oi(this.document, null);
    s.attributes.viewBox = new j(this.document, "viewBox", this.getAttribute("viewBox").getValue()), s.attributes.width = new j(this.document, "width", "".concat(n, "px")), s.attributes.height = new j(this.document, "height", "".concat(a, "px")), s.attributes.transform = new j(this.document, "transform", this.getAttribute("patternTransform").getValue()), s.children = this.children;
    var o = this.document.createCanvas(n, a), l = o.getContext("2d"), c = this.getAttribute("x"), u = this.getAttribute("y");
    c.hasValue() && u.hasValue() && l.translate(c.getPixels("x", !0), u.getPixels("y", !0)), i.hasValue() ? this.styles["fill-opacity"] = i : Reflect.deleteProperty(this.styles, "fill-opacity");
    for (var d = -1; d <= 1; d++)
      for (var h = -1; h <= 1; h++)
        l.save(), s.attributes.x = new j(this.document, "x", d * o.width), s.attributes.y = new j(this.document, "y", h * o.height), s.render(l), l.restore();
    var f = e.createPattern(o, "repeat");
    return f;
  }
}
class Mp extends ge {
  constructor() {
    super(...arguments), this.type = "marker";
  }
  render(e, r, i) {
    if (r) {
      var {
        x: n,
        y: a
      } = r, s = this.getAttribute("orient").getString("auto"), o = this.getAttribute("markerUnits").getString("strokeWidth");
      e.translate(n, a), s === "auto" && e.rotate(i), o === "strokeWidth" && e.scale(e.lineWidth, e.lineWidth), e.save();
      var l = new Oi(this.document, null);
      l.type = this.type, l.attributes.viewBox = new j(this.document, "viewBox", this.getAttribute("viewBox").getValue()), l.attributes.refX = new j(this.document, "refX", this.getAttribute("refX").getValue()), l.attributes.refY = new j(this.document, "refY", this.getAttribute("refY").getValue()), l.attributes.width = new j(this.document, "width", this.getAttribute("markerWidth").getValue()), l.attributes.height = new j(this.document, "height", this.getAttribute("markerHeight").getValue()), l.attributes.overflow = new j(this.document, "overflow", this.getAttribute("overflow").getValue()), l.attributes.fill = new j(this.document, "fill", this.getAttribute("fill").getColor("black")), l.attributes.stroke = new j(this.document, "stroke", this.getAttribute("stroke").getValue("none")), l.children = this.children, l.render(e), e.restore(), o === "strokeWidth" && e.scale(1 / e.lineWidth, 1 / e.lineWidth), s === "auto" && e.rotate(-i), e.translate(-n, -a);
    }
  }
}
class Lp extends ge {
  constructor() {
    super(...arguments), this.type = "defs";
  }
  render() {
  }
}
class qa extends rr {
  constructor() {
    super(...arguments), this.type = "g";
  }
  getBoundingBox(e) {
    var r = new at();
    return this.children.forEach((i) => {
      r.addBoundingBox(i.getBoundingBox(e));
    }), r;
  }
}
class Dc extends ge {
  constructor(e, r, i) {
    super(e, r, i), this.attributesToInherit = ["gradientUnits"], this.stops = [];
    var {
      stops: n,
      children: a
    } = this;
    a.forEach((s) => {
      s.type === "stop" && n.push(s);
    });
  }
  getGradientUnits() {
    return this.getAttribute("gradientUnits").getString("objectBoundingBox");
  }
  createGradient(e, r, i) {
    var n = this;
    this.getHrefAttribute().hasValue() && (n = this.getHrefAttribute().getDefinition(), this.inheritStopContainer(n));
    var {
      stops: a
    } = n, s = this.getGradient(e, r);
    if (!s)
      return this.addParentOpacity(i, a[a.length - 1].color);
    if (a.forEach((b) => {
      s.addColorStop(b.offset, this.addParentOpacity(i, b.color));
    }), this.getAttribute("gradientTransform").hasValue()) {
      var {
        document: o
      } = this, {
        MAX_VIRTUAL_PIXELS: l,
        viewPort: c
      } = o.screen, [u] = c.viewPorts, d = new Mc(o, null);
      d.attributes.x = new j(o, "x", -l / 3), d.attributes.y = new j(o, "y", -l / 3), d.attributes.width = new j(o, "width", l), d.attributes.height = new j(o, "height", l);
      var h = new qa(o, null);
      h.attributes.transform = new j(o, "transform", this.getAttribute("gradientTransform").getValue()), h.children = [d];
      var f = new Oi(o, null);
      f.attributes.x = new j(o, "x", 0), f.attributes.y = new j(o, "y", 0), f.attributes.width = new j(o, "width", u.width), f.attributes.height = new j(o, "height", u.height), f.children = [h];
      var v = o.createCanvas(u.width, u.height), p = v.getContext("2d");
      return p.fillStyle = s, f.render(p), p.createPattern(v, "no-repeat");
    }
    return s;
  }
  inheritStopContainer(e) {
    this.attributesToInherit.forEach((r) => {
      !this.getAttribute(r).hasValue() && e.getAttribute(r).hasValue() && this.getAttribute(r, !0).setValue(e.getAttribute(r).getValue());
    });
  }
  addParentOpacity(e, r) {
    if (e.hasValue()) {
      var i = new j(this.document, "color", r);
      return i.addOpacity(e).getColor();
    }
    return r;
  }
}
class Dp extends Dc {
  constructor(e, r, i) {
    super(e, r, i), this.type = "linearGradient", this.attributesToInherit.push("x1", "y1", "x2", "y2");
  }
  getGradient(e, r) {
    var i = this.getGradientUnits() === "objectBoundingBox", n = i ? r.getBoundingBox(e) : null;
    if (i && !n)
      return null;
    !this.getAttribute("x1").hasValue() && !this.getAttribute("y1").hasValue() && !this.getAttribute("x2").hasValue() && !this.getAttribute("y2").hasValue() && (this.getAttribute("x1", !0).setValue(0), this.getAttribute("y1", !0).setValue(0), this.getAttribute("x2", !0).setValue(1), this.getAttribute("y2", !0).setValue(0));
    var a = i ? n.x + n.width * this.getAttribute("x1").getNumber() : this.getAttribute("x1").getPixels("x"), s = i ? n.y + n.height * this.getAttribute("y1").getNumber() : this.getAttribute("y1").getPixels("y"), o = i ? n.x + n.width * this.getAttribute("x2").getNumber() : this.getAttribute("x2").getPixels("x"), l = i ? n.y + n.height * this.getAttribute("y2").getNumber() : this.getAttribute("y2").getPixels("y");
    return a === o && s === l ? null : e.createLinearGradient(a, s, o, l);
  }
}
class Np extends Dc {
  constructor(e, r, i) {
    super(e, r, i), this.type = "radialGradient", this.attributesToInherit.push("cx", "cy", "r", "fx", "fy", "fr");
  }
  getGradient(e, r) {
    var i = this.getGradientUnits() === "objectBoundingBox", n = r.getBoundingBox(e);
    if (i && !n)
      return null;
    this.getAttribute("cx").hasValue() || this.getAttribute("cx", !0).setValue("50%"), this.getAttribute("cy").hasValue() || this.getAttribute("cy", !0).setValue("50%"), this.getAttribute("r").hasValue() || this.getAttribute("r", !0).setValue("50%");
    var a = i ? n.x + n.width * this.getAttribute("cx").getNumber() : this.getAttribute("cx").getPixels("x"), s = i ? n.y + n.height * this.getAttribute("cy").getNumber() : this.getAttribute("cy").getPixels("y"), o = a, l = s;
    this.getAttribute("fx").hasValue() && (o = i ? n.x + n.width * this.getAttribute("fx").getNumber() : this.getAttribute("fx").getPixels("x")), this.getAttribute("fy").hasValue() && (l = i ? n.y + n.height * this.getAttribute("fy").getNumber() : this.getAttribute("fy").getPixels("y"));
    var c = i ? (n.width + n.height) / 2 * this.getAttribute("r").getNumber() : this.getAttribute("r").getPixels(), u = this.getAttribute("fr").getPixels();
    return e.createRadialGradient(o, l, u, a, s, c);
  }
}
class jp extends ge {
  constructor(e, r, i) {
    super(e, r, i), this.type = "stop";
    var n = Math.max(0, Math.min(1, this.getAttribute("offset").getNumber())), a = this.getStyle("stop-opacity"), s = this.getStyle("stop-color", !0);
    s.getString() === "" && s.setValue("#000"), a.hasValue() && (s = s.addOpacity(a)), this.offset = n, this.color = s.getColor();
  }
}
class Ka extends ge {
  constructor(e, r, i) {
    super(e, r, i), this.type = "animate", this.duration = 0, this.initialValue = null, this.initialUnits = "", this.removed = !1, this.frozen = !1, e.screen.animations.push(this), this.begin = this.getAttribute("begin").getMilliseconds(), this.maxDuration = this.begin + this.getAttribute("dur").getMilliseconds(), this.from = this.getAttribute("from"), this.to = this.getAttribute("to"), this.values = new j(e, "values", null);
    var n = this.getAttribute("values");
    n.hasValue() && this.values.setValue(n.getString().split(";"));
  }
  getProperty() {
    var e = this.getAttribute("attributeType").getString(), r = this.getAttribute("attributeName").getString();
    return e === "CSS" ? this.parent.getStyle(r, !0) : this.parent.getAttribute(r, !0);
  }
  calcValue() {
    var {
      initialUnits: e
    } = this, {
      progress: r,
      from: i,
      to: n
    } = this.getProgress(), a = i.getNumber() + (n.getNumber() - i.getNumber()) * r;
    return e === "%" && (a *= 100), "".concat(a).concat(e);
  }
  update(e) {
    var {
      parent: r
    } = this, i = this.getProperty();
    if (this.initialValue || (this.initialValue = i.getString(), this.initialUnits = i.getUnits()), this.duration > this.maxDuration) {
      var n = this.getAttribute("fill").getString("remove");
      if (this.getAttribute("repeatCount").getString() === "indefinite" || this.getAttribute("repeatDur").getString() === "indefinite")
        this.duration = 0;
      else if (n === "freeze" && !this.frozen)
        this.frozen = !0, r.animationFrozen = !0, r.animationFrozenValue = i.getString();
      else if (n === "remove" && !this.removed)
        return this.removed = !0, i.setValue(r.animationFrozen ? r.animationFrozenValue : this.initialValue), !0;
      return !1;
    }
    this.duration += e;
    var a = !1;
    if (this.begin < this.duration) {
      var s = this.calcValue(), o = this.getAttribute("type");
      if (o.hasValue()) {
        var l = o.getString();
        s = "".concat(l, "(").concat(s, ")");
      }
      i.setValue(s), a = !0;
    }
    return a;
  }
  getProgress() {
    var {
      document: e,
      values: r
    } = this, i = {
      progress: (this.duration - this.begin) / (this.maxDuration - this.begin)
    };
    if (r.hasValue()) {
      var n = i.progress * (r.getValue().length - 1), a = Math.floor(n), s = Math.ceil(n);
      i.from = new j(e, "from", parseFloat(r.getValue()[a])), i.to = new j(e, "to", parseFloat(r.getValue()[s])), i.progress = (n - a) / (s - a);
    } else
      i.from = this.from, i.to = this.to;
    return i;
  }
}
class kp extends Ka {
  constructor() {
    super(...arguments), this.type = "animateColor";
  }
  calcValue() {
    var {
      progress: e,
      from: r,
      to: i
    } = this.getProgress(), n = new nl(r.getColor()), a = new nl(i.getColor());
    if (n.ok && a.ok) {
      var s = n.r + (a.r - n.r) * e, o = n.g + (a.g - n.g) * e, l = n.b + (a.b - n.b) * e;
      return "rgb(".concat(Math.floor(s), ", ").concat(Math.floor(o), ", ").concat(Math.floor(l), ")");
    }
    return this.getAttribute("from").getColor();
  }
}
class zp extends Ka {
  constructor() {
    super(...arguments), this.type = "animateTransform";
  }
  calcValue() {
    var {
      progress: e,
      from: r,
      to: i
    } = this.getProgress(), n = He(r.getString()), a = He(i.getString()), s = n.map((o, l) => {
      var c = a[l];
      return o + (c - o) * e;
    }).join(" ");
    return s;
  }
}
class Bp extends ge {
  constructor(e, r, i) {
    super(e, r, i), this.type = "font", this.glyphs = {}, this.horizAdvX = this.getAttribute("horiz-adv-x").getNumber();
    var {
      definitions: n
    } = e, {
      children: a
    } = this;
    for (var s of a)
      switch (s.type) {
        case "font-face": {
          this.fontFace = s;
          var o = s.getStyle("font-family");
          o.hasValue() && (n[o.getString()] = this);
          break;
        }
        case "missing-glyph":
          this.missingGlyph = s;
          break;
        case "glyph": {
          var l = s;
          l.arabicForm ? (this.isRTL = !0, this.isArabic = !0, typeof this.glyphs[l.unicode] > "u" && (this.glyphs[l.unicode] = {}), this.glyphs[l.unicode][l.arabicForm] = l) : this.glyphs[l.unicode] = l;
          break;
        }
      }
  }
  render() {
  }
}
class Fp extends ge {
  constructor(e, r, i) {
    super(e, r, i), this.type = "font-face", this.ascent = this.getAttribute("ascent").getNumber(), this.descent = this.getAttribute("descent").getNumber(), this.unitsPerEm = this.getAttribute("units-per-em").getNumber();
  }
}
class $p extends ee {
  constructor() {
    super(...arguments), this.type = "missing-glyph", this.horizAdvX = 0;
  }
}
class Up extends ir {
  constructor() {
    super(...arguments), this.type = "tref";
  }
  getText() {
    var e = this.getHrefAttribute().getDefinition();
    if (e) {
      var r = e.children[0];
      if (r)
        return r.getText();
    }
    return "";
  }
}
class Vp extends ir {
  constructor(e, r, i) {
    super(e, r, i), this.type = "a";
    var {
      childNodes: n
    } = r, a = n[0], s = n.length > 0 && Array.from(n).every((o) => o.nodeType === 3);
    this.hasText = s, this.text = s ? this.getTextFromNode(a) : "";
  }
  getText() {
    return this.text;
  }
  renderChildren(e) {
    if (this.hasText) {
      super.renderChildren(e);
      var {
        document: r,
        x: i,
        y: n
      } = this, {
        mouse: a
      } = r.screen, s = new j(r, "fontSize", ke.parse(r.ctx.font).fontSize);
      a.isWorking() && a.checkBoundingBox(this, new at(i, n - s.getPixels("y"), i + this.measureText(e), n));
    } else if (this.children.length > 0) {
      var o = new qa(this.document, null);
      o.children = this.children, o.parent = this, o.render(e);
    }
  }
  onClick() {
    var {
      window: e
    } = this.document;
    e && e.open(this.getHrefAttribute().getString());
  }
  onMouseMove() {
    var e = this.document.ctx;
    e.canvas.style.cursor = "pointer";
  }
}
function $h(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function Nn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? $h(Object(r), !0).forEach(function(i) {
      Pc(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : $h(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
class Hp extends ir {
  constructor(e, r, i) {
    super(e, r, i), this.type = "textPath", this.textWidth = 0, this.textHeight = 0, this.pathLength = -1, this.glyphInfo = null, this.letterSpacingCache = [], this.measuresCache = /* @__PURE__ */ new Map([["", 0]]);
    var n = this.getHrefAttribute().getDefinition();
    this.text = this.getTextFromNode(), this.dataArray = this.parsePathData(n);
  }
  getText() {
    return this.text;
  }
  path(e) {
    var {
      dataArray: r
    } = this;
    e && e.beginPath(), r.forEach((i) => {
      var {
        type: n,
        points: a
      } = i;
      switch (n) {
        case B.LINE_TO:
          e && e.lineTo(a[0], a[1]);
          break;
        case B.MOVE_TO:
          e && e.moveTo(a[0], a[1]);
          break;
        case B.CURVE_TO:
          e && e.bezierCurveTo(a[0], a[1], a[2], a[3], a[4], a[5]);
          break;
        case B.QUAD_TO:
          e && e.quadraticCurveTo(a[0], a[1], a[2], a[3]);
          break;
        case B.ARC: {
          var [s, o, l, c, u, d, h, f] = a, v = l > c ? l : c, p = l > c ? 1 : l / c, b = l > c ? c / l : 1;
          e && (e.translate(s, o), e.rotate(h), e.scale(p, b), e.arc(0, 0, v, u, u + d, !!(1 - f)), e.scale(1 / p, 1 / b), e.rotate(-h), e.translate(-s, -o));
          break;
        }
        case B.CLOSE_PATH:
          e && e.closePath();
          break;
      }
    });
  }
  renderChildren(e) {
    this.setTextData(e), e.save();
    var r = this.parent.getStyle("text-decoration").getString(), i = this.getFontSize(), {
      glyphInfo: n
    } = this, a = e.fillStyle;
    r === "underline" && e.beginPath(), n.forEach((s, o) => {
      var {
        p0: l,
        p1: c,
        rotation: u,
        text: d
      } = s;
      e.save(), e.translate(l.x, l.y), e.rotate(u), e.fillStyle && e.fillText(d, 0, 0), e.strokeStyle && e.strokeText(d, 0, 0), e.restore(), r === "underline" && (o === 0 && e.moveTo(l.x, l.y + i / 8), e.lineTo(c.x, c.y + i / 5));
    }), r === "underline" && (e.lineWidth = i / 20, e.strokeStyle = a, e.stroke(), e.closePath()), e.restore();
  }
  getLetterSpacingAt() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return this.letterSpacingCache[e] || 0;
  }
  findSegmentToFitChar(e, r, i, n, a, s, o, l, c) {
    var u = s, d = this.measureText(e, l);
    l === " " && r === "justify" && i < n && (d += (n - i) / a), c > -1 && (u += this.getLetterSpacingAt(c));
    var h = this.textHeight / 20, f = this.getEquidistantPointOnPath(u, h, 0), v = this.getEquidistantPointOnPath(u + d, h, 0), p = {
      p0: f,
      p1: v
    }, b = f && v ? Math.atan2(v.y - f.y, v.x - f.x) : 0;
    if (o) {
      var y = Math.cos(Math.PI / 2 + b) * o, x = Math.cos(-b) * o;
      p.p0 = Nn(Nn({}, f), {}, {
        x: f.x + y,
        y: f.y + x
      }), p.p1 = Nn(Nn({}, v), {}, {
        x: v.x + y,
        y: v.y + x
      });
    }
    return u += d, {
      offset: u,
      segment: p,
      rotation: b
    };
  }
  measureText(e, r) {
    var {
      measuresCache: i
    } = this, n = r || this.getText();
    if (i.has(n))
      return i.get(n);
    var a = this.measureTargetText(e, n);
    return i.set(n, a), a;
  }
  // This method supposes what all custom fonts already loaded.
  // If some font will be loaded after this method call, <textPath> will not be rendered correctly.
  // You need to call this method manually to update glyphs cache.
  setTextData(e) {
    if (!this.glyphInfo) {
      var r = this.getText(), i = r.split(""), n = r.split(" ").length - 1, a = this.parent.getAttribute("dx").split().map((P) => P.getPixels("x")), s = this.parent.getAttribute("dy").getPixels("y"), o = this.parent.getStyle("text-anchor").getString("start"), l = this.getStyle("letter-spacing"), c = this.parent.getStyle("letter-spacing"), u = 0;
      !l.hasValue() || l.getValue() === "inherit" ? u = c.getPixels() : l.hasValue() && l.getValue() !== "initial" && l.getValue() !== "unset" && (u = l.getPixels());
      var d = [], h = r.length;
      this.letterSpacingCache = d;
      for (var f = 0; f < h; f++)
        d.push(typeof a[f] < "u" ? a[f] : u);
      var v = d.reduce((P, O, A) => A === 0 ? 0 : P + O || 0, 0), p = this.measureText(e), b = Math.max(p + v, 0);
      this.textWidth = p, this.textHeight = this.getFontSize(), this.glyphInfo = [];
      var y = this.getPathLength(), x = this.getStyle("startOffset").getNumber(0) * y, w = 0;
      (o === "middle" || o === "center") && (w = -b / 2), (o === "end" || o === "right") && (w = -b), w += x, i.forEach((P, O) => {
        var {
          offset: A,
          segment: I,
          rotation: D
        } = this.findSegmentToFitChar(e, o, b, y, n, w, s, P, O);
        w = A, !(!I.p0 || !I.p1) && this.glyphInfo.push({
          // transposeX: midpoint.x,
          // transposeY: midpoint.y,
          text: i[O],
          p0: I.p0,
          p1: I.p1,
          rotation: D
        });
      });
    }
  }
  parsePathData(e) {
    if (this.pathLength = -1, !e)
      return [];
    var r = [], {
      pathParser: i
    } = e;
    for (i.reset(); !i.isEnd(); ) {
      var {
        current: n
      } = i, a = n ? n.x : 0, s = n ? n.y : 0, o = i.next(), l = o.type, c = [];
      switch (o.type) {
        case B.MOVE_TO:
          this.pathM(i, c);
          break;
        case B.LINE_TO:
          l = this.pathL(i, c);
          break;
        case B.HORIZ_LINE_TO:
          l = this.pathH(i, c);
          break;
        case B.VERT_LINE_TO:
          l = this.pathV(i, c);
          break;
        case B.CURVE_TO:
          this.pathC(i, c);
          break;
        case B.SMOOTH_CURVE_TO:
          l = this.pathS(i, c);
          break;
        case B.QUAD_TO:
          this.pathQ(i, c);
          break;
        case B.SMOOTH_QUAD_TO:
          l = this.pathT(i, c);
          break;
        case B.ARC:
          c = this.pathA(i);
          break;
        case B.CLOSE_PATH:
          ee.pathZ(i);
          break;
      }
      o.type !== B.CLOSE_PATH ? r.push({
        type: l,
        points: c,
        start: {
          x: a,
          y: s
        },
        pathLength: this.calcLength(a, s, l, c)
      }) : r.push({
        type: B.CLOSE_PATH,
        points: [],
        pathLength: 0
      });
    }
    return r;
  }
  pathM(e, r) {
    var {
      x: i,
      y: n
    } = ee.pathM(e).point;
    r.push(i, n);
  }
  pathL(e, r) {
    var {
      x: i,
      y: n
    } = ee.pathL(e).point;
    return r.push(i, n), B.LINE_TO;
  }
  pathH(e, r) {
    var {
      x: i,
      y: n
    } = ee.pathH(e).point;
    return r.push(i, n), B.LINE_TO;
  }
  pathV(e, r) {
    var {
      x: i,
      y: n
    } = ee.pathV(e).point;
    return r.push(i, n), B.LINE_TO;
  }
  pathC(e, r) {
    var {
      point: i,
      controlPoint: n,
      currentPoint: a
    } = ee.pathC(e);
    r.push(i.x, i.y, n.x, n.y, a.x, a.y);
  }
  pathS(e, r) {
    var {
      point: i,
      controlPoint: n,
      currentPoint: a
    } = ee.pathS(e);
    return r.push(i.x, i.y, n.x, n.y, a.x, a.y), B.CURVE_TO;
  }
  pathQ(e, r) {
    var {
      controlPoint: i,
      currentPoint: n
    } = ee.pathQ(e);
    r.push(i.x, i.y, n.x, n.y);
  }
  pathT(e, r) {
    var {
      controlPoint: i,
      currentPoint: n
    } = ee.pathT(e);
    return r.push(i.x, i.y, n.x, n.y), B.QUAD_TO;
  }
  pathA(e) {
    var {
      rX: r,
      rY: i,
      sweepFlag: n,
      xAxisRotation: a,
      centp: s,
      a1: o,
      ad: l
    } = ee.pathA(e);
    return n === 0 && l > 0 && (l -= 2 * Math.PI), n === 1 && l < 0 && (l += 2 * Math.PI), [s.x, s.y, r, i, o, l, a, n];
  }
  calcLength(e, r, i, n) {
    var a = 0, s = null, o = null, l = 0;
    switch (i) {
      case B.LINE_TO:
        return this.getLineLength(e, r, n[0], n[1]);
      case B.CURVE_TO:
        for (a = 0, s = this.getPointOnCubicBezier(0, e, r, n[0], n[1], n[2], n[3], n[4], n[5]), l = 0.01; l <= 1; l += 0.01)
          o = this.getPointOnCubicBezier(l, e, r, n[0], n[1], n[2], n[3], n[4], n[5]), a += this.getLineLength(s.x, s.y, o.x, o.y), s = o;
        return a;
      case B.QUAD_TO:
        for (a = 0, s = this.getPointOnQuadraticBezier(0, e, r, n[0], n[1], n[2], n[3]), l = 0.01; l <= 1; l += 0.01)
          o = this.getPointOnQuadraticBezier(l, e, r, n[0], n[1], n[2], n[3]), a += this.getLineLength(s.x, s.y, o.x, o.y), s = o;
        return a;
      case B.ARC: {
        a = 0;
        var c = n[4], u = n[5], d = n[4] + u, h = Math.PI / 180;
        if (Math.abs(c - d) < h && (h = Math.abs(c - d)), s = this.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], c, 0), u < 0)
          for (l = c - h; l > d; l -= h)
            o = this.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], l, 0), a += this.getLineLength(s.x, s.y, o.x, o.y), s = o;
        else
          for (l = c + h; l < d; l += h)
            o = this.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], l, 0), a += this.getLineLength(s.x, s.y, o.x, o.y), s = o;
        return o = this.getPointOnEllipticalArc(n[0], n[1], n[2], n[3], d, 0), a += this.getLineLength(s.x, s.y, o.x, o.y), a;
      }
    }
    return 0;
  }
  getPointOnLine(e, r, i, n, a) {
    var s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : r, o = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : i, l = (a - i) / (n - r + xr), c = Math.sqrt(e * e / (1 + l * l));
    n < r && (c *= -1);
    var u = l * c, d = null;
    if (n === r)
      d = {
        x: s,
        y: o + u
      };
    else if ((o - i) / (s - r + xr) === l)
      d = {
        x: s + c,
        y: o + u
      };
    else {
      var h = 0, f = 0, v = this.getLineLength(r, i, n, a);
      if (v < xr)
        return null;
      var p = (s - r) * (n - r) + (o - i) * (a - i);
      p /= v * v, h = r + p * (n - r), f = i + p * (a - i);
      var b = this.getLineLength(s, o, h, f), y = Math.sqrt(e * e - b * b);
      c = Math.sqrt(y * y / (1 + l * l)), n < r && (c *= -1), u = l * c, d = {
        x: h + c,
        y: f + u
      };
    }
    return d;
  }
  getPointOnPath(e) {
    var r = this.getPathLength(), i = 0, n = null;
    if (e < -5e-5 || e - 5e-5 > r)
      return null;
    var {
      dataArray: a
    } = this;
    for (var s of a) {
      if (s && (s.pathLength < 5e-5 || i + s.pathLength + 5e-5 < e)) {
        i += s.pathLength;
        continue;
      }
      var o = e - i, l = 0;
      switch (s.type) {
        case B.LINE_TO:
          n = this.getPointOnLine(o, s.start.x, s.start.y, s.points[0], s.points[1], s.start.x, s.start.y);
          break;
        case B.ARC: {
          var c = s.points[4], u = s.points[5], d = s.points[4] + u;
          if (l = c + o / s.pathLength * u, u < 0 && l < d || u >= 0 && l > d)
            break;
          n = this.getPointOnEllipticalArc(s.points[0], s.points[1], s.points[2], s.points[3], l, s.points[6]);
          break;
        }
        case B.CURVE_TO:
          l = o / s.pathLength, l > 1 && (l = 1), n = this.getPointOnCubicBezier(l, s.start.x, s.start.y, s.points[0], s.points[1], s.points[2], s.points[3], s.points[4], s.points[5]);
          break;
        case B.QUAD_TO:
          l = o / s.pathLength, l > 1 && (l = 1), n = this.getPointOnQuadraticBezier(l, s.start.x, s.start.y, s.points[0], s.points[1], s.points[2], s.points[3]);
          break;
      }
      if (n)
        return n;
      break;
    }
    return null;
  }
  getLineLength(e, r, i, n) {
    return Math.sqrt((i - e) * (i - e) + (n - r) * (n - r));
  }
  getPathLength() {
    return this.pathLength === -1 && (this.pathLength = this.dataArray.reduce((e, r) => r.pathLength > 0 ? e + r.pathLength : e, 0)), this.pathLength;
  }
  getPointOnCubicBezier(e, r, i, n, a, s, o, l, c) {
    var u = l * ul(e) + s * dl(e) + n * hl(e) + r * fl(e), d = c * ul(e) + o * dl(e) + a * hl(e) + i * fl(e);
    return {
      x: u,
      y: d
    };
  }
  getPointOnQuadraticBezier(e, r, i, n, a, s, o) {
    var l = s * gl(e) + n * pl(e) + r * ml(e), c = o * gl(e) + a * pl(e) + i * ml(e);
    return {
      x: l,
      y: c
    };
  }
  getPointOnEllipticalArc(e, r, i, n, a, s) {
    var o = Math.cos(s), l = Math.sin(s), c = {
      x: i * Math.cos(a),
      y: n * Math.sin(a)
    };
    return {
      x: e + (c.x * o - c.y * l),
      y: r + (c.x * l + c.y * o)
    };
  }
  // TODO need some optimisations. possibly build cache only for curved segments?
  buildEquidistantCache(e, r) {
    var i = this.getPathLength(), n = r || 0.25, a = e || i / 100;
    if (!this.equidistantCache || this.equidistantCache.step !== a || this.equidistantCache.precision !== n) {
      this.equidistantCache = {
        step: a,
        precision: n,
        points: []
      };
      for (var s = 0, o = 0; o <= i; o += n) {
        var l = this.getPointOnPath(o), c = this.getPointOnPath(o + n);
        !l || !c || (s += this.getLineLength(l.x, l.y, c.x, c.y), s >= a && (this.equidistantCache.points.push({
          x: l.x,
          y: l.y,
          distance: o
        }), s -= a));
      }
    }
  }
  getEquidistantPointOnPath(e, r, i) {
    if (this.buildEquidistantCache(r, i), e < 0 || e - this.getPathLength() > 5e-5)
      return null;
    var n = Math.round(e / this.getPathLength() * (this.equidistantCache.points.length - 1));
    return this.equidistantCache.points[n] || null;
  }
}
var DA = /^\s*data:(([^/,;]+\/[^/,;]+)(?:;([^,;=]+=[^,;=]+))?)?(?:;(base64))?,(.*)$/i;
class Wp extends rr {
  constructor(e, r, i) {
    super(e, r, i), this.type = "image", this.loaded = !1;
    var n = this.getHrefAttribute().getString();
    if (n) {
      var a = n.endsWith(".svg") || /^\s*data:image\/svg\+xml/i.test(n);
      e.images.push(this), a ? this.loadSvg(n) : this.loadImage(n), this.isSvg = a;
    }
  }
  loadImage(e) {
    var r = this;
    return Ft(function* () {
      try {
        var i = yield r.document.createImage(e);
        r.image = i;
      } catch (n) {
        console.error('Error while loading image "'.concat(e, '":'), n);
      }
      r.loaded = !0;
    })();
  }
  loadSvg(e) {
    var r = this;
    return Ft(function* () {
      var i = DA.exec(e);
      if (i) {
        var n = i[5];
        i[4] === "base64" ? r.image = atob(n) : r.image = decodeURIComponent(n);
      } else
        try {
          var a = yield r.document.fetch(e), s = yield a.text();
          r.image = s;
        } catch (o) {
          console.error('Error while loading image "'.concat(e, '":'), o);
        }
      r.loaded = !0;
    })();
  }
  renderChildren(e) {
    var {
      document: r,
      image: i,
      loaded: n
    } = this, a = this.getAttribute("x").getPixels("x"), s = this.getAttribute("y").getPixels("y"), o = this.getStyle("width").getPixels("x"), l = this.getStyle("height").getPixels("y");
    if (!(!n || !i || !o || !l)) {
      if (e.save(), e.translate(a, s), this.isSvg) {
        var c = r.canvg.forkString(e, this.image, {
          ignoreMouse: !0,
          ignoreAnimation: !0,
          ignoreDimensions: !0,
          ignoreClear: !0,
          offsetX: 0,
          offsetY: 0,
          scaleWidth: o,
          scaleHeight: l
        });
        c.document.documentElement.parent = this, c.render();
      } else {
        var u = this.image;
        r.setViewBox({
          ctx: e,
          aspectRatio: this.getAttribute("preserveAspectRatio").getString(),
          width: o,
          desiredWidth: u.width,
          height: l,
          desiredHeight: u.height
        }), this.loaded && (typeof u.complete > "u" || u.complete) && e.drawImage(u, 0, 0);
      }
      e.restore();
    }
  }
  getBoundingBox() {
    var e = this.getAttribute("x").getPixels("x"), r = this.getAttribute("y").getPixels("y"), i = this.getStyle("width").getPixels("x"), n = this.getStyle("height").getPixels("y");
    return new at(e, r, e + i, r + n);
  }
}
class Gp extends rr {
  constructor() {
    super(...arguments), this.type = "symbol";
  }
  render(e) {
  }
}
class Yp {
  constructor(e) {
    this.document = e, this.loaded = !1, e.fonts.push(this);
  }
  load(e, r) {
    var i = this;
    return Ft(function* () {
      try {
        var {
          document: n
        } = i, a = yield n.canvg.parser.load(r), s = a.getElementsByTagName("font");
        Array.from(s).forEach((o) => {
          var l = n.createElement(o);
          n.definitions[e] = l;
        });
      } catch (o) {
        console.error('Error while loading font "'.concat(r, '":'), o);
      }
      i.loaded = !0;
    })();
  }
}
class Nc extends ge {
  constructor(e, r, i) {
    super(e, r, i), this.type = "style";
    var n = Lr(
      Array.from(r.childNodes).map((s) => s.textContent).join("").replace(/(\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*+\/)|(^[\s]*\/\/.*)/gm, "").replace(/@import.*;/g, "")
      // remove imports
    ), a = n.split("}");
    a.forEach((s) => {
      var o = s.trim();
      if (o) {
        var l = o.split("{"), c = l[0].split(","), u = l[1].split(";");
        c.forEach((d) => {
          var h = d.trim();
          if (h) {
            var f = e.styles[h] || {};
            if (u.forEach((b) => {
              var y = b.indexOf(":"), x = b.substr(0, y).trim(), w = b.substr(y + 1, b.length - y).trim();
              x && w && (f[x] = new j(e, x, w));
            }), e.styles[h] = f, e.stylesSpecificity[h] = mp(h), h === "@font-face") {
              var v = f["font-family"].getString().replace(/"|'/g, ""), p = f.src.getString().split(",");
              p.forEach((b) => {
                if (b.indexOf('format("svg")') > 0) {
                  var y = Ic(b);
                  y && new Yp(e).load(v, y);
                }
              });
            }
          }
        });
      }
    });
  }
}
Nc.parseExternalUrl = Ic;
class Xp extends rr {
  constructor() {
    super(...arguments), this.type = "use";
  }
  setContext(e) {
    super.setContext(e);
    var r = this.getAttribute("x"), i = this.getAttribute("y");
    r.hasValue() && e.translate(r.getPixels("x"), 0), i.hasValue() && e.translate(0, i.getPixels("y"));
  }
  path(e) {
    var {
      element: r
    } = this;
    r && r.path(e);
  }
  renderChildren(e) {
    var {
      document: r,
      element: i
    } = this;
    if (i) {
      var n = i;
      if (i.type === "symbol" && (n = new Oi(r, null), n.attributes.viewBox = new j(r, "viewBox", i.getAttribute("viewBox").getString()), n.attributes.preserveAspectRatio = new j(r, "preserveAspectRatio", i.getAttribute("preserveAspectRatio").getString()), n.attributes.overflow = new j(r, "overflow", i.getAttribute("overflow").getString()), n.children = i.children, i.styles.opacity = new j(r, "opacity", this.calculateOpacity())), n.type === "svg") {
        var a = this.getStyle("width", !1, !0), s = this.getStyle("height", !1, !0);
        a.hasValue() && (n.attributes.width = new j(r, "width", a.getString())), s.hasValue() && (n.attributes.height = new j(r, "height", s.getString()));
      }
      var o = n.parent;
      n.parent = this, n.render(e), n.parent = o;
    }
  }
  getBoundingBox(e) {
    var {
      element: r
    } = this;
    return r ? r.getBoundingBox(e) : null;
  }
  elementTransform() {
    var {
      document: e,
      element: r
    } = this;
    return Zt.fromElement(e, r);
  }
  get element() {
    return this.cachedElement || (this.cachedElement = this.getHrefAttribute().getDefinition()), this.cachedElement;
  }
}
function jn(t, e, r, i, n, a) {
  return t[r * i * 4 + e * 4 + a];
}
function kn(t, e, r, i, n, a, s) {
  t[r * i * 4 + e * 4 + a] = s;
}
function be(t, e, r) {
  var i = t[e];
  return i * r;
}
function Dt(t, e, r, i) {
  return e + Math.cos(t) * r + Math.sin(t) * i;
}
class jc extends ge {
  constructor(e, r, i) {
    super(e, r, i), this.type = "feColorMatrix";
    var n = He(this.getAttribute("values").getString());
    switch (this.getAttribute("type").getString("matrix")) {
      case "saturate": {
        var a = n[0];
        n = [0.213 + 0.787 * a, 0.715 - 0.715 * a, 0.072 - 0.072 * a, 0, 0, 0.213 - 0.213 * a, 0.715 + 0.285 * a, 0.072 - 0.072 * a, 0, 0, 0.213 - 0.213 * a, 0.715 - 0.715 * a, 0.072 + 0.928 * a, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
        break;
      }
      case "hueRotate": {
        var s = n[0] * Math.PI / 180;
        n = [Dt(s, 0.213, 0.787, -0.213), Dt(s, 0.715, -0.715, -0.715), Dt(s, 0.072, -0.072, 0.928), 0, 0, Dt(s, 0.213, -0.213, 0.143), Dt(s, 0.715, 0.285, 0.14), Dt(s, 0.072, -0.072, -0.283), 0, 0, Dt(s, 0.213, -0.213, -0.787), Dt(s, 0.715, -0.715, 0.715), Dt(s, 0.072, 0.928, 0.072), 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1];
        break;
      }
      case "luminanceToAlpha":
        n = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0.2125, 0.7154, 0.0721, 0, 0, 0, 0, 0, 0, 1];
        break;
    }
    this.matrix = n, this.includeOpacity = this.getAttribute("includeOpacity").hasValue();
  }
  apply(e, r, i, n, a) {
    for (var {
      includeOpacity: s,
      matrix: o
    } = this, l = e.getImageData(0, 0, n, a), c = 0; c < a; c++)
      for (var u = 0; u < n; u++) {
        var d = jn(l.data, u, c, n, a, 0), h = jn(l.data, u, c, n, a, 1), f = jn(l.data, u, c, n, a, 2), v = jn(l.data, u, c, n, a, 3), p = be(o, 0, d) + be(o, 1, h) + be(o, 2, f) + be(o, 3, v) + be(o, 4, 1), b = be(o, 5, d) + be(o, 6, h) + be(o, 7, f) + be(o, 8, v) + be(o, 9, 1), y = be(o, 10, d) + be(o, 11, h) + be(o, 12, f) + be(o, 13, v) + be(o, 14, 1), x = be(o, 15, d) + be(o, 16, h) + be(o, 17, f) + be(o, 18, v) + be(o, 19, 1);
        s && (p = 0, b = 0, y = 0, x *= v / 255), kn(l.data, u, c, n, a, 0, p), kn(l.data, u, c, n, a, 1, b), kn(l.data, u, c, n, a, 2, y), kn(l.data, u, c, n, a, 3, x);
      }
    e.clearRect(0, 0, n, a), e.putImageData(l, 0, 0);
  }
}
class vn extends ge {
  constructor() {
    super(...arguments), this.type = "mask";
  }
  apply(e, r) {
    var {
      document: i
    } = this, n = this.getAttribute("x").getPixels("x"), a = this.getAttribute("y").getPixels("y"), s = this.getStyle("width").getPixels("x"), o = this.getStyle("height").getPixels("y");
    if (!s && !o) {
      var l = new at();
      this.children.forEach((v) => {
        l.addBoundingBox(v.getBoundingBox(e));
      }), n = Math.floor(l.x1), a = Math.floor(l.y1), s = Math.floor(l.width), o = Math.floor(l.height);
    }
    var c = this.removeStyles(r, vn.ignoreStyles), u = i.createCanvas(n + s, a + o), d = u.getContext("2d");
    i.screen.setDefaults(d), this.renderChildren(d), new jc(i, {
      nodeType: 1,
      childNodes: [],
      attributes: [{
        nodeName: "type",
        value: "luminanceToAlpha"
      }, {
        nodeName: "includeOpacity",
        value: "true"
      }]
    }).apply(d, 0, 0, n + s, a + o);
    var h = i.createCanvas(n + s, a + o), f = h.getContext("2d");
    i.screen.setDefaults(f), r.render(f), f.globalCompositeOperation = "destination-in", f.fillStyle = d.createPattern(u, "no-repeat"), f.fillRect(0, 0, n + s, a + o), e.fillStyle = f.createPattern(h, "no-repeat"), e.fillRect(0, 0, n + s, a + o), this.restoreStyles(r, c);
  }
  render(e) {
  }
}
vn.ignoreStyles = ["mask", "transform", "clip-path"];
var Uh = () => {
};
class qp extends ge {
  constructor() {
    super(...arguments), this.type = "clipPath";
  }
  apply(e) {
    var {
      document: r
    } = this, i = Reflect.getPrototypeOf(e), {
      beginPath: n,
      closePath: a
    } = e;
    i && (i.beginPath = Uh, i.closePath = Uh), Reflect.apply(n, e, []), this.children.forEach((s) => {
      if (!(typeof s.path > "u")) {
        var o = typeof s.elementTransform < "u" ? s.elementTransform() : null;
        o || (o = Zt.fromElement(r, s)), o && o.apply(e), s.path(e), i && (i.closePath = a), o && o.unapply(e);
      }
    }), Reflect.apply(a, e, []), e.clip(), i && (i.beginPath = n, i.closePath = a);
  }
  render(e) {
  }
}
class yn extends ge {
  constructor() {
    super(...arguments), this.type = "filter";
  }
  apply(e, r) {
    var {
      document: i,
      children: n
    } = this, a = r.getBoundingBox(e);
    if (a) {
      var s = 0, o = 0;
      n.forEach((y) => {
        var x = y.extraFilterDistance || 0;
        s = Math.max(s, x), o = Math.max(o, x);
      });
      var l = Math.floor(a.width), c = Math.floor(a.height), u = l + 2 * s, d = c + 2 * o;
      if (!(u < 1 || d < 1)) {
        var h = Math.floor(a.x), f = Math.floor(a.y), v = this.removeStyles(r, yn.ignoreStyles), p = i.createCanvas(u, d), b = p.getContext("2d");
        i.screen.setDefaults(b), b.translate(-h + s, -f + o), r.render(b), n.forEach((y) => {
          typeof y.apply == "function" && y.apply(b, 0, 0, u, d);
        }), e.drawImage(p, 0, 0, u, d, h - s, f - o, u, d), this.restoreStyles(r, v);
      }
    }
  }
  render(e) {
  }
}
yn.ignoreStyles = ["filter", "transform", "clip-path"];
class Kp extends ge {
  constructor(e, r, i) {
    super(e, r, i), this.type = "feDropShadow", this.addStylesFromStyleDefinition();
  }
  apply(e, r, i, n, a) {
  }
}
class Zp extends ge {
  constructor() {
    super(...arguments), this.type = "feMorphology";
  }
  apply(e, r, i, n, a) {
  }
}
class Qp extends ge {
  constructor() {
    super(...arguments), this.type = "feComposite";
  }
  apply(e, r, i, n, a) {
  }
}
class Jp extends ge {
  constructor(e, r, i) {
    super(e, r, i), this.type = "feGaussianBlur", this.blurRadius = Math.floor(this.getAttribute("stdDeviation").getNumber()), this.extraFilterDistance = this.blurRadius;
  }
  apply(e, r, i, n, a) {
    var {
      document: s,
      blurRadius: o
    } = this, l = s.window ? s.window.document.body : null, c = e.canvas;
    c.id = s.getUniqueId(), l && (c.style.display = "none", l.appendChild(c)), hA(c, r, i, n, a, o), l && l.removeChild(c);
  }
}
class e0 extends ge {
  constructor() {
    super(...arguments), this.type = "title";
  }
}
class t0 extends ge {
  constructor() {
    super(...arguments), this.type = "desc";
  }
}
var NA = {
  svg: Oi,
  rect: Mc,
  circle: Cp,
  ellipse: Ip,
  line: _p,
  polyline: Lc,
  polygon: Ap,
  path: ee,
  pattern: Rp,
  marker: Mp,
  defs: Lp,
  linearGradient: Dp,
  radialGradient: Np,
  stop: jp,
  animate: Ka,
  animateColor: kp,
  animateTransform: zp,
  font: Bp,
  "font-face": Fp,
  "missing-glyph": $p,
  glyph: Rc,
  text: ir,
  tspan: mn,
  tref: Up,
  a: Vp,
  textPath: Hp,
  image: Wp,
  g: qa,
  symbol: Gp,
  style: Nc,
  use: Xp,
  mask: vn,
  clipPath: qp,
  filter: yn,
  feDropShadow: Kp,
  feMorphology: Zp,
  feComposite: Qp,
  feColorMatrix: jc,
  feGaussianBlur: Jp,
  title: e0,
  desc: t0
};
function Vh(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function jA(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Vh(Object(r), !0).forEach(function(i) {
      Pc(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Vh(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
function kA(t, e) {
  var r = document.createElement("canvas");
  return r.width = t, r.height = e, r;
}
function zA(t) {
  return yl.apply(this, arguments);
}
function yl() {
  return yl = Ft(function* (t) {
    var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, r = document.createElement("img");
    return e && (r.crossOrigin = "Anonymous"), new Promise((i, n) => {
      r.onload = () => {
        i(r);
      }, r.onerror = (a, s, o, l, c) => {
        n(c);
      }, r.src = t;
    });
  }), yl.apply(this, arguments);
}
class jt {
  constructor(e) {
    var {
      rootEmSize: r = 12,
      emSize: i = 12,
      createCanvas: n = jt.createCanvas,
      createImage: a = jt.createImage,
      anonymousCrossOrigin: s
    } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    this.canvg = e, this.definitions = {}, this.styles = {}, this.stylesSpecificity = {}, this.images = [], this.fonts = [], this.emSizeStack = [], this.uniqueId = 0, this.screen = e.screen, this.rootEmSize = r, this.emSize = i, this.createCanvas = n, this.createImage = this.bindCreateImage(a, s), this.screen.wait(this.isImagesLoaded.bind(this)), this.screen.wait(this.isFontsLoaded.bind(this));
  }
  bindCreateImage(e, r) {
    return typeof r == "boolean" ? (i, n) => e(i, typeof n == "boolean" ? n : r) : e;
  }
  get window() {
    return this.screen.window;
  }
  get fetch() {
    return this.screen.fetch;
  }
  get ctx() {
    return this.screen.ctx;
  }
  get emSize() {
    var {
      emSizeStack: e
    } = this;
    return e[e.length - 1];
  }
  set emSize(e) {
    var {
      emSizeStack: r
    } = this;
    r.push(e);
  }
  popEmSize() {
    var {
      emSizeStack: e
    } = this;
    e.pop();
  }
  getUniqueId() {
    return "canvg".concat(++this.uniqueId);
  }
  isImagesLoaded() {
    return this.images.every((e) => e.loaded);
  }
  isFontsLoaded() {
    return this.fonts.every((e) => e.loaded);
  }
  createDocumentElement(e) {
    var r = this.createElement(e.documentElement);
    return r.root = !0, r.addStylesFromStyleDefinition(), this.documentElement = r, r;
  }
  createElement(e) {
    var r = e.nodeName.replace(/^[^:]+:/, ""), i = jt.elementTypes[r];
    return typeof i < "u" ? new i(this, e) : new Op(this, e);
  }
  createTextNode(e) {
    return new LA(this, e);
  }
  setViewBox(e) {
    this.screen.setViewBox(jA({
      document: this
    }, e));
  }
}
jt.createCanvas = kA;
jt.createImage = zA;
jt.elementTypes = NA;
function Hh(t, e) {
  var r = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(n) {
      return Object.getOwnPropertyDescriptor(t, n).enumerable;
    })), r.push.apply(r, i);
  }
  return r;
}
function dr(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Hh(Object(r), !0).forEach(function(i) {
      Pc(t, i, r[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(r)) : Hh(Object(r)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(r, i));
    });
  }
  return t;
}
class yr {
  /**
   * Main constructor.
   * @param ctx - Rendering context.
   * @param svg - SVG Document.
   * @param options - Rendering options.
   */
  constructor(e, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    this.parser = new ia(i), this.screen = new pn(e, i), this.options = i;
    var n = new jt(this, i), a = n.createDocumentElement(r);
    this.document = n, this.documentElement = a;
  }
  /**
   * Create Canvg instance from SVG source string or URL.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */
  static from(e, r) {
    var i = arguments;
    return Ft(function* () {
      var n = i.length > 2 && i[2] !== void 0 ? i[2] : {}, a = new ia(n), s = yield a.parse(r);
      return new yr(e, s, n);
    })();
  }
  /**
   * Create Canvg instance from SVG source string.
   * @param ctx - Rendering context.
   * @param svg - SVG source string.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */
  static fromString(e, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = new ia(i), a = n.parseFromString(r);
    return new yr(e, a, i);
  }
  /**
   * Create new Canvg instance with inherited options.
   * @param ctx - Rendering context.
   * @param svg - SVG source string or URL.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */
  fork(e, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return yr.from(e, r, dr(dr({}, this.options), i));
  }
  /**
   * Create new Canvg instance with inherited options.
   * @param ctx - Rendering context.
   * @param svg - SVG source string.
   * @param options - Rendering options.
   * @returns Canvg instance.
   */
  forkString(e, r) {
    var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return yr.fromString(e, r, dr(dr({}, this.options), i));
  }
  /**
   * Document is ready promise.
   * @returns Ready promise.
   */
  ready() {
    return this.screen.ready();
  }
  /**
   * Document is ready value.
   * @returns Is ready or not.
   */
  isReady() {
    return this.screen.isReady();
  }
  /**
   * Render only first frame, ignoring animations and mouse.
   * @param options - Rendering options.
   */
  render() {
    var e = arguments, r = this;
    return Ft(function* () {
      var i = e.length > 0 && e[0] !== void 0 ? e[0] : {};
      r.start(dr({
        enableRedraw: !0,
        ignoreAnimation: !0,
        ignoreMouse: !0
      }, i)), yield r.ready(), r.stop();
    })();
  }
  /**
   * Start rendering.
   * @param options - Render options.
   */
  start() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, {
      documentElement: r,
      screen: i,
      options: n
    } = this;
    i.start(r, dr(dr({
      enableRedraw: !0
    }, n), e));
  }
  /**
   * Stop rendering.
   */
  stop() {
    this.screen.stop();
  }
  /**
   * Resize SVG to fit in given size.
   * @param width
   * @param height
   * @param preserveAspectRatio
   */
  resize(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : e, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
    this.documentElement.resize(e, r, i);
  }
}
const BA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AElement: Vp,
  AnimateColorElement: kp,
  AnimateElement: Ka,
  AnimateTransformElement: zp,
  BoundingBox: at,
  CB1: ul,
  CB2: dl,
  CB3: hl,
  CB4: fl,
  Canvg: yr,
  CircleElement: Cp,
  ClipPathElement: qp,
  DefsElement: Lp,
  DescElement: t0,
  Document: jt,
  Element: ge,
  EllipseElement: Ip,
  FeColorMatrixElement: jc,
  FeCompositeElement: Qp,
  FeDropShadowElement: Kp,
  FeGaussianBlurElement: Jp,
  FeMorphologyElement: Zp,
  FilterElement: yn,
  Font: ke,
  FontElement: Bp,
  FontFaceElement: Fp,
  GElement: qa,
  GlyphElement: Rc,
  GradientElement: Dc,
  ImageElement: Wp,
  LineElement: _p,
  LinearGradientElement: Dp,
  MarkerElement: Mp,
  MaskElement: vn,
  Matrix: _c,
  MissingGlyphElement: $p,
  Mouse: yp,
  PSEUDO_ZERO: xr,
  Parser: ia,
  PathElement: ee,
  PathParser: B,
  PatternElement: Rp,
  Point: pe,
  PolygonElement: Ap,
  PolylineElement: Lc,
  Property: j,
  QB1: gl,
  QB2: pl,
  QB3: ml,
  RadialGradientElement: Np,
  RectElement: Mc,
  RenderedElement: rr,
  Rotate: wp,
  SVGElement: Oi,
  SVGFontLoader: Yp,
  Scale: Ep,
  Screen: pn,
  Skew: Ac,
  SkewX: Tp,
  SkewY: Pp,
  StopElement: jp,
  StyleElement: Nc,
  SymbolElement: Gp,
  TRefElement: Up,
  TSpanElement: mn,
  TextElement: ir,
  TextPathElement: Hp,
  TitleElement: e0,
  Transform: Zt,
  Translate: Sp,
  UnknownElement: Op,
  UseElement: Xp,
  ViewPort: vp,
  compressSpaces: Lr,
  default: yr,
  getSelectorSpecificity: mp,
  normalizeAttributeName: gp,
  normalizeColor: pp,
  parseExternalUrl: Ic,
  presets: mA,
  toNumbers: He,
  trimLeft: hp,
  trimRight: fp,
  vectorMagnitude: ll,
  vectorsAngle: cl,
  vectorsRatio: Pa
}, Symbol.toStringTag, { value: "Module" }));
export {
  $0 as ActionButton,
  VA as Checkmark,
  e8 as Dialog,
  xl as Loader,
  fv as Pane,
  Ef as Panes,
  Tf as Preview,
  Pf as Previews,
  Of as Printable,
  Db as Proof,
  t8 as ProofInterstitial,
  n8 as Sorter,
  r8 as StandaloneImageEditor,
  i8 as Textfield,
  a8 as Toggle,
  UA as canvasDepths,
  uS as cartAdd,
  hS as cartAddTiles,
  dS as cartUpdate,
  fS as cartUpdateTiles,
  l8 as de_DE,
  o8 as en_US,
  rS as fetchArt,
  tS as fetchBundle,
  nS as fetchBundleInstance,
  iS as fetchLineitem,
  mS as fetchMgiProductData,
  eS as fetchProduct,
  aS as fetchProofLineitem,
  lS as fetchSize,
  sS as fetchSizes,
  oS as fetchSuggestedSizes,
  c8 as fr_FR,
  gS as generateArPreview,
  pS as generateArPreviewV3,
  Kc as getClosest,
  KA as hideChatIcon,
  lm as isSmallImage,
  YA as isValidMimeType,
  XA as isValidPixelArea,
  Ni as lightenDarken,
  sm as parseImageData,
  qc as parseOldData,
  am as parseSvg,
  $A as products,
  HA as sanitizeSvg,
  WA as serializeSvg,
  ZA as showChatIcon,
  om as sortImages,
  QA as startChat,
  JA as stopChat,
  s8 as store,
  GA as supportsAR,
  qA as translate,
  cm as trapTabFocus,
  cS as upload
};
(function(){"use strict";try{if(typeof document!="undefined"){var a=document.createElement("style");a.id="scoops",a.appendChild(document.createTextNode("[data-shadow][data-v-1b1b42df]{box-shadow:inset 0 0 1vw #00000080;transform:translateZ(-7px)}[data-background][data-v-1b1b42df]{transition:opacity .25s cubic-bezier(.49,.01,.2,.99)}[data-frame-top-inner][data-v-1b1b42df]{transform:rotateX(-90deg);transform-origin:50% 0%;box-shadow:inset 0 -3vw 4vw -3vw #0000004d,inset 0 -.7vw 1vw -1.2vw #0009}[data-frame-right-inner][data-v-1b1b42df]{transform:rotateY(-90deg);transform-origin:100% 50%;box-shadow:inset 3vw 0 4vw -3vw #0000004d,inset 7px 0 1vw -1.2vw #0009}[data-frame-bottom-inner][data-v-1b1b42df]{transform:rotateX(90deg);transform-origin:50% 100%;box-shadow:inset 0 3vw 4vw -3vw #0000004d,inset 0 7px 1vw -1.2vw #0009}[data-frame-left-inner][data-v-1b1b42df]{transform:rotateY(90deg);transform-origin:0% 50%;box-shadow:inset -3vw 0 4vw -3vw #0000004d,inset -.7vw 0 1vw -1.2vw #0009}[data-mat-top][data-v-1b1b42df]{transform:rotateX(-90deg) translateY(3px);transform-origin:50% 0%;background:white;box-shadow:inset 0 -.2vw 1vw #0000004d;background-image:linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.1))}[data-mat-right][data-v-1b1b42df]{transform:rotateY(-90deg) translate(-3px);transform-origin:100% 50%;background:white;box-shadow:inset .2vw 0 1vw #0003;background-image:linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,0))}[data-mat-bottom][data-v-1b1b42df]{transform:rotateX(90deg) translateY(-3px);transform-origin:50% 100%;background:white;box-shadow:inset 0 .2vw 1vw #0003;background-image:linear-gradient(rgba(0,0,0,0),rgba(0,0,0,0))}[data-mat-left][data-v-1b1b42df]{transform:rotateY(90deg) translate(3px);transform-origin:0% 50%;background:white;box-shadow:inset -.2vw 0 1vw #0000001a;background-image:linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,0))}[data-edge-top][data-v-1b1b42df]{transition:opacity .25s cubic-bezier(.49,.01,.2,.99);transform:translateY(-100%) rotateX(90deg);transform-origin:50% 100%}[data-edge-right][data-v-1b1b42df]{transition:opacity .25s cubic-bezier(.49,.01,.2,.99);transform:translate(100%) rotateY(90deg);transform-origin:0% 50%}[data-edge-bottom][data-v-1b1b42df]{transition:opacity .25s cubic-bezier(.49,.01,.2,.99);transform:translateY(100%) rotateX(-90deg);transform-origin:50% 0%}[data-edge-left][data-v-1b1b42df]{transition:opacity .25s cubic-bezier(.49,.01,.2,.99);transform:translate(-100%) rotateY(-90deg);transform-origin:100% 50%}[data-frame-top-outer][data-v-1b1b42df]{transform:rotateX(90deg);transform-origin:50% 100%;box-shadow:inset 0 3vw 4vw -3vw #0000004d,inset 0 .7vw 1vw -1.2vw #0009;background-image:linear-gradient(rgba(0,0,0,.2),rgba(0,0,0,0))}[data-frame-right-outer][data-v-1b1b42df]{transform:rotateY(90deg);transform-origin:0% 50%;box-shadow:inset -3vw 0 4vw -3vw #0000004d,inset -.7vw 0 1vw -1.2vw #0009;background-image:linear-gradient(-90deg,rgba(0,0,0,.2),rgba(0,0,0,0)),linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.1))}[data-frame-bottom-outer][data-v-1b1b42df]{transform:rotateX(-90deg);transform-origin:50% 0%;box-shadow:inset 0 -3vw 4vw -3vw #0000004d,inset 0 -.7vw 1vw -1.2vw #0009;background-image:linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.2)),linear-gradient(rgba(0,0,0,.2),rgba(0,0,0,.2))}[data-frame-left-outer][data-v-1b1b42df]{transform:rotateY(-90deg);transform-origin:100% 50%;box-shadow:inset 3vw 0 4vw -3vw #0000004d,inset .7vw 0 1vw -1.2vw #0009;background-image:linear-gradient(90deg,rgba(0,0,0,.2),rgba(0,0,0,0)),linear-gradient(rgba(0,0,0,.1),rgba(0,0,0,.1))}[data-mat][data-v-1b1b42df]{transform:translateZ(-3px)}.spinner{animation:rotate 2s linear infinite;z-index:2}.spinner .path{stroke:#9eaa98;stroke-linecap:round;animation:dash 1.5s ease-in-out infinite}@keyframes rotate{to{transform:rotate(360deg)}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}.cursor-move[data-v-98d57ab0]{cursor:move}.cursor-not-allowed[data-v-98d57ab0]{cursor:not-allowed}.grid-move[data-v-98d57ab0],.grid-enter-active[data-v-98d57ab0],.grid-leave-active[data-v-98d57ab0]{transition:all .5s ease}.grid-enter-from[data-v-98d57ab0],.grid-leave-to[data-v-98d57ab0]{opacity:0;transform:translateY(30px)}[data-v-98d57ab0] img{pointer-events:none}")),document.head.appendChild(a)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
